
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("67mQl", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "Onboarding", () => $0387e2665726dcf9$export$70238cd3868b67c9);
$parcel$export(module.exports, "default", () => $0387e2665726dcf9$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Bc5A = parcelRequire("8Bc5A");

var $cE2Qr = parcelRequire("cE2Qr");

var $6jY6G = parcelRequire("6jY6G");

var $lgd3t = parcelRequire("lgd3t");

var $4QigF = parcelRequire("4QigF");

var $ieDtd = parcelRequire("ieDtd");

var $kdIRm = parcelRequire("kdIRm");
const $0387e2665726dcf9$export$70238cd3868b67c9 = ()=>{
    const route = (0, $6jY6G.useCurrentRoute)();
    const [configQueryParam] = (0, $ieDtd.useQueryParam)('config');
    const [quickstartStatus] = (0, $cE2Qr.useQuickstartUiStatus)();
    if ((0, $kdIRm.shouldRouteSkipOnboarding)(route.name, configQueryParam)) return null;
    const shouldRenderOnboardingButton = quickstartStatus !== (0, $8Bc5A.QUICKSTART_UI_STATUS).NOT_LOADED && quickstartStatus !== (0, $8Bc5A.QUICKSTART_UI_STATUS).DISMISSED;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lgd3t.JswQuickStartShouldRender), null), shouldRenderOnboardingButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4QigF.JswOnboardingButton), null));
};
var $0387e2665726dcf9$export$2e2bcd8739ae039 = $0387e2665726dcf9$export$70238cd3868b67c9;

});
parcelRegister("8Bc5A", function(module, exports) {

$parcel$export(module.exports, "PACKAGE_NAME", () => $5f07ce956337ba8b$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "PACKAGE_TEAM_NAME", () => $5f07ce956337ba8b$export$2b3151a089bc8780);
$parcel$export(module.exports, "DEFAULT_NUDGE_WIDTH", () => $5f07ce956337ba8b$export$6826d33e9a2c0119);
$parcel$export(module.exports, "ROOT_TASK", () => $5f07ce956337ba8b$export$b580da85daad7757);
$parcel$export(module.exports, "REVERSE_TRIAL_ROOT_TASK", () => $5f07ce956337ba8b$export$5eef19b26a4bbe70);
$parcel$export(module.exports, "QUICKSTART_TYPE", () => $5f07ce956337ba8b$export$c57d251ae83aff51);
$parcel$export(module.exports, "getBackendVisibilityKey", () => $5f07ce956337ba8b$export$d9df7fd23ab00c49);
$parcel$export(module.exports, "KEY_OPEN", () => $5f07ce956337ba8b$export$93a67c1026e8cb7c);
$parcel$export(module.exports, "KEY_DISMISSED", () => $5f07ce956337ba8b$export$a7dcb0b5013e932b);
$parcel$export(module.exports, "KEY_TASK_GROUP", () => $5f07ce956337ba8b$export$f962b14e410d598f);
$parcel$export(module.exports, "KEY_OPEN_TASK", () => $5f07ce956337ba8b$export$21e8355b28449456);
$parcel$export(module.exports, "KEY_HAS_EVER_SEEN_ROUTE", () => $5f07ce956337ba8b$export$536a90031123e004);
$parcel$export(module.exports, "KEY_PREMIUM_TRIAL_REOPENED", () => $5f07ce956337ba8b$export$3ccd291a1a3a4f6d);
$parcel$export(module.exports, "ACTION_SUBJECT_ID", () => $5f07ce956337ba8b$export$9957974f8b4d8f74);
$parcel$export(module.exports, "SOURCE", () => $5f07ce956337ba8b$export$83c8d7110915321e);
$parcel$export(module.exports, "KEY_JSW_ONBOARDING", () => $5f07ce956337ba8b$export$8b9bd2a9275b0187);
$parcel$export(module.exports, "convertToHaveSeenItTask", () => $5f07ce956337ba8b$export$ec43e7bf5973b10f);
$parcel$export(module.exports, "ADD_COLUMNS_TASK", () => $5f07ce956337ba8b$export$cbeb719208f32c8a);
$parcel$export(module.exports, "CREATE_PROJECT_TASK", () => $5f07ce956337ba8b$export$88c918f2cfaff86);
$parcel$export(module.exports, "CREATE_ISSUE_TASK", () => $5f07ce956337ba8b$export$abbbea7c37c93cb5);
$parcel$export(module.exports, "CREATE_ISSUE_TASK_SIMPLIFIED", () => $5f07ce956337ba8b$export$2a0253cb20f48a8);
$parcel$export(module.exports, "INVITE_TEAMMATES_TASK", () => $5f07ce956337ba8b$export$f97428bb4b1991ec);
$parcel$export(module.exports, "INVITE_TEAMMATES_VIDEO_TASK", () => $5f07ce956337ba8b$export$45eaf4204fcc7);
$parcel$export(module.exports, "CAPTURE_INTEGRATIONS_TASK", () => $5f07ce956337ba8b$export$af57685e201438e8);
$parcel$export(module.exports, "FIND_HELP_TASK", () => $5f07ce956337ba8b$export$d6c67e9aab4e2b26);
$parcel$export(module.exports, "SET_UP_BOARD_TASK", () => $5f07ce956337ba8b$export$3de8c242d2b82f26);
$parcel$export(module.exports, "GET_MOBILE_APP_TASK", () => $5f07ce956337ba8b$export$a01fa44f793dbfac);
$parcel$export(module.exports, "MAP_OUT_YOUR_PROJECT_GOALS_TASK", () => $5f07ce956337ba8b$export$6a4507e462fd41da);
$parcel$export(module.exports, "IDENTIFY_SMALL_CHUNKS_OF_WORK_TASK", () => $5f07ce956337ba8b$export$e64c1dced6ac4458);
$parcel$export(module.exports, "IDENTIFY_SMALL_CHUNKS_OF_WORK_KANBAN_TASK", () => $5f07ce956337ba8b$export$63b0e55f9c6454ac);
$parcel$export(module.exports, "MONITOR_MANAGE_RISK_TASK", () => $5f07ce956337ba8b$export$c1effb1c8979fe22);
$parcel$export(module.exports, "PREMIUM_REVERSE_TRIAL_TASK", () => $5f07ce956337ba8b$export$d97d31d934dbb194);
$parcel$export(module.exports, "PREMIUM_EDITION_OVERVIEW_TASK", () => $5f07ce956337ba8b$export$cafb5bd13b02056b);
$parcel$export(module.exports, "PREMIUM_EDITION_OVERVIEW_TASK_NON_ADMIN", () => $5f07ce956337ba8b$export$e55c18b809946e72);
$parcel$export(module.exports, "STANDARD_EDITION_OVERVIEW_TASK", () => $5f07ce956337ba8b$export$de5640b9ae8140a7);
$parcel$export(module.exports, "ADVANCED_ROADMAPS_TASK", () => $5f07ce956337ba8b$export$540b5c3c4b6ce459);
$parcel$export(module.exports, "CHANGE_CONTROL_TASK", () => $5f07ce956337ba8b$export$6f71dff531ff592);
$parcel$export(module.exports, "AUTOMATIONS_TASK", () => $5f07ce956337ba8b$export$83255ab79e45f34f);
$parcel$export(module.exports, "SITE_ADMINISTRATIONS_TASK", () => $5f07ce956337ba8b$export$b57d172af9ad7647);
$parcel$export(module.exports, "USER_MANAGEMENT_TASK", () => $5f07ce956337ba8b$export$ff4c933c1fe90b68);
$parcel$export(module.exports, "SCRUM_ONBOARDING_TASK", () => $5f07ce956337ba8b$export$3e2776d61f3662dc);
$parcel$export(module.exports, "CUSTOMIZE_SITE_NAME_TASK", () => $5f07ce956337ba8b$export$9048315f2c03fd9d);
$parcel$export(module.exports, "CREATE_BUSINESS_PROJECT_FROM_JSW_QUICKSTART_TASK", () => $5f07ce956337ba8b$export$4145c2cec2da6f9b);
$parcel$export(module.exports, "TRY_ATLASSIAN_UNIVERSITY_ONBOARDING_TASK", () => $5f07ce956337ba8b$export$4957a1ad203cf6dd);
$parcel$export(module.exports, "CALENDAR_VIEW_TASK", () => $5f07ce956337ba8b$export$190b5dd0a1322552);
$parcel$export(module.exports, "JWM_PROJECT_SUMMARY_TASK", () => $5f07ce956337ba8b$export$501166b25f254aab);
$parcel$export(module.exports, "JWM_CREATE_SAMPLE_PROJECT_TASK", () => $5f07ce956337ba8b$export$94ad6507a703f4eb);
$parcel$export(module.exports, "JWM_BACKGROUND_COLOR_TASK", () => $5f07ce956337ba8b$export$be1c522400a1bd7c);
$parcel$export(module.exports, "JWM_CALENDAR_TASK", () => $5f07ce956337ba8b$export$2aa6e7b6e24a04f5);
$parcel$export(module.exports, "JWM_TIMELINE_TASK", () => $5f07ce956337ba8b$export$f3b53199b07af2a1);
$parcel$export(module.exports, "JWM_BUILD_FORM_TASK", () => $5f07ce956337ba8b$export$d37415ffddcf2142);
$parcel$export(module.exports, "JWM_FEEDBACK_TASK", () => $5f07ce956337ba8b$export$2ae00586da7cb606);
$parcel$export(module.exports, "JWM_FEEDBACK_SAMPLE_PROJECT_TASK", () => $5f07ce956337ba8b$export$b86266e6594a97bb);
$parcel$export(module.exports, "JWM_CREATE_YOUR_OWN_PROJECT_TASK", () => $5f07ce956337ba8b$export$20bc3dc137ac1c38);
$parcel$export(module.exports, "JWM_CREATE_PROJECT_TASK", () => $5f07ce956337ba8b$export$77071b77e2801b18);
$parcel$export(module.exports, "JWM_SHARE_PROJECT_TASK", () => $5f07ce956337ba8b$export$9c89f946f05d884a);
$parcel$export(module.exports, "JWM_TRELLO_CROSSFLOW_TASK_IMPORT", () => $5f07ce956337ba8b$export$b52a7c936684cfc5);
$parcel$export(module.exports, "JWM_SUMMARY_AND_REPORTS_TASK", () => $5f07ce956337ba8b$export$b5555f24061f9fb);
$parcel$export(module.exports, "JWM_TRELLO_CROSSFLOW_CALENDAR_AND_TIMELINE_TASK", () => $5f07ce956337ba8b$export$ff25449f34b8abf);
$parcel$export(module.exports, "JWM_TRELLO_CROSSFLOW_TASK_KEY_DIFFERENCES", () => $5f07ce956337ba8b$export$3380e677209260fe);
$parcel$export(module.exports, "GET_STARTED_LIST_TASK", () => $5f07ce956337ba8b$export$7a2fcaad1564e6b7);
$parcel$export(module.exports, "OPS_JTBD_1_LIST", () => $5f07ce956337ba8b$export$da23b72d32bfad9e);
$parcel$export(module.exports, "OPS_JTBD_2_BOARD", () => $5f07ce956337ba8b$export$4b064659282e0238);
$parcel$export(module.exports, "OPS_JTBD_2_FORMS", () => $5f07ce956337ba8b$export$3ab51851f6d823e);
$parcel$export(module.exports, "OPS_JTBD_2_SUMMARY", () => $5f07ce956337ba8b$export$e4a1a37a9a1350ad);
$parcel$export(module.exports, "OPS_JTBD_3_LIST", () => $5f07ce956337ba8b$export$b7f7da5e795f0327);
$parcel$export(module.exports, "OPS_JTBD_3_CALENDAR", () => $5f07ce956337ba8b$export$80a401c1aa47a377);
$parcel$export(module.exports, "OPS_JTBD_3_PAGES", () => $5f07ce956337ba8b$export$934ac7a251b26dc7);
$parcel$export(module.exports, "OPS_JTBD_4_LIST", () => $5f07ce956337ba8b$export$4634f6395df3ebbe);
$parcel$export(module.exports, "OPS_JTBD_4_CALENDAR", () => $5f07ce956337ba8b$export$768fb41107a1e8d7);
$parcel$export(module.exports, "OPS_JTBD_4_TIMELINE", () => $5f07ce956337ba8b$export$d797a81bace17184);
$parcel$export(module.exports, "OPS_JTBD_4_SUMMARY", () => $5f07ce956337ba8b$export$746102c94db9df1f);
$parcel$export(module.exports, "OPS_JTBD_5_LIST", () => $5f07ce956337ba8b$export$5f1efd797d65e349);
$parcel$export(module.exports, "OPS_JTBD_5_TIMELINE", () => $5f07ce956337ba8b$export$cccc812ccafbf11f);
$parcel$export(module.exports, "OPS_JTBD_5_PAGES", () => $5f07ce956337ba8b$export$64822db87abd8a47);
$parcel$export(module.exports, "OPS_JTBD_6_PAGES", () => $5f07ce956337ba8b$export$64f764d8be495c82);
$parcel$export(module.exports, "OPS_JTBD_7_LIST", () => $5f07ce956337ba8b$export$24eae23dc1c68bbd);
$parcel$export(module.exports, "OPS_JTBD_7_CALENDAR", () => $5f07ce956337ba8b$export$50fa92eba6f82feb);
$parcel$export(module.exports, "OPS_JTBD_0_LIST", () => $5f07ce956337ba8b$export$4155d22fe3f14cd6);
$parcel$export(module.exports, "OPS_JTBD_0_TIMELINE", () => $5f07ce956337ba8b$export$76813cbead887191);
$parcel$export(module.exports, "OPS_JTBD_0_PAGES", () => $5f07ce956337ba8b$export$90aab2ff89daf770);
$parcel$export(module.exports, "OPS_JTBD_DEFAULT_LIST", () => $5f07ce956337ba8b$export$a2bc0cbad2e6e605);
$parcel$export(module.exports, "OPS_JTBD_DEFAULT_BOARD", () => $5f07ce956337ba8b$export$f90872a1280728bb);
$parcel$export(module.exports, "OPS_JTBD_DEFAULT_INVITES", () => $5f07ce956337ba8b$export$bce644e96518cbd2);
$parcel$export(module.exports, "MKT_JTBD_1_LIST", () => $5f07ce956337ba8b$export$241aaebffac0a3e5);
$parcel$export(module.exports, "MKT_JTBD_1_CALENDAR", () => $5f07ce956337ba8b$export$f9dfc43b5b31c4b7);
$parcel$export(module.exports, "MKT_JTBD_1_TIMELINE", () => $5f07ce956337ba8b$export$79759e9e62fb9312);
$parcel$export(module.exports, "MKT_JTBD_2_CALENDAR", () => $5f07ce956337ba8b$export$992d1e0dce255d19);
$parcel$export(module.exports, "MKT_JTBD_2_PAGES", () => $5f07ce956337ba8b$export$d28c1b0e5b3e768);
$parcel$export(module.exports, "MKT_JTBD_3_PAGES", () => $5f07ce956337ba8b$export$ca714ee197bed4ec);
$parcel$export(module.exports, "MKT_JTBD_3_TIMELINE", () => $5f07ce956337ba8b$export$faae55ceea4b6073);
$parcel$export(module.exports, "MKT_JTBD_4_LIST", () => $5f07ce956337ba8b$export$200bc24cd120667e);
$parcel$export(module.exports, "MKT_JTBD_4_SUMMARY", () => $5f07ce956337ba8b$export$a0d784a48b4e886c);
$parcel$export(module.exports, "MKT_JTBD_4_PAGES", () => $5f07ce956337ba8b$export$baf5bd09b4b33b8a);
$parcel$export(module.exports, "MKT_JTBD_5_TIMELINE", () => $5f07ce956337ba8b$export$4702007eedbca8ab);
$parcel$export(module.exports, "MKT_JTBD_5_SUMMARY", () => $5f07ce956337ba8b$export$aa9d2d635ea63898);
$parcel$export(module.exports, "MKT_JTBD_6_FORMS", () => $5f07ce956337ba8b$export$2ea449225c1f6cac);
$parcel$export(module.exports, "MKT_JTBD_0_LIST", () => $5f07ce956337ba8b$export$deb8b557e735e26a);
$parcel$export(module.exports, "MKT_JTBD_0_CALENDAR", () => $5f07ce956337ba8b$export$d45754df44e4c309);
$parcel$export(module.exports, "MKT_JTBD_0_TIMELINE", () => $5f07ce956337ba8b$export$78b2913b550edbb);
$parcel$export(module.exports, "MKT_JTBD_0_SUMMARY", () => $5f07ce956337ba8b$export$71243272608c58ab);
$parcel$export(module.exports, "MKT_JTBD_DEFAULT_LIST", () => $5f07ce956337ba8b$export$39a08f215c33bc39);
$parcel$export(module.exports, "MKT_JTBD_DEFAULT_BOARD", () => $5f07ce956337ba8b$export$d2377f6a6fa3b49c);
$parcel$export(module.exports, "MKT_JTBD_DEFAULT_PROJECT", () => $5f07ce956337ba8b$export$befa8f6533309779);
$parcel$export(module.exports, "MKT_JTBD_DEFAULT_INVITES", () => $5f07ce956337ba8b$export$736b40db8701ba6c);
$parcel$export(module.exports, "TAILORED_ONBOARDING_SUMMARY", () => $5f07ce956337ba8b$export$11eff6ae2f70b67b);
$parcel$export(module.exports, "TAILORED_ONBOARDING_LIST", () => $5f07ce956337ba8b$export$fb2d23e5315a67a9);
$parcel$export(module.exports, "TAILORED_ONBOARDING_CALENDAR", () => $5f07ce956337ba8b$export$32e794bb49d60b6);
$parcel$export(module.exports, "TAILORED_ONBOARDING_BOARD", () => $5f07ce956337ba8b$export$fed256238b27db06);
$parcel$export(module.exports, "TAILORED_ONBOARDING_TIMELINE", () => $5f07ce956337ba8b$export$132eecb4d35a590d);
$parcel$export(module.exports, "TAILORED_ONBOARDING_PAGES", () => $5f07ce956337ba8b$export$2579c51cadd45eca);
$parcel$export(module.exports, "TAILORED_ONBOARDING_FORM", () => $5f07ce956337ba8b$export$4b1a0cefa966ea0);
$parcel$export(module.exports, "TAILORED_ONBOARDING_INVITE", () => $5f07ce956337ba8b$export$f6558daacc312a65);
$parcel$export(module.exports, "TAILORED_ONBOARDING_BACKLOG", () => $5f07ce956337ba8b$export$925efa2e24e86b88);
$parcel$export(module.exports, "TAILORED_ONBOARDING_CODE", () => $5f07ce956337ba8b$export$40454d3e062dcd44);
$parcel$export(module.exports, "JSM_CUSTOMIZE_YOUR_REQUEST_TYPES_TASK", () => $5f07ce956337ba8b$export$99b0e09ff6f00490);
$parcel$export(module.exports, "JSM_REVIEW_YOUR_CHANNELS_TASK", () => $5f07ce956337ba8b$export$2a82344eb273eeff);
$parcel$export(module.exports, "JSM_INVITE_YOUR_TEAM_TASK", () => $5f07ce956337ba8b$export$1de5766b7e640d6b);
$parcel$export(module.exports, "KEY_HAS_NAVIGATED_FROM_LINK", () => $5f07ce956337ba8b$export$11c0696d49e68c93);
$parcel$export(module.exports, "ACCOUNT_ID", () => $5f07ce956337ba8b$export$c8ab6996f562d0db);
$parcel$export(module.exports, "KANBAN_ONBOARDING_TASK", () => $5f07ce956337ba8b$export$2b5f951ad8e70cfe);
$parcel$export(module.exports, "QUICKSTART_UI_STATUS", () => $5f07ce956337ba8b$export$5703447487aaccdf);
$parcel$export(module.exports, "BACKLOG_CREATE_SPRINT_NUDGE_ID", () => $5f07ce956337ba8b$export$e0197e09cccd4e50);
$parcel$export(module.exports, "PROJECT_SETTING_PAGES", () => $5f07ce956337ba8b$export$f779bbfe667acddc);
$parcel$export(module.exports, "JSM_BUSINESS_TASKS", () => $5f07ce956337ba8b$export$38fbac7a5bf4aa33);
$parcel$export(module.exports, "allTasksExcludingJSMBusinessTasks", () => $5f07ce956337ba8b$export$7578902c7f420a3);
$parcel$export(module.exports, "SAMPLE_DATA_PROJECT_KEYS_TO_HIDE_ON", () => $5f07ce956337ba8b$export$5980f41aa657f9c7);

var $g5X3G = parcelRequire("g5X3G");
const $5f07ce956337ba8b$var$completeJwmTaskName = (taskId)=>`jwm-onboarding-checklist.${taskId}`;
const $5f07ce956337ba8b$var$completeJswTaskName = (taskId)=>`jsw-onboarding-checklist.${taskId}`;
const $5f07ce956337ba8b$var$completeJsmTaskName = (taskId)=>`jsm-onboarding-checklist.${taskId}`;
const $5f07ce956337ba8b$export$b8b9d90f9e5bd72b = 'jiraSoftwareOnboardingQuickstart';
const $5f07ce956337ba8b$export$2b3151a089bc8780 = 'jlove-makkuro';
const $5f07ce956337ba8b$export$6826d33e9a2c0119 = 320;
const $5f07ce956337ba8b$export$b580da85daad7757 = 'root';
const $5f07ce956337ba8b$export$5eef19b26a4bbe70 = 'reverseTrialRoot';
const $5f07ce956337ba8b$export$c57d251ae83aff51 = {
    JSM_BUSINESS_QUICKSTART_KEY: 'jsm-business-checklist',
    OLD_GLOBAL_QUICKSTART_KEY: 'jsw-onboarding-checklist'
};
const $5f07ce956337ba8b$export$d9df7fd23ab00c49 = (type)=>`${type}.visibility`;
const $5f07ce956337ba8b$export$93a67c1026e8cb7c = 'jsw-onboarding-checklist.open';
const $5f07ce956337ba8b$export$a7dcb0b5013e932b = 'jsw-onboarding-checklist.dismissed';
const $5f07ce956337ba8b$export$f962b14e410d598f = 'jsw-onboarding-checklist.task-group';
const $5f07ce956337ba8b$export$21e8355b28449456 = 'jsw-onboarding-checklist.open-task';
const $5f07ce956337ba8b$export$536a90031123e004 = 'jsw-onboarding-checklist.has-ever-seen-route';
const $5f07ce956337ba8b$export$3ccd291a1a3a4f6d = 'jsw-onboarding-checklist.reopened-on-premium-trial';
const $5f07ce956337ba8b$export$9957974f8b4d8f74 = 'nuxOnboardingQuickstart';
const $5f07ce956337ba8b$export$83c8d7110915321e = 'nuxOnboardingQuickstart';
const $5f07ce956337ba8b$export$8b9bd2a9275b0187 = 'jsw.onboarding';
const $5f07ce956337ba8b$export$ec43e7bf5973b10f = (taskId)=>`${taskId}.have-seenit`;
const $5f07ce956337ba8b$export$cbeb719208f32c8a = $5f07ce956337ba8b$var$completeJswTaskName('add-columns-task');
const $5f07ce956337ba8b$export$88c918f2cfaff86 = $5f07ce956337ba8b$var$completeJswTaskName('create-project-task');
const $5f07ce956337ba8b$export$abbbea7c37c93cb5 = $5f07ce956337ba8b$var$completeJswTaskName('create-issue-task');
const $5f07ce956337ba8b$export$2a0253cb20f48a8 = $5f07ce956337ba8b$var$completeJswTaskName('create-issue-task-simplified');
const $5f07ce956337ba8b$export$f97428bb4b1991ec = $5f07ce956337ba8b$var$completeJswTaskName('invite-teammates-task');
const $5f07ce956337ba8b$export$45eaf4204fcc7 = $5f07ce956337ba8b$var$completeJswTaskName('invite-teammates-video-task');
const $5f07ce956337ba8b$export$af57685e201438e8 = $5f07ce956337ba8b$var$completeJswTaskName('capture-integrations-task');
const $5f07ce956337ba8b$export$d6c67e9aab4e2b26 = $5f07ce956337ba8b$var$completeJswTaskName('find-help-task');
const $5f07ce956337ba8b$export$3de8c242d2b82f26 = $5f07ce956337ba8b$var$completeJswTaskName('set-up-board-task');
const $5f07ce956337ba8b$export$a01fa44f793dbfac = $5f07ce956337ba8b$var$completeJswTaskName('get-mobile-app-task');
const $5f07ce956337ba8b$export$6a4507e462fd41da = $5f07ce956337ba8b$var$completeJswTaskName('map-out-your-project-goals');
const $5f07ce956337ba8b$export$e64c1dced6ac4458 = $5f07ce956337ba8b$var$completeJswTaskName('identify-small-chunks-of-work');
const $5f07ce956337ba8b$export$63b0e55f9c6454ac = $5f07ce956337ba8b$var$completeJswTaskName('identify-small-chunks-of-work-kanban');
const $5f07ce956337ba8b$export$c1effb1c8979fe22 = $5f07ce956337ba8b$var$completeJswTaskName('monitor-manage-risk');
const $5f07ce956337ba8b$export$d97d31d934dbb194 = $5f07ce956337ba8b$var$completeJswTaskName('premium-reverse-trial-task');
const $5f07ce956337ba8b$export$cafb5bd13b02056b = $5f07ce956337ba8b$var$completeJswTaskName('premium-edition-overview-task');
const $5f07ce956337ba8b$export$e55c18b809946e72 = $5f07ce956337ba8b$var$completeJswTaskName('premium-edition-overview-task-non-admin');
const $5f07ce956337ba8b$export$de5640b9ae8140a7 = $5f07ce956337ba8b$var$completeJswTaskName('standard-edition-overview-task');
const $5f07ce956337ba8b$export$540b5c3c4b6ce459 = $5f07ce956337ba8b$var$completeJswTaskName('advanced-roadmaps-task');
const $5f07ce956337ba8b$export$6f71dff531ff592 = $5f07ce956337ba8b$var$completeJswTaskName('change-control-task');
const $5f07ce956337ba8b$export$83255ab79e45f34f = $5f07ce956337ba8b$var$completeJswTaskName('automations-task');
const $5f07ce956337ba8b$export$b57d172af9ad7647 = $5f07ce956337ba8b$var$completeJswTaskName('site-administrations-task');
const $5f07ce956337ba8b$export$ff4c933c1fe90b68 = $5f07ce956337ba8b$var$completeJswTaskName('user-management-task');
const $5f07ce956337ba8b$export$3e2776d61f3662dc = $5f07ce956337ba8b$var$completeJswTaskName('scrum-onboarding-task');
const $5f07ce956337ba8b$export$9048315f2c03fd9d = $5f07ce956337ba8b$var$completeJswTaskName('customize-site-name-task');
const $5f07ce956337ba8b$export$4145c2cec2da6f9b = $5f07ce956337ba8b$var$completeJswTaskName('create-business-project-from-jsw-quickstart-task');
const $5f07ce956337ba8b$export$4957a1ad203cf6dd = $5f07ce956337ba8b$var$completeJswTaskName('try-atlassian-university-task');
const $5f07ce956337ba8b$export$190b5dd0a1322552 = $5f07ce956337ba8b$var$completeJswTaskName('calendar-view-task');
const $5f07ce956337ba8b$export$501166b25f254aab = $5f07ce956337ba8b$var$completeJwmTaskName('jwm-project-summary-task');
const $5f07ce956337ba8b$export$94ad6507a703f4eb = $5f07ce956337ba8b$var$completeJwmTaskName('jwm-create-sample-project-task');
const $5f07ce956337ba8b$export$be1c522400a1bd7c = $5f07ce956337ba8b$var$completeJwmTaskName('background-color-task');
const $5f07ce956337ba8b$export$2aa6e7b6e24a04f5 = $5f07ce956337ba8b$var$completeJwmTaskName('calendar-task');
const $5f07ce956337ba8b$export$f3b53199b07af2a1 = $5f07ce956337ba8b$var$completeJwmTaskName('timeline-task');
const $5f07ce956337ba8b$export$d37415ffddcf2142 = $5f07ce956337ba8b$var$completeJwmTaskName('build-form-task');
const $5f07ce956337ba8b$export$2ae00586da7cb606 = $5f07ce956337ba8b$var$completeJwmTaskName('feedback-task');
const $5f07ce956337ba8b$export$b86266e6594a97bb = $5f07ce956337ba8b$var$completeJwmTaskName('feedback-sample-project-task');
const $5f07ce956337ba8b$export$20bc3dc137ac1c38 = $5f07ce956337ba8b$var$completeJwmTaskName('create-your-own-project-task');
const $5f07ce956337ba8b$export$77071b77e2801b18 = $5f07ce956337ba8b$var$completeJwmTaskName('jwm-create-project-task');
const $5f07ce956337ba8b$export$9c89f946f05d884a = $5f07ce956337ba8b$var$completeJwmTaskName('share-project-task');
const $5f07ce956337ba8b$export$b52a7c936684cfc5 = $5f07ce956337ba8b$var$completeJwmTaskName('trello-crossflow-import');
const $5f07ce956337ba8b$export$b5555f24061f9fb = $5f07ce956337ba8b$var$completeJwmTaskName('summary-and-reports-task');
const $5f07ce956337ba8b$export$ff25449f34b8abf = $5f07ce956337ba8b$var$completeJwmTaskName('trello-crossflow-calendar-and-timeline');
const $5f07ce956337ba8b$export$3380e677209260fe = $5f07ce956337ba8b$var$completeJwmTaskName('trello-crossflow-key-differences');
const $5f07ce956337ba8b$export$7a2fcaad1564e6b7 = $5f07ce956337ba8b$var$completeJwmTaskName('get-started-list-task');
const $5f07ce956337ba8b$export$da23b72d32bfad9e = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_1_LIST');
const $5f07ce956337ba8b$export$4b064659282e0238 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_2_BOARD');
const $5f07ce956337ba8b$export$3ab51851f6d823e = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_2_FORMS');
const $5f07ce956337ba8b$export$e4a1a37a9a1350ad = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_2_SUMMARY');
const $5f07ce956337ba8b$export$b7f7da5e795f0327 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_3_LIST');
const $5f07ce956337ba8b$export$80a401c1aa47a377 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_3_CALENDAR');
const $5f07ce956337ba8b$export$934ac7a251b26dc7 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_3_PAGES');
const $5f07ce956337ba8b$export$4634f6395df3ebbe = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_4_LIST');
const $5f07ce956337ba8b$export$768fb41107a1e8d7 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_4_CALENDAR');
const $5f07ce956337ba8b$export$d797a81bace17184 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_4_TIMELINE');
const $5f07ce956337ba8b$export$746102c94db9df1f = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_4_SUMMARY');
const $5f07ce956337ba8b$export$5f1efd797d65e349 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_5_LIST');
const $5f07ce956337ba8b$export$cccc812ccafbf11f = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_5_TIMELINE');
const $5f07ce956337ba8b$export$64822db87abd8a47 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_5_PAGES');
const $5f07ce956337ba8b$export$64f764d8be495c82 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_6_PAGES');
const $5f07ce956337ba8b$export$24eae23dc1c68bbd = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_7_LIST');
const $5f07ce956337ba8b$export$50fa92eba6f82feb = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_7_CALENDAR');
const $5f07ce956337ba8b$export$4155d22fe3f14cd6 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_0_LIST');
const $5f07ce956337ba8b$export$76813cbead887191 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_0_TIMELINE');
const $5f07ce956337ba8b$export$90aab2ff89daf770 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_0_PAGES');
const $5f07ce956337ba8b$export$a2bc0cbad2e6e605 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_DEFAULT_LIST');
const $5f07ce956337ba8b$export$f90872a1280728bb = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_DEFAULT_BOARD');
const $5f07ce956337ba8b$export$bce644e96518cbd2 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_DEFAULT_INVITES');
const $5f07ce956337ba8b$export$241aaebffac0a3e5 = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_1_LIST');
const $5f07ce956337ba8b$export$f9dfc43b5b31c4b7 = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_1_CALENDAR');
const $5f07ce956337ba8b$export$79759e9e62fb9312 = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_1_TIMELINE');
const $5f07ce956337ba8b$export$992d1e0dce255d19 = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_2_CALENDAR');
const $5f07ce956337ba8b$export$d28c1b0e5b3e768 = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_2_PAGES');
const $5f07ce956337ba8b$export$ca714ee197bed4ec = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_3_PAGES');
const $5f07ce956337ba8b$export$faae55ceea4b6073 = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_3_TIMELINE');
const $5f07ce956337ba8b$export$200bc24cd120667e = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_4_LIST');
const $5f07ce956337ba8b$export$a0d784a48b4e886c = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_4_SUMMARY');
const $5f07ce956337ba8b$export$baf5bd09b4b33b8a = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_4_PAGES');
const $5f07ce956337ba8b$export$4702007eedbca8ab = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_5_TIMELINE');
const $5f07ce956337ba8b$export$aa9d2d635ea63898 = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_5_SUMMARY');
const $5f07ce956337ba8b$export$2ea449225c1f6cac = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_6_FORMS');
const $5f07ce956337ba8b$export$deb8b557e735e26a = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_0_LIST');
const $5f07ce956337ba8b$export$d45754df44e4c309 = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_0_CALENDAR');
const $5f07ce956337ba8b$export$78b2913b550edbb = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_0_TIMELINE');
const $5f07ce956337ba8b$export$71243272608c58ab = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_0_SUMMARY');
const $5f07ce956337ba8b$export$39a08f215c33bc39 = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_DEFAULT_LIST');
const $5f07ce956337ba8b$export$d2377f6a6fa3b49c = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_DEFAULT_BOARD');
const $5f07ce956337ba8b$export$befa8f6533309779 = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_DEFAULT_PROJECT');
const $5f07ce956337ba8b$export$736b40db8701ba6c = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_DEFAULT_INVITES');
const $5f07ce956337ba8b$export$11eff6ae2f70b67b = $5f07ce956337ba8b$var$completeJswTaskName('TAILORED_ONBOARDING_SUMMARY');
const $5f07ce956337ba8b$export$fb2d23e5315a67a9 = $5f07ce956337ba8b$var$completeJswTaskName('TAILORED_ONBOARDING_LIST');
const $5f07ce956337ba8b$export$32e794bb49d60b6 = $5f07ce956337ba8b$var$completeJswTaskName('TAILORED_ONBOARDING_CALENDAR');
const $5f07ce956337ba8b$export$fed256238b27db06 = $5f07ce956337ba8b$var$completeJswTaskName('TAILORED_ONBOARDING_BOARD');
const $5f07ce956337ba8b$export$132eecb4d35a590d = $5f07ce956337ba8b$var$completeJswTaskName('TAILORED_ONBOARDING_TIMELINE');
const $5f07ce956337ba8b$export$2579c51cadd45eca = $5f07ce956337ba8b$var$completeJswTaskName('TAILORED_ONBOARDING_PAGES');
const $5f07ce956337ba8b$export$4b1a0cefa966ea0 = $5f07ce956337ba8b$var$completeJswTaskName('TAILORED_ONBOARDING_FORM');
const $5f07ce956337ba8b$export$f6558daacc312a65 = $5f07ce956337ba8b$var$completeJswTaskName('TAILORED_ONBOARDING_INVITE');
const $5f07ce956337ba8b$export$925efa2e24e86b88 = $5f07ce956337ba8b$var$completeJswTaskName('TAILORED_ONBOARDING_BACKLOG');
const $5f07ce956337ba8b$export$40454d3e062dcd44 = $5f07ce956337ba8b$var$completeJswTaskName('TAILORED_ONBOARDING_CODE');
const $5f07ce956337ba8b$export$99b0e09ff6f00490 = $5f07ce956337ba8b$var$completeJsmTaskName('customize-your-request-types-task');
const $5f07ce956337ba8b$export$2a82344eb273eeff = $5f07ce956337ba8b$var$completeJsmTaskName('review-your-channels-task');
const $5f07ce956337ba8b$export$1de5766b7e640d6b = $5f07ce956337ba8b$var$completeJsmTaskName('invite-your-team-task');
const $5f07ce956337ba8b$export$11c0696d49e68c93 = 'jsw-onboarding-checklist.has.navigated.from.link';
const $5f07ce956337ba8b$export$c8ab6996f562d0db = (0, $g5X3G.toAccountId)('accountId');
const $5f07ce956337ba8b$export$2b5f951ad8e70cfe = $5f07ce956337ba8b$var$completeJswTaskName('kanban-onboarding-task');
const $5f07ce956337ba8b$export$5703447487aaccdf = {
    NOT_LOADED: 'NOT_LOADED',
    OPEN: 'OPEN',
    MINIMIZED: 'MINIMIZED',
    DISMISSED: 'DISMISSED'
};
const $5f07ce956337ba8b$export$e0197e09cccd4e50 = 'backlogCreateSprintNudge';
const $5f07ce956337ba8b$export$f779bbfe667acddc = [
    'legacy-project-settings-people',
    'project-settings-software-access'
];
const $5f07ce956337ba8b$export$38fbac7a5bf4aa33 = [
    $5f07ce956337ba8b$export$2a82344eb273eeff,
    $5f07ce956337ba8b$export$99b0e09ff6f00490,
    $5f07ce956337ba8b$export$1de5766b7e640d6b
];
const $5f07ce956337ba8b$export$7578902c7f420a3 = [
    $5f07ce956337ba8b$export$88c918f2cfaff86,
    $5f07ce956337ba8b$export$6a4507e462fd41da,
    $5f07ce956337ba8b$export$e64c1dced6ac4458,
    $5f07ce956337ba8b$export$63b0e55f9c6454ac,
    $5f07ce956337ba8b$export$c1effb1c8979fe22,
    $5f07ce956337ba8b$export$cbeb719208f32c8a,
    $5f07ce956337ba8b$export$abbbea7c37c93cb5,
    $5f07ce956337ba8b$export$2a0253cb20f48a8,
    $5f07ce956337ba8b$export$f97428bb4b1991ec,
    $5f07ce956337ba8b$export$d6c67e9aab4e2b26,
    $5f07ce956337ba8b$export$3de8c242d2b82f26,
    $5f07ce956337ba8b$export$a01fa44f793dbfac,
    $5f07ce956337ba8b$export$45eaf4204fcc7,
    $5f07ce956337ba8b$export$af57685e201438e8,
    $5f07ce956337ba8b$export$d97d31d934dbb194,
    $5f07ce956337ba8b$export$cafb5bd13b02056b,
    $5f07ce956337ba8b$export$e55c18b809946e72,
    $5f07ce956337ba8b$export$de5640b9ae8140a7,
    $5f07ce956337ba8b$export$540b5c3c4b6ce459,
    $5f07ce956337ba8b$export$6f71dff531ff592,
    $5f07ce956337ba8b$export$83255ab79e45f34f,
    $5f07ce956337ba8b$export$b57d172af9ad7647,
    $5f07ce956337ba8b$export$ff4c933c1fe90b68,
    $5f07ce956337ba8b$export$77071b77e2801b18,
    $5f07ce956337ba8b$export$94ad6507a703f4eb,
    $5f07ce956337ba8b$export$501166b25f254aab,
    $5f07ce956337ba8b$export$be1c522400a1bd7c,
    $5f07ce956337ba8b$export$2aa6e7b6e24a04f5,
    $5f07ce956337ba8b$export$f3b53199b07af2a1,
    $5f07ce956337ba8b$export$d37415ffddcf2142,
    $5f07ce956337ba8b$export$2ae00586da7cb606,
    $5f07ce956337ba8b$export$9c89f946f05d884a,
    $5f07ce956337ba8b$export$20bc3dc137ac1c38,
    $5f07ce956337ba8b$export$b52a7c936684cfc5,
    $5f07ce956337ba8b$export$b5555f24061f9fb,
    $5f07ce956337ba8b$export$ff25449f34b8abf,
    $5f07ce956337ba8b$export$3380e677209260fe,
    $5f07ce956337ba8b$export$b86266e6594a97bb,
    $5f07ce956337ba8b$export$3e2776d61f3662dc,
    $5f07ce956337ba8b$export$2b5f951ad8e70cfe,
    $5f07ce956337ba8b$export$9048315f2c03fd9d,
    $5f07ce956337ba8b$export$4145c2cec2da6f9b,
    $5f07ce956337ba8b$export$4957a1ad203cf6dd,
    $5f07ce956337ba8b$export$7a2fcaad1564e6b7,
    $5f07ce956337ba8b$export$190b5dd0a1322552,
    $5f07ce956337ba8b$export$da23b72d32bfad9e,
    $5f07ce956337ba8b$export$4b064659282e0238,
    $5f07ce956337ba8b$export$3ab51851f6d823e,
    $5f07ce956337ba8b$export$e4a1a37a9a1350ad,
    $5f07ce956337ba8b$export$b7f7da5e795f0327,
    $5f07ce956337ba8b$export$80a401c1aa47a377,
    $5f07ce956337ba8b$export$934ac7a251b26dc7,
    $5f07ce956337ba8b$export$4634f6395df3ebbe,
    $5f07ce956337ba8b$export$768fb41107a1e8d7,
    $5f07ce956337ba8b$export$d797a81bace17184,
    $5f07ce956337ba8b$export$746102c94db9df1f,
    $5f07ce956337ba8b$export$5f1efd797d65e349,
    $5f07ce956337ba8b$export$cccc812ccafbf11f,
    $5f07ce956337ba8b$export$64822db87abd8a47,
    $5f07ce956337ba8b$export$64f764d8be495c82,
    $5f07ce956337ba8b$export$24eae23dc1c68bbd,
    $5f07ce956337ba8b$export$50fa92eba6f82feb,
    $5f07ce956337ba8b$export$4155d22fe3f14cd6,
    $5f07ce956337ba8b$export$76813cbead887191,
    $5f07ce956337ba8b$export$90aab2ff89daf770,
    $5f07ce956337ba8b$export$a2bc0cbad2e6e605,
    $5f07ce956337ba8b$export$f90872a1280728bb,
    $5f07ce956337ba8b$export$bce644e96518cbd2,
    $5f07ce956337ba8b$export$241aaebffac0a3e5,
    $5f07ce956337ba8b$export$f9dfc43b5b31c4b7,
    $5f07ce956337ba8b$export$79759e9e62fb9312,
    $5f07ce956337ba8b$export$992d1e0dce255d19,
    $5f07ce956337ba8b$export$d28c1b0e5b3e768,
    $5f07ce956337ba8b$export$ca714ee197bed4ec,
    $5f07ce956337ba8b$export$faae55ceea4b6073,
    $5f07ce956337ba8b$export$200bc24cd120667e,
    $5f07ce956337ba8b$export$a0d784a48b4e886c,
    $5f07ce956337ba8b$export$baf5bd09b4b33b8a,
    $5f07ce956337ba8b$export$4702007eedbca8ab,
    $5f07ce956337ba8b$export$aa9d2d635ea63898,
    $5f07ce956337ba8b$export$2ea449225c1f6cac,
    $5f07ce956337ba8b$export$deb8b557e735e26a,
    $5f07ce956337ba8b$export$d45754df44e4c309,
    $5f07ce956337ba8b$export$78b2913b550edbb,
    $5f07ce956337ba8b$export$71243272608c58ab,
    $5f07ce956337ba8b$export$39a08f215c33bc39,
    $5f07ce956337ba8b$export$d2377f6a6fa3b49c,
    $5f07ce956337ba8b$export$befa8f6533309779,
    $5f07ce956337ba8b$export$736b40db8701ba6c,
    // Tailored onboarding M3
    $5f07ce956337ba8b$export$11eff6ae2f70b67b,
    $5f07ce956337ba8b$export$fb2d23e5315a67a9,
    $5f07ce956337ba8b$export$32e794bb49d60b6,
    $5f07ce956337ba8b$export$fed256238b27db06,
    $5f07ce956337ba8b$export$132eecb4d35a590d,
    $5f07ce956337ba8b$export$2579c51cadd45eca,
    $5f07ce956337ba8b$export$4b1a0cefa966ea0,
    $5f07ce956337ba8b$export$f6558daacc312a65,
    $5f07ce956337ba8b$export$925efa2e24e86b88,
    $5f07ce956337ba8b$export$40454d3e062dcd44
];
const $5f07ce956337ba8b$export$5980f41aa657f9c7 = [
    'SAM1'
];

});

parcelRegister("cE2Qr", function(module, exports) {

$parcel$export(module.exports, "useJswOnboarding", () => $796be817ff5bbbfa$export$7d91c0af4772787a);
$parcel$export(module.exports, "useOpenTask", () => $796be817ff5bbbfa$export$594f006fa6a1b2e5);
$parcel$export(module.exports, "useNudgeStep", () => $796be817ff5bbbfa$export$c5e63e44ad178ae8);
$parcel$export(module.exports, "useQuickstartActions", () => $796be817ff5bbbfa$export$2c3cd14fff9d6e43);
$parcel$export(module.exports, "useShouldShowNudge", () => $796be817ff5bbbfa$export$b0db7e46e369e1d9);
$parcel$export(module.exports, "useInviteToProject", () => $796be817ff5bbbfa$export$71de79653346a1ea);
$parcel$export(module.exports, "useShowVideoCards", () => $796be817ff5bbbfa$export$61185a9266f1f57a);
$parcel$export(module.exports, "useProjectState", () => $796be817ff5bbbfa$export$ef4747ba36826d6a);
$parcel$export(module.exports, "useQuickstartUiStatus", () => $796be817ff5bbbfa$export$522993b46d9f8266);
$parcel$export(module.exports, "useIsLoaded", () => $796be817ff5bbbfa$export$aa4ba29241532382);
$parcel$export(module.exports, "useIsFocusedOn", () => $796be817ff5bbbfa$export$ed5c755b733bf2b1);
$parcel$export(module.exports, "useIsDismissed", () => $796be817ff5bbbfa$export$35fe0366802512dd);
$parcel$export(module.exports, "useCompletedTaskList", () => $796be817ff5bbbfa$export$a41ee0d3b6938099);
$parcel$export(module.exports, "useAllTasksCompleted", () => $796be817ff5bbbfa$export$4ae7b465b076be9);
$parcel$export(module.exports, "useMountedNudges", () => $796be817ff5bbbfa$export$bf6e646c0476acad);
$parcel$export(module.exports, "useHasEverSeen", () => $796be817ff5bbbfa$export$6b706bff94798d11);
$parcel$export(module.exports, "useRoadmapState", () => $796be817ff5bbbfa$export$c98db656edc5b3e1);
$parcel$export(module.exports, "useShouldShowScrumOnboardingExperience", () => $796be817ff5bbbfa$export$a823278ac9d1112b);
$parcel$export(module.exports, "useShouldShowOnboardingKanbanTour", () => $796be817ff5bbbfa$export$cb9e0e8fe4df8490);
$parcel$export(module.exports, "useHasNudgeActive", () => $796be817ff5bbbfa$export$521909e3dc7ab811);
$parcel$export(module.exports, "useSelectedProjectTemplateKeyFromOnboarding", () => $796be817ff5bbbfa$export$f4a2be940259bf95);
$parcel$export(module.exports, "QUICKSTART_UI_STATUS", () => (parcelRequire("8Bc5A")).QUICKSTART_UI_STATUS);

var $58GFP = parcelRequire("58GFP");

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
var $51nlc = parcelRequire("51nlc");

var $8Bc5A = parcelRequire("8Bc5A");

var $6RAg1 = parcelRequire("6RAg1");

var $ieqoN = parcelRequire("ieqoN");

var $cGE52 = parcelRequire("cGE52");

var $3B5jO = parcelRequire("3B5jO");

var $4ji4w = parcelRequire("4ji4w");

const $796be817ff5bbbfa$export$390f32400eaf98c9 = (0, $iXqE5.createStore)({
    name: 'jsw-onboarding-quickstart',
    initialState: $cGE52.initialState,
    actions: $6RAg1.actions
});
const $796be817ff5bbbfa$export$1cbc60d8dd921852 = (0, $51nlc.createSubscriber)($796be817ff5bbbfa$export$390f32400eaf98c9);
const $796be817ff5bbbfa$export$7d91c0af4772787a = (0, $3sQ5x.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9);
const $796be817ff5bbbfa$export$638bfcfce1254bb8 = (0, $gg7kZ.createContainer)($796be817ff5bbbfa$export$390f32400eaf98c9, {});
const $796be817ff5bbbfa$export$9d731f44f82af09f = (state, { itemNames: itemNames })=>{
    const commonConditionsToShowNudge = state.shouldRenderComponent && state.visibility[(0, $3B5jO.getQuickstartTypeSelector)(state)] === (0, $8Bc5A.QUICKSTART_UI_STATUS).OPEN && // @ts-expect-error - TS2345 - Argument of type 'string | null' is not assignable to parameter of type 'string'.
    itemNames.includes(state.openTask);
    return commonConditionsToShowNudge && state.hasNudgeActive;
};
const $796be817ff5bbbfa$export$ea14030920a5d8e6 = (state)=>state.openTask;
const $796be817ff5bbbfa$export$594f006fa6a1b2e5 = (0, $3sQ5x.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
    selector: $796be817ff5bbbfa$export$ea14030920a5d8e6
});
const $796be817ff5bbbfa$export$a943afa434e9487a = (state)=>state.nudgeStep;
const $796be817ff5bbbfa$export$c5e63e44ad178ae8 = (0, $3sQ5x.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
    selector: $796be817ff5bbbfa$export$a943afa434e9487a
});
const $796be817ff5bbbfa$export$2c3cd14fff9d6e43 = (0, $3sQ5x.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
    selector: null
});
const $796be817ff5bbbfa$export$b0db7e46e369e1d9 = (0, $3sQ5x.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
    selector: $796be817ff5bbbfa$export$9d731f44f82af09f
});
const $796be817ff5bbbfa$export$71de79653346a1ea = (0, $3sQ5x.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
    selector: (state)=>Boolean(state.projectState && state.projectState.canInvitePeopleToProject)
});
const $796be817ff5bbbfa$export$61185a9266f1f57a = (0, $3sQ5x.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
    selector: (state)=>{
        if (!state.projectState) return false;
        const { isNextGen: isNextGen, userRole: userRole, isProjectAdmin: isProjectAdmin } = state.projectState;
        return Boolean(isNextGen && (userRole === (0, $ieqoN.USER_ROLE).JIRA_ADMIN || userRole === (0, $ieqoN.USER_ROLE).SITE_ADMIN || isProjectAdmin));
    }
});
const $796be817ff5bbbfa$export$ef4747ba36826d6a = (0, $3sQ5x.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
    selector: (state)=>state.projectState
});
const $796be817ff5bbbfa$export$522993b46d9f8266 = (0, $3sQ5x.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
    selector: (state)=>{
        const quickstartType = (0, $3B5jO.getQuickstartTypeSelector)(state);
        if (state.shouldRenderComponent === false) return (0, $4ji4w.getLocalStorageItem)(`${quickstartType}.visibility`) ?? (0, $8Bc5A.QUICKSTART_UI_STATUS).NOT_LOADED;
        return state.visibility[quickstartType];
    }
});
const $796be817ff5bbbfa$export$aa4ba29241532382 = (0, $3sQ5x.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
    selector: (state)=>state.isQuickstartLoaded
});
const $796be817ff5bbbfa$export$ed5c755b733bf2b1 = (0, $3sQ5x.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
    selector: (state)=>state.isFocusedOn
});
const $796be817ff5bbbfa$export$35fe0366802512dd = (0, $3sQ5x.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
    selector: (state)=>{
        const visibility = state.visibility[(0, $3B5jO.getQuickstartTypeSelector)(state)];
        return visibility === (0, $8Bc5A.QUICKSTART_UI_STATUS).DISMISSED || visibility === (0, $8Bc5A.QUICKSTART_UI_STATUS).NOT_LOADED;
    }
});
const $796be817ff5bbbfa$export$a41ee0d3b6938099 = (0, $3sQ5x.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
    selector: (state)=>state.completedTaskList
});
const $796be817ff5bbbfa$export$4ae7b465b076be9 = (0, $3sQ5x.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
    selector: (state)=>{
        if (!state.tasks) return null;
        return state.tasks.items.every((task)=>state.completedTaskList.includes(task));
    }
});
const $796be817ff5bbbfa$export$bf6e646c0476acad = (0, $3sQ5x.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
    selector: (state)=>state.mountedNudges
});
const $796be817ff5bbbfa$export$6b706bff94798d11 = (0, $3sQ5x.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
    selector: (state)=>state.hasEverSeenRoute
});
const $796be817ff5bbbfa$export$c98db656edc5b3e1 = (0, $3sQ5x.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
    selector: (state)=>({
            roadmapIsCreateEnabled: state.roadmapIsCreateEnabled,
            roadmapIsListEmpty: state.roadmapIsListEmpty
        })
});
const $796be817ff5bbbfa$export$a823278ac9d1112b = (0, $3sQ5x.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
    selector: (state)=>Boolean(state.isQuickstartLoaded && state.selectedProjectTemplateKeyFromOnboarding === (0, $58GFP.SCRUM_TEAM_MANAGED_KEY) && state.projectState?.userRole === (0, $ieqoN.USER_ROLE).SITE_ADMIN)
});
const $796be817ff5bbbfa$export$cb9e0e8fe4df8490 = (0, $3sQ5x.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
    selector: (state)=>Boolean(state.isQuickstartLoaded && state.selectedProjectTemplateKeyFromOnboarding === (0, $58GFP.KANBAN_TEAM_MANAGED_KEY) && state.projectState?.userRole === (0, $ieqoN.USER_ROLE).SITE_ADMIN && // edge case - if e.g. welcome modal failed to load, and user completed task by themself, then the welcome modal should be skipped on subsequent page loads.
        !state.completedTaskList.includes((0, $8Bc5A.KANBAN_ONBOARDING_TASK)))
});
const $796be817ff5bbbfa$export$521909e3dc7ab811 = (0, $3sQ5x.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
    selector: (state)=>state.hasNudgeActive
});
const $796be817ff5bbbfa$export$f4a2be940259bf95 = (0, $3sQ5x.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
    selector: (state)=>state.selectedProjectTemplateKeyFromOnboarding
});

});
parcelRegister("58GFP", function(module, exports) {

$parcel$export(module.exports, "KANBAN_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$f40a08fc76eb112d);
$parcel$export(module.exports, "KANBAN_COMPANY_MANAGED_KEY", () => $c364c398187f9175$export$e3844688f2693533);
$parcel$export(module.exports, "SCRUM_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$e3cec071fcb2fbd3);
$parcel$export(module.exports, "SCRUM_COMPANY_MANAGED_KEY", () => $c364c398187f9175$export$21783d461e3ef6d);
$parcel$export(module.exports, "BUG_TRACKING_COMPANY_MANAGED_KEY", () => $c364c398187f9175$export$6cd1c1b2ba0f6e2d);
$parcel$export(module.exports, "CROSS_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$57d877f2e01e0029);
$parcel$export(module.exports, "CROSS_TEAM_PLANNING_COMPANY_MANAGED_KEY", () => $c364c398187f9175$export$6f4213a3addc3fdb);
$parcel$export(module.exports, "JWM_TEMPLATE_PREFIX", () => $c364c398187f9175$export$7492b6cc3ef89883);
$parcel$export(module.exports, "PROJECT_MANAGEMENT_COMPANY_MANAGED_KEY", () => $c364c398187f9175$export$7d9a4e0ef5194fe1);
$parcel$export(module.exports, "PROJECT_MANAGEMENT_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$477ca3550da12e43);
$parcel$export(module.exports, "BLANK_TEMPLATE_COMPANY_MANAGED_KEY", () => $c364c398187f9175$export$7c0307155b744916);
$parcel$export(module.exports, "BLANK_TEMPLATE_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$b5ab111fb8825075);
$parcel$export(module.exports, "CAMPAIGN_MANAGEMENT_COMPANY_MANAGED_KEY", () => $c364c398187f9175$export$14139f0ec41d437e);
$parcel$export(module.exports, "CAMPAIGN_MANAGEMENT_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$ebf7af45376deb8b);
$parcel$export(module.exports, "CONTENT_MANAGEMENT_COMPANY_MANAGED_KEY", () => $c364c398187f9175$export$7b6945581ccdab4a);
$parcel$export(module.exports, "CONTENT_MANAGEMENT_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$310a9ac5c28d65f6);
$parcel$export(module.exports, "TASK_TRACKING_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$136d17feb2f4285d);
$parcel$export(module.exports, "DOCUMENT_APPROVAL_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$e288f4758e94a8cc);
$parcel$export(module.exports, "PROCESS_CONTROL_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$4e9ac1417ba54bba);
$parcel$export(module.exports, "POLICY_MANAGEMENT_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$560c9f6765bf9af4);
$parcel$export(module.exports, "SALES_PIPELINE_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$14d4c6dbbb62a127);
$parcel$export(module.exports, "PROCUREMENT_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$1367ee12532c525f);
$parcel$export(module.exports, "WEB_DESIGN_PROCESS_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$278632cc7ed9a312);
$parcel$export(module.exports, "BUDGET_CREATION_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$594d0d4f5ecbf4c7);
$parcel$export(module.exports, "EMPLOYEE_ONBOARDING_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$dda85c7a8278e495);
$parcel$export(module.exports, "RECRUITMENT_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$b92c431651f9ee91);
$parcel$export(module.exports, "LEAD_TRACKING_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$d72d75d9d0e071fc);
$parcel$export(module.exports, "IP_INFRINGEMENT_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$753322ed1c32ff89);
$parcel$export(module.exports, "IT_SERVICE_MANAGEMENT_COMPANY_MANAGED_KEY", () => $c364c398187f9175$export$4d29ee0c00eb5df4);
$parcel$export(module.exports, "IT_SERVICE_MANAGEMENT_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$6278b41164dbde6c);
$parcel$export(module.exports, "IT_SERVICE_MANAGEMENT_BASIC_COMPANY_MANAGED_KEY", () => $c364c398187f9175$export$17a2f771efabf02f);
$parcel$export(module.exports, "IT_SERVICE_MANAGEMENT_OPERATIONS_TEMPLATE_KEY", () => $c364c398187f9175$export$df7d1440e0a80c03);
$parcel$export(module.exports, "JIRA_CUSTOMER_SERVICE_COMPANY_MANAGED_KEY", () => $c364c398187f9175$export$bd14946bcde77195);
$parcel$export(module.exports, "BLANK_SERVICE_MANAGEMENT_PROJECT_BUSINESS_TEMPLATE_KEY", () => $c364c398187f9175$export$e8df553a3f519284);
$parcel$export(module.exports, "BLANK_SERVICE_MANAGEMENT_PROJECT_IT_COMPANY_MANAGED_TEMPLATE_KEY", () => $c364c398187f9175$export$97fc32bd703bb4d1);
$parcel$export(module.exports, "BLANK_SERVICE_MANAGEMENT_PROJECT_IT_TEMPLATE_KEY", () => $c364c398187f9175$export$8eecdf6acea9494);
$parcel$export(module.exports, "BLANK_SERVICE_MANAGEMENT_PROJECT_BUSINESS_COMPANY_MANAGED_TEMPLATE_KEY", () => $c364c398187f9175$export$ff16be7794ed4222);
$parcel$export(module.exports, "BLANK_SERVICE_MANAGEMENT_PROJECT_COMPANY_MANAGED_KEY", () => $c364c398187f9175$export$9917830b560a2f4);
$parcel$export(module.exports, "GENERAL_SERVICE_PROJECT_COMPANY_MANAGED_KEY", () => $c364c398187f9175$export$b0928b02ffab3875);
$parcel$export(module.exports, "GENERAL_SERVICE_PROJECT_FOR_IT_COMPANY_MANAGED_KEY", () => $c364c398187f9175$export$fd75f6abc7861439);
$parcel$export(module.exports, "HR_SERVICE_PROJECT_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$2bc7db2da3df8313);
$parcel$export(module.exports, "INITIAL_PROJECT_TEMPLATE_PROJECT_PROPERTY_KEY", () => $c364c398187f9175$export$87a8fff98b5bc81);
$parcel$export(module.exports, "PRODUCT_DISCOVERY_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$7c567eb725bd36f);
$parcel$export(module.exports, "getIsJsmBlankProjectTemplate", () => $c364c398187f9175$export$73fd025e86012868);
$parcel$export(module.exports, "getGeneralITOrBusinessProjectTemplateMap", () => $c364c398187f9175$export$a062badd78c9993);
// Project template type keys are used to create projects.
// TODO: KURO-1818 consolidate keys from `project-template-keys` in this file.
// Software template keys
const $c364c398187f9175$export$f40a08fc76eb112d = 'com.pyxis.greenhopper.jira:gh-simplified-agility-kanban';
const $c364c398187f9175$export$e3844688f2693533 = 'com.pyxis.greenhopper.jira:gh-simplified-kanban-classic';
const $c364c398187f9175$export$e3cec071fcb2fbd3 = 'com.pyxis.greenhopper.jira:gh-simplified-agility-scrum';
const $c364c398187f9175$export$21783d461e3ef6d = 'com.pyxis.greenhopper.jira:gh-simplified-scrum-classic';
const $c364c398187f9175$export$6cd1c1b2ba0f6e2d = 'com.pyxis.greenhopper.jira:gh-simplified-basic';
const $c364c398187f9175$export$57d877f2e01e0029 = 'com.pyxis.greenhopper.jira:gh-cross-team-template';
const $c364c398187f9175$export$6f4213a3addc3fdb = 'com.pyxis.greenhopper.jira:gh-cross-team-planning-template';
const $c364c398187f9175$export$7492b6cc3ef89883 = 'com.atlassian.jira-core-project-templates';
const $c364c398187f9175$export$7d9a4e0ef5194fe1 = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-core-simplified-project-management`;
const $c364c398187f9175$export$477ca3550da12e43 = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-project-management-team-managed`;
const $c364c398187f9175$export$7c0307155b744916 = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-blank-project`;
const $c364c398187f9175$export$b5ab111fb8825075 = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-blank-project-team-managed`;
const $c364c398187f9175$export$14139f0ec41d437e = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-campaign-management`;
const $c364c398187f9175$export$ebf7af45376deb8b = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-campaign-management-team-managed`;
const $c364c398187f9175$export$7b6945581ccdab4a = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-core-simplified-content-management`;
const $c364c398187f9175$export$310a9ac5c28d65f6 = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-content-management-team-managed`;
const $c364c398187f9175$export$136d17feb2f4285d = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-task-tracking-team-managed`;
const $c364c398187f9175$export$e288f4758e94a8cc = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-document-approval-team-managed`;
const $c364c398187f9175$export$4e9ac1417ba54bba = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-process-control-team-managed`;
const $c364c398187f9175$export$560c9f6765bf9af4 = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-policy-management-team-managed`;
const $c364c398187f9175$export$14d4c6dbbb62a127 = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-sales-pipeline-team-managed`;
const $c364c398187f9175$export$1367ee12532c525f = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-procurement-team-managed`;
const $c364c398187f9175$export$278632cc7ed9a312 = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-web-design-process-team-managed`;
const $c364c398187f9175$export$594d0d4f5ecbf4c7 = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-budget-creation-team-managed`;
const $c364c398187f9175$export$dda85c7a8278e495 = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-employee-onboarding-team-managed`;
const $c364c398187f9175$export$b92c431651f9ee91 = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-recruitment-team-managed`;
const $c364c398187f9175$export$d72d75d9d0e071fc = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-lead-tracking-team-managed`;
const $c364c398187f9175$export$753322ed1c32ff89 = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-ip-infringement-team-managed`;
const $c364c398187f9175$export$4d29ee0c00eb5df4 = 'com.atlassian.servicedesk:simplified-it-service-management';
const $c364c398187f9175$export$6278b41164dbde6c = 'com.atlassian.servicedesk:next-gen-it-service-desk';
const $c364c398187f9175$export$17a2f771efabf02f = 'com.atlassian.servicedesk:simplified-it-service-management-basic';
const $c364c398187f9175$export$df7d1440e0a80c03 = 'com.atlassian.servicedesk:simplified-it-service-management-operations';
const $c364c398187f9175$export$bd14946bcde77195 = 'com.atlassian.jcs:customer-service-management';
const $c364c398187f9175$export$e8df553a3f519284 = 'jsm.blank-project-business-cmp-only';
const $c364c398187f9175$export$97fc32bd703bb4d1 = 'com.atlassian.servicedesk:simplified-blank-project-it';
const $c364c398187f9175$export$8eecdf6acea9494 = 'jsm.blank-project-it-cmp-only';
const $c364c398187f9175$export$ff16be7794ed4222 = 'com.atlassian.servicedesk:simplified-blank-project-business';
const $c364c398187f9175$export$9e38ad41d19608ee = 'jsm.blank-service-management';
const $c364c398187f9175$export$9917830b560a2f4 = 'com.atlassian.servicedesk:company-managed-blank-service-project';
const $c364c398187f9175$export$b95641716115e7f9 = 'com.atlassian.servicedesk:team-managed-blank-service-project';
const $c364c398187f9175$export$e87297d5e9fa3d43 = 'com.atlassian.servicedesk:simplified-legal-service-desk';
const $c364c398187f9175$export$3f1f11fb5d08da21 = 'com.atlassian.servicedesk:next-gen-legal-service-desk';
const $c364c398187f9175$export$2b90912656e0b76b = 'com.atlassian.servicedesk:simplified-general-service-desk';
const $c364c398187f9175$export$e8fdad132bc6d342 = 'com.atlassian.servicedesk:next-gen-general-service-desk';
const $c364c398187f9175$export$b0928b02ffab3875 = 'com.atlassian.servicedesk:company-managed-general-service-project';
const $c364c398187f9175$export$50478ee5ecbf7a4d = 'com.atlassian.servicedesk:team-managed-general-service-project';
const $c364c398187f9175$export$fd75f6abc7861439 = 'com.atlassian.servicedesk:simplified-general-service-desk-it';
const $c364c398187f9175$export$fb658bddae7f81bb = 'com.atlassian.servicedesk:next-gen-general-it-service-desk';
const $c364c398187f9175$export$e82092c4fb277f9b = 'com.atlassian.servicedesk:simplified-general-service-desk-business';
const $c364c398187f9175$export$5eddf3b31dd1858f = 'com.atlassian.servicedesk:next-gen-general-business-service-desk';
const $c364c398187f9175$export$bc3e0c6bccecee38 = 'com.atlassian.servicedesk:simplified-external-service-desk';
const $c364c398187f9175$export$feb6dd6f9d18a640 = 'com.atlassian.servicedesk:next-gen-external-service-desk';
const $c364c398187f9175$export$f3c5f5a180797f04 = 'com.atlassian.servicedesk:simplified-hr-service-desk';
const $c364c398187f9175$export$2bc7db2da3df8313 = 'com.atlassian.servicedesk:next-gen-hr-service-desk';
const $c364c398187f9175$export$a1a1f02e9f561918 = 'com.atlassian.servicedesk:simplified-facilities-service-desk';
const $c364c398187f9175$export$17a955064ab71480 = 'com.atlassian.servicedesk:next-gen-facilities-service-desk';
const $c364c398187f9175$export$d66326f3f6b558b = 'com.atlassian.servicedesk:simplified-analytics-service-desk';
const $c364c398187f9175$export$6c5416b0177f2ef3 = 'com.atlassian.servicedesk:next-gen-analytics-service-desk';
const $c364c398187f9175$export$ea36fb35725fc554 = 'com.atlassian.servicedesk:simplified-finance-service-desk';
const $c364c398187f9175$export$e7038c17e9311de9 = 'com.atlassian.servicedesk:next-gen-finance-service-desk';
const $c364c398187f9175$export$38d7bc62a093e5a3 = 'com.atlassian.servicedesk:simplified-marketing-service-desk';
const $c364c398187f9175$export$fa06d276537993ce = 'com.atlassian.servicedesk:next-gen-marketing-service-desk';
const $c364c398187f9175$export$9801b8ec713d3079 = 'com.atlassian.servicedesk:simplified-sales-service-desk';
const $c364c398187f9175$export$a9f0e6470e3b6147 = 'com.atlassian.servicedesk:next-gen-sales-service-desk';
const $c364c398187f9175$export$aeedd4330ac1268c = 'com.atlassian.servicedesk:simplified-design-service-desk';
const $c364c398187f9175$export$c0e4ffe74102f756 = 'com.atlassian.servicedesk:next-gen-design-service-desk';
const $c364c398187f9175$export$87a8fff98b5bc81 = 'initial.project.template.name';
const $c364c398187f9175$export$7c567eb725bd36f = 'jira.polaris:discovery';
const $c364c398187f9175$export$b0eec2c6558182ca = 'jira.polaris:blank-project';
const $c364c398187f9175$export$f9776303073903dd = 'jira.polaris:roadmap';
const $c364c398187f9175$export$b7c4ca557ac2074e = 'jira.polaris:prioritization';
const $c364c398187f9175$export$789332a2d3504754 = 'jira.polaris:portfolio';
const $c364c398187f9175$export$73fd025e86012868 = (T4JTemplateKey)=>T4JTemplateKey === $c364c398187f9175$export$e8df553a3f519284 || T4JTemplateKey === $c364c398187f9175$export$8eecdf6acea9494 || T4JTemplateKey === $c364c398187f9175$export$9e38ad41d19608ee;
const $c364c398187f9175$export$a062badd78c9993 = {
    [$c364c398187f9175$export$e82092c4fb277f9b]: $c364c398187f9175$export$b0928b02ffab3875,
    [$c364c398187f9175$export$fd75f6abc7861439]: $c364c398187f9175$export$b0928b02ffab3875,
    [$c364c398187f9175$export$5eddf3b31dd1858f]: $c364c398187f9175$export$50478ee5ecbf7a4d,
    [$c364c398187f9175$export$fb658bddae7f81bb]: $c364c398187f9175$export$50478ee5ecbf7a4d
};

});

parcelRegister("6RAg1", function(module, exports) {

$parcel$export(module.exports, "actions", () => $4752306278e43a2d$export$e324594224ef24da);

var $6fSBR = parcelRequire("6fSBR");

var $j6wxT = parcelRequire("j6wxT");

var $7mZ3t = parcelRequire("7mZ3t");

var $8UXiA = parcelRequire("8UXiA");

var $3iEb4 = parcelRequire("3iEb4");

var $7yDu9 = parcelRequire("7yDu9");

var $5UBG2 = parcelRequire("5UBG2");

var $lHcRB = parcelRequire("lHcRB");

var $eiyXc = parcelRequire("eiyXc");

var $jZvbN = parcelRequire("jZvbN");

var $azcAL = parcelRequire("azcAL");

var $gbXQ5 = parcelRequire("gbXQ5");

var $iZuFy = parcelRequire("iZuFy");

var $70Fss = parcelRequire("70Fss");

var $erLQY = parcelRequire("erLQY");

var $dQPsy = parcelRequire("dQPsy");

var $abQXL = parcelRequire("abQXL");

var $4VXxO = parcelRequire("4VXxO");

var $cUGWT = parcelRequire("cUGWT");

var $boV1S = parcelRequire("boV1S");

var $4Viq4 = parcelRequire("4Viq4");

var $jIoq4 = parcelRequire("jIoq4");

var $75A1x = parcelRequire("75A1x");

var $1Xkin = parcelRequire("1Xkin");
const $4752306278e43a2d$export$e324594224ef24da = {
    changeTaskGroupParent: $6fSBR.nextChangeTaskGroupParent,
    goBackToPreviousTaskGroup: $6fSBR.nextGoBackToPreviousTaskGroup,
    setIsOpen: $j6wxT.setIsOpen,
    refreshAppState: $7mZ3t.refreshAppState,
    setNudgeStep: $8UXiA.setNudgeStep,
    addMountedNudge: $3iEb4.addMountedNudge,
    removeMountedNudge: $3iEb4.removeMountedNudge,
    setShouldRenderComponent: $7yDu9.setShouldRenderComponent,
    setProjectState: $5UBG2.setProjectState,
    setHasNudgeActive: $lHcRB.setHasNudgeActive,
    forceHideNudge: $eiyXc.forceHideNudge,
    setHasEverSeenRoute: $jZvbN.setHasEverSeenRoute,
    setRoadmapIsCreateEnabled: $azcAL.setRoadmapIsCreateEnabled,
    setRoadmapIsListEmpty: $azcAL.setRoadmapIsListEmpty,
    openNextTask: $gbXQ5.openNextTask,
    resetIsQuickstartLoaded: $iZuFy.resetIsQuickstartLoaded,
    refreshAppStateUiStatusOnly: $70Fss.refreshAppStateUiStatusOnly,
    nextMarkAsCompletedTask: $erLQY.nextMarkAsCompletedTask,
    nextSetChecklistItemSeen: $dQPsy.nextSetChecklistItemSeen,
    nextSetChecklistIsDismissed: $abQXL.nextSetChecklistIsDismissed,
    nextSetChecklistIsOpen: $4VXxO.nextSetChecklistIsOpen,
    nextOpenTask: $cUGWT.nextOpenTask,
    nextAutoExpand: $boV1S.nextAutoExpand,
    nextShouldShowNudgeAfterNavigation: $4Viq4.nextShouldShowNudgeAfterNavigation,
    nextGetTasks: $jIoq4.nextGetTasks,
    syncVisibilityWithLocal: $75A1x.syncVisibilityWithLocal,
    universalDispatch: $1Xkin.universalDispatch
};

});
parcelRegister("6fSBR", function(module, exports) {

$parcel$export(module.exports, "nextChangeTaskGroupParent", () => $0f1566e1d3fc2987$export$76708cce5888039a);
$parcel$export(module.exports, "nextGoBackToPreviousTaskGroup", () => $0f1566e1d3fc2987$export$57534cbc400a434c);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $4R6GH = parcelRequire("4R6GH");

var $8Bc5A = parcelRequire("8Bc5A");

var $1ftPQ = parcelRequire("1ftPQ");
const $0f1566e1d3fc2987$var$setTaskGroup = (taskGroup, openTask)=>({ setState: setState })=>{
        setState({
            ...taskGroup,
            openTask: openTask || ''
        });
        (0, $1ftPQ.pushToBackend)({
            key: (0, $8Bc5A.KEY_TASK_GROUP),
            value: {
                taskGroup: taskGroup
            }
        });
    };
const $0f1566e1d3fc2987$export$76708cce5888039a = (newCurrentTaskGroupParent)=>({ getState: getState, dispatch: dispatch })=>{
        const { previousTaskGroupParents: previousTaskGroupParents, currentTaskGroupParent: currentTaskGroupParent } = getState();
        if (previousTaskGroupParents.includes(newCurrentTaskGroupParent)) // prevent infinite loop nesting
        return;
        previousTaskGroupParents.push(currentTaskGroupParent);
        const taskGroup = {
            previousTaskGroupParents: previousTaskGroupParents,
            currentTaskGroupParent: newCurrentTaskGroupParent
        };
        dispatch($0f1566e1d3fc2987$var$setTaskGroup(taskGroup));
    };
const $0f1566e1d3fc2987$export$57534cbc400a434c = ()=>({ dispatch: dispatch, getState: getState })=>{
        if ((0, $4R6GH.fg)('jira_a11y_fix_returning_focus')) {
            const { previousTaskGroupParents: previousTaskGroupParents, currentTriggerForTaskGroupParent: currentTriggerForTaskGroupParent } = getState();
            const lastIndexOfPreviousTaskGroupParents = previousTaskGroupParents.length - 1;
            const newTaskGroupParent = previousTaskGroupParents.length === 0 ? (0, $8Bc5A.ROOT_TASK) : previousTaskGroupParents[lastIndexOfPreviousTaskGroupParents];
            const newPreviousTaskGroupParents = previousTaskGroupParents.slice(0, lastIndexOfPreviousTaskGroupParents);
            const taskGroup = {
                previousTaskGroupParents: newPreviousTaskGroupParents,
                currentTaskGroupParent: newTaskGroupParent
            };
            dispatch($0f1566e1d3fc2987$var$setTaskGroup(taskGroup, currentTriggerForTaskGroupParent));
        } else {
            const { previousTaskGroupParents: previousTaskGroupParents } = getState();
            const newTaskGroupParent = previousTaskGroupParents.length === 0 ? (0, $8Bc5A.ROOT_TASK) : previousTaskGroupParents.pop();
            const taskGroup = {
                previousTaskGroupParents: previousTaskGroupParents,
                currentTaskGroupParent: newTaskGroupParent
            };
            // @ts-expect-error - TS2345 - Argument of type '{ previousTaskGroupParents: string[]; currentTaskGroupParent: string | undefined; }' is not assignable to parameter of type 'TaskGroup'.
            dispatch($0f1566e1d3fc2987$var$setTaskGroup(taskGroup));
        }
    };

});
parcelRegister("1ftPQ", function(module, exports) {

$parcel$export(module.exports, "pushToBackend", () => $d3dd40bf54ad27bf$export$583b2d2422a6757f);

var $89SaW = parcelRequire("89SaW");

var $4Pf62 = parcelRequire("4Pf62");

var $jcw0u = parcelRequire("jcw0u");

var $jJZqs = parcelRequire("jJZqs");
const $d3dd40bf54ad27bf$var$getAccountId = ()=>{
    const { atlassianAccountId: atlassianAccountId } = (0, $4Pf62.getTenantContext_DEPRECATED_DO_NOT_USE)();
    if (atlassianAccountId === null) throw new Error('Atlassian Account Id is empty');
    return atlassianAccountId;
};
const $d3dd40bf54ad27bf$var$setRemoteUserProperties = async ({ key: key, value: value })=>(0, $89SaW.setUserProperties)($d3dd40bf54ad27bf$var$getAccountId(), key, JSON.stringify(value)).then((response)=>{
        if (!response.ok) throw new (0, $jJZqs.default)(response.status, response.statusText);
    });
const $d3dd40bf54ad27bf$var$trySetUserProperties = async (props, attemptCount)=>{
    try {
        await $d3dd40bf54ad27bf$var$setRemoteUserProperties(props);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.default)({
            meta: {
                id: 'pushToBackend',
                packageName: 'jiraOnboardingQuickstartCore',
                teamName: 'jlove-makkuro'
            },
            attributes: {
                action: 'pushToBackend',
                actionSubject: 'jiraOnboardingChecklistCore',
                attemptCount: attemptCount,
                key: props.key,
                reason: error && error.message
            },
            error: error
        });
        return false;
    }
    return true;
};
const $d3dd40bf54ad27bf$export$583b2d2422a6757f = async (props)=>{
    const success = await $d3dd40bf54ad27bf$var$trySetUserProperties(props, 1);
    if (!success) // On failure retry - if retry fails data is lost.
    await $d3dd40bf54ad27bf$var$trySetUserProperties(props, 2);
};

});


parcelRegister("j6wxT", function(module, exports) {

$parcel$export(module.exports, "setIsOpen", () => $eefde484654068e9$export$dcf23146e0a40195);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $8Bc5A = parcelRequire("8Bc5A");

var $1ftPQ = parcelRequire("1ftPQ");

var $3B5jO = parcelRequire("3B5jO");
const $eefde484654068e9$export$dcf23146e0a40195 = (isOpen)=>({ getState: getState, setState: setState })=>{
        const state = getState();
        const quickstartType = (0, $3B5jO.getQuickstartTypeSelector)(state);
        const currentIsOpen = state.visibility[quickstartType] === (0, $8Bc5A.QUICKSTART_UI_STATUS).OPEN;
        if (isOpen === currentIsOpen) // if state has not been updated we just return
        return;
        const quickstartStatus = isOpen ? (0, $8Bc5A.QUICKSTART_UI_STATUS).OPEN : (0, $8Bc5A.QUICKSTART_UI_STATUS).MINIMIZED;
        setState({
            visibility: {
                ...state.visibility,
                [quickstartType]: quickstartStatus
            }
        });
        (0, $1ftPQ.pushToBackend)({
            key: (0, $8Bc5A.getBackendVisibilityKey)(quickstartType),
            value: quickstartStatus
        });
        // Delete code below when cleaning up isOpen in state
        (0, $1ftPQ.pushToBackend)({
            key: (0, $8Bc5A.KEY_OPEN),
            value: isOpen
        });
    };
var $eefde484654068e9$export$2e2bcd8739ae039 = $eefde484654068e9$export$dcf23146e0a40195;

});
parcelRegister("3B5jO", function(module, exports) {

$parcel$export(module.exports, "getQuickstartTypeSelector", () => $47424244d57f6abc$export$eae834ce0286017a);

var $2vSU6 = parcelRequire("2vSU6");

var $8Bc5A = parcelRequire("8Bc5A");
const $47424244d57f6abc$export$6f17f2cb816105eb = (state)=>state.projectState?.projectType === (0, $2vSU6.SERVICE_DESK_PROJECT);
const $47424244d57f6abc$export$eae834ce0286017a = (state)=>{
    if ($47424244d57f6abc$export$6f17f2cb816105eb(state)) return (0, $8Bc5A.QUICKSTART_TYPE).JSM_BUSINESS_QUICKSTART_KEY;
    return (0, $8Bc5A.QUICKSTART_TYPE).OLD_GLOBAL_QUICKSTART_KEY;
};

});


parcelRegister("7mZ3t", function(module, exports) {

$parcel$export(module.exports, "refreshAppState", () => $ecf6e94ad9c4f8d6$export$797c35e2e1d0d014);


var $8fqy8 = parcelRequire("8fqy8");

var $8zOmE = parcelRequire("8zOmE");

var $bfWlw = parcelRequire("bfWlw");

var $ldyPw = parcelRequire("ldyPw");

var $8Bc5A = parcelRequire("8Bc5A");

var $6yhDy = parcelRequire("6yhDy");

var $1ftPQ = parcelRequire("1ftPQ");

var $52Vcw = parcelRequire("52Vcw");

var $ljzlb = parcelRequire("ljzlb");

var $6ypzr = parcelRequire("6ypzr");

var $4ji4w = parcelRequire("4ji4w");

var $abQXL = parcelRequire("abQXL");

var $4VXxO = parcelRequire("4VXxO");

var $erLQY = parcelRequire("erLQY");

var $6fSBR = parcelRequire("6fSBR");
const $ecf6e94ad9c4f8d6$var$allTasks = [
    ...(0, $8Bc5A.allTasksExcludingJSMBusinessTasks),
    ...(0, $8Bc5A.JSM_BUSINESS_TASKS)
];
const $ecf6e94ad9c4f8d6$export$797c35e2e1d0d014 = ({ atlassianAccountId: atlassianAccountId, cloudId: cloudId, appEditions: appEditions, isAdmin: isAdmin, canEditPlans: canEditPlans, isAdvancedRoadmapsTrial: isAdvancedRoadmapsTrial, isTargetedForReverseTrials: isTargetedForReverseTrials, createAnalyticsEvent: createAnalyticsEvent, projectType: projectType })=>async ({ getState: getState, setState: setState, dispatch: dispatch })=>{
        // Need to check to see if there is anything in the backend to take that as source of truth
        // If there is nothing then use defaults
        // Check backend for flags that are marked as completed (true)
        // Carry over state from previous actions
        // Create Completed Actions
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const updatedState = {};
        const hasSeenTasks = [
            (0, $8Bc5A.convertToHaveSeenItTask)((0, $8Bc5A.PREMIUM_EDITION_OVERVIEW_TASK)),
            (0, $8Bc5A.convertToHaveSeenItTask)((0, $8Bc5A.PREMIUM_EDITION_OVERVIEW_TASK_NON_ADMIN)),
            (0, $8Bc5A.convertToHaveSeenItTask)((0, $8Bc5A.STANDARD_EDITION_OVERVIEW_TASK))
        ];
        const { projectState: projectState = null } = getState();
        // Open QS Checklist as default state if state cannot be determined from the backend
        updatedState.isOpen = true;
        updatedState.isDismissed = false;
        updatedState.quickstartStateProjectType = projectType;
        let backendVisibilityKeys = [];
        let jsmTaskProjectKeys = [];
        // Open QS Checklist as default state if state cannot be determined from the backend
        updatedState.visibility = Object.values((0, $8Bc5A.QUICKSTART_TYPE)).reduce((acc, type)=>{
            acc[type] = (0, $8Bc5A.QUICKSTART_UI_STATUS).OPEN;
            return acc;
        }, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        {});
        backendVisibilityKeys = Object.values((0, $8Bc5A.QUICKSTART_TYPE)).map((type)=>(0, $8Bc5A.getBackendVisibilityKey)(type));
        if (projectState?.projectId) jsmTaskProjectKeys = (0, $8Bc5A.JSM_BUSINESS_TASKS).map((task)=>`${task}.${projectState?.projectId}`);
        const backendState = await (0, $6yhDy.pollBackend)({
            keys: [
                (0, $8Bc5A.KEY_OPEN),
                (0, $8Bc5A.KEY_DISMISSED),
                (0, $8Bc5A.KEY_OPEN_TASK),
                (0, $8Bc5A.KEY_TASK_GROUP),
                (0, $8Bc5A.KEY_HAS_EVER_SEEN_ROUTE),
                (0, $8Bc5A.KEY_JSW_ONBOARDING),
                (0, $8Bc5A.KEY_PREMIUM_TRIAL_REOPENED),
                ...$ecf6e94ad9c4f8d6$var$allTasks,
                ...hasSeenTasks,
                ...backendVisibilityKeys,
                ...jsmTaskProjectKeys
            ]
        });
        const backendStateExists = backendState !== undefined && Object.keys(backendState).length > 0;
        if (backendStateExists) {
            updatedState.completedTaskList = Object.keys(backendState).filter((key)=>[
                    ...(0, $8Bc5A.allTasksExcludingJSMBusinessTasks),
                    ...jsmTaskProjectKeys
                ].includes(key) && backendState[key] === true);
            updatedState.hasSeenTasks = hasSeenTasks.filter((key)=>backendState[key] === true);
            Object.values((0, $8Bc5A.QUICKSTART_TYPE)).forEach((type)=>{
                // use new state if possible
                if ((0, $8Bc5A.getBackendVisibilityKey)(type) in backendState) updatedState.visibility[type] = backendState[(0, $8Bc5A.getBackendVisibilityKey)(type)];
                else if ((0, $8Bc5A.KEY_DISMISSED) in backendState && backendState[0, $8Bc5A.KEY_DISMISSED]) updatedState.visibility[type] = (0, $8Bc5A.QUICKSTART_UI_STATUS).DISMISSED;
                else if ((0, $8Bc5A.KEY_OPEN) in backendState) updatedState.visibility[type] = backendState[0, $8Bc5A.KEY_OPEN] ? (0, $8Bc5A.QUICKSTART_UI_STATUS).OPEN : (0, $8Bc5A.QUICKSTART_UI_STATUS).MINIMIZED;
                (0, $4ji4w.setLocalStorageItem)(`${type}.visibility`, updatedState.visibility[type]);
            });
            // Delete when cleaning up isDismissed in state
            if ((0, $8Bc5A.KEY_DISMISSED) in backendState) updatedState.isDismissed = backendState[0, $8Bc5A.KEY_DISMISSED];
            // Delete when cleaning up isOpen in state
            if ((0, $8Bc5A.KEY_OPEN) in backendState) updatedState.isOpen = backendState[0, $8Bc5A.KEY_OPEN];
            if ((0, $8Bc5A.KEY_OPEN_TASK) in backendState) updatedState.openTask = backendState[0, $8Bc5A.KEY_OPEN_TASK];
            if ((0, $8Bc5A.KEY_HAS_EVER_SEEN_ROUTE) in backendState) updatedState.hasEverSeenRoute = backendState[0, $8Bc5A.KEY_HAS_EVER_SEEN_ROUTE];
            if ((0, $8Bc5A.KEY_TASK_GROUP) in backendState) {
                updatedState.currentTaskGroupParent = // @ts-expect-error - TS2571 - Object is of type 'unknown'.
                backendState[0, $8Bc5A.KEY_TASK_GROUP].taskGroup.currentTaskGroupParent;
                updatedState.previousTaskGroupParents = // @ts-expect-error - TS2571 - Object is of type 'unknown'.
                backendState[0, $8Bc5A.KEY_TASK_GROUP].taskGroup.previousTaskGroupParents;
            }
            if ((0, $8Bc5A.KEY_JSW_ONBOARDING) in backendState) {
                if (typeof backendState[0, $8Bc5A.KEY_JSW_ONBOARDING] === 'object' && backendState[0, $8Bc5A.KEY_JSW_ONBOARDING] !== null && (0, $6784cbc7d62e5d7c$export$8a00ecf6498ee2fe) in backendState[0, $8Bc5A.KEY_JSW_ONBOARDING]) updatedState.selectedProjectTemplateKeyFromOnboarding = backendState[0, $8Bc5A.KEY_JSW_ONBOARDING][0, $6784cbc7d62e5d7c$export$8a00ecf6498ee2fe];
            }
        }
        // Important that this call is before the dismiss migration logic and the premium card permission migration, otherwise it would
        // override the dismiss and currentTaskGroupParent
        setState(updatedState);
        // Bit of a migration
        // Handles case where non-admin premium users have a premium card child open which they can no longer access as we added more permission checks
        // Or, if a user was on a premium trial and saw premium content but is now free,
        // We take them to the root instead
        if ((updatedState.currentTaskGroupParent === (0, $8Bc5A.PREMIUM_EDITION_OVERVIEW_TASK_NON_ADMIN) || updatedState.currentTaskGroupParent === (0, $8Bc5A.PREMIUM_REVERSE_TRIAL_TASK)) && !canEditPlans || (updatedState.currentTaskGroupParent === (0, $8Bc5A.PREMIUM_EDITION_OVERVIEW_TASK) || updatedState.currentTaskGroupParent === (0, $8Bc5A.PREMIUM_EDITION_OVERVIEW_TASK_NON_ADMIN) || updatedState.currentTaskGroupParent === (0, $8Bc5A.PREMIUM_REVERSE_TRIAL_TASK)) && appEditions.software !== (0, $ldyPw.PREMIUM_EDITION)) {
            dispatch((0, $6fSBR.nextGoBackToPreviousTaskGroup)());
            const analyticsEvent = createAnalyticsEvent({});
            (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'refreshAppState premiumCardPermissionsRevoked');
        }
        if (!(backendStateExists && (0, $8Bc5A.KEY_OPEN) in backendState)) try {
            const skipApplicationProperty = await (0, $6ypzr.getOnboardingSkipApplicationProperty)();
            if (skipApplicationProperty.quickstart) dispatch((0, $abQXL.nextSetChecklistIsDismissed)(true));
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $52Vcw.fireAPIErrorAnalytics)(error, 'skipOnboarding');
        }
        const jswTrackDeferSitenameSiteTrait = await (0, $8fqy8.getJswTrackDeferSitenameSiteTrait)(cloudId, {
            packageName: (0, $8Bc5A.PACKAGE_NAME),
            teamName: (0, $8Bc5A.PACKAGE_TEAM_NAME)
        });
        setState({
            isEligibleToUpdateSitename: jswTrackDeferSitenameSiteTrait?.value === 'experiment-generated-site-name'
        });
        const setPremiumCardAudienceTrait = async (accountId)=>{
            if (accountId === null) return;
            const trait = await (0, $ljzlb.getCrossProjectBoardTrait)(createAnalyticsEvent, cloudId, accountId);
            setState({
                isCrossProjectBoardToPlanUpsell: trait?.value === true || false
            });
        };
        // We only want to check if a non-admin user has the CPB trait if they are in a
        // premium evaluation of jira software (i.e. they have access to Advanced Roadmaps)
        if (appEditions.software === (0, $ldyPw.PREMIUM_EDITION) && !isAdmin) await setPremiumCardAudienceTrait(atlassianAccountId);
        const { isCrossProjectBoardToPlanUpsell: isCrossProjectBoardToPlanUpsell } = getState();
        // If the user is on a JSW Premium instance, perform a fetch to check that they signed up with a Premium Reverse Trial.
        let isReverseTrialForJSW;
        if (isTargetedForReverseTrials) {
            const isOnboardingPremiumTrial = await (0, $bfWlw.getOnboardingPremiumTrial)();
            isReverseTrialForJSW = isOnboardingPremiumTrial?.premiumTrialOnSignup;
        }
        /**
		 * Re-open QS for:
		 *  - admins on an AdvancedRoadmaps trial who haven't had it re-opened for them yet
		 *  - non-admins on an AdvancedRoadmaps trial with isCrossProjectBoardToPlanUpsell trait
		 */ if (!isReverseTrialForJSW && appEditions.software === (0, $ldyPw.PREMIUM_EDITION) && isAdvancedRoadmapsTrial && (isAdmin || isCrossProjectBoardToPlanUpsell) && atlassianAccountId != null && !backendState[0, $8Bc5A.KEY_PREMIUM_TRIAL_REOPENED]) {
            // Re-open QS if not already opened
            dispatch((0, $4VXxO.nextSetChecklistIsOpen)(true));
            dispatch((0, $abQXL.nextSetChecklistIsDismissed)(false));
            const taskToDispatch = isAdmin ? (0, $8Bc5A.PREMIUM_EDITION_OVERVIEW_TASK) : (0, $8Bc5A.PREMIUM_EDITION_OVERVIEW_TASK_NON_ADMIN);
            // Go to advanced roadmaps task
            dispatch((0, $erLQY.nextMarkAsCompletedTask)(taskToDispatch));
            dispatch((0, $6fSBR.nextChangeTaskGroupParent)(taskToDispatch));
            await (0, $1ftPQ.pushToBackend)({
                key: (0, $8Bc5A.KEY_PREMIUM_TRIAL_REOPENED),
                value: true
            });
            const analyticsEvent = createAnalyticsEvent({});
            (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'advancedRoadmapsTask reopened', {
                isAdmin: isAdmin
            });
        }
        setState({
            canEditPlans: canEditPlans
        });
        setState({
            isQuickstartLoaded: true
        });
    };

});
// Session storage constants used between going through initial onboarding screens
// and landing in JIRA
// Note this key used to be 'should-show-scrum-modal' but was changed to prevent a bug where experienced users
// Could see the modal if they were previously enrolled into ISO
const $6784cbc7d62e5d7c$export$67abe0a3b8dfe03f = 'should-show-scrum-modal-v2';
const $6784cbc7d62e5d7c$export$4e1360a3e7785935 = 'should-show-kanban-modal';
const $6784cbc7d62e5d7c$export$e3884212029f7bef = 'should-show-welcome-modal';
const $6784cbc7d62e5d7c$export$c45d2ea50af63a85 = 'showed-welcome-modal-during-signup';
const $6784cbc7d62e5d7c$export$c9dc4cb209930823 = 'can-enroll-in-config-wizard-view';
const $6784cbc7d62e5d7c$export$891ca65264b256bb = 'should-show-personlized-sample-data-for-kanban';
const $6784cbc7d62e5d7c$export$f47dca9dda77d157 = 'should-hide-quickstart-for-personalized-sample-data';
const $6784cbc7d62e5d7c$export$16588d2012f3f89b = 'should-show-business-sample-data-nudge';
const $6784cbc7d62e5d7c$export$928ffae10e4c0006 = 'template-key-to-show-onboarding-modal';
const $6784cbc7d62e5d7c$export$6e69f8dc03075ef8 = 'team-type';
const $6784cbc7d62e5d7c$export$c06666264cd35603 = 'team-type-shorthand';
const $6784cbc7d62e5d7c$export$8a00ecf6498ee2fe = 'onboarding-selected-project-template-type';
const $6784cbc7d62e5d7c$export$6973064a898f5989 = 'should-show-list-view-type-cell-spotlight';
const $6784cbc7d62e5d7c$export$115fac1f1144bda1 = 'should-show-list-view-fields-dropdown-spotlight';
const $6784cbc7d62e5d7c$export$69fe8832c4f79a32 = 'onboarding_started_timestamp';
const $6784cbc7d62e5d7c$export$a8d62e500b59f31e = 'boardCreateColumnButtonNudge';
const $6784cbc7d62e5d7c$export$92c7f0eacc8d8d98 = 'assigneeFilterAddPeopleButtonNudge';
const $6784cbc7d62e5d7c$export$dd63d0099d95ba4f = 'navigationAppsNavItemNudge';
const $6784cbc7d62e5d7c$export$aba87e019f5ccb8d = 'navigationCreateIssueButtonNudge';
const $6784cbc7d62e5d7c$export$46d9a3d441dfd22b = 'navigationPlansNavItemNudge';
const $6784cbc7d62e5d7c$export$e20072f7d0c5357f = 'roadmapCreateEpicButtonNudge';
const $6784cbc7d62e5d7c$export$1e39959907a7f359 = 'roadmapCreateEpicChildIssueButtonNudge';
const $6784cbc7d62e5d7c$export$b74a8fdb2c75b869 = 'navigationPeopleNavItemNudge';
const $6784cbc7d62e5d7c$export$b1a6ab17737f33e = 'backlogAccordionNudge';
const $6784cbc7d62e5d7c$export$eb64d5f1a091478b = 'backlogCreateSprintIssueNudge';
const $6784cbc7d62e5d7c$export$64d75060ee6ba425 = 'backlogCreateIssueNudge';
const $6784cbc7d62e5d7c$export$3366ddefe77d5112 = 'boardCreateColumnNudge';
const $6784cbc7d62e5d7c$export$9d9e95a66a2c6abe = 'addItemsCalendarNudge';
const $6784cbc7d62e5d7c$export$69aca8ebee0d34c8 = 'trelloCrossflowAddItemsCalendarNudge';
const $6784cbc7d62e5d7c$export$7aa8bceae32c7862 = 'navigationAppsProfileItemNudge';
const $6784cbc7d62e5d7c$export$c6df9a2c7447e12d = 'getStartedListNudge';
const $6784cbc7d62e5d7c$export$468488291ccd988 = 'timelineAddItemNudge';
const $6784cbc7d62e5d7c$export$7a33548109ac931d = 'createFormNudge';
const $6784cbc7d62e5d7c$export$b65ba9ea0c0ced43 = 'jsw-onboarding-checklist.open';
const $6784cbc7d62e5d7c$export$3b5d230b66f60471 = 'jsw-onboarding-checklist.visibility';
const $6784cbc7d62e5d7c$export$594d3436316492be = 'summaryViewNudge';
const $6784cbc7d62e5d7c$export$f93b83d735f01fa3 = 'pagesCreatePageNudge';
const $6784cbc7d62e5d7c$export$77bc79debbf5c069 = 'inviteTeamNudge';
const $6784cbc7d62e5d7c$export$6ffa29e74c0304c4 = 'tailorBoardColumnsNudge';
const $6784cbc7d62e5d7c$export$699265ec8ad9a740 = 'Software Development';
const $6784cbc7d62e5d7c$export$e07d1fa2da8ed874 = 'Customer Service';
const $6784cbc7d62e5d7c$export$76dcec3f438d9e56 = 'IT Support';
const $6784cbc7d62e5d7c$export$9a574c301f67ba30 = 'Human Resources';
const $6784cbc7d62e5d7c$export$363ec144a94029c8 = 'Finance';
const $6784cbc7d62e5d7c$export$df0fb32d68ae1e78 = 'Legal';
const $6784cbc7d62e5d7c$export$d9c0e3e59442fb4 = 'Marketing';
const $6784cbc7d62e5d7c$export$27dbc7d7ce66e6e3 = 'Operations';
const $6784cbc7d62e5d7c$export$a5dce388adf922bd = 'Sales';
const $6784cbc7d62e5d7c$export$e1473b31a257caff = 'Data Science';
const $6784cbc7d62e5d7c$export$85657457db93c2c2 = 'Product Management';
const $6784cbc7d62e5d7c$export$c0c2d1dfaeba89dd = 'Project Management';
const $6784cbc7d62e5d7c$export$2e6a7ad3ab9c82a3 = 'Design';
const $6784cbc7d62e5d7c$export$7b60378c3b4372e9 = 'Other or Personal';
const $6784cbc7d62e5d7c$export$572242e58bd07594 = 'CS';
const $6784cbc7d62e5d7c$export$d7de553940261eba = 'ITS';
const $6784cbc7d62e5d7c$export$4c29d0d04c15e55d = 'HR';
const $6784cbc7d62e5d7c$export$3950f7f841bf94b6 = 'FNC';
const $6784cbc7d62e5d7c$export$881249b988b6030f = 'LGL';
const $6784cbc7d62e5d7c$export$e4824f74b9879164 = 'MKT';
const $6784cbc7d62e5d7c$export$4f3cb0844009af52 = 'OPS';
const $6784cbc7d62e5d7c$export$1a65d50c4a641bb4 = 'SAL';
const $6784cbc7d62e5d7c$export$9ee64e8fbd8b03a2 = 'DS';
const $6784cbc7d62e5d7c$export$b8b1ac856ba1434b = 'DEV';
const $6784cbc7d62e5d7c$export$4f54a09a24fd1d74 = 'PDM';
const $6784cbc7d62e5d7c$export$79685802e8ff1098 = 'PJM';
const $6784cbc7d62e5d7c$export$e5c438b7501b5a24 = 'DES';
const $6784cbc7d62e5d7c$export$cbc0e551d91a692d = 'OTR';

parcelRegister("8fqy8", function(module, exports) {

$parcel$export(module.exports, "getSignupTrackDeferSitenameUserTrait", () => $77364531dfabe700$export$686752df505238be);
$parcel$export(module.exports, "getJswTrackDeferSitenameSiteTrait", () => $77364531dfabe700$export$6da79f996c267010);

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");
const $77364531dfabe700$var$PERSONALIZATION_ENDPOINT = '/gateway/api/tap-delivery/api/v3/personalization';
const $77364531dfabe700$var$SITE_PERSONALIZATION_ENDPOINT = `${$77364531dfabe700$var$PERSONALIZATION_ENDPOINT}/site/`;
const $77364531dfabe700$var$USER_PERSONALIZATION_ENDPOINT = `${$77364531dfabe700$var$PERSONALIZATION_ENDPOINT}/user/`;
const $77364531dfabe700$var$SIGNUP_TRACK_DEFER_SITENAME_USER_TRAIT = 'marketing-signup_track_deferred-sitename_signup_server_enrollment';
const $77364531dfabe700$var$JSW_TRACK_DEFER_SITENAME_TRAIT = 'jira_track_instance_created_server_defer_site_rename_cohort';
const $77364531dfabe700$var$fetchPersonalization = (endpoint, subject)=>async (id, meta)=>{
        try {
            const url = endpoint + id;
            return await (0, $eusud.performGetRequest)(url);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $jcw0u.default)({
                meta: {
                    id: 'onboarding',
                    teamName: 'jlove-makkuro',
                    ...meta
                },
                attributes: {
                    subject: subject
                },
                error: error
            });
            return undefined;
        }
    };
const $77364531dfabe700$var$getTraits = (fetch, traitName)=>async (id, meta)=>{
        const personalization = await fetch(id, meta);
        return personalization?.attributes?.find((att)=>att.name === traitName);
    };
const $77364531dfabe700$export$686752df505238be = $77364531dfabe700$var$getTraits($77364531dfabe700$var$fetchPersonalization($77364531dfabe700$var$USER_PERSONALIZATION_ENDPOINT, 'fetchUserPersonalization'), $77364531dfabe700$var$SIGNUP_TRACK_DEFER_SITENAME_USER_TRAIT);
const $77364531dfabe700$export$6da79f996c267010 = $77364531dfabe700$var$getTraits($77364531dfabe700$var$fetchPersonalization($77364531dfabe700$var$SITE_PERSONALIZATION_ENDPOINT, 'fetchSitePersonalization'), $77364531dfabe700$var$JSW_TRACK_DEFER_SITENAME_TRAIT);

});

parcelRegister("bfWlw", function(module, exports) {

$parcel$export(module.exports, "getOnboardingPremiumTrialWithRethrow", () => $a55f3307b43c0521$export$d9a9dd6206da5bef);
$parcel$export(module.exports, "getOnboardingPremiumTrial", () => $a55f3307b43c0521$export$ef676f7f369f74fe);

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");

var $6c7t9 = parcelRequire("6c7t9");
const $a55f3307b43c0521$var$endpoint = '/rest/onboarding/1.0/premium-trial';
const $a55f3307b43c0521$export$d9a9dd6206da5bef = async ()=>{
    try {
        // Attempt to get from localStorage
        const localStorageOnboardingPremiumTrial = (0, $6c7t9.localStorageGetOnboardingPremiumTrial)();
        const localStorageOnboardingPremiumTrialCohort = (0, $6c7t9.localStorageGetOnboardingPremiumTrialCohort)();
        if (typeof localStorageOnboardingPremiumTrial === 'boolean' && typeof localStorageOnboardingPremiumTrialCohort === 'string') return {
            premiumTrialOnSignup: localStorageOnboardingPremiumTrial,
            reverseTrialCohort: localStorageOnboardingPremiumTrialCohort
        };
        const response = await (0, $eusud.performGetRequestWithRetry)($a55f3307b43c0521$var$endpoint);
        const premiumTrialOnSignup = response?.premiumTrialOnSignup;
        const reverseTrialCohort = response?.reverseTrialCohort;
        if (typeof premiumTrialOnSignup === 'boolean' && typeof reverseTrialCohort === 'string') {
            // Set into localStorage
            (0, $6c7t9.localStorageSetOnboardingPremiumTrial)(premiumTrialOnSignup);
            (0, $6c7t9.localStorageSetOnboardingPremiumTrialCohort)(reverseTrialCohort);
            return {
                premiumTrialOnSignup: premiumTrialOnSignup,
                reverseTrialCohort: reverseTrialCohort
            };
        }
        throw new Error('response?.premiumTrialOnSignup or response?.reverseTrialCohort is undefined');
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.default)({
            error: error,
            meta: {
                id: 'getOnboardingPremiumTrialWithRethrow',
                packageName: 'jiraReverseTrialUtils'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }
};
const $a55f3307b43c0521$export$ef676f7f369f74fe = async ()=>{
    try {
        return await $a55f3307b43c0521$export$d9a9dd6206da5bef();
    } catch (e) {
    // ignored
    }
};

});
parcelRegister("6c7t9", function(module, exports) {

$parcel$export(module.exports, "localStorageGetOnboardingPremiumTrial", () => $fab9df2877e9db77$export$782df5489e5cfd1e);
$parcel$export(module.exports, "localStorageGetOnboardingPremiumTrialCohort", () => $fab9df2877e9db77$export$c3378895d06b5528);
$parcel$export(module.exports, "localStorageSetOnboardingPremiumTrial", () => $fab9df2877e9db77$export$f83a7a49524e74ad);
$parcel$export(module.exports, "localStorageSetOnboardingPremiumTrialCohort", () => $fab9df2877e9db77$export$f389f8ca168b4a3a);

var $bSSG7 = parcelRequire("bSSG7");

var $jcw0u = parcelRequire("jcw0u");
const $fab9df2877e9db77$export$3538ee3f5c6c8b5c = 'premiumTrialOnSignup';
const $fab9df2877e9db77$export$2f93fdc3330233dc = 'reverseTrialCohort';
const $fab9df2877e9db77$var$localStorage = (0, $bSSG7.createLocalStorageProvider)('jsw-onboarding-premium-reverse-trial');
const $fab9df2877e9db77$export$782df5489e5cfd1e = ()=>{
    try {
        const value = $fab9df2877e9db77$var$localStorage.get($fab9df2877e9db77$export$3538ee3f5c6c8b5c);
        // localStorage.get is able to return proper booleans and not stringified booleans like "true"/"false"
        return value;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.default)({
            error: error,
            meta: {
                id: 'localStorageGetOnboardingPremiumTrial',
                packageName: 'jiraReverseTrialUtils'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        // note: unlike window.localStorage, the get method returns undefined instead of null. Thus this also returns undefined.
        return undefined;
    }
};
const $fab9df2877e9db77$export$c3378895d06b5528 = ()=>{
    try {
        const value = $fab9df2877e9db77$var$localStorage.get($fab9df2877e9db77$export$2f93fdc3330233dc);
        return value;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.default)({
            error: error,
            meta: {
                id: 'localStorageGetOnboardingPremiumTrial',
                packageName: 'jiraReverseTrialUtils'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        // note: unlike window.localStorage, the get method returns undefined instead of null. Thus this also returns undefined.
        return undefined;
    }
};
const $fab9df2877e9db77$export$f83a7a49524e74ad = (premiumTrialOnSignup)=>{
    try {
        $fab9df2877e9db77$var$localStorage.set($fab9df2877e9db77$export$3538ee3f5c6c8b5c, premiumTrialOnSignup);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.default)({
            error: error,
            meta: {
                id: 'localStorageSetOnboardingPremiumTrial',
                packageName: 'jiraReverseTrialUtils'
            },
            sendToPrivacyUnsafeSplunk: true
        });
    }
};
const $fab9df2877e9db77$export$f389f8ca168b4a3a = (reverseTrialCohort)=>{
    try {
        $fab9df2877e9db77$var$localStorage.set($fab9df2877e9db77$export$2f93fdc3330233dc, reverseTrialCohort);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.default)({
            error: error,
            meta: {
                id: 'localStorageSetOnboardingPremiumTrial',
                packageName: 'jiraReverseTrialUtils'
            },
            sendToPrivacyUnsafeSplunk: true
        });
    }
};

});


parcelRegister("6yhDy", function(module, exports) {

$parcel$export(module.exports, "pollBackend", () => $760653e5a4f27459$export$8420ef0cee98de);

var $1sYcL = parcelRequire("1sYcL");

var $8Bc5A = parcelRequire("8Bc5A");
const $760653e5a4f27459$export$8420ef0cee98de = async ({ keys: keys })=>{
    const { user: user } = await (0, $1sYcL.get)({
        userProperties: keys,
        consumerMeta: {
            id: 'fetchUserProperties',
            packageName: (0, $8Bc5A.PACKAGE_NAME),
            teamName: (0, $8Bc5A.PACKAGE_TEAM_NAME)
        }
    });
    return user;
};

});
parcelRegister("1sYcL", function(module, exports) {

$parcel$export(module.exports, "get", () => $7fc92c544211ac93$export$3988ae62b71be9a3);

var $lbWm4 = parcelRequire("lbWm4");

var $3T6Xo = parcelRequire("3T6Xo");

var $jcw0u = parcelRequire("jcw0u");

var $4R6GH = parcelRequire("4R6GH");

var $fZneA = parcelRequire("fZneA");

var $eusud = parcelRequire("eusud");

var $fjcgS = parcelRequire("fjcgS");

var $atdLB = parcelRequire("atdLB");
var $duUGa = parcelRequire("duUGa");
let $7fc92c544211ac93$var$ufoExperiencesMap = {};
const $7fc92c544211ac93$var$getUfoExperience = (key)=>{
    if (!$7fc92c544211ac93$var$ufoExperiencesMap[key]) $7fc92c544211ac93$var$ufoExperiencesMap[key] = new (0, $duUGa.UFOExperience)(key, {
        type: (0, $atdLB.ExperienceTypes).Operation,
        performanceType: (0, $atdLB.ExperiencePerformanceTypes).Custom
    });
    return $7fc92c544211ac93$var$ufoExperiencesMap[key];
};
const $7fc92c544211ac93$export$c907f169d33b2e25 = ()=>{
    $7fc92c544211ac93$var$ufoExperiencesMap = {};
};
const $7fc92c544211ac93$export$a5b7a8c3b1c6e775 = ({ userProperties: userProperties, projectId: projectId, projectProperties: projectProperties, instanceProperties: instanceProperties })=>{
    const params = new URLSearchParams();
    userProperties && params.append('user', userProperties.join(','));
    projectId !== undefined && params.append('projectId', projectId);
    projectProperties && params.append('project', projectProperties.join(','));
    instanceProperties && params.append('instance', instanceProperties.join(','));
    return `/rest/internal/latest/frontendconfig/properties?${params.toString()}`;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $7fc92c544211ac93$var$patchProperties = (response, propertiesPath)=>((0, $4R6GH.fg)('handle_null_response_for_fe_config_properties_call') ? response : true) && (0, (/*@__PURE__*/$parcel$interopDefault($lbWm4)))(response[propertiesPath], (value, prop)=>{
        try {
            response[propertiesPath][prop] = JSON.parse(value);
        } catch (error) {
            // TODO: Endpoint should ideally only return stringified values
            if (prop === 'initial.project.template.name') response[propertiesPath][prop] = value;
            else throw error;
        }
    });
const $7fc92c544211ac93$export$3988ae62b71be9a3 = async (options)=>{
    const ufoExperience = $7fc92c544211ac93$var$getUfoExperience(`${(0, (/*@__PURE__*/$parcel$interopDefault($3T6Xo)))(options.consumerMeta.packageName)}.${(0, (/*@__PURE__*/$parcel$interopDefault($3T6Xo)))(options.consumerMeta.id)}`);
    try {
        ufoExperience?.start();
        const url = $7fc92c544211ac93$export$a5b7a8c3b1c6e775(options);
        const response = await (0, $eusud.performGetRequest)(url);
        if (response === null) (0, $fjcgS.getAnalyticsWebClientPromise)().then((client)=>{
            const payload = {
                action: 'succeeded',
                actionSubject: 'jiraCommonRestInternalLatest.getConfigProperties',
                source: 'frontendConfigProperties',
                attributes: {
                    package: consumerMeta.packageName,
                    id: consumerMeta.id,
                    isNullResponse: true
                }
            };
            client.getInstance().sendOperationalEvent(payload);
        });
        $7fc92c544211ac93$var$patchProperties(response, 'user');
        $7fc92c544211ac93$var$patchProperties(response, 'instance');
        $7fc92c544211ac93$var$patchProperties(response, 'project');
        const { consumerMeta: consumerMeta } = options;
        (0, $fjcgS.getAnalyticsWebClientPromise)().then((client)=>{
            const payload = {
                source: 'frontendConfigProperties',
                action: 'success',
                actionSubject: `${consumerMeta.packageName}.${consumerMeta.id}`
            };
            client.getInstance().sendOperationalEvent(payload);
        });
        ufoExperience?.success();
        return (0, $4R6GH.fg)('handle_null_response_for_fe_config_properties_call') ? response || {
            user: {},
            instance: {},
            project: {}
        } : response;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        const { consumerMeta: consumerMeta } = options;
        !(0, $fZneA.isClientFetchError)(error) && (0, $jcw0u.default)({
            error: error,
            meta: {
                id: consumerMeta.id,
                packageName: consumerMeta.packageName,
                teamName: consumerMeta.teamName
            },
            sendToPrivacyUnsafeSplunk: true
        });
        ufoExperience?.failure();
        throw error;
    }
};

});


parcelRegister("52Vcw", function(module, exports) {

$parcel$export(module.exports, "fireAnalyticsOnQuickstartClose", () => $5dab66e6da9554ae$export$c98a6ee6aadb8055);
$parcel$export(module.exports, "fireAnalyticsOnQuickstartDismiss", () => $5dab66e6da9554ae$export$45d8c76e0490b3ec);
$parcel$export(module.exports, "fireAnalyticsOnQuickstartBack", () => $5dab66e6da9554ae$export$b1be4ae35a43115d);
$parcel$export(module.exports, "fireAnalyticsOnQuickstartExperienceComplete", () => $5dab66e6da9554ae$export$fa4f266bd2444d14);
$parcel$export(module.exports, "fireAnalyticsOnChecklistItemCompleted", () => $5dab66e6da9554ae$export$a68a2e5a69c8cd74);
$parcel$export(module.exports, "fireAPIErrorAnalytics", () => $5dab66e6da9554ae$export$a4d7f1a52677d339);
$parcel$export(module.exports, "fireAnalyticsOnOpenRightHandSidebar", () => $5dab66e6da9554ae$export$160bb78a3b11a5a9);
$parcel$export(module.exports, "fireAnalyticsOnMinimiseRightHandSidebar", () => $5dab66e6da9554ae$export$6ccbe54cd3a5a12);
$parcel$export(module.exports, "fireAnalyticsOnCloseRightHandSidebar", () => $5dab66e6da9554ae$export$6c39ca65ca354e59);

var $jcw0u = parcelRequire("jcw0u");

var $8zOmE = parcelRequire("8zOmE");

var $8Bc5A = parcelRequire("8Bc5A");

var $izv86 = parcelRequire("izv86");
const $5dab66e6da9554ae$export$c98a6ee6aadb8055 = (analyticsEvent, attributes)=>{
    analyticsEvent.update({
        action: 'closed',
        actionSubject: 'button'
    });
    (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'button closed', (0, $8Bc5A.ACTION_SUBJECT_ID), attributes);
};
const $5dab66e6da9554ae$export$45d8c76e0490b3ec = (analyticsEvent, attributes, source)=>{
    if (source === 'button') (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'button clicked', 'dismissQuickstartButton', attributes);
    else if (source === 'checklist') (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'button clicked', 'dismissQuickstart', attributes);
};
const $5dab66e6da9554ae$export$b1be4ae35a43115d = (analyticsEvent)=>{
    (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'button clicked', 'backButton');
};
const $5dab66e6da9554ae$export$fa4f266bd2444d14 = (createAnalyticsEvent, attributes)=>{
    const analyticsEvent = createAnalyticsEvent({});
    (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'experience completed', (0, $8Bc5A.ACTION_SUBJECT_ID), {
        ...attributes
    });
};
const $5dab66e6da9554ae$export$a68a2e5a69c8cd74 = (createAnalyticsEvent, completedTaskId)=>{
    const analyticsEvent = createAnalyticsEvent({});
    (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'checklistItem completed', (0, $izv86.convertTaskIdToActionSubjectId)(completedTaskId), {
        taskId: completedTaskId
    });
};
const $5dab66e6da9554ae$export$a4d7f1a52677d339 = (error, endpointSource)=>{
    (0, $jcw0u.default)({
        error: error,
        meta: {
            id: 'quickstartApiError',
            packageName: 'jiraOnboardingQuickstartCore',
            teamName: 'jlove-makkuro'
        },
        attributes: {
            error: error.message,
            endpointSource: endpointSource
        }
    });
};
const $5dab66e6da9554ae$export$160bb78a3b11a5a9 = (createAnalyticsEvent, attributes)=>{
    const analyticsEvent = createAnalyticsEvent({});
    (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'nuxOnboardingQuickstart openRightSidebar', (0, $8Bc5A.ACTION_SUBJECT_ID), {
        ...attributes
    });
};
const $5dab66e6da9554ae$export$6ccbe54cd3a5a12 = (createAnalyticsEvent, attributes)=>{
    const analyticsEvent = createAnalyticsEvent({});
    (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'nuxOnboardingQuickstart minimiseRightSidebar', (0, $8Bc5A.ACTION_SUBJECT_ID), {
        ...attributes
    });
};
const $5dab66e6da9554ae$export$6c39ca65ca354e59 = (createAnalyticsEvent, attributes)=>{
    const analyticsEvent = createAnalyticsEvent({});
    (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'nuxOnboardingQuickstart closeRightSidebar', (0, $8Bc5A.ACTION_SUBJECT_ID), {
        ...attributes
    });
};

});
parcelRegister("izv86", function(module, exports) {

$parcel$export(module.exports, "getProductType", () => $4725f5ccfabd2231$export$27e53caf66bae1d);
$parcel$export(module.exports, "convertTaskIdToActionSubjectId", () => $4725f5ccfabd2231$export$3b914201960fa7a6);

var $e4eHl = parcelRequire("e4eHl");

var $2vSU6 = parcelRequire("2vSU6");
const $4725f5ccfabd2231$export$d64a7dd8c7cd80e0 = {
    [(0, $2vSU6.CORE_PROJECT)]: 'workManagement',
    [(0, $2vSU6.SOFTWARE_PROJECT)]: 'software',
    [(0, $2vSU6.SERVICE_DESK_PROJECT)]: 'serviceManagement'
};
const $4725f5ccfabd2231$export$27e53caf66bae1d = (projectType)=>{
    if (projectType) return $4725f5ccfabd2231$export$d64a7dd8c7cd80e0[projectType] || (0, (/*@__PURE__*/$parcel$interopDefault($e4eHl)))(projectType);
    return null;
};
const $4725f5ccfabd2231$export$3b914201960fa7a6 = (taskId)=>{
    if (!taskId) return '';
    return (0, (/*@__PURE__*/$parcel$interopDefault($e4eHl)))(taskId.split('.').pop());
};

});


parcelRegister("ljzlb", function(module, exports) {

$parcel$export(module.exports, "getCrossProjectBoardTrait", () => $9217b5bb53dd29c2$export$7f2186c37a3d095d);

var $jcw0u = parcelRequire("jcw0u");

var $4R6GH = parcelRequire("4R6GH");

var $eusud = parcelRequire("eusud");

var $8zOmE = parcelRequire("8zOmE");

var $8Bc5A = parcelRequire("8Bc5A");

var $k9OK8 = parcelRequire("k9OK8");
const $9217b5bb53dd29c2$var$CROSS_PROJECT_BOARD_TO_PLAN_UPSELL_TRAIT = 'segment_jsw_cross_project_board_trait_siteuser';
const $9217b5bb53dd29c2$var$TAP_DELIVERY_PROXY_ENDPOINT = '/gateway/api/tap-delivery/api/v3/personalization';
const $9217b5bb53dd29c2$var$ONE_DAY = 86400000;
const $9217b5bb53dd29c2$export$88f2f25e1418caf1 = async (createAnalyticsEvent, siteId, userId)=>{
    try {
        const url = `${$9217b5bb53dd29c2$var$TAP_DELIVERY_PROXY_ENDPOINT}/site/${siteId}/user/${userId}`;
        const result = await (0, $eusud.performGetRequest)(url);
        const analyticsEvent = createAnalyticsEvent({});
        (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'getJSWCrossProjectBoardTrait personalizationApi', {
            synthetic: (0, $4R6GH.fg)('is_synthetic_tenant')
        });
        return result;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.default)({
            error: error,
            meta: {
                id: 'quickstartApiError',
                packageName: (0, $8Bc5A.PACKAGE_NAME),
                teamName: (0, $8Bc5A.PACKAGE_TEAM_NAME)
            },
            attributes: {
                error: error.message,
                endpointSource: 'getJSWCrossProjectBoardTrait',
                synthetic: (0, $4R6GH.fg)('is_synthetic_tenant')
            },
            sendToPrivacyUnsafeSplunk: true
        });
        return {
            attributes: []
        };
    }
};
const $9217b5bb53dd29c2$export$7f2186c37a3d095d = async (createAnalyticsEvent, siteId, userId)=>{
    const { get: get, persist: persist } = (0, $k9OK8.crossProjectBoardTraitSessionStorageProvider)();
    // Check session storage
    const sessionStorage = get();
    if (sessionStorage && userId === sessionStorage.userId && siteId === sessionStorage.siteId && Date.now() - sessionStorage.date < $9217b5bb53dd29c2$var$ONE_DAY) {
        const analyticsEvent = createAnalyticsEvent({});
        (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'getJSWCrossProjectBoardTrait sessionStorage', {
            synthetic: (0, $4R6GH.fg)('is_synthetic_tenant')
        });
        return sessionStorage.attribute;
    }
    // Fetch from personalization
    const personalization = await $9217b5bb53dd29c2$export$88f2f25e1418caf1(createAnalyticsEvent, siteId, userId);
    const attribute = personalization.attributes.find((att)=>att.name === $9217b5bb53dd29c2$var$CROSS_PROJECT_BOARD_TO_PLAN_UPSELL_TRAIT);
    if (attribute !== undefined) persist({
        attribute: attribute,
        date: Date.now(),
        userId: userId,
        siteId: siteId
    });
    return attribute;
};

});
parcelRegister("k9OK8", function(module, exports) {

$parcel$export(module.exports, "crossProjectBoardTraitSessionStorageProvider", () => $ee27e8acf854e0ab$export$99f3e48748c2a8c3);

var $eNf8a = parcelRequire("eNf8a");

const $ee27e8acf854e0ab$var$crossProjectBoardTraitSessionProvider = (0, $eNf8a.createSessionExpirableStorageProvider)((0, $111ca51573c84ae8$export$fac14ff24e5b1e7a));
const $ee27e8acf854e0ab$export$99f3e48748c2a8c3 = ()=>{
    const persist = (toPersist)=>{
        $ee27e8acf854e0ab$var$crossProjectBoardTraitSessionProvider.set((0, $111ca51573c84ae8$export$fac14ff24e5b1e7a), toPersist);
    };
    const get = ()=>$ee27e8acf854e0ab$var$crossProjectBoardTraitSessionProvider.get((0, $111ca51573c84ae8$export$fac14ff24e5b1e7a));
    return {
        get: get,
        persist: persist
    };
};

});
const $111ca51573c84ae8$export$fac14ff24e5b1e7a = 'jira-user-cross-project-board-trait';



parcelRegister("6ypzr", function(module, exports) {

$parcel$export(module.exports, "getOnboardingSkipApplicationProperty", () => $98fe78eb4dc2e758$export$980c26b6f100081d);

var $eusud = parcelRequire("eusud");
const $98fe78eb4dc2e758$export$980c26b6f100081d = ()=>(0, $eusud.performGetRequest)('/rest/onboarding/1.0/skip');

});

parcelRegister("4ji4w", function(module, exports) {

$parcel$export(module.exports, "getNextNonCompleteTask", () => $af696889329ec63a$export$b61dc70e2ed3fae3);
$parcel$export(module.exports, "getNextTask", () => $af696889329ec63a$export$404421ce8f3cbf9a);
$parcel$export(module.exports, "setLocalStorageItem", () => $af696889329ec63a$export$5aa524d86254b4f);
$parcel$export(module.exports, "getLocalStorageItem", () => $af696889329ec63a$export$93d719890ad66653);

var $bSSG7 = parcelRequire("bSSG7");

var $aFsRe = parcelRequire("aFsRe");
const $af696889329ec63a$export$b61dc70e2ed3fae3 = (tasks, completed, openTask)=>{
    const taskPosition = (0, $aFsRe.getTaskIndex)(tasks, openTask);
    // if the task does not exist(-1), we want to start at 0
    // if it exists we want to start at array index + 1 (taskPosition is already index+1)
    const start = taskPosition === -1 ? 0 : taskPosition;
    const len = tasks.length;
    // This loop:
    // 1) searches for non completed items from the start index to last index of the array
    // 2) searches from 0 until start if nothing was found during 1)
    for(let i = start; i < start + len; i += 1){
        const ind = i % len;
        if (!completed.includes(tasks[ind])) return tasks[ind];
    }
    // nothing was found there is no task to open
    return null;
};
const $af696889329ec63a$export$404421ce8f3cbf9a = (tasks, openTask)=>{
    const taskPosition = (0, $aFsRe.getTaskIndex)(tasks, openTask);
    // if the task does not exist(-1), we want to start at 0
    // if it exists we want to start at array index + 1 (taskPosition is already index+1)
    const ind = taskPosition === -1 ? 0 : taskPosition;
    return tasks[ind] ? tasks[ind] : null;
};
const $af696889329ec63a$var$store = (0, $bSSG7.createLocalStorageProvider)('quickstart');
const $af696889329ec63a$export$5aa524d86254b4f = (key, value)=>{
    $af696889329ec63a$var$store.set(key, value);
};
const $af696889329ec63a$export$93d719890ad66653 = (key)=>$af696889329ec63a$var$store.get(key);

});
parcelRegister("aFsRe", function(module, exports) {

$parcel$export(module.exports, "getTaskIndex", () => $856e0575daef172f$export$9ba3adcb1954c00);
$parcel$export(module.exports, "convertTaskIdToActionSubjectIdForShowMe", () => $856e0575daef172f$export$9711f11998d5795c);
$parcel$export(module.exports, "convertTaskIdToActionSubjectIdForLink", () => $856e0575daef172f$export$995248f3b43d8505);
$parcel$export(module.exports, "convertTaskIdToActionSubjectIdForCta", () => $856e0575daef172f$export$293f6b2affa6ea5a);

var $izv86 = parcelRequire("izv86");







const $856e0575daef172f$export$9ba3adcb1954c00 = (taskList, taskId)=>{
    if (!taskList || taskId === null) return -1;
    return taskList.indexOf(taskId) + 1;
};
const $856e0575daef172f$export$9711f11998d5795c = (taskId)=>`${(0, $izv86.convertTaskIdToActionSubjectId)(taskId)}ShowMe`;
const $856e0575daef172f$export$995248f3b43d8505 = (taskId)=>`${(0, $izv86.convertTaskIdToActionSubjectId)(taskId)}Link`;
const $856e0575daef172f$export$293f6b2affa6ea5a = (taskId)=>`${(0, $izv86.convertTaskIdToActionSubjectId)(taskId)}Cta`;

});


parcelRegister("abQXL", function(module, exports) {

$parcel$export(module.exports, "nextSetChecklistIsDismissed", () => $dc09dffee9419aae$export$f24c05f83b880547);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $8Bc5A = parcelRequire("8Bc5A");

var $1ftPQ = parcelRequire("1ftPQ");

var $3B5jO = parcelRequire("3B5jO");

var $4ji4w = parcelRequire("4ji4w");
const $dc09dffee9419aae$export$f24c05f83b880547 = (isDismissed)=>({ getState: getState, setState: setState })=>{
        const state = getState();
        const quickstartType = (0, $3B5jO.getQuickstartTypeSelector)(state);
        const currentIsDismissed = state.visibility[quickstartType] === (0, $8Bc5A.QUICKSTART_UI_STATUS).DISMISSED;
        if (isDismissed === currentIsDismissed) // if state has not been updated we just return
        return;
        const quickstartStatus = isDismissed ? (0, $8Bc5A.QUICKSTART_UI_STATUS).DISMISSED : (0, $8Bc5A.QUICKSTART_UI_STATUS).OPEN;
        setState({
            visibility: {
                ...state.visibility,
                [quickstartType]: quickstartStatus
            },
            isFocusedOn: !isDismissed
        });
        (0, $1ftPQ.pushToBackend)({
            key: (0, $8Bc5A.getBackendVisibilityKey)(quickstartType),
            value: quickstartStatus
        });
        (0, $4ji4w.setLocalStorageItem)(`${quickstartType}.visibility`, quickstartStatus);
        // Delete all code below when cleaning up isDismissed in state
        if (isDismissed === false) // When setting IsDismissed to false, also setting QS status to OPEN so checklist appears in open state
        (0, $1ftPQ.pushToBackend)({
            key: (0, $8Bc5A.KEY_OPEN),
            value: true
        });
        else // When setting IsDismissed, also toggle the open state of the checklist to match.
        (0, $1ftPQ.pushToBackend)({
            key: (0, $8Bc5A.KEY_OPEN),
            value: false
        });
        (0, $1ftPQ.pushToBackend)({
            key: (0, $8Bc5A.KEY_DISMISSED),
            value: isDismissed
        });
    };

});

parcelRegister("4VXxO", function(module, exports) {

$parcel$export(module.exports, "nextSetChecklistIsOpen", () => $7815e3bf96163d46$export$4249eabbb34e2e69);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $8Bc5A = parcelRequire("8Bc5A");

var $1ftPQ = parcelRequire("1ftPQ");

var $3B5jO = parcelRequire("3B5jO");

var $4ji4w = parcelRequire("4ji4w");
const $7815e3bf96163d46$export$4249eabbb34e2e69 = (isOpen)=>({ getState: getState, setState: setState })=>{
        const state = getState();
        const quickstartType = (0, $3B5jO.getQuickstartTypeSelector)(state);
        const currentIsOpen = state.visibility[quickstartType] === (0, $8Bc5A.QUICKSTART_UI_STATUS).OPEN;
        const currentIsMinimised = state.visibility[quickstartType] === (0, $8Bc5A.QUICKSTART_UI_STATUS).MINIMIZED;
        if (currentIsOpen && isOpen || currentIsMinimised && !isOpen) // if state has not been updated we just return
        return;
        const quickstartStatus = isOpen ? (0, $8Bc5A.QUICKSTART_UI_STATUS).OPEN : (0, $8Bc5A.QUICKSTART_UI_STATUS).MINIMIZED;
        setState({
            visibility: {
                ...state.visibility,
                [quickstartType]: quickstartStatus
            },
            hasNudgeActive: false,
            isFocusedOn: isOpen
        });
        (0, $1ftPQ.pushToBackend)({
            key: (0, $8Bc5A.getBackendVisibilityKey)(quickstartType),
            value: quickstartStatus
        });
        (0, $4ji4w.setLocalStorageItem)(`${quickstartType}.visibility`, quickstartStatus);
        // Delete all code below when cleaning up isOpen in state
        (0, $1ftPQ.pushToBackend)({
            key: (0, $8Bc5A.KEY_OPEN),
            value: isOpen
        });
    };

});

parcelRegister("erLQY", function(module, exports) {

$parcel$export(module.exports, "nextMarkAsCompletedTask", () => $f082da41253fd664$export$d6628d41a3bec42d);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $1ftPQ = parcelRequire("1ftPQ");
const $f082da41253fd664$export$d6628d41a3bec42d = (taskId)=>({ getState: getState, setState: setState })=>{
        // When a task is complete:
        // Check to see if the task is complete in the completedKeys already
        // update the checklist dict (maybe should be at a different point or use setState)
        const { completedTaskList: completedTaskList } = getState();
        if (completedTaskList.includes(taskId)) return;
        // update the backend with the KEY and true
        (0, $1ftPQ.pushToBackend)({
            key: taskId,
            value: true
        });
        // update itemsList to reflect checked status. clone -> update -> override
        setState({
            completedTaskList: [
                ...completedTaskList,
                taskId
            ]
        });
    };

});


parcelRegister("8UXiA", function(module, exports) {

$parcel$export(module.exports, "setNudgeStep", () => $2d15900fae273e3c$export$4debc323813b6997);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $2d15900fae273e3c$export$4debc323813b6997 = (nudge)=>({ getState: getState, setState: setState })=>{
        const { nudgeStep: nudgeStep } = getState();
        if (nudge === nudgeStep) return;
        setState({
            nudgeStep: nudge
        });
    };
var $2d15900fae273e3c$export$2e2bcd8739ae039 = $2d15900fae273e3c$export$4debc323813b6997;

});

parcelRegister("3iEb4", function(module, exports) {

$parcel$export(module.exports, "addMountedNudge", () => $d23aba2b0749d2be$export$92a89c32d0ea3943);
$parcel$export(module.exports, "removeMountedNudge", () => $d23aba2b0749d2be$export$748f4cda8ab98c91);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $d23aba2b0749d2be$export$92a89c32d0ea3943 = (nudge)=>({ getState: getState, setState: setState })=>{
        const { mountedNudges: mountedNudges } = getState();
        // skip store update if this nudge is already added
        if (mountedNudges.includes(nudge)) return;
        setState({
            mountedNudges: [
                ...mountedNudges,
                nudge
            ]
        });
    };
const $d23aba2b0749d2be$export$748f4cda8ab98c91 = (nudge)=>({ getState: getState, setState: setState })=>{
        const { mountedNudges: mountedNudges } = getState();
        // skip store update if this nudge is already removed
        if (!mountedNudges.includes(nudge)) return;
        setState({
            mountedNudges: mountedNudges.filter((mountedNudge)=>mountedNudge !== nudge)
        });
    };

});

parcelRegister("7yDu9", function(module, exports) {

$parcel$export(module.exports, "setShouldRenderComponent", () => $e7988e1b8f7782bd$export$1f9c6770ed938b6e);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $e7988e1b8f7782bd$export$1f9c6770ed938b6e = (shouldRenderComponent)=>({ getState: getState, setState: setState })=>{
        /* Grab current state of is shouldRenderComponent */ const { shouldRenderComponent: currentShouldRenderComponent } = getState();
        if (shouldRenderComponent === currentShouldRenderComponent) // if state has not been updated we just return
        return;
        setState({
            shouldRenderComponent: shouldRenderComponent
        });
    };
var $e7988e1b8f7782bd$export$2e2bcd8739ae039 = $e7988e1b8f7782bd$export$1f9c6770ed938b6e;

});

parcelRegister("5UBG2", function(module, exports) {

$parcel$export(module.exports, "setProjectState", () => $72dc29ca0b198f0e$export$1ba498e440c0a1e4);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $72dc29ca0b198f0e$export$1ba498e440c0a1e4 = (projectState)=>({ setState: setState })=>{
        setState({
            projectState: projectState
        });
    };
var $72dc29ca0b198f0e$export$2e2bcd8739ae039 = $72dc29ca0b198f0e$export$1ba498e440c0a1e4;

});

parcelRegister("lHcRB", function(module, exports) {

$parcel$export(module.exports, "setHasNudgeActive", () => $4ecbca1b06d3bc5e$export$497c281e6eb0786e);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $4ecbca1b06d3bc5e$export$497c281e6eb0786e = (hasNudgeActive, itemName = '')=>({ getState: getState, setState: setState })=>{
        /* Grab current state of is currentHasNudgeActive */ const { hasNudgeActive: currentHasNudgeActive, openTask: openTask } = getState();
        if (hasNudgeActive === currentHasNudgeActive) // if state has not been updated we just return
        return;
        if (hasNudgeActive === false && itemName !== openTask) // do not update a nudge if the current open task is different than the one we called the function with
        return;
        setState({
            hasNudgeActive: hasNudgeActive
        });
    };
var $4ecbca1b06d3bc5e$export$2e2bcd8739ae039 = $4ecbca1b06d3bc5e$export$497c281e6eb0786e;

});

parcelRegister("eiyXc", function(module, exports) {

$parcel$export(module.exports, "forceHideNudge", () => $7ab5d12e3e83c16f$export$6d1ed97b83a62e8e);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
// We use this action in cases where we want to hide the nudge no matter what.
const $7ab5d12e3e83c16f$export$6d1ed97b83a62e8e = ()=>({ setState: setState })=>{
        setState({
            hasNudgeActive: false
        });
    };

});

parcelRegister("jZvbN", function(module, exports) {

$parcel$export(module.exports, "setHasEverSeenRoute", () => $bde38543b00c29f3$export$28e0a4314a1ce52f);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $8Bc5A = parcelRequire("8Bc5A");

var $1ftPQ = parcelRequire("1ftPQ");
const $bde38543b00c29f3$export$28e0a4314a1ce52f = (update)=>({ getState: getState, setState: setState })=>{
        const { hasEverSeenRoute: currentHasEverSeenRoute } = getState();
        const somethingHasBeenUpdated = Object.keys(update).some(// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<"jsw.onboarding.experiment.personalised.onboarding.ntkw.onboarding.it2.roadmap", boolean>>'.
        (key)=>update[key] !== currentHasEverSeenRoute[key]);
        if (!somethingHasBeenUpdated) return;
        const newHasEverSeenRoute = {
            ...currentHasEverSeenRoute,
            ...update
        };
        setState({
            hasEverSeenRoute: newHasEverSeenRoute
        });
        (0, $1ftPQ.pushToBackend)({
            key: (0, $8Bc5A.KEY_HAS_EVER_SEEN_ROUTE),
            value: newHasEverSeenRoute
        });
    };
var $bde38543b00c29f3$export$2e2bcd8739ae039 = $bde38543b00c29f3$export$28e0a4314a1ce52f;

});

parcelRegister("azcAL", function(module, exports) {

$parcel$export(module.exports, "setRoadmapIsCreateEnabled", () => $f19987e3027503ab$export$35ea35d1a8e07307);
$parcel$export(module.exports, "setRoadmapIsListEmpty", () => $f19987e3027503ab$export$932967764e7a0b31);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $f19987e3027503ab$export$35ea35d1a8e07307 = (roadmapIsCreateEnabled)=>({ getState: getState, setState: setState })=>{
        const { roadmapIsCreateEnabled: currentRoadmapIsCreateEnabled } = getState();
        // skip store update if no state change
        if (currentRoadmapIsCreateEnabled === roadmapIsCreateEnabled) return;
        setState({
            roadmapIsCreateEnabled: roadmapIsCreateEnabled
        });
    };
const $f19987e3027503ab$export$932967764e7a0b31 = (roadmapIsListEmpty)=>({ getState: getState, setState: setState })=>{
        const { roadmapIsListEmpty: currentRoadmapIsListEmpty } = getState();
        // skip store update if no state change
        if (currentRoadmapIsListEmpty === roadmapIsListEmpty) return;
        setState({
            roadmapIsListEmpty: roadmapIsListEmpty
        });
    };

});

parcelRegister("gbXQ5", function(module, exports) {

$parcel$export(module.exports, "openNextTask", () => $460159056a360dfc$export$867dbb6d61569ae9);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $4ji4w = parcelRequire("4ji4w");

var $cUGWT = parcelRequire("cUGWT");
const $460159056a360dfc$export$867dbb6d61569ae9 = ()=>({ getState: getState, dispatch: dispatch })=>{
        const { openTask: openTask, tasks: tasks } = getState();
        if (!tasks) return;
        const { items: items } = tasks;
        const taskIdToExpand = (0, $4ji4w.getNextTask)(items, openTask);
        if (taskIdToExpand === null) return;
        dispatch((0, $cUGWT.nextOpenTask)(taskIdToExpand));
    };

});
parcelRegister("cUGWT", function(module, exports) {

$parcel$export(module.exports, "nextOpenTask", () => $f8b3135a172025f8$export$5deb889489d2f989);
$parcel$export(module.exports, "nextAutoOpenTask", () => $f8b3135a172025f8$export$cc5f3544a6cb2922);


var $8Bc5A = parcelRequire("8Bc5A");

var $1ftPQ = parcelRequire("1ftPQ");

var $8UXiA = parcelRequire("8UXiA");

var $lHcRB = parcelRequire("lHcRB");
const $f8b3135a172025f8$var$openTask = (taskId)=>({ setState: setState })=>{
        setState({
            openTask: taskId
        });
        (0, $1ftPQ.pushToBackend)({
            key: (0, $8Bc5A.KEY_OPEN_TASK),
            value: taskId
        });
    };
const $f8b3135a172025f8$export$5deb889489d2f989 = (taskId, { closeNudge: closeNudge } = {})=>({ dispatch: dispatch, getState: getState })=>{
        dispatch($f8b3135a172025f8$var$openTask(taskId));
        const { completedTaskList: completedTaskList } = getState();
        const taskIsCompleted = completedTaskList.includes(taskId);
        const taskIdExistsAndIsNotCompleted = !(taskId === '' || taskId === null) && !taskIsCompleted;
        if (closeNudge) dispatch((0, $lHcRB.setHasNudgeActive)(false, taskId));
        else dispatch((0, $lHcRB.setHasNudgeActive)(taskIdExistsAndIsNotCompleted, taskId));
        // This is a temporary solution for Scrum Onboarding.
        // See https://hello.atlassian.net/wiki/spaces/agile/pages/1321008806/Draft+Quickstart+Nudge+Interaction for details
        if (taskIdExistsAndIsNotCompleted && taskId === (0, $8Bc5A.SCRUM_ONBOARDING_TASK)) dispatch((0, $8UXiA.setNudgeStep)((0, $6784cbc7d62e5d7c$export$b1a6ab17737f33e)));
        else if (taskIdExistsAndIsNotCompleted && taskId === (0, $8Bc5A.KANBAN_ONBOARDING_TASK)) dispatch((0, $8UXiA.setNudgeStep)((0, $6784cbc7d62e5d7c$export$3366ddefe77d5112)));
        else if (taskIdExistsAndIsNotCompleted && taskId === (0, $8Bc5A.ADD_COLUMNS_TASK)) dispatch((0, $8UXiA.setNudgeStep)((0, $6784cbc7d62e5d7c$export$3366ddefe77d5112)));
        else dispatch((0, $8UXiA.setNudgeStep)(''));
    };
const $f8b3135a172025f8$export$cc5f3544a6cb2922 = (taskId)=>({ dispatch: dispatch })=>{
        dispatch($f8b3135a172025f8$var$openTask(taskId));
        dispatch((0, $lHcRB.setHasNudgeActive)(false, taskId));
        dispatch((0, $8UXiA.setNudgeStep)(''));
    };

});


parcelRegister("iZuFy", function(module, exports) {

$parcel$export(module.exports, "resetIsQuickstartLoaded", () => $b50ce46f86d3e3d7$export$bda085a823763e5a);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $8Bc5A = parcelRequire("8Bc5A");

var $3B5jO = parcelRequire("3B5jO");
const $b50ce46f86d3e3d7$export$bda085a823763e5a = ()=>({ getState: getState, setState: setState })=>{
        const state = getState();
        const quickstartType = (0, $3B5jO.getQuickstartTypeSelector)(state);
        setState({
            visibility: {
                ...state.visibility,
                [quickstartType]: (0, $8Bc5A.QUICKSTART_UI_STATUS).NOT_LOADED
            },
            hasNudgeActive: false,
            isQuickstartLoaded: false
        });
    };

});

parcelRegister("70Fss", function(module, exports) {

$parcel$export(module.exports, "refreshAppStateUiStatusOnly", () => $f0fdda8951af3bde$export$87fe8079a4ed9766);


var $8Bc5A = parcelRequire("8Bc5A");

var $6yhDy = parcelRequire("6yhDy");

var $52Vcw = parcelRequire("52Vcw");

var $6ypzr = parcelRequire("6ypzr");

var $abQXL = parcelRequire("abQXL");
const $f0fdda8951af3bde$export$87fe8079a4ed9766 = ({ taskList: taskList })=>async ({ getState: getState, setState: setState, dispatch: dispatch })=>{
        // Need to check to see if there is anything in the backend to take that as source of truth
        // If there is nothing then use defaults
        // Check backend for flags that are marked as completed (true)
        // Carry over state from previous actions
        // Create Completed Actions
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const updatedState = {};
        const { projectState: projectState } = getState();
        if (!projectState) return;
        // Open QS Checklist as default state if state cannot be determined from the backend
        updatedState.isOpen = true;
        updatedState.isDismissed = false;
        updatedState.quickstartStateProjectType = projectState.projectType;
        let backendVisibilityKeys = [];
        // Open QS Checklist as default state if state cannot be determined from the backend
        updatedState.visibility = Object.values((0, $8Bc5A.QUICKSTART_TYPE)).reduce((acc, type)=>{
            acc[type] = (0, $8Bc5A.QUICKSTART_UI_STATUS).OPEN;
            return acc;
        }, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        {});
        backendVisibilityKeys = Object.values((0, $8Bc5A.QUICKSTART_TYPE)).map((type)=>(0, $8Bc5A.getBackendVisibilityKey)(type));
        const backendState = await (0, $6yhDy.pollBackend)({
            keys: [
                (0, $8Bc5A.KEY_OPEN),
                (0, $8Bc5A.KEY_DISMISSED),
                (0, $8Bc5A.KEY_OPEN_TASK),
                (0, $8Bc5A.KEY_HAS_EVER_SEEN_ROUTE),
                (0, $8Bc5A.KEY_JSW_ONBOARDING),
                ...(0, $8Bc5A.allTasksExcludingJSMBusinessTasks),
                ...backendVisibilityKeys
            ]
        });
        const backendStateExists = backendState !== undefined && Object.keys(backendState).length > 0;
        if (backendStateExists) {
            updatedState.completedTaskList = Object.keys(backendState).filter((key)=>[
                    ...(0, $8Bc5A.allTasksExcludingJSMBusinessTasks)
                ].includes(key) && backendState[key] === true);
            Object.values((0, $8Bc5A.QUICKSTART_TYPE)).forEach((type)=>{
                // use new state if possible
                if ((0, $8Bc5A.getBackendVisibilityKey)(type) in backendState) updatedState.visibility[type] = backendState[(0, $8Bc5A.getBackendVisibilityKey)(type)];
                else if ((0, $8Bc5A.KEY_DISMISSED) in backendState && backendState[0, $8Bc5A.KEY_DISMISSED]) updatedState.visibility[type] = (0, $8Bc5A.QUICKSTART_UI_STATUS).DISMISSED;
                else if ((0, $8Bc5A.KEY_OPEN) in backendState) updatedState.visibility[type] = backendState[0, $8Bc5A.KEY_OPEN] ? (0, $8Bc5A.QUICKSTART_UI_STATUS).OPEN : (0, $8Bc5A.QUICKSTART_UI_STATUS).MINIMIZED;
            });
            if ((0, $8Bc5A.KEY_DISMISSED) in backendState) updatedState.isDismissed = backendState[0, $8Bc5A.KEY_DISMISSED];
            if ((0, $8Bc5A.KEY_OPEN) in backendState) updatedState.isOpen = backendState[0, $8Bc5A.KEY_OPEN];
            if ((0, $8Bc5A.KEY_OPEN_TASK) in backendState) updatedState.openTask = backendState[0, $8Bc5A.KEY_OPEN_TASK];
            if ((0, $8Bc5A.KEY_HAS_EVER_SEEN_ROUTE) in backendState) updatedState.hasEverSeenRoute = backendState[0, $8Bc5A.KEY_HAS_EVER_SEEN_ROUTE];
            if ((0, $8Bc5A.KEY_TASK_GROUP) in backendState) {
                updatedState.currentTaskGroupParent = // @ts-expect-error - TS2571 - Object is of type 'unknown'.
                backendState[0, $8Bc5A.KEY_TASK_GROUP].taskGroup.currentTaskGroupParent;
                updatedState.previousTaskGroupParents = // @ts-expect-error - TS2571 - Object is of type 'unknown'.
                backendState[0, $8Bc5A.KEY_TASK_GROUP].taskGroup.previousTaskGroupParents;
            }
            if ((0, $8Bc5A.KEY_JSW_ONBOARDING) in backendState) {
                if (typeof backendState[0, $8Bc5A.KEY_JSW_ONBOARDING] === 'object' && backendState[0, $8Bc5A.KEY_JSW_ONBOARDING] !== null && (0, $6784cbc7d62e5d7c$export$8a00ecf6498ee2fe) in backendState[0, $8Bc5A.KEY_JSW_ONBOARDING]) updatedState.selectedProjectTemplateKeyFromOnboarding = backendState[0, $8Bc5A.KEY_JSW_ONBOARDING][0, $6784cbc7d62e5d7c$export$8a00ecf6498ee2fe];
            }
        }
        setState(updatedState);
        if (!(backendStateExists && (0, $8Bc5A.KEY_OPEN) in backendState)) try {
            const skipApplicationProperty = await (0, $6ypzr.getOnboardingSkipApplicationProperty)();
            if (skipApplicationProperty.quickstart) dispatch((0, $abQXL.nextSetChecklistIsDismissed)(true));
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $52Vcw.fireAPIErrorAnalytics)(error, 'skipOnboarding');
        }
        setState({
            taskList: taskList
        });
        setState({
            isQuickstartLoaded: true
        });
    };

});

parcelRegister("dQPsy", function(module, exports) {

$parcel$export(module.exports, "nextSetChecklistItemSeen", () => $82a74350685dcd25$export$4eac017dcde0be8f);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $8Bc5A = parcelRequire("8Bc5A");

var $1ftPQ = parcelRequire("1ftPQ");
const $82a74350685dcd25$export$4eac017dcde0be8f = (taskId)=>({ getState: getState, setState: setState })=>{
        const hasSeenTaskId = (0, $8Bc5A.convertToHaveSeenItTask)(taskId);
        const { hasSeenTasks: hasSeenTasks } = getState();
        if (hasSeenTasks.includes(hasSeenTaskId)) return;
        setState({
            hasSeenTasks: [
                ...hasSeenTasks,
                hasSeenTaskId
            ]
        });
        (0, $1ftPQ.pushToBackend)({
            key: (0, $8Bc5A.convertToHaveSeenItTask)(taskId),
            value: true
        });
    };

});

parcelRegister("boV1S", function(module, exports) {

$parcel$export(module.exports, "nextAutoExpand", () => $35a410a5fb89f79b$export$3d24e97d30cfd09e);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $4R6GH = parcelRequire("4R6GH");

var $8Bc5A = parcelRequire("8Bc5A");

var $984bX = parcelRequire("984bX");

var $4ji4w = parcelRequire("4ji4w");

var $cUGWT = parcelRequire("cUGWT");
const $35a410a5fb89f79b$export$3d24e97d30cfd09e = ()=>({ getState: getState, dispatch: dispatch })=>{
        const hasNudgeToShowAfterNavigation = (0, $984bX.localStorageProvider)().get({
            accountId: (0, $8Bc5A.ACCOUNT_ID),
            key: (0, $8Bc5A.KEY_HAS_NAVIGATED_FROM_LINK)
        });
        if (hasNudgeToShowAfterNavigation) return;
        const { openTask: openTask, completedTaskList: completedTaskList, tasks: tasks, currentTriggerForTaskGroupParent: currentTriggerForTaskGroupParent } = getState();
        if (!tasks) return;
        const { items: items } = tasks;
        if (// @ts-expect-error - TS2345 - Argument of type 'string | null' is not assignable to parameter of type 'string'.
        items.includes(openTask) && // @ts-expect-error - TS2345 - Argument of type 'string | null' is not assignable to parameter of type 'string'.
        !completedTaskList.includes(openTask)) return;
        const taskIdToExpand = (0, $4ji4w.getNextNonCompleteTask)(items, completedTaskList, openTask);
        if (taskIdToExpand === null) return;
        // If the openTask is the same as the currentTriggerForTaskGroupParent, we just returned back from a sub menu and don't need to auto open the next task
        if ((0, $4R6GH.fg)('jira_a11y_fix_returning_focus')) {
            if (openTask === currentTriggerForTaskGroupParent) return;
        }
        dispatch((0, $cUGWT.nextAutoOpenTask)(taskIdToExpand));
    };

});
parcelRegister("984bX", function(module, exports) {

$parcel$export(module.exports, "localStorageProvider", () => $a6d0a6873aa6f7aa$export$aa821bfb3308a1f5);
$parcel$export(module.exports, "setLocalStorageHasNavigatedFromLink", () => $a6d0a6873aa6f7aa$export$f2666fae743fa5f);

var $eNf8a = parcelRequire("eNf8a");

var $jcw0u = parcelRequire("jcw0u");

var $8Bc5A = parcelRequire("8Bc5A");
const $a6d0a6873aa6f7aa$var$DAYS_BEFORE_EXPIRY = 1;
const $a6d0a6873aa6f7aa$var$DAY = 86400000;
const $a6d0a6873aa6f7aa$var$getKey = ({ accountId: accountId, key: key })=>`${accountId}.${key}`;
const $a6d0a6873aa6f7aa$var$getExpiryTime = ()=>{
    const now = Date.now();
    return now + $a6d0a6873aa6f7aa$var$DAYS_BEFORE_EXPIRY * $a6d0a6873aa6f7aa$var$DAY;
};
let $a6d0a6873aa6f7aa$var$localStorage;
const $a6d0a6873aa6f7aa$export$aa821bfb3308a1f5 = ()=>{
    if ($a6d0a6873aa6f7aa$var$localStorage) return $a6d0a6873aa6f7aa$var$localStorage;
    const provider = (0, $eNf8a.createSessionExpirableStorageProvider)('jsw-onboarding-checklist');
    try {
        provider.removeExpiredKeys();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        (0, $jcw0u.default)({
            meta: {
                id: 'localStorageProviderKeyRemoval',
                packageName: 'jiraOnboardingQuickstartCore'
            },
            error: e
        });
    }
    const get = ({ accountId: accountId, key: key })=>provider.get($a6d0a6873aa6f7aa$var$getKey({
            accountId: accountId,
            key: key
        }));
    const set = ({ accountId: accountId, key: key, value: value })=>provider.set($a6d0a6873aa6f7aa$var$getKey({
            accountId: accountId,
            key: key
        }), value, $a6d0a6873aa6f7aa$var$getExpiryTime());
    const remove = ({ accountId: accountId, key: key })=>provider.remove($a6d0a6873aa6f7aa$var$getKey({
            accountId: accountId,
            key: key
        }));
    $a6d0a6873aa6f7aa$var$localStorage = {
        provider: provider,
        remove: remove,
        get: get,
        set: set
    };
    return $a6d0a6873aa6f7aa$var$localStorage;
};
const $a6d0a6873aa6f7aa$export$f2666fae743fa5f = (value)=>{
    $a6d0a6873aa6f7aa$export$aa821bfb3308a1f5().set({
        accountId: (0, $8Bc5A.ACCOUNT_ID),
        key: (0, $8Bc5A.KEY_HAS_NAVIGATED_FROM_LINK),
        value: value
    });
};

});


parcelRegister("4Viq4", function(module, exports) {

$parcel$export(module.exports, "nextShouldShowNudgeAfterNavigation", () => $0d74d0b8a43d2c5f$export$6f336ccb6432fcd0);
// Special case for nudges that need to show after a navigation.
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $8Bc5A = parcelRequire("8Bc5A");

var $984bX = parcelRequire("984bX");

var $lHcRB = parcelRequire("lHcRB");
const $0d74d0b8a43d2c5f$export$6f336ccb6432fcd0 = (taskId)=>({ dispatch: dispatch })=>{
        const nudgeToShowAfterNavigationKeyPair = {
            accountId: (0, $8Bc5A.ACCOUNT_ID),
            key: (0, $8Bc5A.KEY_HAS_NAVIGATED_FROM_LINK)
        };
        const shouldShowNudge = (0, $984bX.localStorageProvider)().get(nudgeToShowAfterNavigationKeyPair) === taskId;
        if (shouldShowNudge) {
            dispatch((0, $lHcRB.setHasNudgeActive)(true));
            (0, $984bX.localStorageProvider)().remove(nudgeToShowAfterNavigationKeyPair);
        }
    };

});

parcelRegister("jIoq4", function(module, exports) {

$parcel$export(module.exports, "nextGetTasks", () => $034f263b888956c9$export$15d877e1f3abf489);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $ikZFc = parcelRequire("ikZFc");
const $034f263b888956c9$export$15d877e1f3abf489 = (props)=>({ getState: getState, setState: setState })=>{
        const { taskList: taskList } = getState();
        const tasks = (0, $ikZFc.getAllTasks)({
            ...props,
            taskList: taskList
        });
        setState({
            tasks: tasks
        });
    };

});
parcelRegister("ikZFc", function(module, exports) {

$parcel$export(module.exports, "getAllTasks", () => $cb6c1b1dc7b1b225$export$d1f442602a91e7cc);

var $6s1PB = parcelRequire("6s1PB");

var $c04PQ = parcelRequire("c04PQ");

var $4R6GH = parcelRequire("4R6GH");


var $ldyPw = parcelRequire("ldyPw");

var $jtI3q = parcelRequire("jtI3q");

var $8Bc5A = parcelRequire("8Bc5A");

var $1ffS1 = parcelRequire("1ffS1");

var $ieqoN = parcelRequire("ieqoN");

var $3Iaiu = parcelRequire("3Iaiu");

var $aHo1U = parcelRequire("aHo1U");

var $5yUqp = parcelRequire("5yUqp");

var $5zzQl = parcelRequire("5zzQl");

var $jJca1 = parcelRequire("jJca1");

var $d7Knl = parcelRequire("d7Knl");

var $8VfDj = parcelRequire("8VfDj");

var $pDX5d = parcelRequire("pDX5d");
const $cb6c1b1dc7b1b225$var$getTaskListItem = ({ variants: variants, taskVariants: taskVariants, taskList: taskList, taskGroupParent: taskGroupParent })=>{
    const [expConfig] = (0, $6s1PB.UNSAFE_noExposureExp)('jira_rt_quickstart_m1');
    if (variants.includes((0, $aHo1U.JSW).experiment.jswReverseTrial) && !expConfig.get('isEnabled', false)) {
        const { title: title, items: items } = taskList[taskGroupParent === (0, $8Bc5A.ROOT_TASK) ? (0, $8Bc5A.REVERSE_TRIAL_ROOT_TASK) : taskGroupParent] ?? taskList[0, $8Bc5A.REVERSE_TRIAL_ROOT_TASK];
        return {
            title: title,
            items: (0, $5zzQl.getTasks)(variants, taskVariants, items)
        };
    }
    const { title: title, items: items } = taskList[taskGroupParent] ?? taskList[0, $8Bc5A.ROOT_TASK];
    return {
        title: title,
        items: (0, $5zzQl.getTasks)(variants, taskVariants, items)
    };
};
const $cb6c1b1dc7b1b225$var$createJswTasks = (projectState, taskGroupParent, routeName, shouldShowScrumOnboardingExperience, mountedNudges, canCreateProject, isEligibleToUpdateSitename, isCrossProjectBoardToPlanUpsell, isWizardSimplifyQS, canEditPlans, premiumTrialOnSignup)=>{
    const variants = new Set();
    const isTmpScrumWithSprintPermission = mountedNudges.includes((0, $8Bc5A.BACKLOG_CREATE_SPRINT_NUDGE_ID));
    const isEligibleForKanbanTour = mountedNudges.includes((0, $6784cbc7d62e5d7c$export$3366ddefe77d5112));
    if ((0, $c04PQ.isFedRamp)()) variants.add((0, $aHo1U.JSW).experience.fedRamp);
    if (premiumTrialOnSignup) {
        variants.add((0, $aHo1U.JSW).experiment.jswReverseTrial);
        (0, $6s1PB.expValEquals)('jira_rt_quickstart_m1', 'isEnabled', true) && variants.add((0, $aHo1U.JSW).experiment.rtQuickstartM1);
    }
    if (shouldShowScrumOnboardingExperience && isTmpScrumWithSprintPermission) variants.add((0, $aHo1U.JSW).experiment.scrumOnboarding);
    if (isCrossProjectBoardToPlanUpsell) variants.add((0, $aHo1U.JSW).trait.crossProjectBoardToPlanUpsell);
    if (canEditPlans) variants.add((0, $aHo1U.JSW).permissions.hasPlanEditPermissions);
    if (isEligibleForKanbanTour || routeName !== 'software-boards') variants.add((0, $aHo1U.JSW).experience.kanbanOnboarding);
    if (isWizardSimplifyQS) variants.add((0, $aHo1U.JSW).experiment.wizard);
    if (canCreateProject === false) variants.add((0, $aHo1U.JSW).permissions.notCanCreateProject);
    if (projectState?.isNextGen) variants.add((0, $aHo1U.JSW).projectStyle.teamManaged);
    else variants.add((0, $aHo1U.JSW).projectStyle.companyManaged);
    if (projectState?.isProjectAdmin) variants.add((0, $aHo1U.JSW).userRole.projectAdmin);
    if (projectState?.userRole === (0, $ieqoN.USER_ROLE).JIRA_ADMIN) {
        variants.add((0, $aHo1U.JSW).userRole.jiraAdmin);
        variants.add((0, $aHo1U.JSW).userRole.admin);
    }
    if (projectState?.userRole === (0, $ieqoN.USER_ROLE).SITE_ADMIN) {
        variants.add((0, $aHo1U.JSW).userRole.siteAdmin);
        variants.add((0, $aHo1U.JSW).userRole.admin);
    }
    if (projectState?.edition === (0, $ldyPw.FREE_EDITION)) variants.add((0, $aHo1U.JSW).edition.free);
    else if (projectState?.edition === (0, $ldyPw.STANDARD_EDITION)) variants.add((0, $aHo1U.JSW).edition.standard);
    else if (projectState?.edition === (0, $ldyPw.PREMIUM_EDITION)) variants.add((0, $aHo1U.JSW).edition.premium);
    if ((0, $1ffS1.isRoadmapRoute)(routeName)) variants.add((0, $aHo1U.JSW).route.softwareRoadmap);
    else if (routeName === 'software-backlog') variants.add((0, $aHo1U.JSW).route.softwareBacklog);
    else if (routeName === 'software-boards') variants.add((0, $aHo1U.JSW).route.softwareBoard);
    else if (routeName === 'software-list' || routeName === 'software-list-classic') variants.add((0, $aHo1U.JSW).route.softwareList);
    else if (routeName === 'project-settings-software-access') variants.add((0, $aHo1U.JSW).route.projectSettingsSoftwareAccess);
    else if (routeName === 'issue') variants.add((0, $aHo1U.JSW).route.issue);
    else if ((routeName === 'software-calendar' || routeName === 'software-calendar-classic') && (0, $4R6GH.fg)('software_calendar_quickstart_onboarding')) variants.add((0, $aHo1U.JSW).route.softwareCalendar);
    if (isEligibleToUpdateSitename) variants.add((0, $aHo1U.JSW).experiment.customizeSiteName);
    return $cb6c1b1dc7b1b225$var$getTaskListItem({
        variants: Array.from(variants.values()),
        taskVariants: (0, $aHo1U.JSW).taskVariants,
        taskList: (0, $aHo1U.JSW).taskList,
        taskGroupParent: taskGroupParent
    });
};
const $cb6c1b1dc7b1b225$var$createJwmTasks = ({ projectState: projectState, taskGroupParent: taskGroupParent, taskList: taskList = (0, $5yUqp.JWM).taskList, teamType: teamType, isEligibleForTailoredOnboardingM2P5: isEligibleForTailoredOnboardingM2P5 })=>{
    const variants = [];
    variants.push((0, $5yUqp.JWM).experiments.projectTheming);
    if (isEligibleForTailoredOnboardingM2P5) return $cb6c1b1dc7b1b225$export$e21b96de210942({
        taskGroupParent: taskGroupParent,
        teamType: teamType
    });
    if (projectState?.isProjectAdmin) variants.push((0, $5yUqp.JWM).userRole.projectAdmin);
    if (projectState?.userRole === (0, $ieqoN.USER_ROLE).JIRA_ADMIN) variants.push((0, $5yUqp.JWM).userRole.jiraAdmin);
    if (projectState?.userRole === (0, $ieqoN.USER_ROLE).SITE_ADMIN) variants.push((0, $5yUqp.JWM).userRole.siteAdmin);
    if (projectState?.isSampleProject) variants.push((0, $5yUqp.JWM).experiments.isSampleProject);
    else variants.push((0, $5yUqp.JWM).experiments.isNotSampleProject);
    if (projectState?.isTrelloCrossflow) variants.push((0, $5yUqp.JWM).experiments.trelloCrossflow);
    return $cb6c1b1dc7b1b225$var$getTaskListItem({
        variants: variants,
        taskVariants: (0, $5yUqp.JWM).taskVariants,
        taskList: taskList,
        taskGroupParent: taskGroupParent
    });
};
const $cb6c1b1dc7b1b225$var$createJsmTasks = (projectState, taskGroupParent)=>{
    const variants = [];
    variants.push((0, $3Iaiu.JSM).experiments.projectTheming);
    if (projectState?.isProjectAdmin) variants.push((0, $3Iaiu.JSM).userRole.projectAdmin);
    if (projectState?.userRole === (0, $ieqoN.USER_ROLE).JIRA_ADMIN) variants.push((0, $3Iaiu.JSM).userRole.jiraAdmin);
    if (projectState?.userRole === (0, $ieqoN.USER_ROLE).SITE_ADMIN) variants.push((0, $3Iaiu.JSM).userRole.siteAdmin);
    return $cb6c1b1dc7b1b225$var$getTaskListItem({
        variants: variants,
        taskVariants: (0, $3Iaiu.JSM).taskVariants,
        taskList: (0, $3Iaiu.JSM).taskList,
        taskGroupParent: taskGroupParent
    });
};
const $cb6c1b1dc7b1b225$export$d9d83c8e96505820 = (taskGroupParent, teamType, features, isEligibleForTailoredOnboardingM3, isEligibleForTailoredOnboardingScrumAndSoftwareKanban)=>{
    const variants = [];
    if (features?.hasBacklog) variants.push((0, $pDX5d.Feature).hasBacklog);
    if (features?.hasSprint) variants.push((0, $pDX5d.Feature).hasSprint);
    if (isEligibleForTailoredOnboardingM3) variants.push((0, $8VfDj.Experiment).tailoredOnboardingM3Eligible);
    if (isEligibleForTailoredOnboardingScrumAndSoftwareKanban) variants.push((0, $8VfDj.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible);
    if (teamType && (0, $jtI3q.isTailoredOnboardingTeamType)(teamType)) variants.push(`teamType.${teamType}`);
    else variants.push('teamType.everythingElse');
    return $cb6c1b1dc7b1b225$var$getTaskListItem({
        variants: variants,
        taskVariants: (0, $d7Knl.TAILORED_ONBOARDING_WITH_SINGLE_CONFIG).taskVariants,
        taskList: (0, $d7Knl.TAILORED_ONBOARDING_WITH_SINGLE_CONFIG).taskList,
        taskGroupParent: taskGroupParent
    });
};
const $cb6c1b1dc7b1b225$export$e21b96de210942 = ({ taskGroupParent: taskGroupParent, teamType: teamType })=>{
    const variants = [];
    if (teamType && (0, $jtI3q.isTailoredOnboardingM2P5TailoredTeamType)(teamType)) variants.push(`teamType.${teamType}`);
    else variants.push('teamType.everythingElse');
    return $cb6c1b1dc7b1b225$var$getTaskListItem({
        variants: variants,
        taskVariants: (0, $d7Knl.TAILORED_ONBOARDING_M2P5).getM2P5TaskVariants(teamType ?? 'everythingElse'),
        taskList: (0, $d7Knl.TAILORED_ONBOARDING_M2P5).taskList,
        taskGroupParent: taskGroupParent
    });
};
const $cb6c1b1dc7b1b225$export$d1f442602a91e7cc = ({ projectState: projectState, taskGroupParent: taskGroupParent, routeName: routeName, shouldShowScrumOnboardingExperience: shouldShowScrumOnboardingExperience, mountedNudges: mountedNudges, canCreateProject: canCreateProject, isEligibleToUpdateSitename: isEligibleToUpdateSitename, isCrossProjectBoardToPlanUpsell: isCrossProjectBoardToPlanUpsell, isWizardSimplifyQS: isWizardSimplifyQS = false, canEditPlans: canEditPlans, premiumTrialOnSignup: premiumTrialOnSignup, taskList: taskList, teamType: teamType, isEligibleForTailoredOnboardingM2P5: isEligibleForTailoredOnboardingM2P5, isEligibleForTailoredOnboardingM3: isEligibleForTailoredOnboardingM3, isEligibleForTailoredOnboardingScrumAndSoftwareKanban: isEligibleForTailoredOnboardingScrumAndSoftwareKanban, features: features })=>{
    if ((0, $jJca1.isJwmProject)(projectState)) return $cb6c1b1dc7b1b225$var$createJwmTasks({
        projectState: projectState,
        taskGroupParent: taskGroupParent,
        taskList: taskList,
        teamType: teamType,
        isEligibleForTailoredOnboardingM2P5: isEligibleForTailoredOnboardingM2P5
    });
    if ((0, $jJca1.isJsmProject)(projectState)) return $cb6c1b1dc7b1b225$var$createJsmTasks(projectState, taskGroupParent);
    // We cannot do these in the config itself as we need to fallback to createJswTasks for other users
    // And unlike previous QS experiments, we want to change the entire QS for these users so a new config makes sense over variants to the existing JSW one
    if (isEligibleForTailoredOnboardingM3 || isEligibleForTailoredOnboardingScrumAndSoftwareKanban) return $cb6c1b1dc7b1b225$export$d9d83c8e96505820(taskGroupParent, teamType, features, isEligibleForTailoredOnboardingM3, isEligibleForTailoredOnboardingScrumAndSoftwareKanban);
    return $cb6c1b1dc7b1b225$var$createJswTasks(projectState, taskGroupParent, routeName, shouldShowScrumOnboardingExperience, mountedNudges, canCreateProject, isEligibleToUpdateSitename, isCrossProjectBoardToPlanUpsell, isWizardSimplifyQS, canEditPlans, premiumTrialOnSignup);
};

});
parcelRegister("jtI3q", function(module, exports) {

$parcel$export(module.exports, "isTailoredOnboardingTeamType", () => $606262a699c9299e$export$b924c0b3ec4d268e);
$parcel$export(module.exports, "isTailoredOnboardingM2P5TailoredTeamType", () => $606262a699c9299e$export$26c385918d734203);

var $370Ye = parcelRequire("370Ye");
const $606262a699c9299e$export$b924c0b3ec4d268e = (teamType)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $370Ye.tailoredTeamTypes).includes(teamType);
};
const $606262a699c9299e$export$26c385918d734203 = (teamType)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $370Ye.tailoredM2P5TeamTypes).includes(teamType);
};

});
parcelRegister("370Ye", function(module, exports) {

$parcel$export(module.exports, "tailoredTeamTypes", () => $06c84b7af2a23aee$export$a1fbb7d965e15a39);
$parcel$export(module.exports, "tailoredM2P5TeamTypes", () => $06c84b7af2a23aee$export$52c5394d6e6cfcf3);

const $06c84b7af2a23aee$export$a1fbb7d965e15a39 = [
    (0, $6784cbc7d62e5d7c$export$e5c438b7501b5a24),
    (0, $6784cbc7d62e5d7c$export$d7de553940261eba),
    (0, $6784cbc7d62e5d7c$export$e4824f74b9879164),
    (0, $6784cbc7d62e5d7c$export$4f3cb0844009af52),
    (0, $6784cbc7d62e5d7c$export$cbc0e551d91a692d),
    (0, $6784cbc7d62e5d7c$export$4f54a09a24fd1d74),
    (0, $6784cbc7d62e5d7c$export$79685802e8ff1098),
    (0, $6784cbc7d62e5d7c$export$b8b1ac856ba1434b)
];
const $06c84b7af2a23aee$export$52c5394d6e6cfcf3 = [
    (0, $6784cbc7d62e5d7c$export$e5c438b7501b5a24),
    (0, $6784cbc7d62e5d7c$export$d7de553940261eba),
    (0, $6784cbc7d62e5d7c$export$cbc0e551d91a692d),
    (0, $6784cbc7d62e5d7c$export$4f54a09a24fd1d74),
    (0, $6784cbc7d62e5d7c$export$79685802e8ff1098),
    (0, $6784cbc7d62e5d7c$export$b8b1ac856ba1434b)
];

});


parcelRegister("1ffS1", function(module, exports) {

$parcel$export(module.exports, "isRoadmapRoute", () => $ee93e5dd18635f6d$export$d1fa67c1ffb68871);
const $ee93e5dd18635f6d$export$d1fa67c1ffb68871 = (routeName)=>{
    if (routeName === undefined) return false;
    return routeName === 'software-timeline' || routeName === 'software-timeline-classic';
};

});

parcelRegister("ieqoN", function(module, exports) {

$parcel$export(module.exports, "USER_ROLE", () => $353950c3dd35bbc6$export$8eeb199b23203523);
const $353950c3dd35bbc6$export$8eeb199b23203523 = {
    END_USER: 'end-user',
    SITE_ADMIN: 'site-admin',
    JIRA_ADMIN: 'jira-admin'
};

});

parcelRegister("3Iaiu", function(module, exports) {

$parcel$export(module.exports, "JSM", () => $56a077523ddf70fb$export$63f289f2da861d35);

var $58IQc = parcelRequire("58IQc");
const $56a077523ddf70fb$export$63f289f2da861d35 = {
    taskList: (0, $58IQc.JSM_TASK_LIST),
    taskVariants: (0, $58IQc.JSM_TASK_VARIANTS),
    userRole: (0, $58IQc.UserRole),
    experiments: (0, $58IQc.Experiments)
};

});
parcelRegister("58IQc", function(module, exports) {

$parcel$export(module.exports, "JSM_TASK_LIST", () => $3c13225c81ad4b5c$export$6c6c561944d49bcb);
$parcel$export(module.exports, "Experiments", () => $3c13225c81ad4b5c$export$c8d6ffd15214553a);
$parcel$export(module.exports, "UserRole", () => $3c13225c81ad4b5c$export$eb3485a690c2f0b8);
$parcel$export(module.exports, "JSM_TASK_VARIANTS", () => $3c13225c81ad4b5c$export$5b68aef408c932d9);

var $8Bc5A = parcelRequire("8Bc5A");

var $kTSRm = parcelRequire("kTSRm");
const $3c13225c81ad4b5c$export$6c6c561944d49bcb = Object.freeze({
    root: {
        title: (0, $kTSRm.messages).rootTitle,
        items: [
            (0, $8Bc5A.JSM_REVIEW_YOUR_CHANNELS_TASK),
            (0, $8Bc5A.JSM_CUSTOMIZE_YOUR_REQUEST_TYPES_TASK),
            (0, $8Bc5A.JSM_INVITE_YOUR_TEAM_TASK)
        ]
    }
});
const $3c13225c81ad4b5c$export$c8d6ffd15214553a = {
    projectTheming: 'projectTheming'
};
const $3c13225c81ad4b5c$export$eb3485a690c2f0b8 = {
    projectAdmin: 'projectAdmin',
    jiraAdmin: 'jiraAdmin',
    siteAdmin: 'siteAdmin'
};
const $3c13225c81ad4b5c$export$5b68aef408c932d9 = {
    [(0, $8Bc5A.JSM_REVIEW_YOUR_CHANNELS_TASK)]: {
        position: {
            default: 0
        },
        visibility: {
            default: true
        }
    },
    [(0, $8Bc5A.JSM_CUSTOMIZE_YOUR_REQUEST_TYPES_TASK)]: {
        position: {
            default: 1
        },
        visibility: {
            default: true
        }
    },
    [(0, $8Bc5A.JSM_INVITE_YOUR_TEAM_TASK)]: {
        position: {
            default: 2
        },
        visibility: {
            default: true
        }
    }
};

});
parcelRegister("kTSRm", function(module, exports) {

$parcel$export(module.exports, "messages", () => $f1f6142c4170f38e$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $f1f6142c4170f38e$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    rootTitle: {
        "id": "software-onboarding-quickstart.services.tasks.config.jsm.root-title.no-translate",
        "defaultMessage": "Quickstart"
    }
});

});



parcelRegister("aHo1U", function(module, exports) {

$parcel$export(module.exports, "JSW", () => $563027753d017a60$export$4cfe6e52f2e72a54);

var $8VfDj = parcelRequire("8VfDj");
const $563027753d017a60$export$4cfe6e52f2e72a54 = {
    taskList: (0, $8VfDj.TASK_LIST),
    taskVariants: (0, $8VfDj.TASK_VARIANTS),
    experiment: (0, $8VfDj.Experiment),
    experience: (0, $8VfDj.Experience),
    projectStyle: (0, $8VfDj.ProjectStyle),
    userRole: (0, $8VfDj.UserRole),
    edition: (0, $8VfDj.Edition),
    route: (0, $8VfDj.Route),
    permissions: (0, $8VfDj.Permissions),
    trait: (0, $8VfDj.Trait)
};

});
parcelRegister("8VfDj", function(module, exports) {

$parcel$export(module.exports, "Experiment", () => $ea3903bb15047c3b$export$4e0ab25c8a7e4009);
$parcel$export(module.exports, "Experience", () => $ea3903bb15047c3b$export$c90b54e658fc4d7c);
$parcel$export(module.exports, "ProjectStyle", () => $ea3903bb15047c3b$export$1f66f9f05afa05a8);
$parcel$export(module.exports, "UserRole", () => $ea3903bb15047c3b$export$eb3485a690c2f0b8);
$parcel$export(module.exports, "Edition", () => $ea3903bb15047c3b$export$6f4a0f769e61929);
$parcel$export(module.exports, "Route", () => $ea3903bb15047c3b$export$e7b0ac011bb776c6);
$parcel$export(module.exports, "Permissions", () => $ea3903bb15047c3b$export$2d41982586bbb6be);
$parcel$export(module.exports, "Trait", () => $ea3903bb15047c3b$export$2d08cfa40d69142e);
$parcel$export(module.exports, "TASK_LIST", () => $ea3903bb15047c3b$export$601c8c0f45aeb0a0);
$parcel$export(module.exports, "TASK_VARIANTS", () => $ea3903bb15047c3b$export$36f4d47dfe11b613);

var $8Bc5A = parcelRequire("8Bc5A");

var $ciLFO = parcelRequire("ciLFO");
const $ea3903bb15047c3b$export$4e0ab25c8a7e4009 = {
    scrumOnboarding: 'experiment.scrumOnboarding',
    customizeSiteName: 'experiment.customizeSiteName',
    jswReverseTrial: 'experiment.jswReverseTrial',
    rtQuickstartM1: 'experiment.rtQuickstartM1',
    wizard: 'experiment.wizard',
    tailoredOnboardingM3Eligible: 'experiment.tailoredOnboardingM3Eligible',
    tailoredOnboardingScrumAndSoftwareKanbanEligible: 'experiment.tailoredOnboardingScrumAndSoftwareKanbanEligible'
};
const $ea3903bb15047c3b$export$c90b54e658fc4d7c = {
    kanbanOnboarding: 'experience.kanbanOnboarding',
    fedRamp: 'experience.fedRamp'
};
const $ea3903bb15047c3b$export$1f66f9f05afa05a8 = {
    teamManaged: 'projectStyle.teamManaged',
    companyManaged: 'projectStyle.companyManaged'
};
const $ea3903bb15047c3b$export$eb3485a690c2f0b8 = {
    siteAdmin: 'userRole.siteAdmin',
    jiraAdmin: 'userRole.jiraAdmin',
    admin: 'userRole.admin',
    projectAdmin: 'userRole.projectAdmin'
};
const $ea3903bb15047c3b$export$6f4a0f769e61929 = {
    free: 'productEdition.free',
    standard: 'productEdition.standard',
    premium: 'productEdition.premium'
};
const $ea3903bb15047c3b$export$e7b0ac011bb776c6 = {
    softwareRoadmap: 'route.softwareRoadmap',
    softwareBacklog: 'route.softwareBacklog',
    softwareBoard: 'route.softwareBoard',
    softwareList: 'route.softwareList',
    projectSettingsSoftwareAccess: 'route.projectSettingsSoftwareAccess',
    issue: 'route.issue',
    softwareCalendar: 'route.softwareCalendar'
};
const $ea3903bb15047c3b$export$2d41982586bbb6be = {
    notCanCreateProject: 'permissions.notCanCreateProject',
    hasPlanEditPermissions: 'permissions.hasPlanEditPermissions'
};
const $ea3903bb15047c3b$export$2d08cfa40d69142e = {
    crossProjectBoardToPlanUpsell: 'trait.crossProjectBoardToPlanUpsell'
};
const $ea3903bb15047c3b$var$DEFAULT_TASK_LIST = [
    (0, $8Bc5A.ADD_COLUMNS_TASK),
    (0, $8Bc5A.CREATE_PROJECT_TASK),
    (0, $8Bc5A.CREATE_ISSUE_TASK),
    (0, $8Bc5A.CREATE_ISSUE_TASK_SIMPLIFIED),
    (0, $8Bc5A.TRY_ATLASSIAN_UNIVERSITY_ONBOARDING_TASK),
    (0, $8Bc5A.INVITE_TEAMMATES_TASK),
    (0, $8Bc5A.INVITE_TEAMMATES_VIDEO_TASK),
    (0, $8Bc5A.CAPTURE_INTEGRATIONS_TASK),
    (0, $8Bc5A.FIND_HELP_TASK),
    (0, $8Bc5A.SET_UP_BOARD_TASK),
    (0, $8Bc5A.GET_MOBILE_APP_TASK),
    (0, $8Bc5A.PREMIUM_REVERSE_TRIAL_TASK),
    (0, $8Bc5A.PREMIUM_EDITION_OVERVIEW_TASK),
    (0, $8Bc5A.PREMIUM_EDITION_OVERVIEW_TASK_NON_ADMIN),
    (0, $8Bc5A.STANDARD_EDITION_OVERVIEW_TASK),
    (0, $8Bc5A.MAP_OUT_YOUR_PROJECT_GOALS_TASK),
    (0, $8Bc5A.IDENTIFY_SMALL_CHUNKS_OF_WORK_TASK),
    (0, $8Bc5A.MONITOR_MANAGE_RISK_TASK),
    (0, $8Bc5A.SCRUM_ONBOARDING_TASK),
    (0, $8Bc5A.CUSTOMIZE_SITE_NAME_TASK),
    (0, $8Bc5A.CREATE_BUSINESS_PROJECT_FROM_JSW_QUICKSTART_TASK),
    (0, $8Bc5A.GET_STARTED_LIST_TASK),
    (0, $8Bc5A.CALENDAR_VIEW_TASK)
];
const $ea3903bb15047c3b$export$601c8c0f45aeb0a0 = Object.freeze({
    root: {
        title: (0, $ciLFO.messages).rootTitle,
        items: $ea3903bb15047c3b$var$DEFAULT_TASK_LIST
    },
    reverseTrialRoot: {
        title: (0, $ciLFO.messages).reverseTrialRootTitle,
        items: $ea3903bb15047c3b$var$DEFAULT_TASK_LIST
    },
    [(0, $8Bc5A.PREMIUM_REVERSE_TRIAL_TASK)]: {
        title: (0, $ciLFO.messages).reverseTrialCardTitle,
        items: [
            (0, $8Bc5A.ADVANCED_ROADMAPS_TASK),
            (0, $8Bc5A.CHANGE_CONTROL_TASK),
            (0, $8Bc5A.AUTOMATIONS_TASK),
            (0, $8Bc5A.SITE_ADMINISTRATIONS_TASK),
            (0, $8Bc5A.USER_MANAGEMENT_TASK)
        ]
    },
    [(0, $8Bc5A.PREMIUM_EDITION_OVERVIEW_TASK)]: {
        title: (0, $ciLFO.messages).premiumPlanTitle,
        items: [
            (0, $8Bc5A.ADVANCED_ROADMAPS_TASK),
            (0, $8Bc5A.CHANGE_CONTROL_TASK),
            (0, $8Bc5A.AUTOMATIONS_TASK),
            (0, $8Bc5A.SITE_ADMINISTRATIONS_TASK),
            (0, $8Bc5A.USER_MANAGEMENT_TASK)
        ]
    },
    [(0, $8Bc5A.PREMIUM_EDITION_OVERVIEW_TASK_NON_ADMIN)]: {
        title: (0, $ciLFO.messages).premiumPlanTitle,
        items: [
            (0, $8Bc5A.ADVANCED_ROADMAPS_TASK),
            (0, $8Bc5A.AUTOMATIONS_TASK)
        ]
    },
    [(0, $8Bc5A.STANDARD_EDITION_OVERVIEW_TASK)]: {
        title: (0, $ciLFO.messages).standardPlanTitle,
        items: [
            (0, $8Bc5A.AUTOMATIONS_TASK),
            (0, $8Bc5A.USER_MANAGEMENT_TASK),
            (0, $8Bc5A.SITE_ADMINISTRATIONS_TASK)
        ]
    }
});
const $ea3903bb15047c3b$var$PLAN_ONBOARDING_TASKS = {
    [(0, $8Bc5A.PREMIUM_REVERSE_TRIAL_TASK)]: {
        position: {
            default: 900
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$4e0ab25c8a7e4009.rtQuickstartM1,
                        $ea3903bb15047c3b$export$6f4a0f769e61929.premium
                    ],
                    value: false
                },
                {
                    condition: [
                        $ea3903bb15047c3b$export$4e0ab25c8a7e4009.jswReverseTrial,
                        $ea3903bb15047c3b$export$6f4a0f769e61929.premium
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.PREMIUM_EDITION_OVERVIEW_TASK)]: {
        position: {
            default: 900
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$4e0ab25c8a7e4009.jswReverseTrial,
                        $ea3903bb15047c3b$export$6f4a0f769e61929.premium,
                        $ea3903bb15047c3b$export$eb3485a690c2f0b8.admin
                    ],
                    value: false
                },
                {
                    condition: [
                        $ea3903bb15047c3b$export$6f4a0f769e61929.premium,
                        $ea3903bb15047c3b$export$eb3485a690c2f0b8.admin
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.PREMIUM_EDITION_OVERVIEW_TASK_NON_ADMIN)]: {
        position: {
            default: 900
        },
        visibility: {
            default: false,
            conditional: [
                {
                    // This condition needs to be the opposite condition to PREMIUM_EDITION_OVERVIEW_TASK
                    condition: [
                        $ea3903bb15047c3b$export$6f4a0f769e61929.premium,
                        $ea3903bb15047c3b$export$eb3485a690c2f0b8.admin
                    ],
                    value: false
                },
                {
                    condition: [
                        $ea3903bb15047c3b$export$4e0ab25c8a7e4009.jswReverseTrial,
                        $ea3903bb15047c3b$export$6f4a0f769e61929.premium
                    ],
                    value: false
                },
                {
                    condition: [
                        $ea3903bb15047c3b$export$6f4a0f769e61929.premium
                    ],
                    value: true
                },
                {
                    condition: [
                        $ea3903bb15047c3b$export$2d08cfa40d69142e.crossProjectBoardToPlanUpsell,
                        $ea3903bb15047c3b$export$2d41982586bbb6be.hasPlanEditPermissions
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.STANDARD_EDITION_OVERVIEW_TASK)]: {
        position: {
            default: 900
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$6f4a0f769e61929.standard,
                        $ea3903bb15047c3b$export$eb3485a690c2f0b8.admin
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.ADVANCED_ROADMAPS_TASK)]: {
        position: {
            default: 105
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$2d08cfa40d69142e.crossProjectBoardToPlanUpsell,
                        $ea3903bb15047c3b$export$2d41982586bbb6be.hasPlanEditPermissions
                    ],
                    value: true
                },
                {
                    condition: [
                        $ea3903bb15047c3b$export$6f4a0f769e61929.premium
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.AUTOMATIONS_TASK)]: {
        position: {
            default: 110
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$2d08cfa40d69142e.crossProjectBoardToPlanUpsell,
                        $ea3903bb15047c3b$export$2d41982586bbb6be.hasPlanEditPermissions
                    ],
                    value: true
                },
                {
                    condition: [
                        $ea3903bb15047c3b$export$6f4a0f769e61929.premium,
                        $ea3903bb15047c3b$export$eb3485a690c2f0b8.admin
                    ],
                    value: true
                },
                {
                    condition: [
                        $ea3903bb15047c3b$export$6f4a0f769e61929.standard,
                        $ea3903bb15047c3b$export$eb3485a690c2f0b8.admin
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.USER_MANAGEMENT_TASK)]: {
        position: {
            default: 115
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$6f4a0f769e61929.premium,
                        $ea3903bb15047c3b$export$eb3485a690c2f0b8.admin
                    ],
                    value: true
                },
                {
                    condition: [
                        $ea3903bb15047c3b$export$6f4a0f769e61929.standard,
                        $ea3903bb15047c3b$export$eb3485a690c2f0b8.admin
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.CHANGE_CONTROL_TASK)]: {
        position: {
            default: 120
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$6f4a0f769e61929.premium,
                        $ea3903bb15047c3b$export$eb3485a690c2f0b8.siteAdmin
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.SITE_ADMINISTRATIONS_TASK)]: {
        position: {
            default: 125
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$6f4a0f769e61929.premium,
                        $ea3903bb15047c3b$export$eb3485a690c2f0b8.siteAdmin
                    ],
                    value: true
                },
                {
                    condition: [
                        $ea3903bb15047c3b$export$6f4a0f769e61929.standard,
                        $ea3903bb15047c3b$export$eb3485a690c2f0b8.siteAdmin
                    ],
                    value: true
                }
            ]
        }
    }
};
const $ea3903bb15047c3b$export$36f4d47dfe11b613 = {
    ...$ea3903bb15047c3b$var$PLAN_ONBOARDING_TASKS,
    [(0, $8Bc5A.CREATE_PROJECT_TASK)]: {
        position: {
            default: 0
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$2d41982586bbb6be.notCanCreateProject
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $8Bc5A.CUSTOMIZE_SITE_NAME_TASK)]: {
        position: {
            default: 50
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$eb3485a690c2f0b8.siteAdmin,
                        $ea3903bb15047c3b$export$4e0ab25c8a7e4009.customizeSiteName
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.CALENDAR_VIEW_TASK)]: {
        position: {
            default: 100
        },
        visibility: {
            default: false,
            conditional: [
                {
                    value: true,
                    condition: [
                        $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareCalendar
                    ]
                }
            ]
        }
    },
    [(0, $8Bc5A.SCRUM_ONBOARDING_TASK)]: {
        position: {
            default: 150
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$eb3485a690c2f0b8.siteAdmin,
                        $ea3903bb15047c3b$export$4e0ab25c8a7e4009.scrumOnboarding,
                        $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareBacklog
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.MAP_OUT_YOUR_PROJECT_GOALS_TASK)]: {
        position: {
            default: 150
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareRoadmap
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.IDENTIFY_SMALL_CHUNKS_OF_WORK_TASK)]: {
        position: {
            default: 151
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareRoadmap
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.MONITOR_MANAGE_RISK_TASK)]: {
        position: {
            default: 152
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareRoadmap
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.SET_UP_BOARD_TASK)]: {
        position: {
            default: 200
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$c90b54e658fc4d7c.kanbanOnboarding,
                        $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareBoard
                    ],
                    value: false
                },
                {
                    condition: [
                        $ea3903bb15047c3b$export$c90b54e658fc4d7c.kanbanOnboarding
                    ],
                    value: false
                },
                {
                    condition: [
                        $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareList
                    ],
                    value: false
                },
                {
                    condition: [
                        $ea3903bb15047c3b$export$eb3485a690c2f0b8.projectAdmin,
                        $ea3903bb15047c3b$export$1f66f9f05afa05a8.teamManaged
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.CREATE_ISSUE_TASK)]: {
        position: {
            default: 300
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$c90b54e658fc4d7c.kanbanOnboarding,
                        $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareBoard
                    ],
                    value: false
                },
                {
                    condition: [
                        $ea3903bb15047c3b$export$4e0ab25c8a7e4009.wizard,
                        $ea3903bb15047c3b$export$eb3485a690c2f0b8.admin,
                        $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareList
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $8Bc5A.CREATE_ISSUE_TASK_SIMPLIFIED)]: {
        position: {
            default: 300
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$c90b54e658fc4d7c.kanbanOnboarding,
                        $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareBoard
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.ADD_COLUMNS_TASK)]: {
        position: {
            default: 310
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$c90b54e658fc4d7c.kanbanOnboarding,
                        $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareBoard
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.GET_STARTED_LIST_TASK)]: {
        position: {
            default: 320
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareList
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TRY_ATLASSIAN_UNIVERSITY_ONBOARDING_TASK)]: {
        position: {
            default: 350
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$c90b54e658fc4d7c.kanbanOnboarding,
                        $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareBoard
                    ],
                    value: false
                },
                {
                    condition: [
                        $ea3903bb15047c3b$export$4e0ab25c8a7e4009.wizard,
                        $ea3903bb15047c3b$export$eb3485a690c2f0b8.admin,
                        $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareList
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $8Bc5A.INVITE_TEAMMATES_TASK)]: {
        position: {
            default: 400
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$eb3485a690c2f0b8.projectAdmin,
                        $ea3903bb15047c3b$export$1f66f9f05afa05a8.teamManaged
                    ],
                    value: false
                },
                {
                    condition: [
                        $ea3903bb15047c3b$export$eb3485a690c2f0b8.admin,
                        $ea3903bb15047c3b$export$1f66f9f05afa05a8.teamManaged
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $8Bc5A.INVITE_TEAMMATES_VIDEO_TASK)]: {
        position: {
            default: 400,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$c90b54e658fc4d7c.kanbanOnboarding,
                        $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareBoard
                    ],
                    value: 600
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$eb3485a690c2f0b8.projectAdmin,
                        $ea3903bb15047c3b$export$1f66f9f05afa05a8.teamManaged
                    ],
                    value: true
                },
                {
                    condition: [
                        $ea3903bb15047c3b$export$eb3485a690c2f0b8.admin,
                        $ea3903bb15047c3b$export$1f66f9f05afa05a8.teamManaged
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.CAPTURE_INTEGRATIONS_TASK)]: {
        position: {
            default: 500
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$c90b54e658fc4d7c.fedRamp
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $8Bc5A.GET_MOBILE_APP_TASK)]: {
        position: {
            default: 600
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$c90b54e658fc4d7c.fedRamp
                    ],
                    value: false
                },
                {
                    condition: [
                        $ea3903bb15047c3b$export$c90b54e658fc4d7c.kanbanOnboarding,
                        $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareBoard
                    ],
                    value: false
                },
                {
                    condition: [
                        $ea3903bb15047c3b$export$4e0ab25c8a7e4009.wizard,
                        $ea3903bb15047c3b$export$eb3485a690c2f0b8.admin,
                        $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareList
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $8Bc5A.FIND_HELP_TASK)]: {
        position: {
            default: 700
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$c90b54e658fc4d7c.kanbanOnboarding,
                        $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareBoard
                    ],
                    value: false
                },
                {
                    condition: [
                        $ea3903bb15047c3b$export$4e0ab25c8a7e4009.wizard,
                        $ea3903bb15047c3b$export$eb3485a690c2f0b8.admin,
                        $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareList
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $8Bc5A.CREATE_BUSINESS_PROJECT_FROM_JSW_QUICKSTART_TASK)]: {
        position: {
            default: 800
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$2d41982586bbb6be.notCanCreateProject
                    ],
                    value: false
                },
                {
                    condition: [
                        $ea3903bb15047c3b$export$c90b54e658fc4d7c.kanbanOnboarding,
                        $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareBoard
                    ],
                    value: false
                },
                {
                    condition: [
                        $ea3903bb15047c3b$export$4e0ab25c8a7e4009.wizard,
                        $ea3903bb15047c3b$export$eb3485a690c2f0b8.admin,
                        $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareList
                    ],
                    value: false
                }
            ]
        }
    }
};

});
parcelRegister("ciLFO", function(module, exports) {

$parcel$export(module.exports, "messages", () => $609e253829546460$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $609e253829546460$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    rootTitle: {
        "id": "software-onboarding-quickstart.services.tasks.config.jsw.root-title.no-translate",
        "defaultMessage": "Quickstart"
    },
    premiumPlanTitle: {
        "id": "onboarding-quickstart-core.services.tasks.config.jsw.premium-plan-title",
        "defaultMessage": "Included in your Premium plan"
    },
    standardPlanTitle: {
        "id": "onboarding-quickstart-core.services.tasks.config.jsw.standard-plan-title",
        "defaultMessage": "Your Standard plan"
    },
    reverseTrialRootTitle: {
        "id": "onboarding-quickstart-core.services.tasks.config.jsw.reverse-trial-root-title",
        "defaultMessage": "Your 30-day Premium trial"
    },
    reverseTrialCardTitle: {
        "id": "onboarding-quickstart-core.services.tasks.config.jsw.reverse-trial-card-title",
        "defaultMessage": "Included in your Premium trial"
    }
});

});



parcelRegister("5yUqp", function(module, exports) {

$parcel$export(module.exports, "JWM", () => $80382801c7786de6$export$3ff26c80cb588e12);

var $82B5j = parcelRequire("82B5j");

var $8jC8d = parcelRequire("8jC8d");

var $5PFhq = parcelRequire("5PFhq");
const $80382801c7786de6$export$3ff26c80cb588e12 = {
    taskList: (0, $82B5j.TASK_LIST),
    taskVariants: (0, $82B5j.TASK_VARIANTS),
    userRole: (0, $5PFhq.UserRole),
    experiments: (0, $8jC8d.Experiments)
};

});
parcelRegister("82B5j", function(module, exports) {

$parcel$export(module.exports, "TASK_LIST", () => $3b1179694682c8c8$export$601c8c0f45aeb0a0);
$parcel$export(module.exports, "TASK_VARIANTS", () => $3b1179694682c8c8$export$36f4d47dfe11b613);

var $8Bc5A = parcelRequire("8Bc5A");

var $8jC8d = parcelRequire("8jC8d");

var $aQMWP = parcelRequire("aQMWP");

var $5PFhq = parcelRequire("5PFhq");
const $3b1179694682c8c8$export$601c8c0f45aeb0a0 = Object.freeze({
    root: {
        title: (0, $aQMWP.messages).rootTitle,
        items: [
            (0, $8Bc5A.JWM_CREATE_PROJECT_TASK),
            (0, $8Bc5A.JWM_TRELLO_CROSSFLOW_TASK_IMPORT),
            (0, $8Bc5A.JWM_SUMMARY_AND_REPORTS_TASK),
            (0, $8Bc5A.JWM_TRELLO_CROSSFLOW_CALENDAR_AND_TIMELINE_TASK),
            (0, $8Bc5A.JWM_TRELLO_CROSSFLOW_TASK_KEY_DIFFERENCES),
            (0, $8Bc5A.JWM_CREATE_SAMPLE_PROJECT_TASK),
            (0, $8Bc5A.JWM_PROJECT_SUMMARY_TASK),
            (0, $8Bc5A.GET_STARTED_LIST_TASK),
            (0, $8Bc5A.JWM_CALENDAR_TASK),
            (0, $8Bc5A.JWM_TIMELINE_TASK),
            (0, $8Bc5A.JWM_BUILD_FORM_TASK),
            (0, $8Bc5A.JWM_BACKGROUND_COLOR_TASK),
            (0, $8Bc5A.JWM_FEEDBACK_TASK),
            (0, $8Bc5A.JWM_FEEDBACK_SAMPLE_PROJECT_TASK),
            (0, $8Bc5A.JWM_SHARE_PROJECT_TASK),
            (0, $8Bc5A.JWM_CREATE_YOUR_OWN_PROJECT_TASK)
        ]
    }
});
const $3b1179694682c8c8$var$OPS_TAILORED_ONBOARDING_TASK_VARIANTS = {
    [(0, $8Bc5A.OPS_JTBD_3_LIST)]: {
        position: {
            default: 100
        }
    },
    [(0, $8Bc5A.OPS_JTBD_3_CALENDAR)]: {
        position: {
            default: 200
        }
    },
    [(0, $8Bc5A.OPS_JTBD_3_PAGES)]: {
        position: {
            default: 300
        }
    },
    [(0, $8Bc5A.OPS_JTBD_4_LIST)]: {
        position: {
            default: 400
        }
    },
    [(0, $8Bc5A.OPS_JTBD_4_CALENDAR)]: {
        position: {
            default: 500
        }
    },
    [(0, $8Bc5A.OPS_JTBD_4_TIMELINE)]: {
        position: {
            default: 600
        }
    },
    [(0, $8Bc5A.OPS_JTBD_4_SUMMARY)]: {
        position: {
            default: 700
        }
    },
    [(0, $8Bc5A.OPS_JTBD_5_LIST)]: {
        position: {
            default: 800
        }
    },
    [(0, $8Bc5A.OPS_JTBD_5_TIMELINE)]: {
        position: {
            default: 900
        }
    },
    [(0, $8Bc5A.OPS_JTBD_5_PAGES)]: {
        position: {
            default: 1000
        }
    },
    [(0, $8Bc5A.OPS_JTBD_7_LIST)]: {
        position: {
            default: 1100
        }
    },
    [(0, $8Bc5A.OPS_JTBD_7_CALENDAR)]: {
        position: {
            default: 1200
        }
    },
    [(0, $8Bc5A.OPS_JTBD_2_BOARD)]: {
        position: {
            default: 1300
        }
    },
    [(0, $8Bc5A.OPS_JTBD_2_FORMS)]: {
        position: {
            default: 1400
        }
    },
    [(0, $8Bc5A.OPS_JTBD_2_SUMMARY)]: {
        position: {
            default: 1500
        }
    },
    [(0, $8Bc5A.OPS_JTBD_1_LIST)]: {
        position: {
            default: 1600
        }
    },
    [(0, $8Bc5A.OPS_JTBD_6_PAGES)]: {
        position: {
            default: 1700
        }
    },
    [(0, $8Bc5A.OPS_JTBD_0_LIST)]: {
        position: {
            default: 1800
        }
    },
    [(0, $8Bc5A.OPS_JTBD_0_TIMELINE)]: {
        position: {
            default: 1900
        }
    },
    [(0, $8Bc5A.OPS_JTBD_0_PAGES)]: {
        position: {
            default: 2000
        }
    },
    [(0, $8Bc5A.OPS_JTBD_DEFAULT_LIST)]: {
        position: {
            default: 2100
        }
    },
    [(0, $8Bc5A.OPS_JTBD_DEFAULT_BOARD)]: {
        position: {
            default: 2200
        }
    },
    [(0, $8Bc5A.OPS_JTBD_DEFAULT_INVITES)]: {
        position: {
            default: 2300
        }
    }
};
const $3b1179694682c8c8$var$MKT_TAILORED_ONBOARDING_TASK_VARIANTS = {
    [(0, $8Bc5A.MKT_JTBD_1_LIST)]: {
        position: {
            default: 100
        }
    },
    [(0, $8Bc5A.MKT_JTBD_1_CALENDAR)]: {
        position: {
            default: 200
        }
    },
    [(0, $8Bc5A.MKT_JTBD_1_TIMELINE)]: {
        position: {
            default: 300
        }
    },
    [(0, $8Bc5A.MKT_JTBD_2_CALENDAR)]: {
        position: {
            default: 400
        }
    },
    [(0, $8Bc5A.MKT_JTBD_2_PAGES)]: {
        position: {
            default: 500
        }
    },
    [(0, $8Bc5A.MKT_JTBD_3_PAGES)]: {
        position: {
            default: 600
        }
    },
    [(0, $8Bc5A.MKT_JTBD_3_TIMELINE)]: {
        position: {
            default: 700
        }
    },
    [(0, $8Bc5A.MKT_JTBD_4_LIST)]: {
        position: {
            default: 800
        }
    },
    [(0, $8Bc5A.MKT_JTBD_4_SUMMARY)]: {
        position: {
            default: 900
        }
    },
    [(0, $8Bc5A.MKT_JTBD_4_PAGES)]: {
        position: {
            default: 1000
        }
    },
    [(0, $8Bc5A.MKT_JTBD_5_TIMELINE)]: {
        position: {
            default: 1100
        }
    },
    [(0, $8Bc5A.MKT_JTBD_5_SUMMARY)]: {
        position: {
            default: 1200
        }
    },
    [(0, $8Bc5A.MKT_JTBD_6_FORMS)]: {
        position: {
            default: 1300
        }
    },
    [(0, $8Bc5A.MKT_JTBD_0_LIST)]: {
        position: {
            default: 1400
        }
    },
    [(0, $8Bc5A.MKT_JTBD_0_CALENDAR)]: {
        position: {
            default: 1500
        }
    },
    [(0, $8Bc5A.MKT_JTBD_0_TIMELINE)]: {
        position: {
            default: 1600
        }
    },
    [(0, $8Bc5A.MKT_JTBD_0_SUMMARY)]: {
        position: {
            default: 1700
        }
    },
    [(0, $8Bc5A.MKT_JTBD_DEFAULT_LIST)]: {
        position: {
            default: 1800
        }
    },
    [(0, $8Bc5A.MKT_JTBD_DEFAULT_BOARD)]: {
        position: {
            default: 1900
        }
    },
    [(0, $8Bc5A.MKT_JTBD_DEFAULT_PROJECT)]: {
        position: {
            default: 2000
        }
    },
    [(0, $8Bc5A.MKT_JTBD_DEFAULT_INVITES)]: {
        position: {
            default: 2100
        }
    }
};
const $3b1179694682c8c8$export$36f4d47dfe11b613 = {
    ...$3b1179694682c8c8$var$OPS_TAILORED_ONBOARDING_TASK_VARIANTS,
    ...$3b1179694682c8c8$var$MKT_TAILORED_ONBOARDING_TASK_VARIANTS,
    [(0, $8Bc5A.JWM_CREATE_PROJECT_TASK)]: {
        position: {
            default: 0
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        (0, $8jC8d.Experiments).isSampleProject
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $8Bc5A.JWM_TRELLO_CROSSFLOW_TASK_KEY_DIFFERENCES)]: {
        position: {
            default: 15
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $8jC8d.Experiments).isNotSampleProject,
                        (0, $8jC8d.Experiments).trelloCrossflow
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.JWM_CREATE_SAMPLE_PROJECT_TASK)]: {
        position: {
            default: 40
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $8jC8d.Experiments).isSampleProject
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.JWM_PROJECT_SUMMARY_TASK)]: {
        position: {
            default: 50
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $8jC8d.Experiments).isSampleProject
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.GET_STARTED_LIST_TASK)]: {
        position: {
            default: 100
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        (0, $8jC8d.Experiments).isSampleProject
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $8jC8d.Experiments).trelloCrossflow
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $8Bc5A.JWM_CALENDAR_TASK)]: {
        position: {
            default: 200
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        (0, $8jC8d.Experiments).isSampleProject
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $8jC8d.Experiments).trelloCrossflow
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $8Bc5A.JWM_TIMELINE_TASK)]: {
        position: {
            default: 300
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        (0, $8jC8d.Experiments).isSampleProject
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $8jC8d.Experiments).trelloCrossflow
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $8Bc5A.JWM_BUILD_FORM_TASK)]: {
        position: {
            default: 400
        },
        visibility: {
            default: true
        }
    },
    [(0, $8Bc5A.JWM_TRELLO_CROSSFLOW_CALENDAR_AND_TIMELINE_TASK)]: {
        position: {
            default: 425
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $8jC8d.Experiments).isNotSampleProject,
                        (0, $8jC8d.Experiments).trelloCrossflow
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.JWM_SUMMARY_AND_REPORTS_TASK)]: {
        position: {
            default: 450
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $8jC8d.Experiments).isNotSampleProject,
                        (0, $8jC8d.Experiments).trelloCrossflow
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.JWM_BACKGROUND_COLOR_TASK)]: {
        position: {
            default: 500
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $8jC8d.Experiments).projectTheming,
                        (0, $5PFhq.UserRole).jiraAdmin
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $8jC8d.Experiments).projectTheming,
                        (0, $5PFhq.UserRole).siteAdmin
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $8jC8d.Experiments).projectTheming,
                        (0, $5PFhq.UserRole).projectAdmin
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.JWM_SHARE_PROJECT_TASK)]: {
        position: {
            default: 600
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $8jC8d.Experiments).isSampleProject
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.JWM_TRELLO_CROSSFLOW_TASK_IMPORT)]: {
        position: {
            default: 650
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $8jC8d.Experiments).isNotSampleProject,
                        (0, $8jC8d.Experiments).trelloCrossflow,
                        (0, $5PFhq.UserRole).siteAdmin
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.JWM_FEEDBACK_TASK)]: {
        position: {
            default: 700
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        (0, $8jC8d.Experiments).isSampleProject
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $8jC8d.Experiments).trelloCrossflow
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $8Bc5A.JWM_FEEDBACK_SAMPLE_PROJECT_TASK)]: {
        position: {
            default: 700
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $8jC8d.Experiments).isSampleProject
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.JWM_CREATE_YOUR_OWN_PROJECT_TASK)]: {
        position: {
            default: 800
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $8jC8d.Experiments).isSampleProject,
                        (0, $5PFhq.UserRole).jiraAdmin
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $8jC8d.Experiments).isSampleProject,
                        (0, $5PFhq.UserRole).siteAdmin
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $8jC8d.Experiments).isSampleProject,
                        (0, $5PFhq.UserRole).projectAdmin
                    ],
                    value: true
                }
            ]
        }
    }
};

});
parcelRegister("8jC8d", function(module, exports) {

$parcel$export(module.exports, "Experiments", () => $6cd173da51fb2ca8$export$c8d6ffd15214553a);
const $6cd173da51fb2ca8$export$c8d6ffd15214553a = {
    projectTheming: 'projectTheming',
    isSampleProject: 'isSampleProject',
    isNotSampleProject: 'isNotSampleProject',
    trelloCrossflow: 'trelloCrossflow'
};

});

parcelRegister("aQMWP", function(module, exports) {

$parcel$export(module.exports, "messages", () => $40755a70921f89dd$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $40755a70921f89dd$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    rootTitle: {
        "id": "software-onboarding-quickstart.services.tasks.config.jwm.root-title.no-translate",
        "defaultMessage": "Quickstart"
    }
});

});

parcelRegister("5PFhq", function(module, exports) {

$parcel$export(module.exports, "UserRole", () => $637dacd99a3a1727$export$eb3485a690c2f0b8);
const $637dacd99a3a1727$export$eb3485a690c2f0b8 = {
    projectAdmin: 'projectAdmin',
    jiraAdmin: 'jiraAdmin',
    siteAdmin: 'siteAdmin'
};

});



parcelRegister("5zzQl", function(module, exports) {

$parcel$export(module.exports, "getTasks", () => $f17c108f7b3045ad$export$20b82b4a32771893);

var $fNtu3 = parcelRequire("fNtu3");
const $f17c108f7b3045ad$var$getTaskVisibility = (variants, visibility)=>visibility !== undefined ? (0, $fNtu3.getConditional)(visibility, variants) : true;
const $f17c108f7b3045ad$var$getTaskPosition = (variants, position)=>(0, $fNtu3.getConditional)(position, variants);
const $f17c108f7b3045ad$export$20b82b4a32771893 = (variants, taskVariants, taskList)=>taskList.filter((task)=>$f17c108f7b3045ad$var$getTaskVisibility(variants, taskVariants[task].visibility)).sort((taskA, taskB)=>$f17c108f7b3045ad$var$getTaskPosition(variants, taskVariants[taskA].position) - $f17c108f7b3045ad$var$getTaskPosition(variants, taskVariants[taskB].position));

});
parcelRegister("fNtu3", function(module, exports) {

$parcel$export(module.exports, "getConditional", () => $8978a3b25f57d9ac$export$fe3161cde0106bba);
const $8978a3b25f57d9ac$export$fe3161cde0106bba = ({ conditional: conditions, default: defaultValue }, variants)=>{
    if (conditions === undefined) return defaultValue;
    const variantsIncludesCondition = (c)=>variants.includes(c);
    const conditionObj = conditions.find(({ condition: condition })=>condition.every(variantsIncludesCondition));
    return conditionObj ? conditionObj.value : defaultValue;
};

});


parcelRegister("jJca1", function(module, exports) {

$parcel$export(module.exports, "isJwmProject", () => $6249819f9bc2846f$export$ea2e5a5c1a1a6748);
$parcel$export(module.exports, "isJsmProject", () => $6249819f9bc2846f$export$a972ed853ed1d469);

var $2vSU6 = parcelRequire("2vSU6");
const $6249819f9bc2846f$export$ea2e5a5c1a1a6748 = (projectState)=>projectState?.projectType === (0, $2vSU6.CORE_PROJECT);
const $6249819f9bc2846f$export$a972ed853ed1d469 = (projectState)=>projectState?.projectType === (0, $2vSU6.SERVICE_DESK_PROJECT);

});

parcelRegister("d7Knl", function(module, exports) {

$parcel$export(module.exports, "TAILORED_ONBOARDING_WITH_SINGLE_CONFIG", () => $98ba598c6688dfac$export$83849aa73c0a20db);
$parcel$export(module.exports, "TAILORED_ONBOARDING_M2P5", () => $98ba598c6688dfac$export$eb17ad7838835d2a);


var $8Bc5A = parcelRequire("8Bc5A");

var $57ZKw = parcelRequire("57ZKw");

var $i2O9c = parcelRequire("i2O9c");

var $643hq = parcelRequire("643hq");

var $2Ld7w = parcelRequire("2Ld7w");

var $1bW8Q = parcelRequire("1bW8Q");

var $9mlnS = parcelRequire("9mlnS");

var $f4rKN = parcelRequire("f4rKN");

var $3YqPl = parcelRequire("3YqPl");

var $xk58e = parcelRequire("xk58e");
const $98ba598c6688dfac$export$2757f7b23d120b9b = Object.freeze({
    root: {
        title: (0, $57ZKw.messages).rootTitle,
        items: [
            (0, $8Bc5A.TAILORED_ONBOARDING_SUMMARY),
            (0, $8Bc5A.TAILORED_ONBOARDING_CALENDAR),
            (0, $8Bc5A.TAILORED_ONBOARDING_LIST),
            (0, $8Bc5A.TAILORED_ONBOARDING_TIMELINE),
            (0, $8Bc5A.TAILORED_ONBOARDING_PAGES),
            (0, $8Bc5A.TAILORED_ONBOARDING_FORM),
            (0, $8Bc5A.TAILORED_ONBOARDING_INVITE),
            (0, $8Bc5A.TAILORED_ONBOARDING_BOARD),
            (0, $8Bc5A.TAILORED_ONBOARDING_BACKLOG),
            (0, $8Bc5A.TAILORED_ONBOARDING_CODE)
        ]
    }
});
const $98ba598c6688dfac$export$83849aa73c0a20db = {
    taskList: $98ba598c6688dfac$export$2757f7b23d120b9b,
    taskVariants: (0, $xk58e.TAILORED_ONBOARDING_SINGLE_CONFIG)
};
const $98ba598c6688dfac$export$fd94bb9b6d992528 = Object.freeze({
    root: {
        title: (0, $57ZKw.messages).rootTitle,
        items: [
            (0, $8Bc5A.TAILORED_ONBOARDING_SUMMARY),
            (0, $8Bc5A.TAILORED_ONBOARDING_CALENDAR),
            (0, $8Bc5A.TAILORED_ONBOARDING_LIST),
            (0, $8Bc5A.TAILORED_ONBOARDING_TIMELINE),
            (0, $8Bc5A.TAILORED_ONBOARDING_PAGES),
            (0, $8Bc5A.TAILORED_ONBOARDING_FORM),
            (0, $8Bc5A.TAILORED_ONBOARDING_INVITE),
            (0, $8Bc5A.TAILORED_ONBOARDING_BOARD)
        ]
    }
});
const $98ba598c6688dfac$export$be9c097e18825d4c = {
    ...(0, $643hq.PRODUCT_MANAGEMENT_VARIANTS),
    ...(0, $i2O9c.PROJECT_MANAGEMENT_VARIANTS),
    ...(0, $2Ld7w.DESIGN_VARIANTS),
    ...(0, $1bW8Q.IT_SUPPORT_VARIANTS),
    ...(0, $3YqPl.SOFTWARE_VARIANTS),
    ...(0, $9mlnS.OTHER_PERSONAL_VARIANTS),
    ...(0, $f4rKN.EVERYTHING_ELSE_VARIANTS)
};
const $98ba598c6688dfac$export$3c409334669aec75 = (teamType)=>{
    switch(teamType){
        case 0, $6784cbc7d62e5d7c$export$4f54a09a24fd1d74:
            return 0, $643hq.PRODUCT_MANAGEMENT_VARIANTS;
        case 0, $6784cbc7d62e5d7c$export$79685802e8ff1098:
            return 0, $i2O9c.PROJECT_MANAGEMENT_VARIANTS;
        case 0, $6784cbc7d62e5d7c$export$e5c438b7501b5a24:
            return 0, $2Ld7w.DESIGN_VARIANTS;
        case 0, $6784cbc7d62e5d7c$export$d7de553940261eba:
            return 0, $1bW8Q.IT_SUPPORT_VARIANTS;
        case 0, $6784cbc7d62e5d7c$export$cbc0e551d91a692d:
            return 0, $9mlnS.OTHER_PERSONAL_VARIANTS;
        case 0, $6784cbc7d62e5d7c$export$b8b1ac856ba1434b:
            return 0, $3YqPl.SOFTWARE_VARIANTS;
        default:
            return 0, $f4rKN.EVERYTHING_ELSE_VARIANTS;
    }
};
const $98ba598c6688dfac$export$eb17ad7838835d2a = {
    taskList: $98ba598c6688dfac$export$fd94bb9b6d992528,
    getM2P5TaskVariants: $98ba598c6688dfac$export$3c409334669aec75
};

});
parcelRegister("57ZKw", function(module, exports) {

$parcel$export(module.exports, "messages", () => $b241f4df6ba82218$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $b241f4df6ba82218$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    rootTitle: {
        "id": "software-onboarding-quickstart.services.tasks.config.tailored-onboarding.root-title.no-translate",
        "defaultMessage": "Quickstart"
    }
});

});

parcelRegister("i2O9c", function(module, exports) {

$parcel$export(module.exports, "PROJECT_MANAGEMENT_VARIANTS", () => $c81c85368d94bebb$export$bdd338c80f8962df);

var $8Bc5A = parcelRequire("8Bc5A");

var $pDX5d = parcelRequire("pDX5d");
const $c81c85368d94bebb$export$bdd338c80f8962df = {
    [(0, $8Bc5A.TAILORED_ONBOARDING_BOARD)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_CALENDAR)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_LIST)]: {
        position: {
            default: 0
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).projectManagement
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_TIMELINE)]: {
        position: {
            default: 100
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).projectManagement
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_SUMMARY)]: {
        position: {
            default: 200
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).projectManagement
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_FORM)]: {
        position: {
            default: 300
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).projectManagement
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_PAGES)]: {
        position: {
            default: 400
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).projectManagement
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_INVITE)]: {
        position: {
            default: 500
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).projectManagement
                    ],
                    value: true
                }
            ]
        }
    }
};

});
parcelRegister("pDX5d", function(module, exports) {

$parcel$export(module.exports, "TeamType", () => $c47e1ea5de95ecc4$export$26bc40b960693765);
$parcel$export(module.exports, "Feature", () => $c47e1ea5de95ecc4$export$6e91cf7616333d5);

const $c47e1ea5de95ecc4$export$26bc40b960693765 = {
    productManagement: `teamType.${(0, $6784cbc7d62e5d7c$export$4f54a09a24fd1d74)}`,
    projectManagement: `teamType.${(0, $6784cbc7d62e5d7c$export$79685802e8ff1098)}`,
    design: `teamType.${(0, $6784cbc7d62e5d7c$export$e5c438b7501b5a24)}`,
    itSupport: `teamType.${(0, $6784cbc7d62e5d7c$export$d7de553940261eba)}`,
    otherPersonal: `teamType.${(0, $6784cbc7d62e5d7c$export$cbc0e551d91a692d)}`,
    marketing: `teamType.${(0, $6784cbc7d62e5d7c$export$e4824f74b9879164)}`,
    operations: `teamType.${(0, $6784cbc7d62e5d7c$export$4f3cb0844009af52)}`,
    software: `teamType.${(0, $6784cbc7d62e5d7c$export$b8b1ac856ba1434b)}`,
    // Fallback team type config used for team types we aren't catering for e.g. Data science
    // and also used if the team type is unexpected/unknown
    everythingElse: 'teamType.everythingElse'
};
const $c47e1ea5de95ecc4$export$6e91cf7616333d5 = {
    hasBacklog: 'feature.hasBacklog',
    hasSprint: 'feature.hasSprint'
};

});


parcelRegister("643hq", function(module, exports) {

$parcel$export(module.exports, "PRODUCT_MANAGEMENT_VARIANTS", () => $fed1dddbfb0b30cf$export$b07ea6a2d29f9c08);

var $8Bc5A = parcelRequire("8Bc5A");

var $pDX5d = parcelRequire("pDX5d");
const $fed1dddbfb0b30cf$export$b07ea6a2d29f9c08 = {
    [(0, $8Bc5A.TAILORED_ONBOARDING_BOARD)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_CALENDAR)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_SUMMARY)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_LIST)]: {
        position: {
            default: 0
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).productManagement
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_TIMELINE)]: {
        position: {
            default: 100
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).productManagement
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_PAGES)]: {
        position: {
            default: 200
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).productManagement
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_FORM)]: {
        position: {
            default: 300
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).productManagement
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_INVITE)]: {
        position: {
            default: 400
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).productManagement
                    ],
                    value: true
                }
            ]
        }
    }
};

});

parcelRegister("2Ld7w", function(module, exports) {

$parcel$export(module.exports, "DESIGN_VARIANTS", () => $d62d711ad5ddd92f$export$a3c4cd8e420f13a);

var $8Bc5A = parcelRequire("8Bc5A");

var $pDX5d = parcelRequire("pDX5d");
const $d62d711ad5ddd92f$export$a3c4cd8e420f13a = {
    [(0, $8Bc5A.TAILORED_ONBOARDING_SUMMARY)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_TIMELINE)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_LIST)]: {
        position: {
            default: 0
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).design
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_CALENDAR)]: {
        position: {
            default: 100
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).design
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_PAGES)]: {
        position: {
            default: 200
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).design
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_FORM)]: {
        position: {
            default: 300
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).design
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_BOARD)]: {
        position: {
            default: 400
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).design
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_INVITE)]: {
        position: {
            default: 500
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).design
                    ],
                    value: true
                }
            ]
        }
    }
};

});

parcelRegister("1bW8Q", function(module, exports) {

$parcel$export(module.exports, "IT_SUPPORT_VARIANTS", () => $09c03dfb484f3e93$export$a25e809b52945082);

var $8Bc5A = parcelRequire("8Bc5A");

var $pDX5d = parcelRequire("pDX5d");
const $09c03dfb484f3e93$export$a25e809b52945082 = {
    [(0, $8Bc5A.TAILORED_ONBOARDING_TIMELINE)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_LIST)]: {
        position: {
            default: 0
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).itSupport
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_SUMMARY)]: {
        position: {
            default: 100
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).itSupport
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_BOARD)]: {
        position: {
            default: 200
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).itSupport
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_FORM)]: {
        position: {
            default: 300
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).itSupport
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_CALENDAR)]: {
        position: {
            default: 400
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).itSupport
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_PAGES)]: {
        position: {
            default: 500
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).itSupport
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_INVITE)]: {
        position: {
            default: 500
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).itSupport
                    ],
                    value: true
                }
            ]
        }
    }
};

});

parcelRegister("9mlnS", function(module, exports) {

$parcel$export(module.exports, "OTHER_PERSONAL_VARIANTS", () => $6398fc5437bfee58$export$916be3c140ae8c0);

var $8Bc5A = parcelRequire("8Bc5A");

var $pDX5d = parcelRequire("pDX5d");
const $6398fc5437bfee58$export$916be3c140ae8c0 = {
    [(0, $8Bc5A.TAILORED_ONBOARDING_SUMMARY)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_TIMELINE)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_LIST)]: {
        position: {
            default: 0
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).otherPersonal
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_BOARD)]: {
        position: {
            default: 100
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).otherPersonal
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_CALENDAR)]: {
        position: {
            default: 200
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).otherPersonal
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_PAGES)]: {
        position: {
            default: 300
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).otherPersonal
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_FORM)]: {
        position: {
            default: 400
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).otherPersonal
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_INVITE)]: {
        position: {
            default: 500
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).otherPersonal
                    ],
                    value: true
                }
            ]
        }
    }
};

});

parcelRegister("f4rKN", function(module, exports) {

$parcel$export(module.exports, "EVERYTHING_ELSE_VARIANTS", () => $dc653043c34d0d58$export$7a0daeb069f34de3);

var $8Bc5A = parcelRequire("8Bc5A");

var $pDX5d = parcelRequire("pDX5d");
const $dc653043c34d0d58$export$7a0daeb069f34de3 = {
    [(0, $8Bc5A.TAILORED_ONBOARDING_SUMMARY)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_LIST)]: {
        position: {
            default: 0
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_BOARD)]: {
        position: {
            default: 100
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_CALENDAR)]: {
        position: {
            default: 200
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_TIMELINE)]: {
        position: {
            default: 300
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_PAGES)]: {
        position: {
            default: 400
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_FORM)]: {
        position: {
            default: 500
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_INVITE)]: {
        position: {
            default: 500
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    }
};

});

parcelRegister("3YqPl", function(module, exports) {

$parcel$export(module.exports, "SOFTWARE_VARIANTS", () => $136badd6870fea88$export$76a143792cc73994);

var $8Bc5A = parcelRequire("8Bc5A");

var $pDX5d = parcelRequire("pDX5d");
const $136badd6870fea88$export$76a143792cc73994 = {
    [(0, $8Bc5A.TAILORED_ONBOARDING_CALENDAR)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_SUMMARY)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_LIST)]: {
        position: {
            default: 0
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).software
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_BOARD)]: {
        position: {
            default: 100
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).software
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_PAGES)]: {
        position: {
            default: 200
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).software
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_FORM)]: {
        position: {
            default: 300
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).software
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_TIMELINE)]: {
        position: {
            default: 400
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).software
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_INVITE)]: {
        position: {
            default: 500
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).software
                    ],
                    value: true
                }
            ]
        }
    }
};

});

parcelRegister("xk58e", function(module, exports) {

$parcel$export(module.exports, "TAILORED_ONBOARDING_SINGLE_CONFIG", () => $70190108b7b6e00a$export$64855550cee11b78);

var $8Bc5A = parcelRequire("8Bc5A");

var $8VfDj = parcelRequire("8VfDj");

var $pDX5d = parcelRequire("pDX5d");
const $70190108b7b6e00a$export$64855550cee11b78 = {
    [(0, $8Bc5A.TAILORED_ONBOARDING_SUMMARY)]: {
        position: {
            default: 200,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).marketing
                    ],
                    value: 400
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $8VfDj.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $pDX5d.Feature).hasBacklog,
                        (0, $pDX5d.Feature).hasSprint
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).marketing
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).projectManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).itSupport
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).operations
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_TIMELINE)]: {
        position: {
            default: 0,
            conditional: [
                {
                    condition: [
                        (0, $8VfDj.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $pDX5d.TeamType).software,
                        (0, $pDX5d.Feature).hasBacklog,
                        (0, $pDX5d.Feature).hasSprint
                    ],
                    value: 600
                },
                {
                    condition: [
                        (0, $8VfDj.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $pDX5d.Feature).hasBacklog,
                        (0, $pDX5d.Feature).hasSprint
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $8VfDj.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $pDX5d.TeamType).software
                    ],
                    value: 600
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).marketing
                    ],
                    value: 100
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).productManagement
                    ],
                    value: 200
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).projectManagement
                    ],
                    value: 100
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).software
                    ],
                    value: 400
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).operations
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).everythingElse
                    ],
                    value: 400
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $8VfDj.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $pDX5d.TeamType).software,
                        (0, $pDX5d.Feature).hasBacklog,
                        (0, $pDX5d.Feature).hasSprint
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $8VfDj.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $pDX5d.Feature).hasBacklog,
                        (0, $pDX5d.Feature).hasSprint
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).marketing
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).productManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).projectManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).software
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).operations
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_LIST)]: {
        position: {
            default: 0,
            conditional: []
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $8VfDj.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $pDX5d.Feature).hasBacklog,
                        (0, $pDX5d.Feature).hasSprint
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).marketing
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).design
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).productManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).projectManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).software
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).otherPersonal
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).itSupport
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).operations
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_BACKLOG)]: {
        position: {
            default: 0
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $8VfDj.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $pDX5d.Feature).hasBacklog,
                        (0, $pDX5d.Feature).hasSprint
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_BOARD)]: {
        position: {
            default: 100,
            conditional: [
                {
                    condition: [
                        (0, $8VfDj.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $pDX5d.Feature).hasBacklog,
                        (0, $pDX5d.Feature).hasSprint
                    ],
                    value: 100
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).design
                    ],
                    value: 400
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).itSupport
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).operations
                    ],
                    value: 100
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).everythingElse
                    ],
                    value: 100
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $8VfDj.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $pDX5d.Feature).hasBacklog,
                        (0, $pDX5d.Feature).hasSprint
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).design
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).software
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).otherPersonal
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).itSupport
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).operations
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_CALENDAR)]: {
        position: {
            default: 300,
            conditional: [
                {
                    condition: [
                        (0, $8VfDj.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $pDX5d.Feature).hasBacklog,
                        (0, $pDX5d.Feature).hasSprint
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).marketing
                    ],
                    value: 100
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).productManagement
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).projectManagement
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).software
                    ],
                    value: 200
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).itSupport
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).operations
                    ],
                    value: 400
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).everythingElse
                    ],
                    value: 200
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $8VfDj.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $pDX5d.TeamType).software,
                        (0, $pDX5d.Feature).hasBacklog,
                        (0, $pDX5d.Feature).hasSprint
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $8VfDj.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $pDX5d.Feature).hasBacklog,
                        (0, $pDX5d.Feature).hasSprint
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $8VfDj.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $pDX5d.TeamType).software
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).marketing
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).design
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).software
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).otherPersonal
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).itSupport
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).operations
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_CODE)]: {
        position: {
            default: 300
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $8VfDj.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $pDX5d.TeamType).software,
                        (0, $pDX5d.Feature).hasBacklog,
                        (0, $pDX5d.Feature).hasSprint
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $8VfDj.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $pDX5d.TeamType).software
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_PAGES)]: {
        position: {
            default: 300,
            conditional: [
                {
                    condition: [
                        (0, $8VfDj.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $pDX5d.TeamType).software,
                        (0, $pDX5d.Feature).hasBacklog,
                        (0, $pDX5d.Feature).hasSprint
                    ],
                    value: 400
                },
                {
                    condition: [
                        (0, $8VfDj.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $pDX5d.Feature).hasBacklog,
                        (0, $pDX5d.Feature).hasSprint
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).projectManagement
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).software
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).itSupport
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).everythingElse
                    ],
                    value: 500
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $8VfDj.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $pDX5d.Feature).hasBacklog,
                        (0, $pDX5d.Feature).hasSprint
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).marketing
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).design
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).productManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).projectManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).software
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).otherPersonal
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).itSupport
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).operations
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_FORM)]: {
        position: {
            default: 500,
            conditional: [
                {
                    condition: [
                        (0, $8VfDj.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $pDX5d.Feature).hasBacklog,
                        (0, $pDX5d.Feature).hasSprint
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).marketing
                    ],
                    value: 400
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).design
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).productManagement
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).projectManagement
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).itSupport
                    ],
                    value: 400
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $8VfDj.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $pDX5d.Feature).hasBacklog,
                        (0, $pDX5d.Feature).hasSprint
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).design
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).productManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).projectManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).software
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).otherPersonal
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).itSupport
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).operations
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_INVITE)]: {
        position: {
            default: 500,
            conditional: [
                {
                    condition: [
                        (0, $8VfDj.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $pDX5d.Feature).hasBacklog,
                        (0, $pDX5d.Feature).hasSprint
                    ],
                    value: 700
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).software,
                        (0, $8VfDj.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible
                    ],
                    value: 700
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $8VfDj.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $pDX5d.Feature).hasBacklog,
                        (0, $pDX5d.Feature).hasSprint
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).marketing
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).design
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).productManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).projectManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).software
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).otherPersonal
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).itSupport
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).operations
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    }
};

});




parcelRegister("75A1x", function(module, exports) {

$parcel$export(module.exports, "syncVisibilityWithLocal", () => $f9427b1514e1931c$export$4aab9a98fc53b894);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3B5jO = parcelRequire("3B5jO");

var $4ji4w = parcelRequire("4ji4w");
const $f9427b1514e1931c$export$4aab9a98fc53b894 = ()=>({ getState: getState, setState: setState })=>{
        const state = getState();
        const quickstartType = (0, $3B5jO.getQuickstartTypeSelector)(state);
        const visibilityLocal = (0, $4ji4w.getLocalStorageItem)(`${quickstartType}.visibility`);
        if (visibilityLocal === state.visibility[quickstartType]) return;
        setState({
            visibility: {
                ...state.visibility,
                [quickstartType]: visibilityLocal
            }
        });
    };

});

parcelRegister("1Xkin", function(module, exports) {

$parcel$export(module.exports, "universalDispatch", () => $e706482dec5e8abf$export$efe980271ca9cc08);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $e706482dec5e8abf$export$efe980271ca9cc08 = ({ fn: fn })=>({ dispatch: dispatch })=>{
        dispatch(fn());
    };

});


parcelRegister("cGE52", function(module, exports) {

$parcel$export(module.exports, "initialState", () => $d175a7a443e10f6d$export$d4c72bab9d6cc13a);

var $8Bc5A = parcelRequire("8Bc5A");
const $d175a7a443e10f6d$export$d4c72bab9d6cc13a = {
    shouldRenderComponent: false,
    completedTaskList: [],
    hasSeenTasks: [],
    isDismissed: true,
    isOpen: false,
    isFocusedOn: false,
    openTask: '',
    projectState: null,
    hasNudgeActive: false,
    isQuickstartLoaded: false,
    nudgeStep: '',
    mountedNudges: [],
    hasEverSeenRoute: {
        'jsw.onboarding.experiment.personalised.onboarding.ntkw.onboarding.it2.roadmap': false
    },
    roadmapIsCreateEnabled: false,
    roadmapIsListEmpty: true,
    previousTaskGroupParents: [],
    currentTaskGroupParent: (0, $8Bc5A.ROOT_TASK),
    currentTriggerForTaskGroupParent: '',
    selectedProjectTemplateKeyFromOnboarding: undefined,
    isEligibleToUpdateSitename: false,
    isCrossProjectBoardToPlanUpsell: false,
    canEditPlans: false,
    visibility: {
        [(0, $8Bc5A.QUICKSTART_TYPE).JSM_BUSINESS_QUICKSTART_KEY]: (0, $8Bc5A.QUICKSTART_UI_STATUS).NOT_LOADED,
        [(0, $8Bc5A.QUICKSTART_TYPE).OLD_GLOBAL_QUICKSTART_KEY]: (0, $8Bc5A.QUICKSTART_UI_STATUS).NOT_LOADED
    }
};

});


parcelRegister("lgd3t", function(module, exports) {

$parcel$export(module.exports, "JswQuickStartShouldRender", () => $965d07c32b6c14f6$export$66f5975ba6556512);

var $iG76j = parcelRequire("iG76j");
const $965d07c32b6c14f6$export$66f5975ba6556512 = (0, $iG76j.default);

});
parcelRegister("iG76j", function(module, exports) {

$parcel$export(module.exports, "default", () => $b6c61bf75aaa2492$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $7XYc4 = parcelRequire("7XYc4");

var $8GOso = parcelRequire("8GOso");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $4DPZY = parcelRequire("4DPZY");

var $dAfqg = parcelRequire("dAfqg");

var $doZTA = parcelRequire("doZTA");

var $4igab = parcelRequire("4igab");
/*
    This hook will be used in spa-app in order to set the shouldRenderComponent
    when it is loaded in side of the proper paths. Once it is unmounted it should set the component to false.
    Next-Gen:
        Board: jira/software/projects/MT1/boards/1 --> spa-app/next-gen-board
        Backlog: jira/software/projects/MT1/boards/1/backlog --> spa-app/next-gen-backlog
        Roadmap: jira/software/projects/MT1/boards/1/roadmap --> spa-app/roadmap/src/view/common/roadmap
        Project Setting (Details): /jira/software/projects/MT1/settings/details --> spa-app/project-settings/details
        Pages: projects/MT1?selectedItem=com.atlassian.jira.jira-projects-plugin:project-pages-page --> spa-app/project/pages
    Classic:
        Board: secure/RapidBoard.jspa?projectKey=CK&rapidView=5 --> spa-app/rapid-board
        Backlog: secure/RapidBoard.jspa?rapidView=5&projectKey=CK&view=planning.nodetail&issueLimit=100 --> spa-app/rapid-board
    Both:
        OpsGenie: projects/CK?selectedItem=com.atlassian.jira.jira-projects-plugin:opsgenie-schedule-page --> spa-app/project/opsgenie-schedule

*/ const $b6c61bf75aaa2492$var$QuickstartShouldRenderWithoutPersonalisation = (props)=>{
    const [{ match: match, route: route }] = (0, $doZTA.useRouter)();
    const { projectContext: projectContext } = props;
    // Require to calculate analytics attributes in this component
    const [{ data: containerContext }] = (0, $4DPZY.useContainerContext)();
    const projectContextData = projectContext && projectContext.data;
    const { canShowExperience: canShowExperience, isEnrolledForProjectSettings: isEnrolledForProjectSettings } = (0, $4igab.useQuickstartInitialise)(projectContextData);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>{
        if (canShowExperience && isEnrolledForProjectSettings) {
            const analyticsEvent = createAnalyticsEvent({});
            (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'invitePeopleToProject shouldRender', {
                isNextGen: Boolean(projectContextData && projectContextData.simplified)
            });
        }
    }, [
        canShowExperience,
        containerContext,
        createAnalyticsEvent,
        isEnrolledForProjectSettings,
        match,
        projectContextData,
        route
    ]);
    return null;
};
const $b6c61bf75aaa2492$var$QuickstartShouldRenderWithPersonalisation = (props)=>{
    const [{ match: match, route: route }] = (0, $doZTA.useRouter)();
    const { projectContext: projectContext } = props;
    // Require to calculate analytics attributes in this component
    const [{ data: containerContext }] = (0, $4DPZY.useContainerContext)();
    const projectContextData = projectContext && projectContext.data;
    const { canShowExperience: canShowExperience, isEnrolledForProjectSettings: isEnrolledForProjectSettings } = (0, $4igab.useQuickstartInitialiseWithPersonalisation)(projectContextData);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>{
        if (canShowExperience && isEnrolledForProjectSettings) {
            const analyticsEvent = createAnalyticsEvent({});
            (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'invitePeopleToProject shouldRender', {
                isNextGen: Boolean(projectContextData && projectContextData.simplified)
            });
        }
    }, [
        canShowExperience,
        containerContext,
        createAnalyticsEvent,
        isEnrolledForProjectSettings,
        match,
        projectContextData,
        route
    ]);
    return null;
};
const $b6c61bf75aaa2492$export$15fdcfee517a071d = (0, $7XYc4.componentWithCondition)(()=>{
    return (0, $8GOso.useCommonEligibilityConditionsForJtbdOnboarding)();
}, $b6c61bf75aaa2492$var$QuickstartShouldRenderWithPersonalisation, $b6c61bf75aaa2492$var$QuickstartShouldRenderWithoutPersonalisation);
const $b6c61bf75aaa2492$var$QuickstartShouldRenderWithProjectContext = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "QuickStartShouldRender",
        packageName: "jiraSoftwareOnboardingQuickstart",
        sendToPrivacyUnsafeSplunk: true,
        teamName: "jlove-makkuro",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dAfqg.ProjectContextProvider), null, (projectContext)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b6c61bf75aaa2492$export$15fdcfee517a071d, {
            projectContext: projectContext
        })));
var $b6c61bf75aaa2492$export$2e2bcd8739ae039 = $b6c61bf75aaa2492$var$QuickstartShouldRenderWithProjectContext;

});
parcelRegister("8GOso", function(module, exports) {

$parcel$export(module.exports, "usePersonalisationActions", () => $adde9919a40069db$export$5b1d43353c334c00);
$parcel$export(module.exports, "useCommonEligibilityConditionsForJtbdOnboarding", () => $adde9919a40069db$export$c89644b13b6e777f);
$parcel$export(module.exports, "useCommonEligibilityConditionsForTOM2P5", () => $adde9919a40069db$export$b633031bd0a88786);
$parcel$export(module.exports, "useTailoredOnboardingPersonalisationAttributes", () => $adde9919a40069db$export$9aad8798ea46e07f);
$parcel$export(module.exports, "useTailoredOnboardingPersonalisationM2", () => $adde9919a40069db$export$5875295cb096b1f2);
$parcel$export(module.exports, "useIsTailoredOnboardingM2ForQuickstartEnabled", () => $adde9919a40069db$export$6bc15f8ade1cf36);

var $5uXOq = parcelRequire("5uXOq");

var $2vSU6 = parcelRequire("2vSU6");

var $jcw0u = parcelRequire("jcw0u");

var $4R6GH = parcelRequire("4R6GH");

var $cNd4s = parcelRequire("cNd4s");

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $dAfqg = parcelRequire("dAfqg");

var $AK64q = parcelRequire("AK64q");

var $8UmI9 = parcelRequire("8UmI9");

var $4mXzi = parcelRequire("4mXzi");

var $iAFnF = parcelRequire("iAFnF");
const $adde9919a40069db$var$store = (0, $iXqE5.createStore)({
    name: 'jira-onboarding-personalisation',
    initialState: (0, $AK64q.initialCachedEndpointState),
    actions: $4mXzi.actions
});
const $adde9919a40069db$export$5b1d43353c334c00 = (0, $3sQ5x.createActionsHook)($adde9919a40069db$var$store);
const $adde9919a40069db$export$31a443426d101362 = (0, $3sQ5x.createHook)($adde9919a40069db$var$store);
const $adde9919a40069db$export$c89644b13b6e777f = ()=>{
    const isSiteAdmin = (0, $cNd4s.useIsSiteAdmin)();
    const { data: projectContextData } = (0, $dAfqg.useProjectContext)();
    const isBusinessProject = projectContextData?.projectType === undefined || // letting undefined pass for non-project context usage, eg: onboarding
    projectContextData?.projectType === (0, $2vSU6.CORE_PROJECT); // limiting only to CORE for Tailired Onboarding M2 usage
    return isBusinessProject && isSiteAdmin;
};
const $adde9919a40069db$export$b633031bd0a88786 = ()=>{
    const isSiteAdmin = (0, $cNd4s.useIsSiteAdmin)();
    const { isBusinessProject: isBusinessProject } = (0, $8UmI9.useIsBusinessProject)();
    return isBusinessProject && isSiteAdmin && (0, $4R6GH.fg)('tailored_onboarding_m2p5_gate');
};
const $adde9919a40069db$export$6f87e1662a24f8b9 = ({ isEligible: isEligible, experienceTypes: experienceTypes, additionalParameters: additionalParameters })=>{
    const [{ fetchedOnce: fetchedOnce, isFetching: isFetching, data: data }, { fetchOnboardingPersonalisation: fetchOnboardingPersonalisation }] = $adde9919a40069db$export$31a443426d101362();
    (0, $5uXOq.useEffect)(()=>{
        if (isEligible && !fetchedOnce && !isFetching && data === undefined) fetchOnboardingPersonalisation({
            experienceTypes: experienceTypes,
            additionalParameters: additionalParameters
        });
    }, [
        additionalParameters,
        data,
        experienceTypes,
        fetchOnboardingPersonalisation,
        fetchedOnce,
        isEligible,
        isFetching
    ]);
    if (!isEligible) // If not eligible, no fetching is done. Data is ready to be read
    return {
        data: undefined,
        isReady: true
    };
    return {
        data: data,
        isReady: fetchedOnce && !isFetching
    };
};
const $adde9919a40069db$export$9aad8798ea46e07f = ()=>{
    const isEligibleForTailoredOnboardingM2 = $adde9919a40069db$export$c89644b13b6e777f();
    const { data: personalisationData, isReady: personalisationDataIsReady } = $adde9919a40069db$export$6f87e1662a24f8b9({
        isEligible: isEligibleForTailoredOnboardingM2
    });
    return {
        personalisationDataIsReady: personalisationDataIsReady,
        teamType: personalisationData?.matched.variants.find((variant)=>variant.startsWith('teamType.'))?.replace('teamType.', ''),
        jtbd: personalisationData?.matched.variants.filter((variant)=>variant.startsWith('jtbd.option_')).map((option)=>option.replace('jtbd.option_', '')).join(',')
    };
};
const $adde9919a40069db$export$5875295cb096b1f2 = ({ isEligible: isEligible, additionalParameters: additionalParameters })=>{
    const hasSentErrorOnce = (0, $5uXOq.useRef)(false);
    const { data: data, isReady: isReady } = $adde9919a40069db$export$6f87e1662a24f8b9({
        isEligible: isEligible,
        experienceTypes: [
            'QUICKSTART',
            'TEMPLATE',
            'LANDING_PAGE'
        ],
        additionalParameters: additionalParameters
    });
    try {
        const conditionalProjectType = `projectType.${additionalParameters?.projectType}`;
        // If projectType is not given as parameter, ignore restriction to match on projectType
        const isMatchingProjectType = Boolean(!additionalParameters?.projectType || data?.matched.variants.some((variant)=>variant === conditionalProjectType));
        const isMatchingTeamType = Boolean(data?.matched.variants.some((variant)=>variant.startsWith('teamType.') && (0, $iAFnF.ELIGIBLE_TEAM_TYPES_M2_FULL_NOTATION).includes(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            variant.split('.')[1])));
        const isMatchingJtbd = Boolean(data?.matched.variants.some((variant)=>variant.startsWith('jtbd')));
        const matched = Boolean(data && isMatchingJtbd && isMatchingProjectType && isMatchingTeamType);
        return {
            isReady: isReady,
            data: {
                matched: matched,
                matchedVariants: {
                    projectType: isMatchingProjectType,
                    tt: isMatchingTeamType,
                    jtbd: isMatchingJtbd
                },
                QUICKSTART: matched && data ? data.experience.QUICKSTART : [],
                TEMPLATE: matched && data ? data.experience.TEMPLATE?.[0] : undefined,
                LANDING_PAGE: matched && data ? data.experience.LANDING_PAGE?.[0] : undefined
            }
        };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (!hasSentErrorOnce.current) {
            (0, $jcw0u.default)({
                error: error,
                meta: {
                    id: 'useTailoredOnboardingPersonalisationM2',
                    packageName: 'jiraOnboardingCore',
                    teamName: 'jlove-makkuro'
                },
                sendToPrivacyUnsafeSplunk: true
            });
            hasSentErrorOnce.current = true;
        }
    }
    return {
        isReady: isReady,
        data: {
            matched: false,
            matchedVariants: {
                jtbd: false,
                tt: false,
                projectType: false
            },
            QUICKSTART: [],
            TEMPLATE: undefined,
            LANDING_PAGE: undefined
        }
    };
};
const $adde9919a40069db$export$6bc15f8ade1cf36 = ()=>{
    const isEligibleForJtbdOnboarding = $adde9919a40069db$export$c89644b13b6e777f();
    const { data: projectContextData } = (0, $dAfqg.useProjectContext)();
    const projectType = (0, $4R6GH.fg)('tailored_onboarding_m3_gate') ? projectContextData?.projectType : (0, $2vSU6.CORE_PROJECT);
    const { isReady: personalisationDataIsReady, data: personalisationData } = $adde9919a40069db$export$5875295cb096b1f2({
        isEligible: isEligibleForJtbdOnboarding,
        additionalParameters: {
            projectType: projectType
        }
    });
    return Boolean(personalisationDataIsReady && personalisationData.QUICKSTART && personalisationData.QUICKSTART?.length > 0);
};

});
parcelRegister("cNd4s", function(module, exports) {

$parcel$export(module.exports, "useIsSiteAdmin", () => $3ad4a3e53b34f026$export$f9f8a5cdb0c565ef);

var $9OXo1 = parcelRequire("9OXo1");
const $3ad4a3e53b34f026$export$f9f8a5cdb0c565ef = ()=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    return tenantContext && tenantContext.isSiteAdmin || false;
};

});

parcelRegister("dAfqg", function(module, exports) {

$parcel$export(module.exports, "useProjectContext", () => $0baaa0dcf730951a$export$8f31c2503e1efa93);
$parcel$export(module.exports, "useIsSimplifiedProject", () => $0baaa0dcf730951a$export$524ef4f6102ed540);
$parcel$export(module.exports, "ProjectContextProvider", () => $0baaa0dcf730951a$export$a85f6b5857d2176);

var $5uXOq = parcelRequire("5uXOq");

var $324W5 = parcelRequire("324W5");

var $dxCvy = parcelRequire("dxCvy");
const $0baaa0dcf730951a$export$8f31c2503e1efa93 = (customContext)=>{
    const { data: data, error: error, loading: loading, update: update, key: key } = (0, $324W5.useResourceWithCustomRouterContext)((0, $dxCvy.projectContextResourceWithCache), customContext);
    const updateCache = (0, $5uXOq.useCallback)((d)=>update(()=>d), [
        update
    ]);
    return {
        data: data,
        error: error,
        loading: loading,
        updateCache: updateCache,
        key: key
    };
};
const $0baaa0dcf730951a$export$524ef4f6102ed540 = ()=>{
    const { data: data } = $0baaa0dcf730951a$export$8f31c2503e1efa93();
    return data?.simplified || false;
};
const $0baaa0dcf730951a$export$a85f6b5857d2176 = ({ children: children })=>{
    const projectContext = $0baaa0dcf730951a$export$8f31c2503e1efa93();
    return children(projectContext);
};

});

parcelRegister("AK64q", function(module, exports) {

$parcel$export(module.exports, "initialCachedEndpointState", () => $e18633c22e50182e$export$aaed2d023c5dc2c);
const $e18633c22e50182e$export$aaed2d023c5dc2c = {
    isFetching: false,
    wasFetched: false,
    fetchedOnce: false,
    fetchError: null
};

});

parcelRegister("8UmI9", function(module, exports) {

$parcel$export(module.exports, "useIsBusinessProject", () => $d1bed05bd9fbc7d5$export$f1bf366948a19b0f);

var $dAfqg = parcelRequire("dAfqg");

var $2vSU6 = parcelRequire("2vSU6");
const $d1bed05bd9fbc7d5$export$f1bf366948a19b0f = ()=>{
    const { data: data, loading: loading } = (0, $dAfqg.useProjectContext)();
    const isBusinessProject = data?.projectType === (0, $2vSU6.CORE_PROJECT);
    return {
        isBusinessProject: isBusinessProject,
        loading: loading
    };
};

});

parcelRegister("4mXzi", function(module, exports) {

$parcel$export(module.exports, "actions", () => $f50a5e3bb7b9f239$export$e324594224ef24da);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $7bRcT = parcelRequire("7bRcT");

var $FroD7 = parcelRequire("FroD7");
const $f50a5e3bb7b9f239$var$fetchOnboardingPersonalisation = (0, $7bRcT.cachedEndpointCall)((args)=>(0, $FroD7.fetchOnboardingPersonalisationWithRethrow)(args));
const $f50a5e3bb7b9f239$var$trackPersonalisationAction = ({ additionalParameters: additionalParameters })=>()=>(0, $FroD7.trackPersonalisation)({
            additionalParameters: additionalParameters
        });
const $f50a5e3bb7b9f239$export$e324594224ef24da = {
    fetchOnboardingPersonalisation: $f50a5e3bb7b9f239$var$fetchOnboardingPersonalisation,
    trackPersonalisation: $f50a5e3bb7b9f239$var$trackPersonalisationAction
};

});
parcelRegister("7bRcT", function(module, exports) {

$parcel$export(module.exports, "cachedEndpointCall", () => $69bbbca5d7164078$export$9ab04ab45a9b99da);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $69bbbca5d7164078$export$9ab04ab45a9b99da = (call)=>(params)=>async ({ getState: getState, setState: setState })=>{
            const { isFetching: isFetching, wasFetched: wasFetched, fetchedOnce: fetchedOnce } = getState();
            if (isFetching || wasFetched) return;
            setState({
                isFetching: true
            });
            try {
                const data = await call(params);
                if (data !== null) setState({
                    data: data,
                    wasFetched: true
                });
                else setState({
                    wasFetched: fetchedOnce
                });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                setState({
                    fetchError: error
                });
            } finally{
                setState({
                    isFetching: false,
                    fetchedOnce: true
                });
            }
        };

});

parcelRegister("FroD7", function(module, exports) {

$parcel$export(module.exports, "fetchOnboardingPersonalisationWithRethrow", () => $501ec097caecd266$export$6bc39428b6510a7c);
$parcel$export(module.exports, "trackPersonalisation", () => $501ec097caecd266$export$9835c32b78102887);

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");

var $fv5ut = parcelRequire("fv5ut");
const $501ec097caecd266$var$PERSONALISATION_ENDPOINT = '/rest/personalisation/v1/experience';
const $501ec097caecd266$var$TRACK_PERSONALISATION_ENDPOINT = '/rest/personalisation/v1/track';
const $501ec097caecd266$var$responseHasAllRequestedExperienceTypes = ({ response: response, requestedExperienceTypes: requestedExperienceTypes })=>requestedExperienceTypes.every((requestedExperienceType)=>response.experience[requestedExperienceType]);
const $501ec097caecd266$export$6bc39428b6510a7c = async ({ experienceTypes: experienceTypes = [
    'QUICKSTART',
    'TEMPLATE',
    'LANDING_PAGE'
], additionalParameters: additionalParameters })=>{
    try {
        const localStorageOnboardingPersonalisationResponse = (0, $fv5ut.getLocalStorageOnboardingPersonalisationResponse)();
        if (localStorageOnboardingPersonalisationResponse && $501ec097caecd266$var$responseHasAllRequestedExperienceTypes({
            response: localStorageOnboardingPersonalisationResponse,
            requestedExperienceTypes: experienceTypes
        })) return localStorageOnboardingPersonalisationResponse;
        const response = await (0, $eusud.performPostRequestWithRetry)($501ec097caecd266$var$PERSONALISATION_ENDPOINT, {
            body: JSON.stringify({
                experienceTypes: experienceTypes,
                additionalParameters: additionalParameters
            })
        });
        if (response) {
            const mergedResponse = {
                experience: {
                    ...localStorageOnboardingPersonalisationResponse?.experience,
                    ...response.experience
                },
                matched: response.matched
            };
            (0, $fv5ut.setLocalStorageOnboardingPersonalisationResponse)(mergedResponse);
            return mergedResponse;
        }
        throw new Error('response from OnboardingPersonalisation is falsy');
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.default)({
            error: error,
            meta: {
                id: 'fetchOnboardingPersonalisationWithRethrow',
                packageName: 'jiraOnboardingCore',
                teamName: 'jlove-makkuro'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }
};
const $501ec097caecd266$export$9835c32b78102887 = ({ additionalParameters: additionalParameters })=>{
    try {
        (0, $eusud.performPostRequestWithRetry)($501ec097caecd266$var$TRACK_PERSONALISATION_ENDPOINT, {
            body: JSON.stringify({
                additionalParameters: additionalParameters
            })
        });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.default)({
            error: error,
            meta: {
                id: 'trackOnboardingPersonalisation',
                packageName: 'jiraOnboardingCore',
                teamName: 'jlove-makkuro'
            },
            sendToPrivacyUnsafeSplunk: true
        });
    }
};

});
parcelRegister("fv5ut", function(module, exports) {

$parcel$export(module.exports, "getLocalStorageOnboardingPersonalisationResponse", () => $673c953eac85fdf0$export$e9fb5b94c03fa495);
$parcel$export(module.exports, "setLocalStorageOnboardingPersonalisationResponse", () => $673c953eac85fdf0$export$dda9cd59669fc243);

var $bSSG7 = parcelRequire("bSSG7");

var $jcw0u = parcelRequire("jcw0u");
const $673c953eac85fdf0$var$LOCALSTORAGE_ONBOARDING_PERSONALISATION_RESPONSE = 'response';
const $673c953eac85fdf0$var$localStorage = (0, $bSSG7.createLocalStorageProvider)('jira-onboarding-personalisation');
const $673c953eac85fdf0$export$e9fb5b94c03fa495 = ()=>{
    try {
        return $673c953eac85fdf0$var$localStorage.get($673c953eac85fdf0$var$LOCALSTORAGE_ONBOARDING_PERSONALISATION_RESPONSE);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.default)({
            error: error,
            meta: {
                id: 'localStorageGetOnboardingPersonalisation',
                packageName: 'jiraOnboardingCore',
                teamName: 'jlove-makkuro'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        return undefined;
    }
};
const $673c953eac85fdf0$export$dda9cd59669fc243 = (response)=>{
    try {
        $673c953eac85fdf0$var$localStorage.set($673c953eac85fdf0$var$LOCALSTORAGE_ONBOARDING_PERSONALISATION_RESPONSE, response);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.default)({
            error: error,
            meta: {
                id: 'localStorageSetOnboardingPersonalisationResponse',
                packageName: 'jiraOnboardingCore',
                teamName: 'jlove-makkuro'
            },
            sendToPrivacyUnsafeSplunk: true
        });
    }
};

});



parcelRegister("iAFnF", function(module, exports) {

$parcel$export(module.exports, "ELIGIBLE_TEAM_TYPES_M2_FULL_NOTATION", () => $afa1ef0e1c3d15e2$export$1d38dc41bb005254);

var $5PxqD = parcelRequire("5PxqD");
const $afa1ef0e1c3d15e2$export$1d38dc41bb005254 = [
    (0, $5PxqD.USER_SEGMENTATION_TEAM_TYPE_MARKETING),
    (0, $5PxqD.USER_SEGMENTATION_TEAM_TYPE_OPERATIONS)
];

});
parcelRegister("5PxqD", function(module, exports) {

$parcel$export(module.exports, "USER_SEGMENTATION_TEAM_TYPE_MARKETING", () => $5d0851fa8905d151$export$e4824f74b9879164);
$parcel$export(module.exports, "USER_SEGMENTATION_TEAM_TYPE_OPERATIONS", () => $5d0851fa8905d151$export$4f3cb0844009af52);
$parcel$export(module.exports, "userBelongsToBusinessUserSegCategory", () => $5d0851fa8905d151$export$517f94ab07724226);

var $jcw0u = parcelRequire("jcw0u");
// Roles defined in user segmentation
const $5d0851fa8905d151$var$USER_SEGMENTATION_ROLE_DESIGNER = 'designer';
const $5d0851fa8905d151$export$572242e58bd07594 = 'customer-service';
const $5d0851fa8905d151$export$d7de553940261eba = 'it-support';
const $5d0851fa8905d151$export$4c29d0d04c15e55d = 'human-resources';
const $5d0851fa8905d151$export$3950f7f841bf94b6 = 'finance';
const $5d0851fa8905d151$export$881249b988b6030f = 'legal';
const $5d0851fa8905d151$export$e4824f74b9879164 = 'marketing';
const $5d0851fa8905d151$export$4f3cb0844009af52 = 'operations';
const $5d0851fa8905d151$export$1a65d50c4a641bb4 = 'sales';
const $5d0851fa8905d151$export$b8b1ac856ba1434b = 'software-development';
// Unique identifier used where all roles in a team type are eligible
const $5d0851fa8905d151$var$ALL_ROLES_ELIGIBLE = 'all-roles-eligible';
const $5d0851fa8905d151$export$2f3f9640393bd078 = 'unknown';
const $5d0851fa8905d151$export$4c9a72dac5ce80ae = '';
// @ts-expect-error - It seems to be missing some translations (for all-roles-eligible).
const $5d0851fa8905d151$var$USER_SEGMENTATION_CLIENT_MAPPING = {
    [$5d0851fa8905d151$var$USER_SEGMENTATION_ROLE_DESIGNER]: [
        'Designer',
        'Disainer',
        "Dise\xf1ador",
        'Formgivare',
        "Nh\xe0 thi\u1EBFt k\u1EBF",
        'Projektant',
        'Suunnittelija',
        "Tasar\u0131mc\u0131",
        "Tervez\u0151",
        "\u0414\u0438\u0437\u0430\u0439\u043D\u0435\u0440",
        "\u0E19\u0E31\u0E01\u0E2D\u0E2D\u0E01\u0E41\u0E1A\u0E1A",
        "\u30C7\u30B6\u30A4\u30CA\u30FC",
        "\u8A2D\u8A08\u5E2B",
        "\u8BBE\u8BA1\u5E08",
        "\uB514\uC790\uC774\uB108"
    ],
    [$5d0851fa8905d151$export$572242e58bd07594]: [
        'Asiakaspalvelu',
        'Atendimento ao cliente',
        'Customer Service',
        "D\u1ECBch v\u1EE5 kh\xe1ch h\xe0ng",
        'Klantenservice',
        'Klienditeenindus',
        'Kundenservice',
        'Kundeservice',
        'Kundservice',
        "M\xfc\u015Fteri Hizmetleri",
        "Obs\u0142uga klienta",
        "Service \xe0 la client\xe8le",
        "Servicio de atenci\xf3n al cliente",
        'Servizio clienti',
        "Servi\xe7o de apoio ao cliente",
        "Z\xe1kaznick\xfd servis",
        "Z\xe1kazn\xedcky servis",
        "\xdcgyf\xe9lszolg\xe1lati",
        "\u041E\u0431\u0441\u043B\u0443\u0436\u0438\u0432\u0430\u043D\u0438\u0435 \u043A\u043B\u0438\u0435\u043D\u0442\u043E\u0432",
        "\u0421\u043B\u0443\u0436\u0431\u0430 \u043F\u0456\u0434\u0442\u0440\u0438\u043C\u043A\u0438 \u043A\u043B\u0456\u0454\u043D\u0442\u0456\u0432",
        "\u0E1A\u0E23\u0E34\u0E01\u0E32\u0E23\u0E25\u0E39\u0E01\u0E04\u0E49\u0E32",
        "\u30AB\u30B9\u30BF\u30DE\u30FC \u30B5\u30FC\u30D3\u30B9",
        "\u5BA2\u6237\u670D\u52A1",
        "\u9867\u5BA2\u670D\u52D9",
        "\uACE0\uAC1D \uC11C\uBE44\uC2A4"
    ],
    [$5d0851fa8905d151$export$d7de553940261eba]: [
        'Assistenza IT',
        "BT Deste\u011Fi",
        "H\u1ED7 tr\u1EE3 CNTT",
        'IT',
        'IT Support',
        'IT podpora',
        "IT \u30B5\u30DD\u30FC\u30C8",
        "IT \u652F\u6301",
        "IT \u652F\u63F4",
        "IT \uC9C0\uC6D0",
        'IT_Support',
        "IT_st\xf8tte",
        'IT_support',
        'IT_tugi',
        'IT_tuki',
        "Informatikai t\xe1mogat\xe1si",
        'Soporte de TI',
        'Suporte de TI',
        "Support\xa0IT",
        'Wsparcie IT',
        "\u0418\u0422-\u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0430",
        "\u0421\u043B\u0443\u0436\u0431\u0430 \u0442\u0435\u0445\u043D\u0456\u0447\u043D\u043E\u0457 \u043F\u0456\u0434\u0442\u0440\u0438\u043C\u043A\u0438",
        "\u0E1D\u0E48\u0E32\u0E22\u0E2A\u0E19\u0E31\u0E1A\u0E2A\u0E19\u0E38\u0E19 IT"
    ],
    [$5d0851fa8905d151$export$3950f7f841bf94b6]: [
        'Ekonomi',
        'Finance',
        'Financeiro',
        'Financie',
        'Finans',
        'Finanse',
        'Finants',
        'Finanza',
        'Finanzas',
        'Finanzen',
        "Finan\xe7as",
        "P\xe9nz\xfcgyi",
        'Rahoitus',
        "T\xe0i ch\xednh",
        "\xd8konomi",
        "\u0424\u0438\u043D\u0430\u043D\u0441\u044B",
        "\u0424\u0456\u043D\u0430\u043D\u0441\u0438",
        "\u0E01\u0E32\u0E23\u0E40\u0E07\u0E34\u0E19",
        "\u8CA1\u52D9",
        "\u91D1\u878D",
        "\uC7AC\uBB34"
    ],
    [$5d0851fa8905d151$export$4c29d0d04c15e55d]: [
        'HR',
        "Henkil\xf6st\xf6hallinto",
        'Human Resources',
        'Human resources',
        'human-resources',
        "Lidsk\xe9 zdroje",
        'Menneskelige ressourcer',
        "Nh\xe2n s\u1EF1",
        'Personal',
        "Personalfr\xe5gor",
        'RH',
        'Recursos Humanos',
        'Recursos humanos',
        'Risorse umane',
        "Szem\xe9lyzeti",
        'Zasoby ludzkie',
        "\u0130nsan Kaynaklar\u0131",
        "\u013Dudsk\xe9 zdroje",
        "\u0412\u0456\u0434\u0434\u0456\u043B \u043A\u0430\u0434\u0440\u0456\u0432",
        "\u041A\u0430\u0434\u0440\u043E\u0432\u044B\u0435 \u0432\u043E\u043F\u0440\u043E\u0441\u044B",
        "\u0E17\u0E23\u0E31\u0E1E\u0E22\u0E32\u0E01\u0E23\u0E1A\u0E38\u0E04\u0E04\u0E25",
        "\u4EBA\u4E8B",
        "\u4EBA\u529B\u8CC7\u6E90",
        "\u4EBA\u529B\u8D44\u6E90",
        "\uC778\uC0AC"
    ],
    [$5d0851fa8905d151$export$881249b988b6030f]: [
        "Departamento jur\xeddico",
        'Hukuk',
        'Jogi',
        'Jura',
        'Juridik',
        'Juridisk',
        "Jur\xeddico",
        'Legal',
        'Legale',
        'Oikeudelliset asiat',
        "Ph\xe1p l\xfd",
        'Prawo',
        "Pr\xe1vne oddelenie",
        "Pr\xe1vn\xed odd\u011Blen\xed",
        'Rechtliches',
        'Service juridique',
        "\xd5igus",
        "\u042E\u0440\u0438\u0434\u0438\u0447\u0435\u0441\u043A\u0438\u0435 \u0432\u043E\u043F\u0440\u043E\u0441\u044B",
        "\u042E\u0440\u0438\u0434\u0438\u0447\u043D\u0438\u0439 \u0432\u0456\u0434\u0434\u0456\u043B",
        "\u0E01\u0E0E\u0E2B\u0E21\u0E32\u0E22",
        "\u6CD5\u52D9",
        "\u6CD5\u5F8B",
        "\uBC95\uB960"
    ],
    [$5d0851fa8905d151$export$e4824f74b9879164]: [
        "Markedsf\xf8ring",
        'Marketing',
        'Markkinointi',
        "Marknadsf\xf6ring",
        'Pazarlama',
        "Ti\u1EBFp th\u1ECB",
        'Turundus',
        "\u041C\u0430\u0440\u043A\u0435\u0442\u0438\u043D\u0433",
        "\u0E01\u0E32\u0E23\u0E15\u0E25\u0E32\u0E14",
        "\u30DE\u30FC\u30B1\u30C6\u30A3\u30F3\u30B0",
        "\u8425\u9500",
        "\u884C\u92B7",
        "\uB9C8\uCF00\uD305"
    ],
    [$5d0851fa8905d151$export$4f3cb0844009af52]: [
        'Drift',
        'Haldus',
        'Operacional',
        'Operaciones',
        'Operacje',
        'Operasyonlar',
        'Operations',
        'Operativer Betrieb',
        'Operazioni',
        "Opera\xe7\xf5es",
        "Op\xe9rations",
        "Prev\xe1dzka",
        'Provoz',
        'Toiminnot',
        "V\u1EADn h\xe0nh",
        "\xdczemeltet\xe9si",
        "\u0412\u0438\u0440\u043E\u0431\u043D\u0438\u0447\u0438\u0439 \u0432\u0456\u0434\u0434\u0456\u043B",
        "\u041E\u043F\u0435\u0440\u0430\u0446\u0438\u043E\u043D\u043D\u044B\u0435 \u0432\u043E\u043F\u0440\u043E\u0441\u044B",
        "\u0E1D\u0E48\u0E32\u0E22\u0E1B\u0E0F\u0E34\u0E1A\u0E31\u0E15\u0E34\u0E01\u0E32\u0E23",
        "\u30AA\u30DA\u30EC\u30FC\u30B7\u30E7\u30F3",
        "\u71DF\u904B",
        "\u8FD0\u8425",
        "\uC6B4\uC601"
    ],
    [$5d0851fa8905d151$export$1a65d50c4a641bb4]: [
        "B\xe1n h\xe0ng",
        "F\xf6rs\xe4ljning",
        'Myynti',
        "M\xfc\xfck",
        'Predaj',
        'Prodej',
        'Sales',
        'Salg',
        "Sat\u0131\u015F",
        "Sprzeda\u017C",
        'Vendas',
        'Vendite',
        'Ventas',
        'Ventes',
        'Vertrieb',
        "\xc9rt\xe9kes\xedt\xe9si",
        "\u041F\u0440\u043E\u0434\u0430\u0436\u0438",
        "\u041F\u0440\u043E\u0434\u0430\u0436\u0456",
        "\u0E1D\u0E48\u0E32\u0E22\u0E02\u0E32\u0E22",
        "\u30BB\u30FC\u30EB\u30B9",
        "\u92B7\u552E",
        "\u9500\u552E",
        "\uC601\uC5C5"
    ],
    [$5d0851fa8905d151$export$b8b1ac856ba1434b]: [
        'Desarrollo de software',
        'Desenvolvimento de software',
        "D\xe9veloppement logiciel",
        'Ohjelmistokehitys',
        "Ph\xe1t tri\u1EC3n ph\u1EA7n m\u1EC1m",
        'Programutveckling',
        'Programvareutvikling',
        'Software Development',
        'Softwareentwicklung',
        'Softwareontwikkeling',
        'Softwareudvikling',
        'Sviluppo software',
        "Szoftverfejleszt\u0151",
        'Tarkvaraarendus',
        'Tworzenie oprogramowania',
        "V\xfdvoj softv\xe9ru",
        "V\xfdvoj softwaru",
        "Yaz\u0131l\u0131m Geli\u015Ftirme",
        "\u0420\u0430\u0437\u0440\u0430\u0431\u043E\u0442\u043A\u0430 \u041F\u041E",
        "\u0420\u043E\u0437\u0440\u043E\u0431\u043A\u0430 \u041F\u0417",
        "\u0E1E\u0E31\u0E12\u0E19\u0E32\u0E0B\u0E2D\u0E1F\u0E15\u0E4C\u0E41\u0E27\u0E23\u0E4C",
        "\u30BD\u30D5\u30C8\u30A6\u30A7\u30A2\u958B\u767A",
        "\u8EDF\u9AD4\u958B\u767C",
        "\u8F6F\u4EF6\u5F00\u53D1",
        "\uC18C\uD504\uD2B8\uC6E8\uC5B4 \uAC1C\uBC1C"
    ]
};
const $5d0851fa8905d151$var$BUSINESS_TEAM_TYPES = [
    $5d0851fa8905d151$export$4c29d0d04c15e55d,
    $5d0851fa8905d151$export$3950f7f841bf94b6,
    $5d0851fa8905d151$export$881249b988b6030f,
    $5d0851fa8905d151$export$e4824f74b9879164,
    $5d0851fa8905d151$export$4f3cb0844009af52,
    $5d0851fa8905d151$export$1a65d50c4a641bb4,
    $5d0851fa8905d151$export$b8b1ac856ba1434b
];
const $5d0851fa8905d151$var$BUSINESS_ROLES_PER_TEAM_TYPE = {
    [$5d0851fa8905d151$export$4c29d0d04c15e55d]: [
        $5d0851fa8905d151$var$ALL_ROLES_ELIGIBLE
    ],
    [$5d0851fa8905d151$export$3950f7f841bf94b6]: [
        $5d0851fa8905d151$var$ALL_ROLES_ELIGIBLE
    ],
    [$5d0851fa8905d151$export$881249b988b6030f]: [
        $5d0851fa8905d151$var$ALL_ROLES_ELIGIBLE
    ],
    [$5d0851fa8905d151$export$e4824f74b9879164]: [
        $5d0851fa8905d151$var$ALL_ROLES_ELIGIBLE
    ],
    [$5d0851fa8905d151$export$4f3cb0844009af52]: [
        $5d0851fa8905d151$var$ALL_ROLES_ELIGIBLE
    ],
    [$5d0851fa8905d151$export$1a65d50c4a641bb4]: [
        $5d0851fa8905d151$var$ALL_ROLES_ELIGIBLE
    ],
    [$5d0851fa8905d151$export$b8b1ac856ba1434b]: [
        $5d0851fa8905d151$var$USER_SEGMENTATION_ROLE_DESIGNER
    ]
};
const $5d0851fa8905d151$var$getNormalizedEntry = (userSegValue)=>{
    const lowerCaseUserSegValue = userSegValue.toLowerCase();
    return Object.entries($5d0851fa8905d151$var$USER_SEGMENTATION_CLIENT_MAPPING).find(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    ([, translatedValues])=>translatedValues.map((v)=>v.toLowerCase()).includes(lowerCaseUserSegValue));
};
const $5d0851fa8905d151$export$d0bc507f0556398 = (value)=>{
    if (value === '') return $5d0851fa8905d151$export$4c9a72dac5ce80ae;
    const normalizedEntry = $5d0851fa8905d151$var$getNormalizedEntry(value);
    return normalizedEntry !== undefined ? normalizedEntry[0] : $5d0851fa8905d151$export$2f3f9640393bd078;
};
class $5d0851fa8905d151$var$SkipSentryError extends Error {
    constructor(message){
        super(message);
        this.skipSentry = true;
    }
}
const $5d0851fa8905d151$var$fireAnalyticsError = ({ id: id, field: field, error: error, unMatchedValue: unMatchedValue })=>{
    (0, $jcw0u.default)({
        meta: {
            id: id,
            packageName: 'jiraOnboardingCore'
        },
        attributes: {
            field: field,
            unMatchedValue: unMatchedValue
        },
        error: error,
        sendToPrivacyUnsafeSplunk: true
    });
};
const $5d0851fa8905d151$export$af8a28b856b3556f = (teamType)=>{
    if (!teamType) return false;
    const normalizedTeamType = $5d0851fa8905d151$export$d0bc507f0556398(teamType);
    if (normalizedTeamType === $5d0851fa8905d151$export$2f3f9640393bd078) $5d0851fa8905d151$var$fireAnalyticsError({
        id: 'isInSoftwareTeam',
        field: 'teamType',
        error: new $5d0851fa8905d151$var$SkipSentryError('teamType mapping is not found'),
        unMatchedValue: teamType
    });
    return normalizedTeamType === $5d0851fa8905d151$export$b8b1ac856ba1434b;
};
const $5d0851fa8905d151$export$517f94ab07724226 = (userAccountData)=>{
    const { teamType: teamType = '', role: role = '' } = userAccountData;
    const normalizedTeamType = $5d0851fa8905d151$export$d0bc507f0556398(teamType);
    if (normalizedTeamType === $5d0851fa8905d151$export$2f3f9640393bd078) $5d0851fa8905d151$var$fireAnalyticsError({
        id: 'userBelongsToBusinessUserSegCategory',
        field: 'teamType',
        error: new $5d0851fa8905d151$var$SkipSentryError('teamType mapping is not found'),
        unMatchedValue: teamType
    });
    const normalizedRole = $5d0851fa8905d151$export$d0bc507f0556398(role);
    if (normalizedRole === $5d0851fa8905d151$export$2f3f9640393bd078) $5d0851fa8905d151$var$fireAnalyticsError({
        id: 'userBelongsToBusinessUserSegCategory',
        field: 'role',
        error: new $5d0851fa8905d151$var$SkipSentryError('role mapping is not found'),
        unMatchedValue: role
    });
    // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'UserSegmentationTeamTypes'.
    const isTeamTypeEligible = $5d0851fa8905d151$var$BUSINESS_TEAM_TYPES.includes(normalizedTeamType);
    const isRoleEligible = // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<UserSegmentationTeamTypes, UserSegmentationRoleTypes[]>>'.
    $5d0851fa8905d151$var$BUSINESS_ROLES_PER_TEAM_TYPE[normalizedTeamType]?.includes($5d0851fa8905d151$var$ALL_ROLES_ELIGIBLE) || // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<UserSegmentationTeamTypes, UserSegmentationRoleTypes[]>>'.
    $5d0851fa8905d151$var$BUSINESS_ROLES_PER_TEAM_TYPE[normalizedTeamType]?.includes(normalizedRole);
    return isTeamTypeEligible && isRoleEligible;
};
const $5d0851fa8905d151$export$6710e0127706b297 = (userAccountData)=>{
    const { teamType: teamType = '', role: role = '' } = userAccountData;
    const normalizedTeamType = $5d0851fa8905d151$export$d0bc507f0556398(teamType);
    if (normalizedTeamType === $5d0851fa8905d151$export$2f3f9640393bd078) $5d0851fa8905d151$var$fireAnalyticsError({
        id: 'userBelongsToSoftwareUserSegCategory',
        field: 'teamType',
        error: new $5d0851fa8905d151$var$SkipSentryError('teamType mapping is not found'),
        unMatchedValue: teamType
    });
    const normalizedRole = $5d0851fa8905d151$export$d0bc507f0556398(role);
    if (normalizedRole === $5d0851fa8905d151$export$2f3f9640393bd078) $5d0851fa8905d151$var$fireAnalyticsError({
        id: 'userBelongsToSoftwareUserSegCategory',
        field: 'role',
        error: new $5d0851fa8905d151$var$SkipSentryError('role mapping is not found'),
        unMatchedValue: role
    });
    const isTeamTypeEligible = normalizedTeamType === $5d0851fa8905d151$export$b8b1ac856ba1434b;
    const isRoleEligible = normalizedRole !== $5d0851fa8905d151$var$USER_SEGMENTATION_ROLE_DESIGNER;
    return isTeamTypeEligible && isRoleEligible;
};

});



parcelRegister("4DPZY", function(module, exports) {

$parcel$export(module.exports, "useContainerContext", () => $a65e0c39573f7437$export$c7066c2d215990cf);
$parcel$export(module.exports, "ContainerContextSubscriber", () => $a65e0c39573f7437$export$5b87a78c45d5dd17);
// eslint-disable-next-line jira/restricted/react-component-props

var $5uXOq = parcelRequire("5uXOq");

var $7xTO3 = parcelRequire("7xTO3");

var $ggg5j = parcelRequire("ggg5j");

var $2YP9W = parcelRequire("2YP9W");

var $6SkQo = parcelRequire("6SkQo");
const $a65e0c39573f7437$var$useProjectContext = ()=>{
    const { data: data, loading: loading, error: error, refresh: refresh } = (0, $2YP9W.useResource)((0, $ggg5j.staticProjectSidebarNavigationResource));
    const projectContext = (0, $5uXOq.useMemo)(()=>data && (0, $6SkQo.getProjectContext)(data), [
        data
    ]);
    return [
        {
            data: projectContext,
            error: error,
            loading: loading
        },
        {
            fetch: refresh,
            refetch: refresh
        }
    ];
};
const $a65e0c39573f7437$var$useUserBoardContext = ()=>{
    const { data: data, loading: loading, error: error, refresh: refresh } = (0, $2YP9W.useResource)((0, $7xTO3.staticJSWUserBoardSidebarNavigationResource));
    const userContext = (0, $5uXOq.useMemo)(()=>data && (0, $6SkQo.getUserContext)(data), [
        data
    ]);
    return [
        {
            data: userContext,
            error: error,
            loading: loading
        },
        {
            fetch: refresh,
            refetch: refresh
        }
    ];
};
const $a65e0c39573f7437$export$c7066c2d215990cf = ()=>{
    const projectContext = $a65e0c39573f7437$var$useProjectContext();
    const userBoardContext = $a65e0c39573f7437$var$useUserBoardContext();
    if (userBoardContext && userBoardContext[0] && userBoardContext[0].data != null) return userBoardContext;
    return projectContext;
};
const $a65e0c39573f7437$export$5b87a78c45d5dd17 = (props)=>{
    const [data, actions] = $a65e0c39573f7437$export$c7066c2d215990cf();
    // @ts-expect-error - TS2345 - Argument of type '{ readonly data: ContainerContext | null; readonly error: Error | Record<string, any> | (Error & Record<string, any>) | (Record<string, any> & Error) | null; readonly loading: boolean; }' is not assignable to parameter of type 'ContainerContextData'.
    return props.children(data, actions);
};
$a65e0c39573f7437$export$5b87a78c45d5dd17.displayName = 'ContainerContextSubscriber';

});
parcelRegister("6SkQo", function(module, exports) {

$parcel$export(module.exports, "getUserContext", () => $84cf60e2c9c0e289$export$114c35c2c23732ab);
$parcel$export(module.exports, "getProjectContext", () => $84cf60e2c9c0e289$export$d17fffd59c7b3c60);

var $4R6GH = parcelRequire("4R6GH");

var $2vSU6 = parcelRequire("2vSU6");

var $bsuuc = parcelRequire("bsuuc");
const $84cf60e2c9c0e289$export$114c35c2c23732ab = (userBoardNavData)=>{
    const { boardInfo: boardInfo, owner: owner } = userBoardNavData;
    return {
        contextType: 'user',
        user: {
            id: owner.id,
            name: owner.name,
            avatarUrl: owner.avatarUrl,
            profileUrl: owner.profileUrl,
            accountId: owner.accountId
        },
        scope: {
            id: boardInfo.id,
            type: boardInfo.type,
            name: boardInfo.name
        }
    };
};
const $84cf60e2c9c0e289$var$getScope = (projectNavInfo)=>{
    if (projectNavInfo.projectType === 'jira_software' && projectNavInfo?.jiraSoftwareNavData?.boardInfo) {
        const { boardInfo: boardInfo } = projectNavInfo.jiraSoftwareNavData;
        return {
            id: boardInfo.id,
            type: boardInfo.type,
            name: boardInfo.name
        };
    }
    return undefined;
};
const $84cf60e2c9c0e289$var$getProjectType = (projectType)=>{
    if (projectType === 'customer_service' && (0, $4R6GH.fg)('jcs_project_type_m3')) return 0, $2vSU6.CUSTOMER_SERVICE_PROJECT;
    switch(projectType){
        case 'business':
            return 0, $2vSU6.CORE_PROJECT;
        case 'software':
            return 0, $2vSU6.SOFTWARE_PROJECT;
        case 'service_desk':
            return 0, $2vSU6.SERVICE_DESK_PROJECT;
        case 'product_discovery':
            return 0, $2vSU6.PRODUCT_DISCOVERY_PROJECT;
        default:
            return null;
    }
};
const $84cf60e2c9c0e289$export$d17fffd59c7b3c60 = (projectNavInfo)=>{
    const project = (0, $bsuuc.extractData)(projectNavInfo);
    const scope = $84cf60e2c9c0e289$var$getScope(projectNavInfo);
    if (project) {
        const projectType = $84cf60e2c9c0e289$var$getProjectType(project.type);
        if (projectType) return {
            contextType: 'project',
            project: {
                key: project.key,
                // @ts-expect-error TS2322: Type 'number' is not assignable to type 'string'
                id: project.id,
                name: project.name,
                type: projectType,
                isSimplified: project.isSimplified,
                avatarUrl: project.avatarUrl,
                style: (0, $bsuuc.getStyle)(project.isSimplified)
            },
            scope: scope
        };
    }
    return null;
};

});


parcelRegister("4igab", function(module, exports) {

$parcel$export(module.exports, "useQuickstartInitialise", () => $acadf6219835098e$export$10654bdbbe3c2561);
$parcel$export(module.exports, "useQuickstartInitialiseWithPersonalisation", () => $acadf6219835098e$export$6ef8438579867e87);

var $5uXOq = parcelRequire("5uXOq");

var $2vSU6 = parcelRequire("2vSU6");

var $i6yVb = parcelRequire("i6yVb");

var $8GOso = parcelRequire("8GOso");

var $8Bc5A = parcelRequire("8Bc5A");

var $cE2Qr = parcelRequire("cE2Qr");

var $byS8t = parcelRequire("byS8t");

var $h9iZl = parcelRequire("h9iZl");

var $6jY6G = parcelRequire("6jY6G");

var $2NMNM = parcelRequire("2NMNM");

var $gh567 = parcelRequire("gh567");


var $fZRGa = parcelRequire("fZRGa");


var $jrUuh = parcelRequire("jrUuh");

var $ldyPw = parcelRequire("ldyPw");

var $heI7y = parcelRequire("heI7y");

var $9OXo1 = parcelRequire("9OXo1");

var $doZTA = parcelRequire("doZTA");

var $4R6GH = parcelRequire("4R6GH");

var $gWE9S = parcelRequire("gWE9S");

var $6MqfV = parcelRequire("6MqfV");

var $bPD6R = parcelRequire("bPD6R");

var $2S7gn = parcelRequire("2S7gn");

var $lQB52 = parcelRequire("lQB52");
const $acadf6219835098e$export$10654bdbbe3c2561 = (projectContextData)=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    const isTrelloCrossflow = (0, $i6yVb.useIsTrelloCrossflowEnabled)();
    const canShowExperience = (0, $2S7gn.useQuickstart)(projectContextData);
    const [quickstartStatus] = (0, $cE2Qr.useQuickstartUiStatus)();
    const [{ data: jsmOnboardingData }, { fetchOnboardingType: fetchOnboardingType }] = (0, $jrUuh.useJsmOnboardingType)();
    (0, $6MqfV.useRefreshOnJSMProjectSwitch)(projectContextData?.projectId, projectContextData?.projectType);
    const canEditPlans = (0, $h9iZl.useNavigationEditPlansPermission)();
    const isAdvancedRoadmapsTrial = (0, $h9iZl.useIsAdvancedRoadmapsTrial)();
    const isTargetedForReverseTrials = (0, $gh567.useIsTargetedForReverseTrials)();
    const [{ isQuickstartLoaded: isQuickstartLoaded, shouldRenderComponent: shouldRenderComponent }, { refreshAppState: refreshAppState, setShouldRenderComponent: setShouldRenderComponent, forceHideNudge: forceHideNudge, setProjectState: setProjectState, syncVisibilityWithLocal: syncVisibilityWithLocal }] = (0, $cE2Qr.useJswOnboarding)();
    const [{ hasOpened: hasOpened }, { setHasOpened: setHasOpened }] = (0, $heI7y.useHasOpened)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [isSampleProject, { fetchIsSampleProject: fetchIsSampleProject }] = (0, $gWE9S.useIsSampleProjectService)();
    const canInvitePeopleToProject = (0, $lQB52.getCanInvitePeopleToProject)(projectContextData, tenantContext);
    const route = (0, $6jY6G.useCurrentRoute)();
    const isProjectSettingsPage = (0, $8Bc5A.PROJECT_SETTING_PAGES).includes(route.name);
    const isEnrolledForProjectSettings = isProjectSettingsPage && canShowExperience && canInvitePeopleToProject;
    const hasLoadedRemoteState = (0, $5uXOq.useRef)(false);
    const [{ location: location }] = (0, $doZTA.useRouter)();
    (0, $5uXOq.useEffect)(()=>{
        if (projectContextData?.projectKey && projectContextData?.projectType === (0, $2vSU6.CORE_PROJECT)) fetchIsSampleProject(projectContextData.projectKey);
    }, [
        fetchIsSampleProject,
        projectContextData?.projectKey,
        projectContextData?.projectType
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!projectContextData) return;
        const { projectKey: projectKey, projectName: projectName, projectId: projectId, simplified: isNextGen, projectType: projectType, isProjectAdmin: isProjectAdminMaybe } = projectContextData;
        setProjectState({
            canInvitePeopleToProject: canInvitePeopleToProject,
            projectKey: projectKey,
            projectId: projectId,
            projectName: projectName,
            isNextGen: isNextGen,
            projectType: projectType,
            isProjectAdmin: Boolean(isProjectAdminMaybe),
            userRole: (0, $lQB52.getUserRole)(tenantContext.isSiteAdmin, tenantContext.isAdmin),
            edition: (0, $ldyPw.getEditionForProject)(projectType, tenantContext.appEditions),
            isSampleProject: isSampleProject[projectKey],
            isTrelloCrossflow: isTrelloCrossflow
        });
    }, [
        setProjectState,
        projectContextData,
        canInvitePeopleToProject,
        isProjectSettingsPage,
        tenantContext,
        isSampleProject,
        isTrelloCrossflow
    ]);
    (0, $5uXOq.useEffect)(()=>{
        fetchOnboardingType(projectContextData?.projectId, projectContextData?.projectType);
    }, [
        fetchOnboardingType,
        projectContextData
    ]);
    // When the component is re-mounted after the initial remote state load.
    (0, $5uXOq.useEffect)(()=>{
        // We can show the experience and are in the right page or experiment.
        const pathNameWithoutTrailingSlash = (0, $fZRGa.extractTrailingSlashFromPath)(location.pathname);
        const isJsmBusinessPeopleSettingsPage = projectContextData?.projectType === (0, $2vSU6.SERVICE_DESK_PROJECT) && jsmOnboardingData?.onboardingType === (0, $e7830161eb8674f1$export$6f454e69bce3a691) && pathNameWithoutTrailingSlash.endsWith((0, $08a37b02293d63ea$export$d2fcfad22215d3a3));
        const canReallyShowExperience = canShowExperience && // TODO: move this logic inside the useQuickstart hook (canShowExperience)
        (isJsmBusinessPeopleSettingsPage || !isProjectSettingsPage || canInvitePeopleToProject);
        if (!canReallyShowExperience) return;
        const projectType = projectContextData?.projectType;
        if (!isQuickstartLoaded && !hasLoadedRemoteState.current) {
            if (quickstartStatus === (0, $8Bc5A.QUICKSTART_UI_STATUS).MINIMIZED || quickstartStatus === (0, $8Bc5A.QUICKSTART_UI_STATUS).DISMISSED) {
                syncVisibilityWithLocal();
                return;
            }
            // We need to load QuickStart remote data.
            hasLoadedRemoteState.current = true;
            const { atlassianAccountId: atlassianAccountId, cloudId: cloudId, appEditions: appEditions, isAdmin: isAdmin } = tenantContext;
            refreshAppState({
                atlassianAccountId: atlassianAccountId,
                cloudId: cloudId,
                appEditions: appEditions,
                isAdmin: isAdmin,
                createAnalyticsEvent: createAnalyticsEvent,
                canEditPlans: canEditPlans,
                isAdvancedRoadmapsTrial: isAdvancedRoadmapsTrial,
                isTargetedForReverseTrials: isTargetedForReverseTrials,
                projectType: projectType
            });
            return;
        }
        if (!shouldRenderComponent && isQuickstartLoaded) // Quickstart has loaded data but currently hidden.
        setShouldRenderComponent(true);
    }, [
        refreshAppState,
        canInvitePeopleToProject,
        canShowExperience,
        isProjectSettingsPage,
        isQuickstartLoaded,
        setShouldRenderComponent,
        shouldRenderComponent,
        tenantContext,
        location.pathname,
        projectContextData,
        jsmOnboardingData,
        createAnalyticsEvent,
        canEditPlans,
        isAdvancedRoadmapsTrial,
        isTargetedForReverseTrials,
        quickstartStatus,
        syncVisibilityWithLocal
    ]);
    /**
		Note: We triggers feature exposure for our
		Invite people to project experiment,
		If user is in project settings page.
		FD Ticket: https://hello.atlassian.net/browse/FD-15096
	*/ (0, $5uXOq.useEffect)(()=>// When component unmounts we should set shouldRenderComponent to false
        ()=>{
            // NOTE: we need to make sure the nudge is not active when the component unmounts.
            // This prevents seeing the nudge flickering if a user navigates when the nudge
            // is active for example.
            forceHideNudge();
            setShouldRenderComponent(false);
        }, [
        setShouldRenderComponent,
        forceHideNudge
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (isQuickstartLoaded === true && quickstartStatus === (0, $8Bc5A.QUICKSTART_UI_STATUS).OPEN && hasOpened === false) setHasOpened();
    }, [
        isQuickstartLoaded,
        quickstartStatus,
        setHasOpened,
        hasOpened
    ]);
    return {
        canShowExperience: canShowExperience,
        isEnrolledForProjectSettings: isEnrolledForProjectSettings
    };
};
const $acadf6219835098e$export$6ef8438579867e87 = (projectContextData)=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    const isTrelloCrossflow = (0, $i6yVb.useIsTrelloCrossflowEnabled)();
    const canShowExperience = (0, $2S7gn.useQuickstart)(projectContextData);
    const [quickstartStatus] = (0, $cE2Qr.useQuickstartUiStatus)();
    const [{ data: jsmOnboardingData }, { fetchOnboardingType: fetchOnboardingType }] = (0, $jrUuh.useJsmOnboardingType)();
    (0, $bPD6R.useRefreshQuickstartOnProjectSwitch)(projectContextData);
    const convertToRootTaskList = (0, $byS8t.useConvertToRootTaskList)();
    const canEditPlans = (0, $h9iZl.useNavigationEditPlansPermission)();
    const isAdvancedRoadmapsTrial = (0, $h9iZl.useIsAdvancedRoadmapsTrial)();
    const isTargetedForReverseTrials = (0, $gh567.useIsTargetedForReverseTrials)();
    const [{ isQuickstartLoaded: isQuickstartLoaded, shouldRenderComponent: shouldRenderComponent }, { refreshAppState: refreshAppState, refreshAppStateUiStatusOnly: refreshAppStateUiStatusOnly, setShouldRenderComponent: setShouldRenderComponent, forceHideNudge: forceHideNudge, setProjectState: setProjectState }] = (0, $cE2Qr.useJswOnboarding)();
    const isEligibleForJtbdOnboarding = (0, $8GOso.useCommonEligibilityConditionsForJtbdOnboarding)();
    // TODO: Can share this variable with rest of file
    const projectTypeForTO = (0, $4R6GH.fg)('tailored_onboarding_m3_gate') ? projectContextData?.projectType : (0, $2vSU6.CORE_PROJECT);
    const { isReady: personalisationDataIsReady, data: personalisationData } = (0, $8GOso.useTailoredOnboardingPersonalisationM2)({
        isEligible: isEligibleForJtbdOnboarding,
        additionalParameters: {
            projectType: projectTypeForTO
        }
    });
    const [{ hasOpened: hasOpened }, { setHasOpened: setHasOpened }] = (0, $heI7y.useHasOpened)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [isSampleProject, { fetchIsSampleProject: fetchIsSampleProject }] = (0, $gWE9S.useIsSampleProjectService)();
    const canInvitePeopleToProject = (0, $lQB52.getCanInvitePeopleToProject)(projectContextData, tenantContext);
    const route = (0, $6jY6G.useCurrentRoute)();
    const isProjectSettingsPage = (0, $8Bc5A.PROJECT_SETTING_PAGES).includes(route.name);
    const isEnrolledForProjectSettings = isProjectSettingsPage && canShowExperience && canInvitePeopleToProject;
    const hasLoadedRemoteState = (0, $5uXOq.useRef)(false);
    const [{ location: location }] = (0, $doZTA.useRouter)();
    (0, $5uXOq.useEffect)(()=>{
        if (projectContextData?.projectKey && projectContextData?.projectType === (0, $2vSU6.CORE_PROJECT)) fetchIsSampleProject(projectContextData.projectKey);
    }, [
        fetchIsSampleProject,
        projectContextData?.projectKey,
        projectContextData?.projectType
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!projectContextData) return;
        const { projectKey: projectKey, projectName: projectName, projectId: projectId, simplified: isNextGen, projectType: projectType, isProjectAdmin: isProjectAdminMaybe } = projectContextData;
        setProjectState({
            canInvitePeopleToProject: canInvitePeopleToProject,
            projectKey: projectKey,
            projectId: projectId,
            projectName: projectName,
            isNextGen: isNextGen,
            projectType: projectType,
            isProjectAdmin: Boolean(isProjectAdminMaybe),
            userRole: (0, $lQB52.getUserRole)(tenantContext.isSiteAdmin, tenantContext.isAdmin),
            edition: (0, $ldyPw.getEditionForProject)(projectType, tenantContext.appEditions),
            isSampleProject: isSampleProject[projectKey],
            isTrelloCrossflow: isTrelloCrossflow
        });
    }, [
        setProjectState,
        projectContextData,
        canInvitePeopleToProject,
        isProjectSettingsPage,
        tenantContext,
        isSampleProject,
        isTrelloCrossflow
    ]);
    (0, $5uXOq.useEffect)(()=>{
        fetchOnboardingType(projectContextData?.projectId, projectContextData?.projectType);
    }, [
        fetchOnboardingType,
        projectContextData
    ]);
    // When the component is re-mounted after the initial remote state load.
    (0, $5uXOq.useEffect)(()=>{
        // We can show the experience and are in the right page or experiment.
        const pathNameWithoutTrailingSlash = (0, $fZRGa.extractTrailingSlashFromPath)(location.pathname);
        const isJsmBusinessPeopleSettingsPage = projectContextData?.projectType === (0, $2vSU6.SERVICE_DESK_PROJECT) && jsmOnboardingData?.onboardingType === (0, $e7830161eb8674f1$export$6f454e69bce3a691) && pathNameWithoutTrailingSlash.endsWith((0, $08a37b02293d63ea$export$d2fcfad22215d3a3));
        const canReallyShowExperience = canShowExperience && // TODO: move this logic inside the useQuickstart hook (canShowExperience)
        (isJsmBusinessPeopleSettingsPage || !isProjectSettingsPage || canInvitePeopleToProject);
        if (!canReallyShowExperience) return;
        const projectType = projectContextData?.projectType;
        if (personalisationDataIsReady && !isQuickstartLoaded && !hasLoadedRemoteState.current) {
            // We need to load QuickStart remote data.
            hasLoadedRemoteState.current = true;
            if (personalisationData.QUICKSTART && personalisationData.QUICKSTART?.length > 0 && // For Tailored onboarding M3, we have an option to stick to the FE and avoid the BE since M2 scoped the BE call to business projects
            projectType === (0, $2vSU6.CORE_PROJECT)) {
                const taskList = convertToRootTaskList(personalisationData.QUICKSTART);
                refreshAppStateUiStatusOnly({
                    taskList: taskList
                });
            } else {
                const { atlassianAccountId: atlassianAccountId, cloudId: cloudId, appEditions: appEditions, isAdmin: isAdmin } = tenantContext;
                refreshAppState({
                    atlassianAccountId: atlassianAccountId,
                    cloudId: cloudId,
                    appEditions: appEditions,
                    isAdmin: isAdmin,
                    createAnalyticsEvent: createAnalyticsEvent,
                    canEditPlans: canEditPlans,
                    isAdvancedRoadmapsTrial: isAdvancedRoadmapsTrial,
                    isTargetedForReverseTrials: isTargetedForReverseTrials,
                    projectType: projectType
                });
            }
            return;
        }
        if (!shouldRenderComponent && isQuickstartLoaded) // Quickstart has loaded data but currently hidden.
        setShouldRenderComponent(true);
    }, [
        refreshAppState,
        canInvitePeopleToProject,
        canShowExperience,
        isProjectSettingsPage,
        isQuickstartLoaded,
        refreshAppStateUiStatusOnly,
        createAnalyticsEvent,
        canEditPlans,
        isAdvancedRoadmapsTrial,
        isTargetedForReverseTrials,
        location.pathname,
        projectContextData?.projectType,
        jsmOnboardingData?.onboardingType,
        personalisationDataIsReady,
        shouldRenderComponent,
        personalisationData.QUICKSTART,
        tenantContext,
        setShouldRenderComponent,
        convertToRootTaskList
    ]);
    /**
		Note: We triggers feature exposure for our
		Invite people to project experiment,
		If user is in project settings page.
		FD Ticket: https://hello.atlassian.net/browse/FD-15096
	*/ (0, $5uXOq.useEffect)(()=>// When component unmounts we should set shouldRenderComponent to false
        ()=>{
            // NOTE: we need to make sure the nudge is not active when the component unmounts.
            // This prevents seeing the nudge flickering if a user navigates when the nudge
            // is active for example.
            forceHideNudge();
            setShouldRenderComponent(false);
        }, [
        setShouldRenderComponent,
        forceHideNudge
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (isQuickstartLoaded === true && quickstartStatus === (0, $8Bc5A.QUICKSTART_UI_STATUS).OPEN && hasOpened === false) setHasOpened();
    }, [
        isQuickstartLoaded,
        quickstartStatus,
        setHasOpened,
        hasOpened
    ]);
    return {
        canShowExperience: canShowExperience,
        isEnrolledForProjectSettings: isEnrolledForProjectSettings
    };
};

});
parcelRegister("i6yVb", function(module, exports) {

$parcel$export(module.exports, "useIsTrelloCrossflowEnabled", () => $d8636b504a9bdfe4$export$9ab9cbe3c36cf94c);

var $5uXOq = parcelRequire("5uXOq");

var $koeKL = parcelRequire("koeKL");

var $5GDqD = parcelRequire("5GDqD");

var $k6Mdf = parcelRequire("k6Mdf");
const $d8636b504a9bdfe4$export$9ab9cbe3c36cf94c = ()=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const { fetchTraits: fetchTraits } = (0, $5GDqD.useTraitsActions)();
    (0, $5uXOq.useEffect)(()=>{
        fetchTraits([
            'SITE'
        ], {
            cloudId: cloudId
        });
    }, [
        fetchTraits,
        cloudId
    ]);
    const [isTrelloWorkspaceLinked] = (0, $k6Mdf.useLinkedTrelloWorkspaceTraitSelector)();
    return isTrelloWorkspaceLinked;
};

});
parcelRegister("koeKL", function(module, exports) {

$parcel$export(module.exports, "useCloudId", () => $559e3c14e9652b55$export$9da0f7c65f28ed16);

var $9OXo1 = parcelRequire("9OXo1");
const $559e3c14e9652b55$export$9da0f7c65f28ed16 = ()=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    return tenantContext && tenantContext.cloudId;
};

});

parcelRegister("5GDqD", function(module, exports) {

$parcel$export(module.exports, "useTraits", () => $5e4cf08f88a8a143$export$243330301a7ccf01);
$parcel$export(module.exports, "useTraitsActions", () => $5e4cf08f88a8a143$export$87f1d888def9d5a0);
$parcel$export(module.exports, "createTraitsSelector", () => $5e4cf08f88a8a143$export$fb8309e220d0dd3b);
$parcel$export(module.exports, "composeTraitsSelectors", () => $5e4cf08f88a8a143$export$e653f602b87eec56);

var $eusud = parcelRequire("eusud");

var $3sQ5x = parcelRequire("3sQ5x");
var $6dDSs = parcelRequire("6dDSs");
var $iXqE5 = parcelRequire("iXqE5");

var $jX0pr = parcelRequire("jX0pr");

var $8ilPk = parcelRequire("8ilPk");

var $13UaH = parcelRequire("13UaH");

var $2LwjF = parcelRequire("2LwjF");
const $5e4cf08f88a8a143$var$addTrait = (traitType, trait)=>({ getState: getState, setState: setState })=>{
        const currentUserTraits = getState();
        const state = currentUserTraits[traitType];
        if (!state.attributes) {
            setState({
                ...currentUserTraits,
                [traitType]: {
                    attributes: [
                        trait
                    ]
                }
            });
            return;
        }
        if (state.attributes.some((existingTrait)=>existingTrait.name === trait.name)) setState({
            ...currentUserTraits,
            [traitType]: {
                attributes: state.attributes.map((existingTrait)=>existingTrait.name === trait.name ? trait : existingTrait)
            }
        });
        else setState({
            ...currentUserTraits,
            [traitType]: {
                attributes: [
                    ...state.attributes,
                    trait
                ]
            }
        });
    };
const $5e4cf08f88a8a143$var$fetchTraits = (traitTypes, { cloudId: cloudId, accountId: accountId, orgId: orgId })=>async ({ getState: getState, setState: setState })=>{
        const state = getState();
        await Promise.all(traitTypes.map(async (traitType)=>{
            if (state[traitType].loaded || state[traitType].loading) return;
            setState({
                ...state,
                [traitType]: {
                    ...state[traitType],
                    loading: true
                }
            });
            const traitEndpointEndingFragment = (0, $2LwjF.buildTraitEndpointEndingFragment)({
                traitType: traitType,
                accountId: accountId,
                cloudId: cloudId,
                orgId: orgId
            });
            if (!traitEndpointEndingFragment) return;
            const url = (0, $13UaH.TRAIT_ENDPOINT_STARTING_FRAGMENT) + traitEndpointEndingFragment;
            try {
                let fetchedTraits = null;
                // TODO: in the future, we will need to also memoise site user trait and user trait here
                // Thus, we need to add FG at each conditions to fetch if we should use the memoised fetcher
                if (traitType === (0, $13UaH.SITE) && cloudId) fetchedTraits = {
                    attributes: await (0, $jX0pr.memoizedFetchSitePersonalization)({
                        cloudId: cloudId
                    })
                };
                else if (traitType === (0, $13UaH.SITE_USER) && cloudId && accountId) fetchedTraits = {
                    attributes: await (0, $8ilPk.memoizedFetchSiteUserPersonalization)({
                        cloudId: cloudId,
                        userId: accountId
                    })
                };
                else fetchedTraits = await (0, $eusud.performGetRequest)(url);
                setState({
                    ...getState(),
                    [traitType]: {
                        attributes: fetchedTraits?.attributes?.length ? fetchedTraits.attributes : null,
                        loading: false,
                        loaded: true
                    }
                });
            } catch  {
                setState({
                    ...getState(),
                    [traitType]: {
                        attributes: null,
                        loading: false,
                        loaded: true
                    }
                });
            }
        }));
    };
const $5e4cf08f88a8a143$var$actions = {
    fetchTraits: $5e4cf08f88a8a143$var$fetchTraits,
    addTrait: $5e4cf08f88a8a143$var$addTrait
};
const $5e4cf08f88a8a143$var$initialState = {
    ATLASSIAN_ACCOUNT: {
        attributes: null,
        loading: false,
        loaded: false
    },
    SITE: {
        attributes: null,
        loading: false,
        loaded: false
    },
    SITE_USER: {
        attributes: null,
        loading: false,
        loaded: false
    },
    ORG: {
        attributes: null,
        loading: false,
        loaded: false
    },
    ORG_USER: {
        attributes: null,
        loading: false,
        loaded: false
    }
};
const $5e4cf08f88a8a143$export$5b11e13f463f4eb = (0, $iXqE5.createStore)({
    initialState: $5e4cf08f88a8a143$var$initialState,
    actions: $5e4cf08f88a8a143$var$actions,
    name: 'TraitsStore'
});
const $5e4cf08f88a8a143$export$243330301a7ccf01 = (0, $3sQ5x.createHook)($5e4cf08f88a8a143$export$5b11e13f463f4eb);
const $5e4cf08f88a8a143$export$87f1d888def9d5a0 = (0, $3sQ5x.createActionsHook)($5e4cf08f88a8a143$export$5b11e13f463f4eb);
const $5e4cf08f88a8a143$var$defaultSelector = (traitsType, selector)=>(0, $6dDSs.createSelector)((state)=>({
            loading: !!state[traitsType]?.loading,
            loaded: state[traitsType]?.loaded || false,
            attributes: state[traitsType]?.attributes,
            userCreatedAfter: (date)=>state[traitsType].loaded ? (0, $2LwjF.userCreatedAfter)(state, date) : false,
            userCreatedBefore: (date)=>state[traitsType].loaded ? (0, $2LwjF.userCreatedBefore)(state, date) : false,
            getTraitByName: (name)=>state[traitsType].loaded ? (0, $2LwjF.getTraitByName)(state, name) : null,
            hasTrait: (name)=>state[traitsType].loaded ? (0, $2LwjF.hasTrait)(state, name) : false,
            getTraitValue: (name)=>state[traitsType].loaded ? (0, $2LwjF.getTraitValue)(state, name) : null
        }), selector);
const $5e4cf08f88a8a143$export$fb8309e220d0dd3b = (traitsType, selector)=>(0, $3sQ5x.createHook)($5e4cf08f88a8a143$export$5b11e13f463f4eb, {
        selector: $5e4cf08f88a8a143$var$defaultSelector(traitsType, selector)
    });
const $5e4cf08f88a8a143$export$e653f602b87eec56 = (traitTypes, hooks)=>({
        traitTypes: traitTypes,
        hooks: hooks
    });

});
parcelRegister("13UaH", function(module, exports) {

$parcel$export(module.exports, "ATLASSIAN_ACCOUNT", () => $c8223610b88d815b$export$eac8289d83d13c9e);
$parcel$export(module.exports, "SITE", () => $c8223610b88d815b$export$1f4740cb59ea887e);
$parcel$export(module.exports, "SITE_USER", () => $c8223610b88d815b$export$2b629adc0b711448);
$parcel$export(module.exports, "ORG", () => $c8223610b88d815b$export$c7bc89c720838974);
$parcel$export(module.exports, "ORG_USER", () => $c8223610b88d815b$export$872e93425a929c06);
$parcel$export(module.exports, "TRAIT_ENDPOINT_STARTING_FRAGMENT", () => $c8223610b88d815b$export$ff5c5bd50c21e9a4);
const $c8223610b88d815b$export$eac8289d83d13c9e = 'ATLASSIAN_ACCOUNT';
const $c8223610b88d815b$export$1f4740cb59ea887e = 'SITE';
const $c8223610b88d815b$export$2b629adc0b711448 = 'SITE_USER';
const $c8223610b88d815b$export$c7bc89c720838974 = 'ORG';
const $c8223610b88d815b$export$872e93425a929c06 = 'ORG_USER';
const $c8223610b88d815b$export$ff5c5bd50c21e9a4 = '/gateway/api/tap-delivery/api/v3/personalization/';
const $c8223610b88d815b$export$ab3e7784d2a104d4 = [
    $c8223610b88d815b$export$eac8289d83d13c9e,
    $c8223610b88d815b$export$1f4740cb59ea887e,
    $c8223610b88d815b$export$2b629adc0b711448,
    $c8223610b88d815b$export$c7bc89c720838974,
    $c8223610b88d815b$export$872e93425a929c06
];

});

parcelRegister("2LwjF", function(module, exports) {

$parcel$export(module.exports, "buildTraitEndpointEndingFragment", () => $a4882989c0079311$export$118c30eb4b4c51e8);
$parcel$export(module.exports, "getTraitByName", () => $a4882989c0079311$export$e5b0d140cf11f46a);
$parcel$export(module.exports, "hasTrait", () => $a4882989c0079311$export$252a469687875173);
$parcel$export(module.exports, "getTraitValue", () => $a4882989c0079311$export$43a43c2e6ec7b13);
$parcel$export(module.exports, "userCreatedAfter", () => $a4882989c0079311$export$8388eb33623a9cff);
$parcel$export(module.exports, "userCreatedBefore", () => $a4882989c0079311$export$da1e8ce191f01409);

var $13UaH = parcelRequire("13UaH");
const $a4882989c0079311$export$e320a062b20fddc3 = (traitsData)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.entries(traitsData).reduce((acc, [, val])=>{
        if (val?.attributes) acc.push(...val.attributes.map((singleTrait)=>singleTrait));
        return acc;
    }, []);
const $a4882989c0079311$export$118c30eb4b4c51e8 = ({ traitType: traitType, accountId: accountId, cloudId: cloudId, orgId: orgId })=>{
    switch(traitType){
        case 0, $13UaH.ATLASSIAN_ACCOUNT:
            return `user/${accountId}`;
        case 0, $13UaH.SITE:
            return `site/${cloudId}`;
        case 0, $13UaH.SITE_USER:
            return `site/${cloudId}/user/${accountId}`;
        case 0, $13UaH.ORG:
            return `org/${orgId}`;
        case 0, $13UaH.ORG_USER:
            return `org/${orgId}/user/${accountId}`;
        default:
            return null;
    }
};
function $a4882989c0079311$export$e5b0d140cf11f46a(traitsData, traitName) {
    return $a4882989c0079311$export$e320a062b20fddc3(traitsData)?.find((trait)=>trait.name === traitName);
}
function $a4882989c0079311$export$252a469687875173(traitsData, traitName) {
    return $a4882989c0079311$export$e320a062b20fddc3(traitsData)?.find((trait)=>trait.name === traitName) !== undefined;
}
function $a4882989c0079311$export$43a43c2e6ec7b13(traitsData, traitName) {
    return $a4882989c0079311$export$e320a062b20fddc3(traitsData)?.find((trait)=>trait.name === traitName)?.value ?? null;
}
const $a4882989c0079311$export$d2a3b2f9735b6874 = (traitsData, traitNames)=>$a4882989c0079311$export$e320a062b20fddc3(traitsData)?.filter((trait)=>traitNames.includes(trait.name));
const $a4882989c0079311$export$8388eb33623a9cff = (traitsData, date)=>{
    const accountCreationDate = $a4882989c0079311$export$e5b0d140cf11f46a(traitsData, 'jira_first_active')?.value;
    if (!accountCreationDate) return false;
    return new Date(accountCreationDate) > date;
};
const $a4882989c0079311$export$da1e8ce191f01409 = (traitsData, date)=>{
    const accountCreationDate = $a4882989c0079311$export$e5b0d140cf11f46a(traitsData, 'jira_first_active')?.value;
    if (!accountCreationDate) return false;
    return new Date(accountCreationDate) < date;
};

});


parcelRegister("k6Mdf", function(module, exports) {

$parcel$export(module.exports, "useLinkedTrelloWorkspaceTraitSelector", () => $01c6496536a406d4$export$11aeed7eb2d4ff8c);

var $5GDqD = parcelRequire("5GDqD");
const $01c6496536a406d4$export$11aeed7eb2d4ff8c = (0, $5GDqD.createTraitsSelector)('SITE', ({ getTraitByName: getTraitByName })=>{
    return !!getTraitByName('jira_workmanagement_linked_trello_workspace')?.value;
});

});


parcelRegister("byS8t", function(module, exports) {

$parcel$export(module.exports, "useConvertToRootTaskList", () => $7e85bec4cfe468a8$export$52350a71fa563521);

var $5uXOq = parcelRequire("5uXOq");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $8Bc5A = parcelRequire("8Bc5A");

var $55tv8 = parcelRequire("55tv8");
const $7e85bec4cfe468a8$export$52350a71fa563521 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    return (0, $5uXOq.useCallback)((taskItems)=>{
        const filteredTaskItems = taskItems.filter((task)=>(0, $8Bc5A.allTasksExcludingJSMBusinessTasks).includes(task));
        if (filteredTaskItems.length === 0) {
            (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'quickstartTaskList mismatched', {
                taskItems: taskItems
            });
            return undefined;
        }
        return {
            root: {
                title: (0, $55tv8.messages).rootTitle,
                items: filteredTaskItems
            }
        };
    }, [
        createAnalyticsEvent
    ]);
};

});
parcelRegister("55tv8", function(module, exports) {

$parcel$export(module.exports, "messages", () => $a60625a31fb4f969$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $a60625a31fb4f969$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    rootTitle: {
        "id": "onboarding-quickstart-core.utils.create-task-list.root-title",
        "defaultMessage": "Quickstart"
    }
});

});


parcelRegister("gh567", function(module, exports) {

$parcel$export(module.exports, "useIsTargetedForReverseTrials", () => $b8cd58920d764600$export$897219a3ca9649b9);

var $2vSU6 = parcelRequire("2vSU6");

var $dAfqg = parcelRequire("dAfqg");

var $ldyPw = parcelRequire("ldyPw");

var $k9JTq = parcelRequire("k9JTq");
const $b8cd58920d764600$export$897219a3ca9649b9 = ()=>{
    const { data: projectContextData } = (0, $dAfqg.useProjectContext)();
    const jswEdition = (0, $k9JTq.useAppEditions)().software;
    const isCurrentProjectJSW = projectContextData?.projectType === (0, $2vSU6.SOFTWARE_PROJECT);
    if (jswEdition === (0, $ldyPw.PREMIUM_EDITION) && isCurrentProjectJSW) return true;
    return false;
};

});
parcelRegister("k9JTq", function(module, exports) {

$parcel$export(module.exports, "useAppEditions", () => $dde261c9da85268a$export$92ed15881fc090d7);

var $9OXo1 = parcelRequire("9OXo1");
const $dde261c9da85268a$export$92ed15881fc090d7 = ()=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    return tenantContext && tenantContext.appEditions;
};

});


const $08a37b02293d63ea$export$d2fcfad22215d3a3 = '/people';
const $08a37b02293d63ea$export$7c6780602715dd47 = '/settings/request-types';
const $08a37b02293d63ea$export$7593cbf14f41f9a1 = '/settings/email';
const $08a37b02293d63ea$export$b06c4270dc16727f = '/settings/chat';
const $08a37b02293d63ea$export$3e8b796a515650a1 = '/settings/portal-settings';

parcelRegister("fZRGa", function(module, exports) {

$parcel$export(module.exports, "extractTrailingSlashFromPath", () => $25d037ca117ae5ed$export$4e1e835a1af3ba50);
const $25d037ca117ae5ed$export$4e1e835a1af3ba50 = (path)=>path.replace(/\/$/, '');

});

const $e7830161eb8674f1$export$6f454e69bce3a691 = 'business';
const $e7830161eb8674f1$export$e6952b12ade67489 = 'default';

parcelRegister("jrUuh", function(module, exports) {

$parcel$export(module.exports, "useJsmOnboardingType", () => $664311160f9d0bff$export$5daaa68c3a578af9);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $gcnn5 = parcelRequire("gcnn5");
const $664311160f9d0bff$export$d4c72bab9d6cc13a = {
    projectId: undefined,
    data: undefined,
    error: undefined,
    isLoading: false
};
const $664311160f9d0bff$var$Store = (0, $iXqE5.createStore)({
    initialState: $664311160f9d0bff$export$d4c72bab9d6cc13a,
    actions: $gcnn5.actions,
    name: 'JSMOnboardingType'
});
const $664311160f9d0bff$export$5daaa68c3a578af9 = (0, $3sQ5x.createHook)($664311160f9d0bff$var$Store);

});
parcelRegister("gcnn5", function(module, exports) {

$parcel$export(module.exports, "actions", () => $efcda9e0ca78f7c5$export$e324594224ef24da);

var $5R3PH = parcelRequire("5R3PH");
const $efcda9e0ca78f7c5$export$e324594224ef24da = {
    fetchOnboardingType: $5R3PH.fetchOnboardingType
};

});
parcelRegister("5R3PH", function(module, exports) {

$parcel$export(module.exports, "fetchOnboardingType", () => $a0d1630df8d288ca$export$ea62467635172b55);

var $2vSU6 = parcelRequire("2vSU6");

var $7f4tk = parcelRequire("7f4tk");
const $a0d1630df8d288ca$var$getOnboardingTypeUrl = (projectId)=>`/rest/servicedesk/onboarding/1/onboarding-type/project/${projectId}`;
const $a0d1630df8d288ca$export$ea62467635172b55 = (projectId, projectType)=>async ({ getState: getState, setState: setState })=>{
        if (!projectId || projectType !== (0, $2vSU6.SERVICE_DESK_PROJECT)) return;
        const { data: data, isLoading: isLoading, projectId: oldProjectId } = getState();
        if (projectId !== oldProjectId) setState({
            data: undefined,
            projectId: undefined
        });
        if (data || isLoading) return;
        setState({
            projectId: projectId,
            isLoading: true,
            error: undefined
        });
        try {
            const onboardingTypeResponse = await (0, $7f4tk.default)($a0d1630df8d288ca$var$getOnboardingTypeUrl(String(projectId)));
            setState({
                isLoading: false,
                data: onboardingTypeResponse
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                isLoading: false,
                error: error
            });
        }
    };

});



parcelRegister("heI7y", function(module, exports) {

$parcel$export(module.exports, "useHasOpened", () => $c02ba9c4f48115f2$export$cbaabcded53b5c1f);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $h97QA = parcelRequire("h97QA");
const $c02ba9c4f48115f2$var$actions = {
    setHasOpened: $h97QA.setHasOpened
};
const $c02ba9c4f48115f2$var$initialState = {
    hasOpened: false
};
const $c02ba9c4f48115f2$var$Store = (0, $iXqE5.createStore)({
    initialState: $c02ba9c4f48115f2$var$initialState,
    actions: $c02ba9c4f48115f2$var$actions,
    name: 'jsw-onboarding-quickstart-has-opened'
});
const $c02ba9c4f48115f2$export$cbaabcded53b5c1f = (0, $3sQ5x.createHook)($c02ba9c4f48115f2$var$Store);

});
parcelRegister("h97QA", function(module, exports) {

$parcel$export(module.exports, "setHasOpened", () => $68011af9f70af395$export$c4743c64a7c42294);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $68011af9f70af395$export$c4743c64a7c42294 = ()=>({ getState: getState, setState: setState })=>{
        const { hasOpened: hasOpened } = getState();
        if (hasOpened === true) // if state has been updated already return
        return;
        setState({
            hasOpened: true
        });
    };
var $68011af9f70af395$export$2e2bcd8739ae039 = $68011af9f70af395$export$c4743c64a7c42294;

});


parcelRegister("gWE9S", function(module, exports) {

$parcel$export(module.exports, "useIsSampleProjectService", () => $c05aee306f77b927$export$7c31b8e3dc4a5de0);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $bXw8Z = parcelRequire("bXw8Z");
const $c05aee306f77b927$var$initialState = {};
const $c05aee306f77b927$var$store = (0, $iXqE5.createStore)({
    name: 'jwm-quickstart-is-sample-project',
    initialState: $c05aee306f77b927$var$initialState,
    actions: $bXw8Z.actions
});
const $c05aee306f77b927$export$7c31b8e3dc4a5de0 = (0, $3sQ5x.createHook)($c05aee306f77b927$var$store);

});
parcelRegister("bXw8Z", function(module, exports) {

$parcel$export(module.exports, "actions", () => $4da4050f584fa8d0$export$e324594224ef24da);

var $kPeNb = parcelRequire("kPeNb");
const $4da4050f584fa8d0$export$e324594224ef24da = {
    fetchIsSampleProject: $kPeNb.fetchIsSampleProject
};

});
parcelRegister("kPeNb", function(module, exports) {

$parcel$export(module.exports, "fetchIsSampleProject", () => $87d81bf4bc3fa8ca$export$be137911e8102855);

var $eusud = parcelRequire("eusud");
const $87d81bf4bc3fa8ca$var$getIsSampleProject = async (projectKey)=>{
    try {
        const response = await (0, $eusud.performGetRequest)(`/rest/api/3/project/${projectKey}/properties/isDemo`);
        return response.value;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        return false;
    }
};
const $87d81bf4bc3fa8ca$export$be137911e8102855 = (projectKey)=>async ({ getState: getState, setState: setState })=>{
        const currentState = getState();
        if (projectKey in currentState) return;
        const isSampleProject = await $87d81bf4bc3fa8ca$var$getIsSampleProject(projectKey);
        setState({
            [projectKey]: isSampleProject
        });
    };

});



parcelRegister("6MqfV", function(module, exports) {

$parcel$export(module.exports, "useRefreshOnJSMProjectSwitch", () => $4b5cbff36d91cc78$export$baa0db9dc3861527);

var $5uXOq = parcelRequire("5uXOq");

var $2vSU6 = parcelRequire("2vSU6");

var $cE2Qr = parcelRequire("cE2Qr");
const $4b5cbff36d91cc78$export$baa0db9dc3861527 = (projectId, projectType)=>{
    const [, { resetIsQuickstartLoaded: resetIsQuickstartLoaded }] = (0, $cE2Qr.useJswOnboarding)();
    (0, $5uXOq.useEffect)(()=>{
        if (projectType === (0, $2vSU6.SERVICE_DESK_PROJECT)) resetIsQuickstartLoaded();
    }, [
        resetIsQuickstartLoaded,
        projectId,
        projectType
    ]);
};

});

parcelRegister("bPD6R", function(module, exports) {

$parcel$export(module.exports, "useRefreshQuickstartOnProjectSwitch", () => $c696f71579cc298d$export$610571bb07c3f15a);

var $5uXOq = parcelRequire("5uXOq");

var $2vSU6 = parcelRequire("2vSU6");

var $cE2Qr = parcelRequire("cE2Qr");

var $6MqfV = parcelRequire("6MqfV");
const $c696f71579cc298d$export$610571bb07c3f15a = (projectContextData)=>{
    const [{ quickstartStateProjectType: quickstartStateProjectType }, { resetIsQuickstartLoaded: resetIsQuickstartLoaded }] = (0, $cE2Qr.useJswOnboarding)();
    // Handles JSM projects
    (0, $6MqfV.useRefreshOnJSMProjectSwitch)(projectContextData?.projectId, projectContextData?.projectType);
    // Handles all other non JSM project types
    (0, $5uXOq.useEffect)(()=>{
        if (projectContextData?.projectType !== (0, $2vSU6.SERVICE_DESK_PROJECT) && quickstartStateProjectType !== projectContextData?.projectType) resetIsQuickstartLoaded();
    }, [
        resetIsQuickstartLoaded,
        projectContextData?.projectType,
        quickstartStateProjectType
    ]);
};

});

parcelRegister("2S7gn", function(module, exports) {

$parcel$export(module.exports, "useQuickstart", () => $ee4740cbfba38ee1$export$eee715064db7b785);

var $5uXOq = parcelRequire("5uXOq");

var $2vSU6 = parcelRequire("2vSU6");

var $4DPZY = parcelRequire("4DPZY");


var $jrUuh = parcelRequire("jrUuh");

var $6yXtV = parcelRequire("6yXtV");
const $ee4740cbfba38ee1$export$eee715064db7b785 = (projectContextData)=>{
    const [{ data: containerContext }] = (0, $4DPZY.useContainerContext)();
    const [{ isReady: spaStatePageReady }] = (0, $6yXtV.useSpaStatePageReady)();
    const [{ data: jsmOnboardingData }, { fetchOnboardingType: fetchOnboardingType }] = (0, $jrUuh.useJsmOnboardingType)();
    (0, $5uXOq.useEffect)(()=>{
        fetchOnboardingType(projectContextData?.projectId, projectContextData?.projectType);
    }, [
        jsmOnboardingData,
        fetchOnboardingType,
        projectContextData?.projectId,
        projectContextData?.projectType
    ]);
    if (projectContextData?.projectType !== (0, $2vSU6.SOFTWARE_PROJECT) && projectContextData?.projectType !== (0, $2vSU6.CORE_PROJECT) && projectContextData?.projectType !== (0, $2vSU6.SERVICE_DESK_PROJECT)) // If projectContext is present and it is not software, core or service management, don't render
    return false;
    // Scope Type in classic -- scrum/kanban/undefined(non-scrum/kanban) & next-gen -- simple
    const isProjectScopeAvailable = containerContext && containerContext.scope && containerContext.scope.type;
    const isProjectScopeAndSpaPageReady = Boolean(isProjectScopeAvailable) && spaStatePageReady;
    const showJwmExperience = containerContext?.contextType === 'project' && projectContextData?.projectType === (0, $2vSU6.CORE_PROJECT);
    const showJsmExperience = containerContext?.contextType === 'project' && projectContextData?.projectType === (0, $2vSU6.SERVICE_DESK_PROJECT) && jsmOnboardingData?.onboardingType === (0, $e7830161eb8674f1$export$6f454e69bce3a691);
    const canShowExperience = showJwmExperience || showJsmExperience || isProjectScopeAndSpaPageReady;
    return canShowExperience;
};

});
parcelRegister("6yXtV", function(module, exports) {

$parcel$export(module.exports, "useSpaStatePageReady", () => $44de65c7edb80809$export$ea2491906b753456);
$parcel$export(module.exports, "SpaStatePageReady", () => $44de65c7edb80809$export$c34439f945fccbdf);
$parcel$export(module.exports, "SpaStatePageReadyOnUpdate", () => $44de65c7edb80809$export$41e70078eeddaddc);

var $5uXOq = parcelRequire("5uXOq");

var $5h5Fg = parcelRequire("5h5Fg");

var $3sQ5x = parcelRequire("3sQ5x");

var $4oDnX = parcelRequire("4oDnX");

var $7w9eZ = parcelRequire("7w9eZ");
const $44de65c7edb80809$export$e6897aa59ee7aee5 = ({ currentPage: currentPage })=>{
    const { apps: apps } = currentPage;
    const appIds = Object.keys(apps);
    return {
        isReady: appIds.length ? appIds.every((id)=>apps[id].endTime || apps[id].timeoutTime) : false
    };
};
const $44de65c7edb80809$export$ea2491906b753456 = (0, $3sQ5x.createHook)((0, $7w9eZ.default), {
    selector: $44de65c7edb80809$export$e6897aa59ee7aee5
});
const $44de65c7edb80809$export$c34439f945fccbdf = ()=>/* TODO - this should be using only the actions subscriber not state+actions subscriber */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4oDnX.SpaStateSubscriber), null, (_, { setAppReady: setAppReady })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5h5Fg.default), {
            op: setAppReady
        }));
const $44de65c7edb80809$export$41e70078eeddaddc = ({ comparer: comparer })=>/* TODO - this should be using only the actions subscriber not state+actions subscriber */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4oDnX.SpaStateSubscriber), null, (_, { setAppReady: setAppReady })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5h5Fg.default), {
            op: setAppReady,
            args: comparer
        }));

});


parcelRegister("lQB52", function(module, exports) {

$parcel$export(module.exports, "getUserRole", () => $43cd27dfa61aaa51$export$c33a4269214e2ec4);
$parcel$export(module.exports, "getCanInvitePeopleToProject", () => $43cd27dfa61aaa51$export$7155ad229e9ef96);

var $iMd5l = parcelRequire("iMd5l");

var $ieqoN = parcelRequire("ieqoN");


var $ldyPw = parcelRequire("ldyPw");
const $43cd27dfa61aaa51$export$c33a4269214e2ec4 = (isSiteAdmin, isAdmin)=>{
    if (isSiteAdmin) return (0, $ieqoN.USER_ROLE).SITE_ADMIN;
    if (isAdmin) return (0, $ieqoN.USER_ROLE).JIRA_ADMIN;
    return (0, $ieqoN.USER_ROLE).END_USER;
};
const $43cd27dfa61aaa51$export$7155ad229e9ef96 = (projectContext, tenantContext)=>{
    const isProjectAdmin = Boolean(projectContext && projectContext.isProjectAdmin) || tenantContext.isAdmin;
    const isInFreeClassicProject = projectContext && !projectContext.simplified && (0, $iMd5l.getProductEdition)((0, $c06e1abca7c13910$export$1346c9aa3cbb477d), tenantContext) === (0, $ldyPw.FREE_EDITION);
    return isProjectAdmin && !isInFreeClassicProject;
};

});
parcelRegister("iMd5l", function(module, exports) {

$parcel$export(module.exports, "getProductEdition", () => $658df12da4e62335$export$53e066a63a960439);

const $658df12da4e62335$export$53e066a63a960439 = (product, tenantContext)=>{
    if (product === (0, $c06e1abca7c13910$export$1346c9aa3cbb477d)) return tenantContext.appEditions.software;
    if (product === (0, $c06e1abca7c13910$export$c8c1c8c3f8ddba61)) return tenantContext.appEditions.serviceDesk;
    return tenantContext.appEditions.core;
};

});
const $c06e1abca7c13910$export$c8c1c8c3f8ddba61 = 'jira-servicedesk';
const $c06e1abca7c13910$export$e9c56aa3b027d98f = 'jira-customer-service';
const $c06e1abca7c13910$export$1346c9aa3cbb477d = 'jira-software';
const $c06e1abca7c13910$export$202f50ee62667e32 = 'jira-product-discovery';
const $c06e1abca7c13910$export$db515c8cec1e6f79 = 'jira-core';
const $c06e1abca7c13910$export$c811f21c9ad05dc2 = 'confluence';
const $c06e1abca7c13910$export$961148c98d198270 = 'opsgenie';






parcelRegister("4QigF", function(module, exports) {

$parcel$export(module.exports, "JswOnboardingChecklist", () => $a3ce66216f7840ff$export$aea93106aaeec3fc);
$parcel$export(module.exports, "JswOnboardingButton", () => $a3ce66216f7840ff$export$c0cbc1198da400db);
$parcel$export(module.exports, "LazyOpenMenuItem", () => $a3ce66216f7840ff$export$e6a8d3e2a6acc946);
$parcel$export(module.exports, "OpenMenuItem", () => $a3ce66216f7840ff$export$67c4b22563f33286);

var $5uXOq = parcelRequire("5uXOq");

var $hYRTO = parcelRequire("hYRTO");

var $7CMCs = parcelRequire("7CMCs");

var $94Uc1 = parcelRequire("94Uc1");

var $353uQ = parcelRequire("353uQ");

var $30rnQ = parcelRequire("30rnQ");

var $iuzc0 = parcelRequire("iuzc0");

var $l8ruj = parcelRequire("l8ruj");

var $kxZPA = parcelRequire("kxZPA");

var $5Nzrp = parcelRequire("5Nzrp");

var $eIh4F = parcelRequire("eIh4F");
const $a3ce66216f7840ff$var$FallbackChecklist = ()=>{
    (0, $5uXOq.useLayoutEffect)(()=>{
        (0, $353uQ.qsChecklistAutoLoadTime).start();
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null);
};
const $a3ce66216f7840ff$export$aea93106aaeec3fc = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "quickstart"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "asyncChecklistComponent",
        packageName: "jiraSoftwareOnboardingQuickstart",
        teamName: "jlove-makkuro",
        fallback: "unmount",
        attributes: (0, $30rnQ.addChunkLoadErrorAnalyticsAttribute)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hYRTO.default), {
        name: "software-onboarding-checklist-new",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a3ce66216f7840ff$var$FallbackChecklist, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Nzrp.JswOnboardingChecklistNext), null))));
const $a3ce66216f7840ff$var$FallbackButton = ()=>{
    (0, $5uXOq.useLayoutEffect)(()=>{
        (0, $353uQ.qsButtonAutoLoadTime).start();
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null);
};
const $a3ce66216f7840ff$export$c0cbc1198da400db = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "asyncChecklistButtonComponent",
        packageName: "jiraSoftwareOnboardingQuickstart",
        teamName: "jlove-makkuro",
        fallback: "unmount",
        attributes: (0, $30rnQ.addChunkLoadErrorAnalyticsAttribute)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hYRTO.default), {
        name: "software-onboarding-checklist-button-new",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a3ce66216f7840ff$var$FallbackButton, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iuzc0.QuickstartPillVisibilityContainer), {
        scope: "ListPageQuickstartPill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eIh4F.JswOnboardingButtonNext), null))));

const $a3ce66216f7840ff$export$e6a8d3e2a6acc946 = (0, $kxZPA.lazy)(()=>(parcelRequire("4x4NO")).then(({ OpenMenuItem: OpenMenuItem })=>{
        (0, $353uQ.openMenuItemLoadTime).mark((0, $94Uc1.PERFORMANCE_MARK).BUNDLE_LOAD_END);
        return OpenMenuItem;
    }), {
    moduleId: "./src/packages/software/onboarding-quickstart/src/ui/open-menu-item/index.tsx"
});
const $a3ce66216f7840ff$var$SubmitOpenMenuItemLoadStart = ()=>{
    (0, $5uXOq.useLayoutEffect)(()=>{
        (0, $353uQ.openMenuItemLoadTime).start();
        (0, $353uQ.openMenuItemLoadTime).mark((0, $94Uc1.PERFORMANCE_MARK).BUNDLE_LOAD_START);
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null);
};
const $a3ce66216f7840ff$export$67c4b22563f33286 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "asyncOpenMenuItemComponent",
        packageName: "jiraSoftwareOnboardingQuickstart",
        teamName: "jlove-makkuro",
        fallback: "unmount",
        attributes: (0, $30rnQ.addChunkLoadErrorAnalyticsAttribute)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hYRTO.default), {
        name: "software-onboarding-checklist-open-menu-item",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a3ce66216f7840ff$var$SubmitOpenMenuItemLoadStart, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a3ce66216f7840ff$export$e6a8d3e2a6acc946, props)));

});
parcelRegister("94Uc1", function(module, exports) {

$parcel$export(module.exports, "PANEL_ID", () => $5bee65240229f284$export$e1d562d81d0e502d);
$parcel$export(module.exports, "PANEL_WIDTH", () => $5bee65240229f284$export$e05cfff20e9274e6);
$parcel$export(module.exports, "PERFORMANCE_METRIC_PREFIX", () => $5bee65240229f284$export$495d0560d6ea05d0);
$parcel$export(module.exports, "PERFORMANCE_MARK", () => $5bee65240229f284$export$5da8d06749e84d86);
const $5bee65240229f284$export$e1d562d81d0e502d = 'jsw-nux-onboarding-checklist';
const $5bee65240229f284$export$e05cfff20e9274e6 = 360;
const $5bee65240229f284$export$495d0560d6ea05d0 = 'onboarding-quickstart';
const $5bee65240229f284$export$5da8d06749e84d86 = {
    BUNDLE_LOAD_START: 'bundleLoaded',
    BUNDLE_LOAD_END: 'bundleLoadedEnd'
};

});

parcelRegister("353uQ", function(module, exports) {

$parcel$export(module.exports, "isMetricRunning", () => $56fd78ac33bc6df4$export$5c2d3e87043198cf);
$parcel$export(module.exports, "openMenuItemLoadTime", () => $56fd78ac33bc6df4$export$9aef270bc11ae96b);
$parcel$export(module.exports, "qsButtonAutoLoadTime", () => $56fd78ac33bc6df4$export$844f48c93ed69757);
$parcel$export(module.exports, "qsChecklistAutoLoadTime", () => $56fd78ac33bc6df4$export$c501d2dfab0e9e45);
$parcel$export(module.exports, "qsChecklistMinimiseInteraction", () => $56fd78ac33bc6df4$export$ac78fba7425e64da);
$parcel$export(module.exports, "qsChecklistDismissInteraction", () => $56fd78ac33bc6df4$export$494d4094aaa2bc4d);
$parcel$export(module.exports, "qsButtonOpenInteraction", () => $56fd78ac33bc6df4$export$da7d38041ee220c8);
$parcel$export(module.exports, "qsButtonDismissInteraction", () => $56fd78ac33bc6df4$export$ce2841e9d619cdfd);
// @ts-expect-error - TS2305 - Module '"@atlassian/browser-metrics"' has no exported member 'BaseMetric'.

var $dGrdR = parcelRequire("dGrdR");

var $94Uc1 = parcelRequire("94Uc1");
const $56fd78ac33bc6df4$export$5c2d3e87043198cf = (metric)=>metric?.state === 'started';
const $56fd78ac33bc6df4$export$9aef270bc11ae96b = (0, $dGrdR.metrics).custom({
    key: `${(0, $94Uc1.PERFORMANCE_METRIC_PREFIX)}.open.menu-item.load`,
    timings: [
        {
            key: (0, $94Uc1.PERFORMANCE_MARK).BUNDLE_LOAD_START,
            endMark: (0, $94Uc1.PERFORMANCE_MARK).BUNDLE_LOAD_END
        }
    ]
});
const $56fd78ac33bc6df4$export$844f48c93ed69757 = (0, $dGrdR.metrics).custom({
    key: `${(0, $94Uc1.PERFORMANCE_METRIC_PREFIX)}.button.load`,
    timings: [
        {
            key: (0, $94Uc1.PERFORMANCE_MARK).BUNDLE_LOAD_START,
            endMark: (0, $94Uc1.PERFORMANCE_MARK).BUNDLE_LOAD_END
        }
    ]
});
const $56fd78ac33bc6df4$export$c501d2dfab0e9e45 = (0, $dGrdR.metrics).custom({
    key: `${(0, $94Uc1.PERFORMANCE_METRIC_PREFIX)}.checklist.load`,
    timings: [
        {
            key: (0, $94Uc1.PERFORMANCE_MARK).BUNDLE_LOAD_START,
            endMark: (0, $94Uc1.PERFORMANCE_MARK).BUNDLE_LOAD_END
        }
    ]
});
const $56fd78ac33bc6df4$export$ac78fba7425e64da = (0, $dGrdR.metrics).interaction({
    key: `${(0, $94Uc1.PERFORMANCE_METRIC_PREFIX)}.checklist.minimize`
});
const $56fd78ac33bc6df4$export$494d4094aaa2bc4d = (0, $dGrdR.metrics).interaction({
    key: `${(0, $94Uc1.PERFORMANCE_METRIC_PREFIX)}.checklist.dismiss`
});
const $56fd78ac33bc6df4$export$da7d38041ee220c8 = (0, $dGrdR.metrics).interaction({
    key: `${(0, $94Uc1.PERFORMANCE_METRIC_PREFIX)}.button.open`
});
const $56fd78ac33bc6df4$export$ce2841e9d619cdfd = (0, $dGrdR.metrics).interaction({
    key: `${(0, $94Uc1.PERFORMANCE_METRIC_PREFIX)}.button.dismiss`
});

});

parcelRegister("30rnQ", function(module, exports) {

$parcel$export(module.exports, "addChunkLoadErrorAnalyticsAttribute", () => $53c68ff9a9edd0fe$export$94ee0b5fca1e74d2);
$parcel$export(module.exports, "useAddErrorBoundaryAnalyticsAttributes", () => $53c68ff9a9edd0fe$export$807be5f3f1ea996);

var $5uXOq = parcelRequire("5uXOq");

var $bCf8q = parcelRequire("bCf8q");
const $53c68ff9a9edd0fe$export$94ee0b5fca1e74d2 = (error)=>({
        chunkLoadError: (0, $bCf8q.isLoaderError)(error)
    });
const $53c68ff9a9edd0fe$export$807be5f3f1ea996 = (attributes = {})=>(0, $5uXOq.useCallback)((error)=>({
            ...attributes,
            ...$53c68ff9a9edd0fe$export$94ee0b5fca1e74d2(error)
        }), [
        attributes
    ]);

});

parcelRegister("iuzc0", function(module, exports) {

$parcel$export(module.exports, "QuickstartPillVisibilityContainer", () => $eb306ed6e1ecf691$export$1a5202e8ea7b76ab);
$parcel$export(module.exports, "useQuickstartPillVisibilityStore", () => $eb306ed6e1ecf691$export$70dc54081d2075ff);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
const $eb306ed6e1ecf691$var$actions = {
    toggleShowQuickstart: ({ showQuickstartPill: showQuickstartPill })=>({ setState: setState })=>{
            setState({
                showQuickstartPill: showQuickstartPill
            });
        }
};
const $eb306ed6e1ecf691$var$initialState = {
    showQuickstartPill: null
};
const $eb306ed6e1ecf691$var$Store = (0, $iXqE5.createStore)({
    initialState: $eb306ed6e1ecf691$var$initialState,
    actions: $eb306ed6e1ecf691$var$actions,
    name: 'JiraQuickstartPillVisibility'
});
const $eb306ed6e1ecf691$export$1a5202e8ea7b76ab = (0, $gg7kZ.createContainer)($eb306ed6e1ecf691$var$Store, {
    onInit: ()=>({ setState: setState })=>{
            setState({
                ...$eb306ed6e1ecf691$var$initialState
            });
        }
});
const $eb306ed6e1ecf691$export$70dc54081d2075ff = (0, $3sQ5x.createHook)($eb306ed6e1ecf691$var$Store);

});

parcelRegister("l8ruj", function(module, exports) {

$parcel$export(module.exports, "default", () => $6056b4460d0127e0$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $1tcYS = parcelRequire("1tcYS");

var $bFU4G = parcelRequire("bFU4G");

var $8Ec39 = parcelRequire("8Ec39");

var $cEm1b = parcelRequire("cEm1b");

var $4R6GH = parcelRequire("4R6GH");

var $c1haS = parcelRequire("c1haS");

var $aJOZ3 = parcelRequire("aJOZ3");
/** A portion of the page we apply measurement to */ function $6056b4460d0127e0$var$JiraUFOSegmentWrapper({ children: children }) {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const interactionContext = (0, $1tcYS.useInteractionContext)();
    const relayProfilerContext = (0, $5uXOq.useMemo)(()=>({
            getInteractionContext: ()=>interactionContext,
            wrapPrepareQueryResource (cb) {
                return cb();
            },
            retainQuery (info) {
                this.getInteractionContext().retainQuery(info);
            }
        }), [
        interactionContext
    ]);
    const reactLooselyLazyContext = (0, $5uXOq.useMemo)(()=>{
        const moduleLoadingRequests = {};
        return {
            current: {
                getInteractionContext () {
                    return interactionContext;
                },
                onPreload (moduleId, _priority) {
                    if ((0, $c1haS.getIsConcurrentEnabled)() && (0, $4R6GH.fg)('ufo-disable-rll-bundle-loads-jira')) return;
                    this.getInteractionContext().addPreload((0, $bFU4G.extractModuleName)(moduleId), performance.now());
                },
                onLoadStart (info) {
                    if ((0, $c1haS.getIsConcurrentEnabled)() && (0, $4R6GH.fg)('ufo-disable-rll-bundle-loads-jira')) return;
                    const timeoutId = setTimeout(()=>{
                        delete moduleLoadingRequests[info.identifier];
                    }, 30000);
                    const request = {
                        start: performance.now(),
                        timeoutId: timeoutId
                    };
                    moduleLoadingRequests[info.identifier] = request;
                },
                onLoadComplete (info) {
                    if ((0, $c1haS.getIsConcurrentEnabled)() && (0, $4R6GH.fg)('ufo-disable-rll-bundle-loads-jira')) return;
                    const request = moduleLoadingRequests[info.identifier];
                    if (request) {
                        clearTimeout(request.timeoutId);
                        delete moduleLoadingRequests[info.identifier];
                        this.getInteractionContext()?.addLoad((0, $bFU4G.extractModuleName)(info.identifier), request.start, performance.now());
                    }
                },
                placeholderFallBackMounted (id, name, lazyWait) {
                    if ((name === 'nav4-ignore.sidebar' || name === 'nav4-ignore.sidebar.anonymous') && (0, $4R6GH.fg)('afo-3421-remove-sidebar-nav4-suspense')) return;
                    if (lazyWait) return;
                    this.getInteractionContext().addHoldByID(this.getInteractionContext().labelStack, id, name);
                },
                placeholderFallBackUnmounted (id, name, lazyWait) {
                    if ((name === 'nav4-ignore.sidebar' || name === 'nav4-ignore.sidebar.anonymous') && (0, $4R6GH.fg)('afo-3421-remove-sidebar-nav4-suspense')) return;
                    if (lazyWait) return;
                    this.getInteractionContext().removeHoldByID(this.getInteractionContext().labelStack, id, name);
                }
            }
        };
    }, [
        interactionContext
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8Uumt.ProfilerContext).Provider, {
        value: relayProfilerContext
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aJOZ3.default), {
        labelStack: interactionContext.labelStack,
        onRender: (...args)=>interactionContext.onRender(...args)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cEm1b.ProfilerContext).Provider, {
        value: reactLooselyLazyContext
    }, children)));
}
function $6056b4460d0127e0$export$2e2bcd8739ae039({ name: segmentName, children: children, mode: mode = 'single' }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8Ec39.default), {
        name: segmentName,
        mode: mode
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6056b4460d0127e0$var$JiraUFOSegmentWrapper, null, children));
}

});
parcelRegister("aJOZ3", function(module, exports) {

$parcel$export(module.exports, "default", () => $37d596e34a54eb72$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
const $37d596e34a54eb72$var$SsrRenderProfiler = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
};
var $37d596e34a54eb72$export$2e2bcd8739ae039 = $37d596e34a54eb72$var$SsrRenderProfiler;

});


parcelRegister("5Nzrp", function(module, exports) {

$parcel$export(module.exports, "JswOnboardingChecklistNext", () => $c4258442d9598a49$export$bbc4e97e9a15a84b);

var $5uXOq = parcelRequire("5uXOq");

var $2NMNM = parcelRequire("2NMNM");

var $fNobW = parcelRequire("fNobW");

var $hYRTO = parcelRequire("hYRTO");

var $7CMCs = parcelRequire("7CMCs");

var $hsmeR = parcelRequire("hsmeR");

var $30rnQ = parcelRequire("30rnQ");

var $8Bc5A = parcelRequire("8Bc5A");

var $cE2Qr = parcelRequire("cE2Qr");

var $52Vcw = parcelRequire("52Vcw");

var $94Uc1 = parcelRequire("94Uc1");

var $353uQ = parcelRequire("353uQ");

var $9TQ3l = parcelRequire("9TQ3l");
const $c4258442d9598a49$export$bbc4e97e9a15a84b = ()=>{
    const [quickstartStatus] = (0, $cE2Qr.useQuickstartUiStatus)();
    const { openRightSidebar: openRightSidebar, closeRightSidebar: closeRightSidebar } = (0, $hsmeR.useRightSidebarController)();
    const currentRightSidebarState = (0, $hsmeR.useActiveRightSidebarState)();
    const currentRightSidebarPanelId = currentRightSidebarState?.panelId;
    const isRightSidePanelMinimised = currentRightSidebarState?.isMinimised ?? false;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>()=>{
            closeRightSidebar((0, $94Uc1.PANEL_ID));
            (0, $52Vcw.fireAnalyticsOnCloseRightHandSidebar)(createAnalyticsEvent, {
                quickstartStatus: quickstartStatus,
                isRightSidePanelCollapsed: isRightSidePanelMinimised,
                isRightSidePanelMinimised: isRightSidePanelMinimised,
                currentRightSidebarPanelId: currentRightSidebarPanelId || '',
                trigger: 'JswOnboardingChecklistNext'
            });
        }, // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    (0, $5uXOq.useEffect)(()=>{
        if ((quickstartStatus === (0, $8Bc5A.QUICKSTART_UI_STATUS).DISMISSED || quickstartStatus === (0, $8Bc5A.QUICKSTART_UI_STATUS).MINIMIZED) && (0, $353uQ.isMetricRunning)((0, $353uQ.qsChecklistAutoLoadTime))) // QS Checklist loading cancelled for page load action
        (0, $353uQ.qsChecklistAutoLoadTime).cancel();
        if (quickstartStatus === (0, $8Bc5A.QUICKSTART_UI_STATUS).DISMISSED && (0, $353uQ.isMetricRunning)((0, $353uQ.qsChecklistDismissInteraction))) // User interaction completed for QS Checklist dismiss action
        (0, $353uQ.qsChecklistDismissInteraction).stop();
        if (quickstartStatus === (0, $8Bc5A.QUICKSTART_UI_STATUS).DISMISSED && currentRightSidebarPanelId === (0, $94Uc1.PANEL_ID)) {
            closeRightSidebar((0, $94Uc1.PANEL_ID));
            (0, $52Vcw.fireAnalyticsOnCloseRightHandSidebar)(createAnalyticsEvent, {
                quickstartStatus: quickstartStatus,
                isRightSidePanelCollapsed: isRightSidePanelMinimised,
                isRightSidePanelMinimised: isRightSidePanelMinimised,
                currentRightSidebarPanelId: currentRightSidebarPanelId || '',
                trigger: 'JswOnboardingChecklistNext'
            });
            return;
        }
        if (quickstartStatus === (0, $8Bc5A.QUICKSTART_UI_STATUS).OPEN && currentRightSidebarPanelId !== (0, $94Uc1.PANEL_ID)) {
            openRightSidebar((0, $94Uc1.PANEL_ID), (0, $94Uc1.PANEL_WIDTH));
            (0, $52Vcw.fireAnalyticsOnOpenRightHandSidebar)(createAnalyticsEvent, {
                quickstartStatus: quickstartStatus,
                isRightSidePanelCollapsed: isRightSidePanelMinimised,
                isRightSidePanelMinimised: isRightSidePanelMinimised,
                currentRightSidebarPanelId: currentRightSidebarPanelId || '',
                openRightSidebarAsMinimised: false,
                openRightSidebarToTop: false,
                trigger: 'JswOnboardingChecklistNext'
            });
        }
    }, [
        currentRightSidebarPanelId,
        openRightSidebar,
        closeRightSidebar,
        quickstartStatus,
        createAnalyticsEvent,
        isRightSidePanelMinimised
    ]);
    if (quickstartStatus === (0, $8Bc5A.QUICKSTART_UI_STATUS).NOT_LOADED) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fNobW.default), {
        name: "quickstart-fetching-data"
    });
    if (quickstartStatus !== (0, $8Bc5A.QUICKSTART_UI_STATUS).OPEN) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "internalChecklistComponent",
        packageName: "jiraSoftwareOnboardingQuickstart",
        sendToPrivacyUnsafeSplunk: true,
        teamName: "jlove-makkuro",
        fallback: "unmount",
        attributes: (0, $30rnQ.addChunkLoadErrorAnalyticsAttribute)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hYRTO.default), {
        name: "software-onboarding-checklist-next",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9TQ3l.AsyncJswOnboardingChecklistInternal), null)));
};

});
parcelRegister("hsmeR", function(module, exports) {

$parcel$export(module.exports, "useActiveRightSidebarState", () => $39a48ee662f10943$export$ba763ab7661c3103);
$parcel$export(module.exports, "useRightSidebarState", () => $39a48ee662f10943$export$d1828e7f46a4960b);
$parcel$export(module.exports, "useRightSidebarController", () => $39a48ee662f10943$export$ebe5e907fb0bb63a);

var $5uXOq = parcelRequire("5uXOq");

var $3sQ5x = parcelRequire("3sQ5x");

var $byk51 = parcelRequire("byk51");

var $5e5zm = parcelRequire("5e5zm");
const $39a48ee662f10943$var$useActiveRightSidebar = (0, $3sQ5x.createHook)((0, $5e5zm.layoutStore), {
    selector: (state)=>{
        const rightSidebarState = (0, $byk51.selectCurrentRightSidebar)(state.content.rightSidebar);
        if (!rightSidebarState) return null;
        return {
            ...rightSidebarState,
            shouldRender: !state.isChromeless
        };
    }
});
const $39a48ee662f10943$export$ba763ab7661c3103 = ()=>{
    const [rightSidebar] = $39a48ee662f10943$var$useActiveRightSidebar();
    return rightSidebar;
};
const $39a48ee662f10943$var$useRightSidebar = (0, $3sQ5x.createHook)((0, $5e5zm.layoutStore), {
    selector: (state)=>state.content.rightSidebar
});
const $39a48ee662f10943$export$d1828e7f46a4960b = ()=>{
    const [rightSidebarState] = $39a48ee662f10943$var$useRightSidebar();
    return rightSidebarState;
};
const $39a48ee662f10943$export$ebe5e907fb0bb63a = ()=>{
    const [, { setRightSidebarState: setRightSidebarState, openRightSidebar: openRightSidebar, closeRightSidebar: closeRightSidebar, closeCurrentRightSidebar: closeCurrentRightSidebar, closeAllRightSidebar: closeAllRightSidebar, minimiseRightSidebar: minimiseRightSidebar }] = (0, $5e5zm.useLayoutStoreActions)();
    return (0, $5uXOq.useMemo)(()=>({
            setRightSidebarState: setRightSidebarState,
            closeRightSidebar: closeRightSidebar,
            openRightSidebar: openRightSidebar,
            closeCurrentRightSidebar: closeCurrentRightSidebar,
            closeAllRightSidebar: closeAllRightSidebar,
            minimiseRightSidebar: minimiseRightSidebar
        }), [
        closeAllRightSidebar,
        closeCurrentRightSidebar,
        closeRightSidebar,
        openRightSidebar,
        setRightSidebarState,
        minimiseRightSidebar
    ]);
};

});
parcelRegister("byk51", function(module, exports) {

$parcel$export(module.exports, "selectCurrentRightSidebar", () => $4dabd377b098e1a2$export$57758d0cfaeec2c);
$parcel$export(module.exports, "setRightSidebarState", () => $4dabd377b098e1a2$export$f5584170a8c1db02);
$parcel$export(module.exports, "closeAllRightSidebar", () => $4dabd377b098e1a2$export$d91a6e55d52aa3e9);
$parcel$export(module.exports, "closeCurrentRightSidebar", () => $4dabd377b098e1a2$export$a9a5075d3d1b2165);
$parcel$export(module.exports, "closeRightSidebar", () => $4dabd377b098e1a2$export$d7149233c76efb32);
$parcel$export(module.exports, "minimiseRightSidebar", () => $4dabd377b098e1a2$export$4eedf7fa26a2749a);
$parcel$export(module.exports, "openRightSidebar", () => $4dabd377b098e1a2$export$c8dafe074328c4ca);

var $ajpes = parcelRequire("ajpes");
const $4dabd377b098e1a2$var$arrayMove = (array, oldIndex, newIndex)=>{
    const arrayCopy = [
        ...array
    ];
    const f = arrayCopy.splice(oldIndex, 1)[0];
    arrayCopy.splice(newIndex, 0, f);
    return arrayCopy;
};
const $4dabd377b098e1a2$var$dedupe = (stackState = [])=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const visited = {};
    return stackState.filter((item)=>{
        if (visited[item.panelId]) return false;
        visited[item.panelId] = true;
        return true;
    });
};
const $4dabd377b098e1a2$export$57758d0cfaeec2c = (state)=>{
    if (state.stackState.length === 1) return state.stackState[0];
    return state.stackState.find((sidebar)=>!sidebar.isCollapsed && !sidebar.isMinimised) || null;
};
const $4dabd377b098e1a2$export$f5584170a8c1db02 = (newState)=>({ getState: getState, setState: setState })=>{
        const { content: content } = getState();
        setState({
            content: {
                ...content,
                rightSidebar: {
                    stackState: $4dabd377b098e1a2$var$dedupe(newState.stackState)
                }
            }
        });
    };
const $4dabd377b098e1a2$export$d91a6e55d52aa3e9 = ()=>({ getState: getState, setState: setState })=>{
        const { content: content } = getState();
        setState({
            content: {
                ...content,
                rightSidebar: {
                    stackState: []
                }
            }
        });
    };
const $4dabd377b098e1a2$export$a9a5075d3d1b2165 = ()=>({ getState: getState, setState: setState })=>{
        const { content: content } = getState();
        const currentStack = content.rightSidebar.stackState || [];
        if (!currentStack.length) return;
        const currentRightSidebar = $4dabd377b098e1a2$export$57758d0cfaeec2c(content.rightSidebar);
        if (!currentRightSidebar) return;
        setState({
            content: {
                ...content,
                rightSidebar: {
                    stackState: content.rightSidebar.stackState.filter((item)=>item !== currentRightSidebar)
                }
            }
        });
    };
const $4dabd377b098e1a2$export$d7149233c76efb32 = (panelId)=>({ getState: getState, setState: setState })=>{
        const { content: content } = getState();
        const currentStack = content.rightSidebar.stackState || [];
        setState({
            content: {
                ...content,
                rightSidebar: {
                    stackState: currentStack.filter((item)=>item.panelId !== panelId)
                }
            }
        });
    };
const $4dabd377b098e1a2$export$4eedf7fa26a2749a = (panelId)=>({ getState: getState, setState: setState })=>{
        const { content: content } = getState();
        const currentStack = content.rightSidebar.stackState || [];
        setState({
            content: {
                ...content,
                rightSidebar: {
                    stackState: currentStack.map((item)=>{
                        if (item.panelId !== panelId) return item;
                        return {
                            ...item,
                            isMinimised: true
                        };
                    })
                }
            }
        });
    };
const $4dabd377b098e1a2$export$c8dafe074328c4ca = (panelId, width, isMinimised = false, toTop = false)=>({ getState: getState, setState: setState })=>{
        const { content: content } = getState();
        const tempRightSidebarStackStateValue = content.rightSidebar.stackState ? [
            ...content.rightSidebar.stackState.map((item)=>{
                if (item.panelId === panelId) return {
                    ...item,
                    isMinimised: isMinimised,
                    width: width
                };
                return item;
            })
        ] : [];
        const matchedPanelIndex = tempRightSidebarStackStateValue.findIndex((obj)=>obj.panelId === panelId);
        // if there's any matched panel id, we only move it to the top of the stack.
        if (matchedPanelIndex >= 0) {
            const nextIdx = toTop ? 0 : tempRightSidebarStackStateValue.length - 1;
            tempRightSidebarStackStateValue[matchedPanelIndex].isCollapsed = false;
            tempRightSidebarStackStateValue[matchedPanelIndex].isMinimised = isMinimised;
            const newRightSidebarStackStateValue = $4dabd377b098e1a2$var$arrayMove(tempRightSidebarStackStateValue, matchedPanelIndex, nextIdx);
            newRightSidebarStackStateValue[nextIdx].width = width;
            setState({
                content: {
                    ...content,
                    rightSidebar: {
                        stackState: newRightSidebarStackStateValue
                    }
                }
            });
            return;
        }
        const newRightSidebarStackStateValue = toTop ? [
            {
                panelId: panelId,
                width: width,
                isCollapsed: false,
                isMinimised: isMinimised
            },
            ...tempRightSidebarStackStateValue
        ] : [
            ...tempRightSidebarStackStateValue,
            {
                panelId: panelId,
                width: width,
                isCollapsed: false,
                isMinimised: isMinimised
            }
        ];
        if ((0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(newRightSidebarStackStateValue, content.rightSidebar.stackState)) return;
        setState({
            content: {
                ...content,
                rightSidebar: {
                    stackState: newRightSidebarStackStateValue
                }
            }
        });
    };

});

parcelRegister("5e5zm", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_LEFT_SIDEBAR_WIDTH", () => $0c99a19d69d506cf$export$539e68c09584883a);
$parcel$export(module.exports, "layoutStore", () => $0c99a19d69d506cf$export$b8cdfd44cddaf07);
$parcel$export(module.exports, "useLayoutStoreActions", () => $0c99a19d69d506cf$export$6136bc3b9858cff4);
$parcel$export(module.exports, "useDetailPanelWidth", () => $0c99a19d69d506cf$export$95fd7b6da3b9bbb0);
$parcel$export(module.exports, "useDetailPanelActions", () => $0c99a19d69d506cf$export$99e05a60cac05e86);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $8CM3x = parcelRequire("8CM3x");
const $0c99a19d69d506cf$export$539e68c09584883a = 240;
const $0c99a19d69d506cf$export$b92df8810d2fcd01 = 0;
const $0c99a19d69d506cf$var$initialState = {
    isChromeless: false,
    isFullscreen: false,
    banner: {
        height: 0,
        activeBanner: null
    },
    topNavigation: {
        isVisible: true
    },
    leftPanel: {
        isVisible: true,
        width: 0
    },
    rightPanel: {
        isVisible: true,
        width: 0
    },
    bottomRightCorner: {
        container: undefined,
        portals: []
    },
    content: {
        leftSidebar: {
            width: $0c99a19d69d506cf$export$539e68c09584883a,
            isCollapsed: true,
            isVisible: true,
            isFlyoutOpen: false
        },
        rightSidebar: {
            stackState: []
        }
    }
};
const $0c99a19d69d506cf$export$b8cdfd44cddaf07 = (0, $iXqE5.createStore)({
    initialState: $0c99a19d69d506cf$var$initialState,
    actions: $8CM3x.actions,
    name: 'JiraLayoutStore'
});
const $0c99a19d69d506cf$export$6136bc3b9858cff4 = (0, $3sQ5x.createHook)($0c99a19d69d506cf$export$b8cdfd44cddaf07, {
    selector: null
});
const $0c99a19d69d506cf$var$detailPanelWidthStore = (0, $iXqE5.createStore)({
    name: 'detailPanelWidth',
    initialState: {
        width: 0
    },
    actions: {
        setWidth: (value)=>({ setState: setState })=>{
                setState({
                    width: value
                });
            }
    }
});
const $0c99a19d69d506cf$export$95fd7b6da3b9bbb0 = (0, $3sQ5x.createHook)($0c99a19d69d506cf$var$detailPanelWidthStore);
const $0c99a19d69d506cf$export$99e05a60cac05e86 = (0, $3sQ5x.createActionsHook)($0c99a19d69d506cf$var$detailPanelWidthStore);

});
parcelRegister("8CM3x", function(module, exports) {

$parcel$export(module.exports, "actions", () => $939ad82f8ddcb8d9$export$e324594224ef24da);

var $4oU0I = parcelRequire("4oU0I");

var $flhve = parcelRequire("flhve");

var $f5TQt = parcelRequire("f5TQt");

var $hPsAX = parcelRequire("hPsAX");

var $gqQUV = parcelRequire("gqQUV");

var $byk51 = parcelRequire("byk51");
const $939ad82f8ddcb8d9$export$e324594224ef24da = {
    setIsChromeless: // global
    $f5TQt.setIsChromeless,
    setIsFullscreen: $hPsAX.setIsFullscreen,
    showBanner: // banner
    $4oU0I.showBanner,
    dismissCurrentBanner: $4oU0I.dismissCurrentBanner,
    setLeftSidebarState: // left-sidebar
    $gqQUV.setLeftSidebarState,
    setRightSidebarState: // right-sidebar
    $byk51.setRightSidebarState,
    openRightSidebar: $byk51.openRightSidebar,
    closeRightSidebar: $byk51.closeRightSidebar,
    closeAllRightSidebar: $byk51.closeAllRightSidebar,
    closeCurrentRightSidebar: $byk51.closeCurrentRightSidebar,
    minimiseRightSidebar: $byk51.minimiseRightSidebar,
    registerBottomRightCornerContainer: // bottom-right-corner
    $flhve.registerBottomRightCornerContainer,
    insertBottomRightCornerPortal: $flhve.insertBottomRightCornerPortal,
    removeBottomRightCornerPortal: $flhve.removeBottomRightCornerPortal
};

});
parcelRegister("4oU0I", function(module, exports) {

$parcel$export(module.exports, "showBanner", () => $820929f36789bf81$export$f5c0eb035ef26e87);
$parcel$export(module.exports, "dismissCurrentBanner", () => $820929f36789bf81$export$a45bccc0cc9ac424);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $820929f36789bf81$export$f5c0eb035ef26e87 = (newState)=>({ setState: setState })=>{
        setState({
            banner: newState
        });
    };
const $820929f36789bf81$export$a45bccc0cc9ac424 = ()=>({ dispatch: dispatch })=>{
        dispatch($820929f36789bf81$export$f5c0eb035ef26e87({
            height: 0,
            activeBanner: null
        }));
    };

});

parcelRegister("flhve", function(module, exports) {

$parcel$export(module.exports, "registerBottomRightCornerContainer", () => $560ff4740e75fa9e$export$2992ecf780497763);
$parcel$export(module.exports, "insertBottomRightCornerPortal", () => $560ff4740e75fa9e$export$3ed25a6bee272520);
$parcel$export(module.exports, "removeBottomRightCornerPortal", () => $560ff4740e75fa9e$export$928bf7e228ce06d2);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $560ff4740e75fa9e$export$2992ecf780497763 = (ref)=>({ setState: setState, getState: getState })=>{
        const { bottomRightCorner: bottomRightCorner } = getState();
        setState({
            bottomRightCorner: {
                ...bottomRightCorner,
                container: ref ?? undefined
            }
        });
    };
const $560ff4740e75fa9e$export$3ed25a6bee272520 = (item)=>// @ts-expect-error - TS2322 - Type '({ setState, getState }: StoreActionApi<LayoutState>) => number' is not assignable to type 'Action<LayoutState, void, void | Promise<void>>'.
    ({ setState: setState, getState: getState })=>{
        const { bottomRightCorner: bottomRightCorner } = getState();
        const { portals: portals } = bottomRightCorner;
        const sorted = [
            item,
            ...portals
        ].sort((a, b)=>b.orderFromRight - a.orderFromRight);
        const index = sorted.findIndex((portal)=>portal.id === item.id);
        setState({
            bottomRightCorner: {
                ...bottomRightCorner,
                portals: sorted
            }
        });
        return index;
    };
const $560ff4740e75fa9e$export$928bf7e228ce06d2 = (id)=>({ setState: setState, getState: getState })=>{
        const { bottomRightCorner: bottomRightCorner } = getState();
        const { portals: portals } = bottomRightCorner;
        setState({
            bottomRightCorner: {
                ...bottomRightCorner,
                portals: portals.filter((portal)=>portal.id !== id)
            }
        });
    };

});

parcelRegister("f5TQt", function(module, exports) {

$parcel$export(module.exports, "setIsChromeless", () => $0389a2d5715d1f25$export$1998c4816ad37edb);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $0389a2d5715d1f25$export$1998c4816ad37edb = (isChromeless)=>({ setState: setState })=>{
        setState({
            isChromeless: isChromeless
        });
    };

});

parcelRegister("hPsAX", function(module, exports) {

$parcel$export(module.exports, "setIsFullscreen", () => $e3c9e6899dc6b3f0$export$9c73b2f282069160);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $e3c9e6899dc6b3f0$export$9c73b2f282069160 = (isFullscreen)=>({ setState: setState })=>{
        setState({
            isFullscreen: isFullscreen
        });
    };

});

parcelRegister("gqQUV", function(module, exports) {

$parcel$export(module.exports, "setLeftSidebarState", () => $54ca906cbb882b25$export$3e0fd2d894ef83c8);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $54ca906cbb882b25$export$3e0fd2d894ef83c8 = (newState)=>({ getState: getState, setState: setState })=>{
        const { content: content } = getState();
        setState({
            content: {
                ...content,
                leftSidebar: {
                    ...content.leftSidebar,
                    ...newState
                }
            }
        });
    };

});




parcelRegister("9TQ3l", function(module, exports) {

$parcel$export(module.exports, "AsyncJswOnboardingChecklistInternal", () => $9a33006f56b5e7d2$export$9f3262905af42485);

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

var $94Uc1 = parcelRequire("94Uc1");

var $353uQ = parcelRequire("353uQ");

// eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/deprecations/no-rll-client-async-experiences
const $9a33006f56b5e7d2$var$Checklist = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("hffkV")).then(({ JswOnboardingChecklistFinal: JswOnboardingChecklistFinal })=>{
        (0, $353uQ.qsChecklistAutoLoadTime).mark((0, $94Uc1.PERFORMANCE_MARK).BUNDLE_LOAD_END);
        return JswOnboardingChecklistFinal;
    }), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/onboarding/onboarding-checklist-next/src/ui/onboarding-checklist/checklist/index.tsx"
});
const $9a33006f56b5e7d2$var$ChecklistInternalLoadStart = ()=>{
    (0, $5uXOq.useLayoutEffect)(()=>{
        (0, $353uQ.qsChecklistAutoLoadTime).mark((0, $94Uc1.PERFORMANCE_MARK).BUNDLE_LOAD_START);
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null);
};
const $9a33006f56b5e7d2$export$9f3262905af42485 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "software-onboarding-checklist-view-internal",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9a33006f56b5e7d2$var$ChecklistInternalLoadStart, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9a33006f56b5e7d2$var$Checklist, null));

});
parcelRegister("hffkV", function(module, exports) {

let $c8dfbbe404e6b325$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $c8dfbbe404e6b325$var$load("ffQaD"),
    $c8dfbbe404e6b325$var$load("kvRbA"),
    $c8dfbbe404e6b325$var$load("kVX56"),
    $c8dfbbe404e6b325$var$load("76n7a"),
    $c8dfbbe404e6b325$var$load("l253H"),
    $c8dfbbe404e6b325$var$load("aP74E")
]).then(()=>parcelRequire('2wwLq'));

});



parcelRegister("eIh4F", function(module, exports) {

$parcel$export(module.exports, "JswOnboardingButtonNext", () => $51c1715fc5801c45$export$bc3535037a418fa9);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $2NMNM = parcelRequire("2NMNM");

var $7CMCs = parcelRequire("7CMCs");

var $hsmeR = parcelRequire("hsmeR");

var $ACELo = parcelRequire("ACELo");

var $94Uc1 = parcelRequire("94Uc1");

var $353uQ = parcelRequire("353uQ");

var $30rnQ = parcelRequire("30rnQ");

var $8Bc5A = parcelRequire("8Bc5A");

var $1ffS1 = parcelRequire("1ffS1");

var $cE2Qr = parcelRequire("cE2Qr");

var $52Vcw = parcelRequire("52Vcw");

var $6jY6G = parcelRequire("6jY6G");

var $iuzc0 = parcelRequire("iuzc0");

var $ieDtd = parcelRequire("ieDtd");

var $lysGg = parcelRequire("lysGg");
const $51c1715fc5801c45$export$7127386abbb0f79c = ()=>{
    const route = (0, $6jY6G.useCurrentRoute)();
    const [selectedIssueValue] = (0, $ieDtd.useQueryParam)('selectedIssue');
    const [viewValue] = (0, $ieDtd.useQueryParam)('view');
    const isInRoadMapRoute = (0, $1ffS1.isRoadmapRoute)(route?.name);
    const isInBacklogRoute = route?.name === 'software-backlog';
    const isInBoardRoute = route?.name === 'software-boards';
    const isInRapidBoardBacklogRoute = route?.name === 'rapidboard-backlog';
    const isInRapidBoardBoardRoute = route?.name === 'rapidboard-board';
    // CMP & TMP Roadmap, and TMP backlog & board use selectedIssue query param
    if ((isInRoadMapRoute || isInBacklogRoute || isInBoardRoute) && Boolean(selectedIssueValue)) return true;
    // CMP backlog use view="detail" query param
    // (detail view can be triggered from the meatball menu on the issue modal)
    if (isInRapidBoardBacklogRoute) return viewValue === 'detail';
    // CMP Active Sprints and Kanban board uses view=detail query param
    // (detail view can be triggered from the meatball menu on the issue modal)
    if (isInRapidBoardBoardRoute && viewValue === 'detail') return true;
    return false;
};
const $51c1715fc5801c45$export$bc3535037a418fa9 = ()=>{
    const [quickstartStatus] = (0, $cE2Qr.useQuickstartUiStatus)();
    const isIssueViewOpened = $51c1715fc5801c45$export$7127386abbb0f79c();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { openRightSidebar: openRightSidebar } = (0, $hsmeR.useRightSidebarController)();
    const currentRightSidebarState = (0, $hsmeR.useActiveRightSidebarState)();
    const isRightSidePanelMinimised = currentRightSidebarState?.isMinimised ?? false;
    const currentRightSidebarPanelId = currentRightSidebarState?.panelId;
    const [{ showQuickstartPill: showQuickstartPill }] = (0, $iuzc0.useQuickstartPillVisibilityStore)();
    (0, $5uXOq.useEffect)(()=>{
        if ((quickstartStatus === (0, $8Bc5A.QUICKSTART_UI_STATUS).DISMISSED || quickstartStatus === (0, $8Bc5A.QUICKSTART_UI_STATUS).OPEN) && (0, $353uQ.isMetricRunning)((0, $353uQ.qsButtonAutoLoadTime))) // QS Button loading cancelled for page load action
        (0, $353uQ.qsButtonAutoLoadTime).cancel();
        if (quickstartStatus === (0, $8Bc5A.QUICKSTART_UI_STATUS).DISMISSED && (0, $353uQ.isMetricRunning)((0, $353uQ.qsButtonDismissInteraction))) // User interaction completed for QS Button dismiss action
        (0, $353uQ.qsButtonDismissInteraction).stop();
        if (quickstartStatus !== (0, $8Bc5A.QUICKSTART_UI_STATUS).MINIMIZED) return;
        // check if quickstart panel is already shown in minimised state in right-hand sidebar
        if (currentRightSidebarPanelId === (0, $94Uc1.PANEL_ID) && isRightSidePanelMinimised === true) return;
        openRightSidebar((0, $94Uc1.PANEL_ID), (0, $94Uc1.PANEL_WIDTH), true);
        (0, $52Vcw.fireAnalyticsOnOpenRightHandSidebar)(createAnalyticsEvent, {
            quickstartStatus: quickstartStatus,
            isRightSidePanelCollapsed: isRightSidePanelMinimised,
            isRightSidePanelMinimised: isRightSidePanelMinimised,
            currentRightSidebarPanelId: currentRightSidebarPanelId || '',
            openRightSidebarAsMinimised: true,
            openRightSidebarToTop: false,
            trigger: 'JswOnboardingButtonNext'
        });
    }, [
        isRightSidePanelMinimised,
        openRightSidebar,
        currentRightSidebarPanelId,
        quickstartStatus,
        createAnalyticsEvent
    ]);
    if (quickstartStatus !== (0, $8Bc5A.QUICKSTART_UI_STATUS).MINIMIZED || showQuickstartPill !== null && !showQuickstartPill && // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.location.pathname.endsWith('/list')) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "internalChecklistButtonComponent",
        packageName: "jiraSoftwareOnboardingQuickstart",
        sendToPrivacyUnsafeSplunk: true,
        teamName: "jlove-makkuro",
        fallback: "unmount",
        attributes: (0, $30rnQ.addChunkLoadErrorAnalyticsAttribute)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ACELo.JiraBottomRightCornerOutlet), {
        orderFromRight: 1,
        id: "software-onboarding-quickstart-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($51c1715fc5801c45$var$QuickstartButtonContainer, {
        isIssueViewOpened: isIssueViewOpened,
        "data-testid": "software-onboarding-quickstart.ui.onboarding-button.onboarding-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lysGg.JswOnboardingChecklistButton), null))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $51c1715fc5801c45$var$QuickstartButtonContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isIssueViewOpened: isIssueViewOpened, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "",
            __cmplp.isIssueViewOpened ? "_1e0cglyw" : "_1e0c1kw7",
            __cmplp.className
        ])
    });
});

});
parcelRegister("ACELo", function(module, exports) {

$parcel$export(module.exports, "JiraBottomRightCornerOutlet", () => $8d24666022201b4c$export$ee54e6ed235df65e);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $7nsd3 = parcelRequire("7nsd3");

var $b71gk = parcelRequire("b71gk");

var $hvrWv = parcelRequire("hvrWv");
const $8d24666022201b4c$var$OutletWithPortal = ({ orderFromRight: orderFromRight, children: children, id: id })=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const portalWrapper = (0, $5uXOq.useRef)(document.createElement('div'));
    const container = (0, $hvrWv.useBottomRightCornerContainer)();
    if (!container) throw new Error('GlobalBottomRightContainer could not be found. Please ensure that this container was rendered on the page.');
    const { insertBottomRightCornerPortal: insertBottomRightCornerPortal, removeBottomRightCornerPortal: removeBottomRightCornerPortal } = (0, $hvrWv.useBottomRightCornerActions)();
    (0, $5uXOq.useEffect)(()=>{
        if (container) {
            const indexToRender = insertBottomRightCornerPortal({
                orderFromRight: orderFromRight,
                id: id
            });
            // @ts-expect-error - TS2538 - Type 'Promise<void>' cannot be used as an index type. | TS2538 - Type 'void' cannot be used as an index type.
            container.insertBefore(portalWrapper.current, container.children[indexToRender]);
        }
        // required as eslint complains about the ref in cleanup function
        const portalCurrent = portalWrapper.current;
        return ()=>{
            container?.removeChild(portalCurrent);
            removeBottomRightCornerPortal(id);
        };
    }, [
        container,
        id,
        orderFromRight,
        insertBottomRightCornerPortal,
        removeBottomRightCornerPortal
    ]);
    return /*#__PURE__*/ (0, $7nsd3.createPortal)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8d24666022201b4c$var$StyledOutlet, null, children), portalWrapper.current);
};
const $8d24666022201b4c$export$ee54e6ed235df65e = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        id: "bottom-right-corner-outlet",
        packageName: "jira-bottom-right-corner-controller",
        extraEventData: {
            portalId: props.id
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8d24666022201b4c$var$OutletWithPortal, props));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8d24666022201b4c$var$StyledOutlet = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1vgl1wug _1ko9pxbi",
            __cmplp.className
        ])
    });
});

});
parcelRegister("hvrWv", function(module, exports) {

$parcel$export(module.exports, "useBottomRightCornerContainer", () => $4dcd4c0b25ba3fd4$export$84542488b6b6c309);
$parcel$export(module.exports, "useBottomRightCornerActions", () => $4dcd4c0b25ba3fd4$export$de496fd0e0151c81);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");

var $5e5zm = parcelRequire("5e5zm");
const $4dcd4c0b25ba3fd4$export$84542488b6b6c309 = (0, $3sQ5x.createStateHook)((0, $5e5zm.layoutStore), {
    selector: (state)=>state.bottomRightCorner.container
});
const $4dcd4c0b25ba3fd4$export$de496fd0e0151c81 = (0, $3sQ5x.createActionsHook)((0, $5e5zm.layoutStore));

});


parcelRegister("lysGg", function(module, exports) {

$parcel$export(module.exports, "JswOnboardingChecklistButton", () => $abb3d5d8a2c0e8b0$export$235000cc42ca709a);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $1RztZ = parcelRequire("1RztZ");

var $2NMNM = parcelRequire("2NMNM");

var $hsmeR = parcelRequire("hsmeR");

var $94Uc1 = parcelRequire("94Uc1");

var $353uQ = parcelRequire("353uQ");


var $8Bc5A = parcelRequire("8Bc5A");

var $izv86 = parcelRequire("izv86");

var $cE2Qr = parcelRequire("cE2Qr");

var $4R6GH = parcelRequire("4R6GH");

var $52Vcw = parcelRequire("52Vcw");

var $2OMDV = parcelRequire("2OMDV");
var $iXVV6 = parcelRequire("iXVV6");
var $5oFIy = parcelRequire("5oFIy");
var $8zOmE = parcelRequire("8zOmE");


var $4i99S = parcelRequire("4i99S");
const $abb3d5d8a2c0e8b0$var$ChecklistButtonAnaylticsWrapper = (0, $2OMDV.AnalyticsEventToProps)('button', {
    onClick: 'clicked'
})((0, $1RztZ.default));
const $abb3d5d8a2c0e8b0$export$235000cc42ca709a = ()=>{
    const currentRightSidebarState = (0, $hsmeR.useActiveRightSidebarState)();
    const [, { nextSetChecklistIsDismissed: nextSetChecklistIsDismissed, setNudgeStep: setNudgeStep, setHasNudgeActive: setHasNudgeActive }] = (0, $cE2Qr.useQuickstartActions)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const openChecklist = (0, $4i99S.useOpenChecklist)();
    const [quickstartStatus] = (0, $cE2Qr.useQuickstartUiStatus)();
    const [remoteStateFromHook] = (0, $cE2Qr.useJswOnboarding)();
    const currentRightSidebarPanelId = currentRightSidebarState?.panelId;
    const onDismiss = (0, $5uXOq.useCallback)((e)=>{
        e.preventDefault();
        (0, $353uQ.qsButtonDismissInteraction).start();
        nextSetChecklistIsDismissed(true);
        setNudgeStep((0, $6784cbc7d62e5d7c$export$7aa8bceae32c7862));
        setHasNudgeActive(true);
        const analyticsEvent = createAnalyticsEvent({});
        (0, $52Vcw.fireAnalyticsOnQuickstartDismiss)(analyticsEvent, {
            projectId: remoteStateFromHook.projectState?.projectId,
            productType: (0, $izv86.getProductType)(remoteStateFromHook.projectState?.projectType)
        }, 'button');
    }, [
        createAnalyticsEvent,
        nextSetChecklistIsDismissed,
        setNudgeStep,
        setHasNudgeActive,
        remoteStateFromHook
    ]);
    (0, $5uXOq.useLayoutEffect)(()=>{
        if ((0, $353uQ.isMetricRunning)((0, $353uQ.qsButtonAutoLoadTime))) // QS Button loading completed on page load action
        (0, $353uQ.qsButtonAutoLoadTime).stop();
        if ((0, $353uQ.isMetricRunning)((0, $353uQ.qsChecklistMinimiseInteraction))) // User interaction completed for QS Checklist minimise action
        (0, $353uQ.qsChecklistMinimiseInteraction).stop();
    }, []);
    const projectKey = remoteStateFromHook.projectState?.projectKey;
    if (projectKey && (0, $8Bc5A.SAMPLE_DATA_PROJECT_KEYS_TO_HIDE_ON).includes(projectKey) && (0, $4R6GH.fg)('jfind-mature-example-project-gate')) return;
    if (currentRightSidebarPanelId !== (0, $94Uc1.PANEL_ID)) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($abb3d5d8a2c0e8b0$var$TriggerWrapper, {
        reposition: quickstartStatus === (0, $8Bc5A.QUICKSTART_UI_STATUS).OPEN
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceType: (0, $4d5e0871c06cee03$export$9d2de6eebf7462b5),
        sourceName: (0, $8e02302c3f52a3b4$export$75cc63c8ac8ae533)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), {
        attributes: {
            projectId: remoteStateFromHook.projectState?.projectId,
            productType: (0, $izv86.getProductType)(remoteStateFromHook.projectState?.projectType)
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($abb3d5d8a2c0e8b0$var$ChecklistButtonAnaylticsWrapper, {
        isOpen: quickstartStatus === (0, $8Bc5A.QUICKSTART_UI_STATUS).MINIMIZED,
        title: "Quickstart",
        onClick: (event, analyticsEvent)=>{
            (0, $353uQ.qsButtonOpenInteraction).start();
            openChecklist({
                trigger: 'JswOnboardingChecklistButton'
            });
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, (0, $8e02302c3f52a3b4$export$75cc63c8ac8ae533), {
                projectId: remoteStateFromHook.projectState?.projectId,
                productType: (0, $izv86.getProductType)(remoteStateFromHook.projectState?.projectType)
            });
        },
        onDismiss: onDismiss
    })));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $abb3d5d8a2c0e8b0$var$TriggerWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { reposition: reposition, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_v564vccv _syaz1gjq _80omtlke",
            __cmplp.reposition ? "_otyr8vuz" : "_otyridpf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("2OMDV", function(module, exports) {

$parcel$export(module.exports, "AnalyticsEventToProps", () => $28422a5dfa4a4065$export$3e9ef96ba97ea9dc);

var $cb25w = parcelRequire("cb25w");
const $28422a5dfa4a4065$export$871de8747c9eaa88 = (props, componentName)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.keys(props).reduce((result, key)=>({
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            ...result,
            [key]: {
                action: props[key],
                actionSubject: componentName
            }
        }), {});
const $28422a5dfa4a4065$export$3e9ef96ba97ea9dc = (componentName, eventActions)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (WrappedComponent)=>(0, $cb25w.default)($28422a5dfa4a4065$export$871de8747c9eaa88(eventActions, componentName))(WrappedComponent);

});

// SCREENS
const $4d5e0871c06cee03$export$f636b5b56f1d624a = 'Screen';
const $4d5e0871c06cee03$export$9d2de6eebf7462b5 = 'Drawer';
const $4d5e0871c06cee03$export$1171103ea9083ffa = 'Modal';
const $4d5e0871c06cee03$export$cae2783c9279926 = 'InlineDialog';
const $4d5e0871c06cee03$export$d1123261ca8831d2 = 'Dropdown';
const $4d5e0871c06cee03$export$238d30785c4bca84 = 'Banner';
const $4d5e0871c06cee03$export$a1562d08625f5d7e = 'UI';
const $4d5e0871c06cee03$export$947dac6c72b26f81 = 'TRACK';
const $4d5e0871c06cee03$export$f1d537d508d2945a = 'SCREEN';
const $4d5e0871c06cee03$export$12346a674644c156 = 'OPERATIONAL';

parcelRegister("5oFIy", function(module, exports) {

$parcel$export(module.exports, "FireUiAnalytics", () => $3ea3e1dfbcd8cda6$export$5a67e7291fd4569e);
$parcel$export(module.exports, "FireTrackAnalytics", () => $3ea3e1dfbcd8cda6$export$5f0d7aae8dfa8b86);
$parcel$export(module.exports, "FireOperationalAnalytics", () => $3ea3e1dfbcd8cda6$export$b71c3ada5d4ec5da);
$parcel$export(module.exports, "FireScreenAnalytics", () => $3ea3e1dfbcd8cda6$export$2ccf161b817b43b);

var $5uXOq = parcelRequire("5uXOq");

var $cb25w = parcelRequire("cb25w");


var $8zOmE = parcelRequire("8zOmE");
// eslint-disable-next-line jira/react/no-class-components
class $3ea3e1dfbcd8cda6$var$FireComponent extends (0, $5uXOq.Component) {
    componentDidMount() {
        const { type: type, attributes: attributes, eventName: eventName, componentName: componentName, action: actionProps, actionSubject: actionSubjectProps, actionSubjectId: actionSubjectIdProps } = this.props;
        if (eventName && (actionProps || actionSubjectProps)) throw Error('eventName is an alias for action & actionSubject, provide only one of those');
        if (componentName && actionSubjectIdProps) throw Error('componentName is an alias for actionSubjectId, provide only one of those');
        const eventNameSplit = eventName ? eventName.split(' ') : [];
        const action = actionProps || eventNameSplit[1];
        const actionSubject = actionSubjectProps || eventNameSplit[0];
        if (!action || !actionSubject) throw Error('eventName should exist and be in the format "subject action", i.e. "button clicked", "menu opened", "issue created", etc');
        const actionSubjectId = actionSubjectIdProps || componentName;
        const analyticsEvent = this.props.createAnalyticsEvent({
            action: action
        });
        (0, $8zOmE.fireAnalytics)(analyticsEvent, type, {
            action: action,
            actionSubject: actionSubject,
            actionSubjectId: actionSubjectId,
            attributes: attributes
        });
    }
    render() {
        return null;
    }
}
const $3ea3e1dfbcd8cda6$export$64eb47d7b94ba089 = (0, $cb25w.default)()($3ea3e1dfbcd8cda6$var$FireComponent);
const $3ea3e1dfbcd8cda6$export$5a67e7291fd4569e = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3ea3e1dfbcd8cda6$export$64eb47d7b94ba089, {
        ...props,
        type: (0, $4d5e0871c06cee03$export$a1562d08625f5d7e)
    });
const $3ea3e1dfbcd8cda6$export$5f0d7aae8dfa8b86 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3ea3e1dfbcd8cda6$export$64eb47d7b94ba089, {
        ...props,
        type: (0, $4d5e0871c06cee03$export$947dac6c72b26f81)
    });
const $3ea3e1dfbcd8cda6$export$b71c3ada5d4ec5da = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3ea3e1dfbcd8cda6$export$64eb47d7b94ba089, {
        ...props,
        type: (0, $4d5e0871c06cee03$export$12346a674644c156)
    });
const $3ea3e1dfbcd8cda6$export$2ccf161b817b43b = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3ea3e1dfbcd8cda6$export$64eb47d7b94ba089, {
        ...props,
        type: (0, $4d5e0871c06cee03$export$f1d537d508d2945a),
        eventName: "screen viewed"
    });

});

// Used for analytics event context for secondary (floating button) view
const $8e02302c3f52a3b4$export$75cc63c8ac8ae533 = 'nuxOnboardingQuickstartButton';

parcelRegister("4i99S", function(module, exports) {

$parcel$export(module.exports, "useOpenChecklist", () => $5c528ffca81c6bae$export$318fa8576ad8aa73);

var $2NMNM = parcelRequire("2NMNM");

var $hsmeR = parcelRequire("hsmeR");

var $94Uc1 = parcelRequire("94Uc1");

var $8Bc5A = parcelRequire("8Bc5A");

var $cE2Qr = parcelRequire("cE2Qr");

var $52Vcw = parcelRequire("52Vcw");
const $5c528ffca81c6bae$export$318fa8576ad8aa73 = ()=>{
    const [{ openTask: currentOpenTask }, { nextSetChecklistIsOpen: nextSetChecklistIsOpen, nextSetChecklistIsDismissed: nextSetChecklistIsDismissed, nextOpenTask: nextOpenTask }] = (0, $cE2Qr.useJswOnboarding)();
    const { openRightSidebar: openRightSidebar } = (0, $hsmeR.useRightSidebarController)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [quickstartStatus] = (0, $cE2Qr.useQuickstartUiStatus)();
    const currentRightSidebarState = (0, $hsmeR.useActiveRightSidebarState)();
    const currentPanelId = currentRightSidebarState?.panelId;
    const openChecklist = ({ trigger: trigger, openTask: openTask })=>{
        if (openTask && openTask !== currentOpenTask) nextOpenTask(openTask);
        openRightSidebar((0, $94Uc1.PANEL_ID), (0, $94Uc1.PANEL_WIDTH), false, true);
        (0, $52Vcw.fireAnalyticsOnOpenRightHandSidebar)(createAnalyticsEvent, {
            quickstartStatus: quickstartStatus,
            currentRightSidebarPanelId: currentPanelId || '',
            openRightSidebarToTop: true,
            trigger: trigger
        });
        if (quickstartStatus === (0, $8Bc5A.QUICKSTART_UI_STATUS).DISMISSED) nextSetChecklistIsDismissed(false);
        else nextSetChecklistIsOpen(true);
    };
    return openChecklist;
};

});



parcelRegister("4x4NO", function(module, exports) {

let $34cdf82c7fb01ce6$var$load = (parcelRequire("28QjX"))(4);
module.exports = $34cdf82c7fb01ce6$var$load("gUkrx").then(()=>parcelRequire('jVPxT'));

});


parcelRegister("kdIRm", function(module, exports) {

$parcel$export(module.exports, "shouldRouteSkipOnboarding", () => $c1a599cdb35daf55$export$731515a1bfabb2c9);

var $4R6GH = parcelRequire("4R6GH");

var $c0dQj = parcelRequire("c0dQj");

var $jOXuX = parcelRequire("jOXuX");
const $c1a599cdb35daf55$export$961d422b19aa42f4 = (routeName, configQueryParam)=>{
    if ((0, $c0dQj.isMobileAndInMvpOrExistingUsersExperiment)()) return false;
    if ((0, $4R6GH.fg)('tailored_onboarding_m3_gate') || (0, $jOXuX.isTailoredOnboardingScrumAndSoftwareKanbanEnabled)()) {
        const allowedRoutes = new Set([
            'software-timeline',
            'software-backlog',
            'software-boards',
            'software-timeline-classic',
            'rapidboard-backlog',
            'rapidboard-board',
            'project-settings-software-access',
            'legacy-project-settings-people',
            'issue',
            'opsgenie-schedule',
            'software-code-classic',
            'software-list',
            'software-list-classic',
            'software-summary',
            'project-pages',
            'software-form',
            'software-calendar'
        ]);
        if ((0, $jOXuX.isTailoredOnboardingScrumAndSoftwareKanbanEnabled)()) allowedRoutes.add('software-code');
        if ((0, $4R6GH.fg)('software_calendar_quickstart_onboarding')) {
            allowedRoutes.add('software-calendar-classic');
            allowedRoutes.add('software-calendar');
        }
        return allowedRoutes.has(routeName) && configQueryParam === undefined;
    }
    const allowedRoutes = [
        'software-timeline',
        'software-backlog',
        'software-boards',
        'software-timeline-classic',
        'rapidboard-backlog',
        'rapidboard-board',
        'project-settings-software-access',
        'legacy-project-settings-people',
        'issue',
        'opsgenie-schedule',
        'software-code-classic',
        'software-list',
        'software-list-classic'
    ];
    (0, $4R6GH.fg)('software_calendar_quickstart_onboarding') && allowedRoutes.push('software-calendar-classic', 'software-calendar');
    return allowedRoutes.includes(routeName) && configQueryParam === undefined;
};
const $c1a599cdb35daf55$export$731515a1bfabb2c9 = (routeName, configQueryParam)=>!$c1a599cdb35daf55$export$961d422b19aa42f4(routeName, configQueryParam);

});
parcelRegister("jOXuX", function(module, exports) {

$parcel$export(module.exports, "isTailoredOnboardingScrumAndSoftwareKanbanEnabled", () => $4b94b4e85c1e2fc8$export$5dd90adc2e8ee137);
$parcel$export(module.exports, "isTailoredOnboardingEnabled", () => $4b94b4e85c1e2fc8$export$8eec918bc6d2ab67);
$parcel$export(module.exports, "isEligibleForTailoredOnboardingM3", () => $4b94b4e85c1e2fc8$export$54c132e77bb6d105);
$parcel$export(module.exports, "isEligibleForTailoredOnboardingScrumAndSoftwareKanban", () => $4b94b4e85c1e2fc8$export$713219ba4b63fe78);
$parcel$export(module.exports, "useIsTailoredOnboardingEnabledAndEligible", () => $4b94b4e85c1e2fc8$export$46047e5fecf4cae5);
$parcel$export(module.exports, "isTailoredOnboardingEnabledWithExposure", () => $4b94b4e85c1e2fc8$export$142e2425d224298f);
$parcel$export(module.exports, "useIsTailoredOnboardingM2p5EligibleWithExposure", () => $4b94b4e85c1e2fc8$export$fd0589feb622f26b);
$parcel$export(module.exports, "useIsScrumProject", () => $4b94b4e85c1e2fc8$export$f9373c9ef51fa1f4);

var $5uXOq = parcelRequire("5uXOq");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $bNm1d = parcelRequire("bNm1d");

var $gQEFa = parcelRequire("gQEFa");

var $dAfqg = parcelRequire("dAfqg");

var $58GFP = parcelRequire("58GFP");


var $cNd4s = parcelRequire("cNd4s");

var $8zOmE = parcelRequire("8zOmE");

var $2NMNM = parcelRequire("2NMNM");

var $43qGj = parcelRequire("43qGj");
const $4b94b4e85c1e2fc8$export$7889b94f54c2d416 = ()=>{
    // eslint-disable-next-line jira/ff/unsafe-no-exposure
    const [expConfig] = (0, $6s1PB.UNSAFE_noExposureExp)('tailored_onboarding_m3');
    return (0, $4R6GH.fg)('tailored_onboarding_m3_gate') && expConfig.get('isEnabled', false);
};
const $4b94b4e85c1e2fc8$export$5dd90adc2e8ee137 = ()=>{
    // eslint-disable-next-line jira/ff/unsafe-no-exposure
    const [expConfig] = (0, $6s1PB.UNSAFE_noExposureExp)('tailored_onboarding_scrum_and_software_kanban');
    return expConfig.get('isEnabled', false);
};
const $4b94b4e85c1e2fc8$export$8eec918bc6d2ab67 = ()=>{
    return $4b94b4e85c1e2fc8$export$7889b94f54c2d416() || $4b94b4e85c1e2fc8$export$5dd90adc2e8ee137();
};
const $4b94b4e85c1e2fc8$export$54c132e77bb6d105 = ({ teamType: teamType, templateKey: templateKey, isSiteAdmin: isSiteAdmin })=>{
    if (!isSiteAdmin) return false;
    const isSoftwareTeamType = teamType === (0, $6784cbc7d62e5d7c$export$b8b1ac856ba1434b);
    const isKanbanTemplate = templateKey?.startsWith((0, $58GFP.KANBAN_TEAM_MANAGED_KEY));
    if (isKanbanTemplate && !isSoftwareTeamType && $4b94b4e85c1e2fc8$export$7889b94f54c2d416()) return true;
    return false;
};
const $4b94b4e85c1e2fc8$export$713219ba4b63fe78 = ({ teamType: teamType, templateKey: templateKey, isSiteAdmin: isSiteAdmin, fireExposure: fireExposure = false, analyticEvent: analyticEvent })=>{
    if (!isSiteAdmin) return false;
    const isSoftwareTeamType = teamType === (0, $6784cbc7d62e5d7c$export$b8b1ac856ba1434b);
    const isScrumTemplate = templateKey?.startsWith((0, $58GFP.SCRUM_TEAM_MANAGED_KEY));
    const isKanbanTemplate = templateKey?.startsWith((0, $58GFP.KANBAN_TEAM_MANAGED_KEY));
    // Software Kanban or Scrum all Team Types
    if (isKanbanTemplate && isSoftwareTeamType || isScrumTemplate) {
        // User is eligible for experiment. Fires exposure for those in control too here
        if (fireExposure) {
            analyticEvent && (0, $8zOmE.fireTrackAnalytics)(analyticEvent, 'tailoredOnboardingWithScrumAndSoftwareKanban personalised', {
                teamType: teamType,
                templateKey: templateKey,
                isEnabled: (0, $6s1PB.expVal)('tailored_onboarding_scrum_and_software_kanban', 'isEnabled', false)
            });
            return (0, $6s1PB.expVal)('tailored_onboarding_scrum_and_software_kanban', 'isEnabled', false);
        }
        if ($4b94b4e85c1e2fc8$export$5dd90adc2e8ee137()) return true;
    }
    return false;
};
const $4b94b4e85c1e2fc8$export$5188e1ffa34f6a91 = ({ teamType: teamType, templateKey: templateKey, isSiteAdmin: isSiteAdmin })=>{
    return $4b94b4e85c1e2fc8$export$54c132e77bb6d105({
        teamType: teamType,
        templateKey: templateKey,
        isSiteAdmin: isSiteAdmin
    }) || $4b94b4e85c1e2fc8$export$713219ba4b63fe78({
        teamType: teamType,
        templateKey: templateKey,
        isSiteAdmin: isSiteAdmin
    });
};
const $4b94b4e85c1e2fc8$export$46047e5fecf4cae5 = ()=>{
    const isEnabled = $4b94b4e85c1e2fc8$export$8eec918bc6d2ab67();
    const isSiteAdmin = (0, $cNd4s.useIsSiteAdmin)();
    const { data: projectData } = (0, $dAfqg.useProjectContext)();
    const projectType = projectData?.projectType;
    const isSoftwareProject = projectType === 'software';
    const shouldFetch = isEnabled && isSiteAdmin && isSoftwareProject;
    const { isReady: teamTypeIsReady, teamType: teamType } = (0, $bNm1d.useTeamTypeShortHand)({
        shouldFetch: shouldFetch
    });
    const { loading: projectContextLoading, data: projectContext } = (0, $dAfqg.useProjectContext)();
    const { isReady: templateKeyIsReady, data: templateKey } = (0, $gQEFa.useFetchInitialProjectTemplateName)({
        shouldFetch: shouldFetch,
        projectId: projectContext?.projectId
    });
    if (!isEnabled) return {
        isReady: true,
        isTailoredOnboardingM3EnabledAndEligible: false,
        isTailoredOnboardingScrumAndSoftwareKanbanEnabled: false
    };
    const isTailoredOnboardingM3EnabledAndEligible = $4b94b4e85c1e2fc8$export$54c132e77bb6d105({
        teamType: teamType,
        templateKey: templateKey,
        isSiteAdmin: isSiteAdmin
    });
    const isTailoredOnboardingEnabledWithScrumAndSoftware = $4b94b4e85c1e2fc8$export$713219ba4b63fe78({
        teamType: teamType,
        templateKey: templateKey,
        isSiteAdmin: isSiteAdmin
    });
    return {
        isReady: teamTypeIsReady && templateKeyIsReady && !projectContextLoading,
        isTailoredOnboardingM3EnabledAndEligible: isEnabled && isTailoredOnboardingM3EnabledAndEligible,
        isTailoredOnboardingScrumAndSoftwareKanbanEnabled: isEnabled && isTailoredOnboardingEnabledWithScrumAndSoftware,
        teamType: teamType
    };
};
const $4b94b4e85c1e2fc8$export$142e2425d224298f = ({ isSiteAdmin: isSiteAdmin, analyticEvent: analyticEvent, teamType: teamType, templateKey: templateKey })=>{
    if ($4b94b4e85c1e2fc8$export$54c132e77bb6d105({
        teamType: teamType,
        templateKey: templateKey,
        isSiteAdmin: isSiteAdmin
    })) {
        (0, $8zOmE.fireTrackAnalytics)(analyticEvent, 'tailoredM3Redirect personalised', {
            teamType: teamType,
            templateKey: templateKey,
            isEnabled: (0, $6s1PB.expVal)('tailored_onboarding_m3', 'isEnabled', false)
        });
        return (0, $6s1PB.expVal)('tailored_onboarding_m3', 'isEnabled', false);
    }
    return $4b94b4e85c1e2fc8$export$713219ba4b63fe78({
        teamType: teamType,
        templateKey: templateKey,
        isSiteAdmin: isSiteAdmin,
        fireExposure: true,
        analyticEvent: analyticEvent
    });
};
const $4b94b4e85c1e2fc8$export$fd0589feb622f26b = ({ isBusinessProject: isBusinessProject, isTrelloCrossflow: isTrelloCrossflow, isOnboarding: isOnboarding })=>{
    const isSiteAdmin = (0, $cNd4s.useIsSiteAdmin)();
    const isBasicEligible = isSiteAdmin && isBusinessProject && !isTrelloCrossflow;
    const { isReady: teamTypeIsReady, teamType: teamType } = (0, $bNm1d.useTeamTypeShortHand)({
        shouldFetch: isBasicEligible
    });
    const isTargettedTeamType = ![
        (0, $6784cbc7d62e5d7c$export$4f3cb0844009af52),
        (0, $6784cbc7d62e5d7c$export$e4824f74b9879164)
    ].includes(teamType ?? '');
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const fireOnce = (0, $5uXOq.useRef)(false);
    if (!isBasicEligible) return {
        isEligible: false,
        isReady: true
    };
    if (!teamTypeIsReady) return {
        isEligible: undefined,
        isReady: false
    };
    if (isBusinessProject && isSiteAdmin && isTargettedTeamType) {
        if (!fireOnce.current) {
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'tailoredM2p5 exposed', {
                teamType: teamType,
                isOnboarding: isOnboarding,
                isEnabled: (0, $6s1PB.expVal)('tailored_onboarding_m2p5', 'isEnabled', false)
            });
            fireOnce.current = true;
        }
        return {
            isEligible: (0, $6s1PB.expVal)('tailored_onboarding_m2p5', 'isEnabled', false),
            isReady: true,
            teamType: teamType
        };
    }
    return {
        isEligible: false,
        isReady: true,
        teamType: teamType
    };
};
const $4b94b4e85c1e2fc8$export$f9373c9ef51fa1f4 = ()=>{
    if (!$4b94b4e85c1e2fc8$export$5dd90adc2e8ee137()) return false;
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { data: data } = (0, $43qGj.useFeatures)();
    return (data?.hasSprint && data?.hasBacklog) ?? false;
};

});
parcelRegister("bNm1d", function(module, exports) {

$parcel$export(module.exports, "useUserEmailDomain", () => $e92819165abac823$export$f95c1c6f997ec47f);
$parcel$export(module.exports, "useAtlassianAccount", () => $e92819165abac823$export$19d38f479bd18098);
$parcel$export(module.exports, "useTeamTypeShortHand", () => $e92819165abac823$export$1a086dfae472ccfe);

var $5uXOq = parcelRequire("5uXOq");

var $3sQ5x = parcelRequire("3sQ5x");
var $6dDSs = parcelRequire("6dDSs");
var $iXqE5 = parcelRequire("iXqE5");

var $9yQlD = parcelRequire("9yQlD");


var $asmQK = parcelRequire("asmQK");

var $2LmB4 = parcelRequire("2LmB4");
const $e92819165abac823$export$d4c72bab9d6cc13a = {
    isFetching: false,
    wasFetchedOnce: false,
    fetchError: null
};
const $e92819165abac823$var$Store = (0, $iXqE5.createStore)({
    initialState: $e92819165abac823$export$d4c72bab9d6cc13a,
    actions: $2LmB4.actions,
    name: 'atlassian-account'
});
const $e92819165abac823$var$loggedInEmailDomainSelector = (0, $6dDSs.createSelector)((state)=>state.data, (accountInfo)=>{
    if (!accountInfo) return null;
    const [, loggedInEmailDomain] = accountInfo.email?.split('@') ?? [];
    return loggedInEmailDomain;
});
const $e92819165abac823$export$2a9b22328f7b68fa = (0, $3sQ5x.createHook)($e92819165abac823$var$Store, {
    selector: $e92819165abac823$var$loggedInEmailDomainSelector
});
const $e92819165abac823$export$f95c1c6f997ec47f = (isEligibleToCall = true)=>{
    const [loggedInEmailDomain, { fetchAtlassianAccountData: fetchAtlassianAccountData }] = $e92819165abac823$export$2a9b22328f7b68fa();
    (0, $5uXOq.useEffect)(()=>{
        if (isEligibleToCall && !loggedInEmailDomain) fetchAtlassianAccountData();
    }, [
        fetchAtlassianAccountData,
        isEligibleToCall,
        loggedInEmailDomain
    ]);
    return {
        data: loggedInEmailDomain
    };
};
const $e92819165abac823$export$19d38f479bd18098 = (0, $3sQ5x.createHook)($e92819165abac823$var$Store);
const $e92819165abac823$export$1a086dfae472ccfe = ({ shouldFetch: shouldFetch })=>{
    const [{ data: atlassianAccountData, isFetching: isFetching, wasFetchedOnce: wasFetchedOnce }, { fetchAtlassianAccountData: fetchAtlassianAccountData }] = $e92819165abac823$export$19d38f479bd18098();
    const localStorageTeamTypeShorthand = (0, $9yQlD.localStorageProvider).get((0, $6784cbc7d62e5d7c$export$c06666264cd35603));
    (0, $5uXOq.useEffect)(()=>{
        if (shouldFetch && !localStorageTeamTypeShorthand && !isFetching && !wasFetchedOnce) fetchAtlassianAccountData({
            source: 'useTeamTypeShortHand'
        });
    }, [
        fetchAtlassianAccountData,
        isFetching,
        localStorageTeamTypeShorthand,
        shouldFetch,
        wasFetchedOnce
    ]);
    if (localStorageTeamTypeShorthand) return {
        isReady: true,
        teamType: localStorageTeamTypeShorthand
    };
    if (!shouldFetch) return {
        isReady: true,
        teamType: (0, $asmQK.mapUserSegmentationFullToShorthand)(atlassianAccountData?.extendedProfile.teamType)
    };
    if (atlassianAccountData?.extendedProfile.teamType && !localStorageTeamTypeShorthand) (0, $9yQlD.localStorageProvider).set((0, $6784cbc7d62e5d7c$export$c06666264cd35603), (0, $asmQK.mapUserSegmentationFullToShorthand)(atlassianAccountData.extendedProfile.teamType));
    return {
        isReady: !isFetching && wasFetchedOnce,
        teamType: (0, $asmQK.mapUserSegmentationFullToShorthand)(atlassianAccountData?.extendedProfile.teamType)
    };
};

});
parcelRegister("9yQlD", function(module, exports) {

$parcel$export(module.exports, "sessionStorageProvider", () => $816fbeb16311dd64$export$5a24cb3021127ff7);
$parcel$export(module.exports, "localStorageProvider", () => $816fbeb16311dd64$export$aa821bfb3308a1f5);

var $bSSG7 = parcelRequire("bSSG7");

var $eNf8a = parcelRequire("eNf8a");




const $816fbeb16311dd64$export$5a24cb3021127ff7 = (0, $eNf8a.createSessionExpirableStorageProvider)('onboarding-core');
const $816fbeb16311dd64$export$aa821bfb3308a1f5 = (0, $bSSG7.createLocalExpirableStorageProvider)('onboarding-core');

});

parcelRegister("asmQK", function(module, exports) {

$parcel$export(module.exports, "mapUserSegmentationFullToShorthand", () => $2244820289929c87$export$8897f7082e20c8df);

const $2244820289929c87$export$8897f7082e20c8df = (teamTypeFromMe)=>{
    switch(teamTypeFromMe){
        case 0, $6784cbc7d62e5d7c$export$e07d1fa2da8ed874:
            return 0, $6784cbc7d62e5d7c$export$572242e58bd07594;
        case 0, $6784cbc7d62e5d7c$export$76dcec3f438d9e56:
            return 0, $6784cbc7d62e5d7c$export$d7de553940261eba;
        case 0, $6784cbc7d62e5d7c$export$9a574c301f67ba30:
            return 0, $6784cbc7d62e5d7c$export$4c29d0d04c15e55d;
        case 0, $6784cbc7d62e5d7c$export$363ec144a94029c8:
            return 0, $6784cbc7d62e5d7c$export$3950f7f841bf94b6;
        case 0, $6784cbc7d62e5d7c$export$df0fb32d68ae1e78:
            return 0, $6784cbc7d62e5d7c$export$881249b988b6030f;
        case 0, $6784cbc7d62e5d7c$export$d9c0e3e59442fb4:
            return 0, $6784cbc7d62e5d7c$export$e4824f74b9879164;
        case 0, $6784cbc7d62e5d7c$export$27dbc7d7ce66e6e3:
            return 0, $6784cbc7d62e5d7c$export$4f3cb0844009af52;
        case 0, $6784cbc7d62e5d7c$export$a5dce388adf922bd:
            return 0, $6784cbc7d62e5d7c$export$1a65d50c4a641bb4;
        case 0, $6784cbc7d62e5d7c$export$e1473b31a257caff:
            return 0, $6784cbc7d62e5d7c$export$9ee64e8fbd8b03a2;
        case 0, $6784cbc7d62e5d7c$export$699265ec8ad9a740:
            return 0, $6784cbc7d62e5d7c$export$b8b1ac856ba1434b;
        case 0, $6784cbc7d62e5d7c$export$85657457db93c2c2:
            return 0, $6784cbc7d62e5d7c$export$4f54a09a24fd1d74;
        case 0, $6784cbc7d62e5d7c$export$c0c2d1dfaeba89dd:
            return 0, $6784cbc7d62e5d7c$export$79685802e8ff1098;
        case 0, $6784cbc7d62e5d7c$export$2e6a7ad3ab9c82a3:
            return 0, $6784cbc7d62e5d7c$export$e5c438b7501b5a24;
        case 0, $6784cbc7d62e5d7c$export$7b60378c3b4372e9:
            return 0, $6784cbc7d62e5d7c$export$cbc0e551d91a692d;
        default:
            return teamTypeFromMe;
    }
};

});

parcelRegister("2LmB4", function(module, exports) {

$parcel$export(module.exports, "actions", () => $263b01c2e713c075$export$e324594224ef24da);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $fBogR = parcelRequire("fBogR");
const $263b01c2e713c075$export$e324594224ef24da = {
    fetchAtlassianAccountData: ({ source: source } = {})=>async ({ setState: setState, getState: getState })=>{
            const { isFetching: isFetching, wasFetchedOnce: wasFetchedOnce } = getState();
            if (isFetching || wasFetchedOnce) return;
            setState({
                isFetching: true
            });
            try {
                const data = await (0, $fBogR.getAtlassianAccountWithRethrow)({
                    source: source
                });
                if (data !== null) setState({
                    data: data
                });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                setState({
                    fetchError: error
                });
            } finally{
                setState({
                    isFetching: false,
                    wasFetchedOnce: true
                });
            }
        }
};

});
parcelRegister("fBogR", function(module, exports) {

$parcel$export(module.exports, "getAtlassianAccountWithRethrow", () => $284b5d88f7e7a408$export$1f20b0741dc598bc);

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");

const $284b5d88f7e7a408$export$1f20b0741dc598bc = async ({ source: source } = {})=>{
    try {
        const { extended_profile: { job_title: jobTitle, team_type: teamType }, email: email, account_id: accountId } = await (0, $eusud.performGetRequestWithRetry)((0, $53b7c6a1de61c1d4$export$80945eb3738bcee8));
        return {
            extendedProfile: {
                jobTitle: jobTitle,
                teamType: teamType
            },
            email: email,
            accountId: accountId
        };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.default)({
            meta: {
                id: 'getAtlassianAccountWithRethrow',
                packageName: 'jiraAtlassianAccount',
                teamName: 'jlove-makkuro'
            },
            attributes: {
                source: source
            },
            error: error
        });
        throw error;
    }
};

});
const $53b7c6a1de61c1d4$export$80945eb3738bcee8 = '/gateway/api/me';




parcelRegister("gQEFa", function(module, exports) {

$parcel$export(module.exports, "useFetchInitialProjectTemplateName", () => $be0087b09b981e14$export$b11629f839f2f12a);

var $5uXOq = parcelRequire("5uXOq");

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $ggwAD = parcelRequire("ggwAD");
const $be0087b09b981e14$export$d4c72bab9d6cc13a = {};
const $be0087b09b981e14$var$store = (0, $iXqE5.createStore)({
    name: 'jira-initial-project-template-name',
    initialState: $be0087b09b981e14$export$d4c72bab9d6cc13a,
    actions: $ggwAD.actions
});
const $be0087b09b981e14$export$ee6e247e51917971 = (0, $3sQ5x.createHook)($be0087b09b981e14$var$store);
const $be0087b09b981e14$export$b11629f839f2f12a = ({ shouldFetch: shouldFetch, projectId: projectId })=>{
    const [state, { fetchInitialProjectTemplateName: fetchInitialProjectTemplateName }] = $be0087b09b981e14$export$ee6e247e51917971();
    (0, $5uXOq.useEffect)(()=>{
        if (shouldFetch && projectId) fetchInitialProjectTemplateName(`${projectId}`);
    }, [
        fetchInitialProjectTemplateName,
        projectId,
        shouldFetch
    ]);
    if (!projectId) return {
        data: undefined,
        isReady: true
    };
    if (!shouldFetch) return {
        // Still return the data if it's already fetched
        // leave it to consumer to decide what to do with it
        data: state[`${projectId}`]?.templateKey,
        isReady: true
    };
    return {
        data: state[`${projectId}`]?.templateKey,
        isReady: state[`${projectId}`]?.fetchStatus === 'fetched'
    };
};

});
parcelRegister("ggwAD", function(module, exports) {

$parcel$export(module.exports, "actions", () => $7361e67f73cde4dc$export$e324594224ef24da);

var $2y6my = parcelRequire("2y6my");
const $7361e67f73cde4dc$export$e324594224ef24da = {
    fetchInitialProjectTemplateName: (0, $2y6my.fetchInitialProjectTemplateNameWithRethrow)
};

});
parcelRegister("2y6my", function(module, exports) {

$parcel$export(module.exports, "fetchInitialProjectTemplateNameWithRethrow", () => $a69f9ed7a08e4d60$export$c837cab65def4654);

var $1sYcL = parcelRequire("1sYcL");

var $jcw0u = parcelRequire("jcw0u");

var $5fQRY = parcelRequire("5fQRY");
const $a69f9ed7a08e4d60$export$c837cab65def4654 = (projectId)=>async ({ getState: getState, setState: setState })=>{
        try {
            const currentState = getState();
            const currentStateForProjectId = currentState[projectId];
            if (currentStateForProjectId?.fetchStatus === 'fetched' || currentStateForProjectId?.fetchStatus === 'fetching') return;
            const localStorageInitialProjectTemplateName = (0, $5fQRY.getLocalStorageInitialProjectTemplateName)({
                projectId: projectId
            });
            if (localStorageInitialProjectTemplateName) {
                setState({
                    [projectId]: {
                        fetchStatus: 'fetched',
                        templateKey: localStorageInitialProjectTemplateName
                    }
                });
                return;
            }
            setState({
                [projectId]: {
                    ...currentStateForProjectId,
                    fetchStatus: 'fetching'
                }
            });
            const response = await (0, $1sYcL.get)({
                consumerMeta: {
                    id: 'fetchInitialProjectTemplateNameWithRethrow',
                    packageName: '@atlassian/jira-onboarding-core',
                    teamName: 'Jlove-Makkuro'
                },
                projectId: projectId,
                projectProperties: [
                    'initial.project.template.name'
                ]
            });
            const templateKey = response?.project?.['initial.project.template.name'];
            if (templateKey) {
                (0, $5fQRY.setLocalStorageInitialProjectTemplateName)({
                    projectId: projectId,
                    templateKey: templateKey
                });
                setState({
                    [projectId]: {
                        fetchStatus: 'fetched',
                        templateKey: templateKey
                    }
                });
            } else setState({
                [projectId]: {
                    fetchStatus: 'fetched',
                    templateKey: ''
                }
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $jcw0u.default)({
                error: error,
                meta: {
                    id: 'fetchInitialProjectTemplateNameWithRethrow',
                    packageName: 'jiraOnboardingCore',
                    teamName: 'jlove-makkuro'
                }
            });
            setState({
                [projectId]: {
                    fetchStatus: 'fetched',
                    templateKey: ''
                }
            });
        }
    };

});
parcelRegister("5fQRY", function(module, exports) {

$parcel$export(module.exports, "getLocalStorageInitialProjectTemplateName", () => $fa50145683a10f14$export$82cce58d3eca5268);
$parcel$export(module.exports, "setLocalStorageInitialProjectTemplateName", () => $fa50145683a10f14$export$8767e71370b25cc2);

var $bSSG7 = parcelRequire("bSSG7");

var $jcw0u = parcelRequire("jcw0u");
const $fa50145683a10f14$var$localStorageProvider = (0, $bSSG7.createLocalStorageProvider)('jira-initial-project-template-name');
const $fa50145683a10f14$export$82cce58d3eca5268 = ({ projectId: projectId })=>{
    try {
        return $fa50145683a10f14$var$localStorageProvider.get(projectId);
    } catch (error) {
        const typeGuardedError = error instanceof Error ? error : new Error('getLocalStorageInitialProjectTemplateName');
        (0, $jcw0u.default)({
            error: typeGuardedError,
            meta: {
                id: 'getLocalStorageInitialProjectTemplateName',
                packageName: 'jiraOnboardingCore',
                teamName: 'jlove-makkuro'
            }
        });
        return undefined;
    }
};
const $fa50145683a10f14$export$8767e71370b25cc2 = ({ projectId: projectId, templateKey: templateKey })=>{
    try {
        $fa50145683a10f14$var$localStorageProvider.set(projectId, templateKey);
    } catch (error) {
        const typeGuardedError = error instanceof Error ? error : new Error('localStorageSetOnboardingPersonalisationResponse');
        (0, $jcw0u.default)({
            error: typeGuardedError,
            meta: {
                id: 'localStorageSetOnboardingPersonalisationResponse',
                packageName: 'jiraOnboardingCore',
                teamName: 'jlove-makkuro'
            }
        });
    }
};

});




parcelRegister("43qGj", function(module, exports) {

$parcel$export(module.exports, "useFeatures", () => $64d4caaed133b77d$export$4a39035bacc4ed76);

var $5uXOq = parcelRequire("5uXOq");

var $1J3t1 = parcelRequire("1J3t1");

var $4bPSV = parcelRequire("4bPSV");

var $hDSPU = parcelRequire("hDSPU");

var $iHqA4 = parcelRequire("iHqA4");

var $j8sa8 = parcelRequire("j8sa8");
const $64d4caaed133b77d$export$4a39035bacc4ed76 = ()=>{
    const { data: data, loading: loading, error: error } = (0, $1J3t1.useJiraSoftwareProjectNavigation)();
    const isEligibleForFeatureToggle = (0, $j8sa8.useShouldApplyFeatureToggle)();
    const [sidebarFeatureToggled] = (0, $hDSPU.useSidebarFeatureToggled)();
    const extractedData = (0, $5uXOq.useMemo)(()=>data && (0, $4bPSV.extractData)(data), [
        data
    ]);
    // merged feature status before navigation resource gets refreshed
    // if and only if there are features toggled and they are eligible for the feature
    const features = (0, $5uXOq.useMemo)(()=>{
        if (!extractedData || !isEligibleForFeatureToggle || !sidebarFeatureToggled) return extractedData;
        return {
            ...extractedData,
            ...sidebarFeatureToggled
        };
    }, [
        extractedData,
        isEligibleForFeatureToggle,
        sidebarFeatureToggled
    ]);
    (0, $iHqA4.useClearSidebarToggled)();
    return {
        data: features,
        loading: loading,
        error: error
    };
};

});
parcelRegister("4bPSV", function(module, exports) {

$parcel$export(module.exports, "extractData", () => $4795c1c4367ea315$export$9df5fa0a366163d2);

var $6s1PB = parcelRequire("6s1PB");
const $4795c1c4367ea315$export$9df5fa0a366163d2 = (navData)=>{
    const { permissionInfo: permissionInfo, hasBacklog: hasBacklog, hasBoard: hasBoard, hasCode: hasCode, hasGoals: hasGoals, hasGetStarted: hasGetStarted, hasSecurity: hasSecurity, hasDeployments: hasDeployments, hasDevelopment: hasDevelopment, hasList: hasList, hasOpsgenieSchedule: hasOpsgenieSchedule, hasPages: hasPages, hasReleases: hasReleases, hasRoadmap: hasRoadmap, hasReports: hasReports, hasRequests: hasRequests, hasIssues: hasIssues, hasSprint: hasSprint, hasIncidents: hasIncidents, hasCalendar: hasCalendar, hasForms: hasForms, hasSummaryPage: hasSummaryPage, aiInfo: aiInfo, hasArchivedIssues: hasArchivedIssues = false } = navData;
    const isProjectOrJiraAdmin = permissionInfo.isAdmin || permissionInfo.projectPermissionsQueried.ADMINISTER_PROJECTS === true;
    return {
        hasArchivedIssues: hasArchivedIssues,
        hasBacklog: hasBacklog,
        hasBoard: hasBoard,
        hasRoadmap: hasRoadmap,
        hasCode: hasCode,
        hasGoals: hasGoals,
        hasGetStarted: isProjectOrJiraAdmin && hasGetStarted,
        hasSecurity: hasSecurity,
        hasDeployments: hasDeployments,
        hasDevelopment: hasDevelopment,
        hasList: (0, $6s1PB.expValEquals)('jsw_list_view', 'cohort', 'variation') ? hasList : false,
        hasReleases: hasReleases,
        hasSIN: hasIssues,
        hasReports: hasReports,
        hasRequests: hasRequests,
        hasPages: hasPages,
        hasOpsgenie: hasOpsgenieSchedule,
        hasShortcutsAdd: isProjectOrJiraAdmin,
        hasSettings: isProjectOrJiraAdmin,
        hasSprint: hasSprint,
        hasIncidents: hasIncidents,
        hasCalendar: hasCalendar,
        hasForms: (0, $6s1PB.expValEquals)('forms_for_jsw_experiment', 'isEnabled', true) && hasForms,
        hasSummaryPage: hasSummaryPage,
        hasAIInNIN: hasIssues && aiInfo?.isEnabledInIssueNavigator === true
    };
};

});

parcelRegister("hDSPU", function(module, exports) {

$parcel$export(module.exports, "useFeature", () => $605ea180d8f833cc$export$fc97652867e5867e);
$parcel$export(module.exports, "useEnablingFeature", () => $605ea180d8f833cc$export$207b461610a7fca6);
$parcel$export(module.exports, "useSidebarFeatureToggled", () => $605ea180d8f833cc$export$9eef668f94562feb);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $6wyfe = parcelRequire("6wyfe");
const $605ea180d8f833cc$var$initialState = {
    features: [],
    isLoading: false,
    enablingFeatures: [],
    isFetchError: false,
    sidebarFeatureToggled: null
};
const $605ea180d8f833cc$var$store = (0, $iXqE5.createStore)({
    name: 'feature-toggle',
    initialState: $605ea180d8f833cc$var$initialState,
    actions: $6wyfe.actions
});
const $605ea180d8f833cc$export$fc97652867e5867e = (0, $3sQ5x.createHook)($605ea180d8f833cc$var$store);
const $605ea180d8f833cc$export$207b461610a7fca6 = (0, $3sQ5x.createHook)($605ea180d8f833cc$var$store, {
    selector: (state, { feature: feature })=>state.enablingFeatures.some((f)=>f === feature)
});
const $605ea180d8f833cc$export$e7699ed698eeb9ec = (0, $3sQ5x.createHook)($605ea180d8f833cc$var$store, {
    selector: (state, { feature: feature })=>state.features.find((f)=>f.feature === feature)?.state
});
const $605ea180d8f833cc$export$9eef668f94562feb = (0, $3sQ5x.createHook)($605ea180d8f833cc$var$store, {
    selector: (state)=>state.sidebarFeatureToggled
});

});
parcelRegister("6wyfe", function(module, exports) {

$parcel$export(module.exports, "actions", () => $158a47dbcbb0832b$export$e324594224ef24da);

var $jcw0u = parcelRequire("jcw0u");

var $6s1PB = parcelRequire("6s1PB");

var $8zOmE = parcelRequire("8zOmE");

var $3Jf4N = parcelRequire("3Jf4N");

var $czzsL = parcelRequire("czzsL");

var $iZZTd = parcelRequire("iZZTd");

var $ke207 = parcelRequire("ke207");
const $158a47dbcbb0832b$var$clearSiderbarFeatureToggled = ()=>({ setState: setState })=>{
        setState({
            sidebarFeatureToggled: null
        });
    };
const $158a47dbcbb0832b$var$fetchFeatures = (boardId)=>async ({ getState: getState, setState: setState })=>{
        const { features: features, isLoading: isLoading } = getState();
        if (isLoading) return;
        setState({
            isFetchError: false
        });
        try {
            if (features.length === 0) {
                setState({
                    isLoading: true
                });
                const data = await (0, $iZZTd.getBoardFeatures)(boardId);
                const filteredFeatures = (0, $czzsL.filterAndSort)(data);
                (0, $czzsL.fireErrorAnalyticsOnUnmatchFeatureKey)(filteredFeatures);
                setState({
                    isLoading: false,
                    features: filteredFeatures
                });
            }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                isFetchError: true,
                isLoading: false
            });
            (0, $jcw0u.default)({
                meta: {
                    ...(0, $3Jf4N.commonErrorAnalyticsMeta),
                    id: 'fetchFeatures'
                },
                error: error
            });
        }
    };
const $158a47dbcbb0832b$var$syncFeatures = (sidebarFeatureStatus)=>({ getState: getState, setState: setState })=>{
        const { features: features } = getState();
        const featureMap = (0, $3Jf4N.getFeatureMap)({
            isListViewEnabled: (0, $6s1PB.expValEquals)('jsw_list_view', 'cohort', 'variation')
        });
        const synced = features.map((f)=>{
            const id = f.feature;
            if (featureMap[id]) {
                const { statusKey: statusKey } = featureMap[id];
                return {
                    ...f,
                    state: sidebarFeatureStatus[statusKey] ? 'ENABLED' : 'DISABLED'
                };
            }
            return f;
        });
        setState({
            features: synced
        });
    };
const $158a47dbcbb0832b$var$updateFeature = ({ boardId: boardId, feature: feature, dependentFeature: dependentFeature, analyticsEvent: analyticsEvent, onError: onError, onAfterUpdate: onAfterUpdate })=>async ({ getState: getState, setState: setState })=>{
        const { features: features, enablingFeatures: enablingFeatures, sidebarFeatureToggled: sidebarFeatureToggled } = getState();
        let featureMap = (0, $3Jf4N.getFeatureMap)();
        if ((0, $6s1PB.expValEquals)('jsw_list_view', 'cohort', 'variation')) featureMap = {
            ...featureMap,
            ...(0, $3Jf4N.listFeature)
        };
        const currentStatus = features.find((f)=>f.feature === feature)?.state;
        const isEnabling = currentStatus === 'DISABLED';
        if (!boardId || feature.length === 0 || !currentStatus) return;
        try {
            // Optimistically update the toggle status before the API call finishes
            // and add feature to the enabling states
            setState({
                features: features.map((0, $czzsL.updateFeatureState)(feature, dependentFeature)),
                sidebarFeatureToggled: {
                    ...sidebarFeatureToggled ?? {},
                    [featureMap[feature].statusKey]: isEnabling,
                    ...dependentFeature && {
                        [featureMap[dependentFeature].statusKey]: isEnabling
                    }
                },
                ...isEnabling && {
                    enablingFeatures: [
                        ...enablingFeatures,
                        feature
                    ]
                }
            });
            await (0, $ke207.updateBoardFeature)({
                boardId: boardId,
                feature: feature,
                enabling: isEnabling
            });
            (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'featureStatus updated', {
                featureId: feature,
                newStatus: currentStatus
            });
            onAfterUpdate?.(feature, isEnabling);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            onError?.();
            setState({
                features: features,
                sidebarFeatureToggled: sidebarFeatureToggled
            });
            (0, $jcw0u.default)({
                meta: {
                    ...(0, $3Jf4N.commonErrorAnalyticsMeta),
                    id: 'updateFeature'
                },
                error: error
            });
        }
        if (isEnabling) setState({
            // feature has been enabled, remove from enabling state
            enablingFeatures: getState().enablingFeatures.filter((f)=>f !== feature)
        });
    };
const $158a47dbcbb0832b$export$e324594224ef24da = {
    fetchFeatures: $158a47dbcbb0832b$var$fetchFeatures,
    updateFeature: $158a47dbcbb0832b$var$updateFeature,
    syncFeatures: $158a47dbcbb0832b$var$syncFeatures,
    clearSiderbarFeatureToggled: $158a47dbcbb0832b$var$clearSiderbarFeatureToggled
};

});
parcelRegister("3Jf4N", function(module, exports) {

$parcel$export(module.exports, "commonErrorAnalyticsMeta", () => $d07f845012e39eac$export$47825241dc3c472c);
$parcel$export(module.exports, "MANAGE_FEATURE_MENU_ITEM_TEST_ID", () => $d07f845012e39eac$export$143e1d685830adbe);
$parcel$export(module.exports, "listFeature", () => $d07f845012e39eac$export$4ddfd7a9f5527982);
$parcel$export(module.exports, "getFeatureMap", () => $d07f845012e39eac$export$6ac50cf33852adb5);
$parcel$export(module.exports, "ERROR_FLAG_ID", () => $d07f845012e39eac$export$f5e4c120ac01b615);

var $5uXOq = parcelRequire("5uXOq");

var $ajpes = parcelRequire("ajpes");

var $8QpSo = parcelRequire("8QpSo");

var $QasRB = parcelRequire("QasRB");

var $dME4E = parcelRequire("dME4E");

var $aZ5rg = parcelRequire("aZ5rg");

var $lfDf7 = parcelRequire("lfDf7");

var $eQfWH = parcelRequire("eQfWH");

var $k2Gga = parcelRequire("k2Gga");
const $d07f845012e39eac$export$47825241dc3c472c = {
    packageName: 'jiraTmpFeatureToggle',
    teamName: 'jlove-makkuro'
};
const $d07f845012e39eac$export$143e1d685830adbe = 'manage-feature-menu-item';
const $d07f845012e39eac$export$4ddfd7a9f5527982 = {
    'jsw.agility.list_view': {
        descriptionKey: 'listDescription',
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aZ5rg))), {
            spacing: "spacious",
            label: ""
        }),
        statusKey: 'hasList',
        order: 35,
        redirectOn: [
            'software-list'
        ]
    }
};
const $d07f845012e39eac$export$a712b1e96d47b856 = {
    'jsw.agility.simple-roadmap': {
        descriptionKey: 'timelineDescription',
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($k2Gga))), {
            spacing: "spacious",
            label: ""
        }),
        statusKey: 'hasRoadmap',
        order: 10,
        redirectOn: [
            'software-timeline',
            'software-roadmap'
        ]
    },
    'jsw.agility.backlog': {
        descriptionKey: 'backlogDescription',
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($QasRB))), {
            spacing: "spacious",
            label: ""
        }),
        statusKey: 'hasBacklog',
        order: 20,
        redirectOn: [
            'software-backlog'
        ]
    },
    'jsw.agility.board': {
        descriptionKey: 'boardDescription',
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dME4E))), {
            spacing: "spacious",
            label: ""
        }),
        statusKey: 'hasBoard',
        order: 30
    },
    'jsw.agility.issue_navigator': {
        descriptionKey: 'issueNavigatorDescription',
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lfDf7))), {
            spacing: "spacious",
            label: ""
        }),
        statusKey: 'hasSIN',
        order: 40,
        redirectOn: [
            'software-issue-navigator',
            'issue'
        ]
    },
    'jsw.agility.sprints': {
        descriptionKey: 'releasesDescription',
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null),
        statusKey: 'hasSprint',
        order: 50,
        isHidden: true
    }
}; // satisfies Partial<Record<ToggleableFeatureKey, FeatureProperties>>
const $d07f845012e39eac$export$6ac50cf33852adb5 = (0, $8QpSo.default)(({ isSimplifyNavExperimentEnabled: isSimplifyNavExperimentEnabled, isListViewEnabled: isListViewEnabled } = {})=>({
        'jsw.agility.simple-roadmap': {
            descriptionKey: 'timelineDescription',
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($k2Gga))), {
                spacing: "spacious",
                label: ""
            }),
            statusKey: 'hasRoadmap',
            order: 10,
            redirectOn: [
                'software-timeline',
                'software-roadmap'
            ]
        },
        'jsw.agility.backlog': {
            descriptionKey: 'backlogDescription',
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($QasRB))), {
                spacing: "spacious",
                label: ""
            }),
            statusKey: 'hasBacklog',
            order: 20,
            redirectOn: [
                'software-backlog'
            ]
        },
        'jsw.agility.board': {
            descriptionKey: 'boardDescription',
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dME4E))), {
                spacing: "spacious",
                label: ""
            }),
            statusKey: 'hasBoard',
            order: 30
        },
        ...!isSimplifyNavExperimentEnabled && {
            'jsw.agility.issue_navigator': {
                descriptionKey: 'issueNavigatorDescription',
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lfDf7))), {
                    spacing: "spacious",
                    label: ""
                }),
                statusKey: 'hasSIN',
                order: 40,
                redirectOn: [
                    'software-issue-navigator',
                    'issue'
                ]
            }
        },
        'jsw.agility.sprints': {
            descriptionKey: 'releasesDescription',
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null),
            statusKey: 'hasSprint',
            order: 50,
            isHidden: true
        },
        'jsw.agility.pages': {
            descriptionKey: 'projectPagesDescription',
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eQfWH))), {
                spacing: "spacious",
                label: ""
            }),
            statusKey: 'hasPages',
            order: 60,
            redirectOn: [
                'project-pages'
            ]
        },
        ...isListViewEnabled && $d07f845012e39eac$export$4ddfd7a9f5527982
    }), (0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))); // satisfies Partial<Record<ToggleableFeatureKey, FeatureProperties>>;
const $d07f845012e39eac$export$f5e4c120ac01b615 = 'feature-toggle-error-flag';

});
parcelRegister("QasRB", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b8757186054f9d759a1f776986ffd32d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $09ccf97ba5b2cc01$var$_react = $09ccf97ba5b2cc01$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $09ccf97ba5b2cc01$var$_backlog = $09ccf97ba5b2cc01$var$_interopRequireDefault((parcelRequire("bRTCF")));

var $09ccf97ba5b2cc01$var$_backlog2 = $09ccf97ba5b2cc01$var$_interopRequireDefault((parcelRequire("adDD5")));
function $09ccf97ba5b2cc01$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for BacklogIcon.
 * This component is BacklogIcon, with `UNSAFE_fallbackIcon` set to "BacklogIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for backlogs in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $09ccf97ba5b2cc01$var$BacklogIcon = (props)=>/*#__PURE__*/ $09ccf97ba5b2cc01$var$_react.default.createElement($09ccf97ba5b2cc01$var$_backlog.default, Object.assign({
        LEGACY_fallbackIcon: $09ccf97ba5b2cc01$var$_backlog2.default
    }, props));
$09ccf97ba5b2cc01$var$BacklogIcon.Name = 'BacklogIconMigration';
var $09ccf97ba5b2cc01$var$_default = module.exports.default = $09ccf97ba5b2cc01$var$BacklogIcon;

});
parcelRegister("bRTCF", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::471b5e5cdc883753bc3e3b52ee5ae2e2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8a3fca7537c506d3$var$_react = $8a3fca7537c506d3$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $8a3fca7537c506d3$var$_baseNew = $8a3fca7537c506d3$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $8a3fca7537c506d3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Backlog".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for backlogs in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8a3fca7537c506d3$var$BacklogIcon = (props)=>/*#__PURE__*/ $8a3fca7537c506d3$var$_react.default.createElement($8a3fca7537c506d3$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v2.167h11V3a.5.5 0 0 0-.5-.5zm10.5 4.167h-11v2.666h11zm0 4.166h-11V13a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5z" clip-rule="evenodd"/>`
    }, props));
$8a3fca7537c506d3$var$BacklogIcon.displayName = 'BacklogIcon';
var $8a3fca7537c506d3$var$_default = module.exports.default = $8a3fca7537c506d3$var$BacklogIcon;

});

parcelRegister("adDD5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7709dbddc6671c4c$var$_react = $7709dbddc6671c4c$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $7709dbddc6671c4c$var$_backlog = $7709dbddc6671c4c$var$_interopRequireDefault((parcelRequire("bRTCF")));
function $7709dbddc6671c4c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $7709dbddc6671c4c$var$BacklogIcon = (props)=>/*#__PURE__*/ $7709dbddc6671c4c$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M5 19.002C5 19 17 19 17 19v-2.002C17 17 5 17 5 17zm-2-2.004C3 15.894 3.895 15 4.994 15h12.012c1.101 0 1.994.898 1.994 1.998v2.004A1.997 1.997 0 0 1 17.006 21H4.994A2 2 0 0 1 3 19.002z"/><path d="M5 15h12v-2H5zm-2-4h16v6H3z"/><path d="M7 11.002C7 11 19 11 19 11V8.998C19 9 7 9 7 9zM5 8.998C5 7.894 5.895 7 6.994 7h12.012C20.107 7 21 7.898 21 8.998v2.004A1.997 1.997 0 0 1 19.006 13H6.994A2 2 0 0 1 5 11.002z"/><path d="M5 5v2h12V5zm-2-.002C3 3.894 3.895 3 4.994 3h12.012C18.107 3 19 3.898 19 4.998V9H3z"/></g></svg>`
    }, props, {
        newIcon: $7709dbddc6671c4c$var$_backlog.default
    }));
$7709dbddc6671c4c$var$BacklogIcon.displayName = 'BacklogIcon';
var $7709dbddc6671c4c$var$_default = module.exports.default = $7709dbddc6671c4c$var$BacklogIcon;

});


parcelRegister("dME4E", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2d6de69f6e8d23d80c647d0a6d3ecd7a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a08ed7e863649bfd$var$_react = $a08ed7e863649bfd$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $a08ed7e863649bfd$var$_board = $a08ed7e863649bfd$var$_interopRequireDefault((parcelRequire("8EsNC")));

var $a08ed7e863649bfd$var$_board2 = $a08ed7e863649bfd$var$_interopRequireDefault((parcelRequire("v8Zna")));
function $a08ed7e863649bfd$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for BoardIcon.
 * This component is BoardIcon, with `UNSAFE_fallbackIcon` set to "BoardIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for boards in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a08ed7e863649bfd$var$BoardIcon = (props)=>/*#__PURE__*/ $a08ed7e863649bfd$var$_react.default.createElement($a08ed7e863649bfd$var$_board.default, Object.assign({
        LEGACY_fallbackIcon: $a08ed7e863649bfd$var$_board2.default
    }, props));
$a08ed7e863649bfd$var$BoardIcon.Name = 'BoardIconMigration';
var $a08ed7e863649bfd$var$_default = module.exports.default = $a08ed7e863649bfd$var$BoardIcon;

});
parcelRegister("8EsNC", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6bfc058bc597636775f186a66702ef9b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $64c8661ab6d81803$var$_react = $64c8661ab6d81803$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $64c8661ab6d81803$var$_baseNew = $64c8661ab6d81803$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $64c8661ab6d81803$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Board".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for boards in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $64c8661ab6d81803$var$BoardIcon = (props)=>/*#__PURE__*/ $64c8661ab6d81803$var$_react.default.createElement($64c8661ab6d81803$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 3.5a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h2.833v-9zm4.333 0v9h3.334v-9zm4.834 0v9H14a.5.5 0 0 0 .5-.5V4a.5.5 0 0 0-.5-.5zM0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2z" clip-rule="evenodd"/>`
    }, props));
$64c8661ab6d81803$var$BoardIcon.displayName = 'BoardIcon';
var $64c8661ab6d81803$var$_default = module.exports.default = $64c8661ab6d81803$var$BoardIcon;

});

parcelRegister("v8Zna", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $05d9de5ec3a4369b$var$_react = $05d9de5ec3a4369b$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $05d9de5ec3a4369b$var$_board = $05d9de5ec3a4369b$var$_interopRequireDefault((parcelRequire("8EsNC")));
function $05d9de5ec3a4369b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $05d9de5ec3a4369b$var$BoardIcon = (props)=>/*#__PURE__*/ $05d9de5ec3a4369b$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M4 18h16.008C20 18 20 6 20 6H3.992C4 6 4 18 4 18M2 5.994C2 4.893 2.898 4 3.99 4h16.02C21.108 4 22 4.895 22 5.994v12.012A1.997 1.997 0 0 1 20.01 20H3.99A1.994 1.994 0 0 1 2 18.006z"/><path d="M8 6v12h2V6zm6 0v12h2V6z"/></g></svg>`
    }, props, {
        newIcon: $05d9de5ec3a4369b$var$_board.default
    }));
$05d9de5ec3a4369b$var$BoardIcon.displayName = 'BoardIcon';
var $05d9de5ec3a4369b$var$_default = module.exports.default = $05d9de5ec3a4369b$var$BoardIcon;

});


parcelRegister("aZ5rg", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e406a416cb0a4f8d2c2370983b384961>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7ff3d1eb1c83e4c4$var$_react = $7ff3d1eb1c83e4c4$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $7ff3d1eb1c83e4c4$var$_listBulleted = $7ff3d1eb1c83e4c4$var$_interopRequireDefault((parcelRequire("bEjt9")));

var $7ff3d1eb1c83e4c4$var$_bulletList = $7ff3d1eb1c83e4c4$var$_interopRequireDefault((parcelRequire("90gd1")));
function $7ff3d1eb1c83e4c4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ListBulletedIcon.
 * This component is ListBulletedIcon, with `UNSAFE_fallbackIcon` set to "BulletListIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: bulleted lists, view all.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7ff3d1eb1c83e4c4$var$ListBulletedIcon = (props)=>/*#__PURE__*/ $7ff3d1eb1c83e4c4$var$_react.default.createElement($7ff3d1eb1c83e4c4$var$_listBulleted.default, Object.assign({
        LEGACY_fallbackIcon: $7ff3d1eb1c83e4c4$var$_bulletList.default
    }, props));
$7ff3d1eb1c83e4c4$var$ListBulletedIcon.Name = 'ListBulletedIconMigration';
var $7ff3d1eb1c83e4c4$var$_default = module.exports.default = $7ff3d1eb1c83e4c4$var$ListBulletedIcon;

});
parcelRegister("bEjt9", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c464a7d95484e897372db9f1fff872cb>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $87b28849bcb64a34$var$_react = $87b28849bcb64a34$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $87b28849bcb64a34$var$_baseNew = $87b28849bcb64a34$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $87b28849bcb64a34$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ListBulleted".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: bulleted lists, view all.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $87b28849bcb64a34$var$ListBulletedIcon = (props)=>/*#__PURE__*/ $87b28849bcb64a34$var$_react.default.createElement($87b28849bcb64a34$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M.5 4.25a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m0 7.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0M16 5H6V3.5h10zm0 7.5H6V11h10z" clip-rule="evenodd"/>`
    }, props));
$87b28849bcb64a34$var$ListBulletedIcon.displayName = 'ListBulletedIcon';
var $87b28849bcb64a34$var$_default = module.exports.default = $87b28849bcb64a34$var$ListBulletedIcon;

});

parcelRegister("90gd1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $68e0afe9fd548c5c$var$_react = $68e0afe9fd548c5c$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $68e0afe9fd548c5c$var$_listBulleted = $68e0afe9fd548c5c$var$_interopRequireDefault((parcelRequire("bEjt9")));
function $68e0afe9fd548c5c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $68e0afe9fd548c5c$var$BulletListIcon = (props)=>/*#__PURE__*/ $68e0afe9fd548c5c$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><rect width="8" height="2" x="10" y="15" rx="1"/><rect width="2" height="2" x="6" y="15" rx="1"/><rect width="8" height="2" x="10" y="11" rx="1"/><rect width="2" height="2" x="6" y="11" rx="1"/><rect width="8" height="2" x="10" y="7" rx="1"/><rect width="2" height="2" x="6" y="7" rx="1"/></g></svg>`
    }, props, {
        newIcon: $68e0afe9fd548c5c$var$_listBulleted.default
    }));
$68e0afe9fd548c5c$var$BulletListIcon.displayName = 'BulletListIcon';
var $68e0afe9fd548c5c$var$_default = module.exports.default = $68e0afe9fd548c5c$var$BulletListIcon;

});


parcelRegister("eQfWH", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::182e7300aed0f8931ea6d6a6afcdcbad>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ace24a83748025fe$var$_react = $ace24a83748025fe$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $ace24a83748025fe$var$_page = $ace24a83748025fe$var$_interopRequireDefault((parcelRequire("kdfZa")));

var $ace24a83748025fe$var$_page2 = $ace24a83748025fe$var$_interopRequireDefault((parcelRequire("eWXbg")));
function $ace24a83748025fe$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for PageIcon.
 * This component is PageIcon, with `UNSAFE_fallbackIcon` set to "PageIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for pages in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ace24a83748025fe$var$PageIcon = (props)=>/*#__PURE__*/ $ace24a83748025fe$var$_react.default.createElement($ace24a83748025fe$var$_page.default, Object.assign({
        LEGACY_fallbackIcon: $ace24a83748025fe$var$_page2.default
    }, props));
$ace24a83748025fe$var$PageIcon.Name = 'PageIconMigration';
var $ace24a83748025fe$var$_default = module.exports.default = $ace24a83748025fe$var$PageIcon;

});
parcelRegister("kdfZa", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f64abe706416b0877b5dd221be64e7d7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $eb716bf3c984513d$var$_react = $eb716bf3c984513d$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $eb716bf3c984513d$var$_baseNew = $eb716bf3c984513d$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $eb716bf3c984513d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Page".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for pages in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $eb716bf3c984513d$var$PageIcon = (props)=>/*#__PURE__*/ $eb716bf3c984513d$var$_react.default.createElement($eb716bf3c984513d$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zM12 6H4V4.5h8zm-2 3.5H4V8h6z" clip-rule="evenodd"/>`
    }, props));
$eb716bf3c984513d$var$PageIcon.displayName = 'PageIcon';
var $eb716bf3c984513d$var$_default = module.exports.default = $eb716bf3c984513d$var$PageIcon;

});

parcelRegister("eWXbg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ae246388ea520792$var$_react = $ae246388ea520792$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $ae246388ea520792$var$_page = $ae246388ea520792$var$_interopRequireDefault((parcelRequire("kdfZa")));
function $ae246388ea520792$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $ae246388ea520792$var$PageIcon = (props)=>/*#__PURE__*/ $ae246388ea520792$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><rect width="8" height="2" x="8" y="6" rx="1"/><rect width="8" height="2" x="8" y="9" rx="1"/><rect width="4" height="2" x="8" y="12" rx="1"/><path fill-rule="nonzero" d="M7 4v16h10V4zm-2-.01C5 2.892 5.897 2 7.006 2h9.988C18.102 2 19 2.898 19 3.99v16.02c0 1.099-.897 1.99-2.006 1.99H7.006A2.003 2.003 0 0 1 5 20.01z"/></g></svg>`
    }, props, {
        newIcon: $ae246388ea520792$var$_page.default
    }));
$ae246388ea520792$var$PageIcon.displayName = 'PageIcon';
var $ae246388ea520792$var$_default = module.exports.default = $ae246388ea520792$var$PageIcon;

});


parcelRegister("k2Gga", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::478474977414af6f20354d0841ac3249>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e974c67850595917$var$_react = $e974c67850595917$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $e974c67850595917$var$_roadmap = $e974c67850595917$var$_interopRequireDefault((parcelRequire("ifnb0")));

var $e974c67850595917$var$_roadmap2 = $e974c67850595917$var$_interopRequireDefault((parcelRequire("i3vuN")));
function $e974c67850595917$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for RoadmapIcon.
 * This component is RoadmapIcon, with `UNSAFE_fallbackIcon` set to "RoadmapIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for roadmaps in Jira or Trello.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e974c67850595917$var$RoadmapIcon = (props)=>/*#__PURE__*/ $e974c67850595917$var$_react.default.createElement($e974c67850595917$var$_roadmap.default, Object.assign({
        LEGACY_fallbackIcon: $e974c67850595917$var$_roadmap2.default
    }, props));
$e974c67850595917$var$RoadmapIcon.Name = 'RoadmapIconMigration';
var $e974c67850595917$var$_default = module.exports.default = $e974c67850595917$var$RoadmapIcon;

});
parcelRegister("i3vuN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d250f039686fbf24$var$_react = $d250f039686fbf24$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $d250f039686fbf24$var$_roadmap = $d250f039686fbf24$var$_interopRequireDefault((parcelRequire("ifnb0")));
function $d250f039686fbf24$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d250f039686fbf24$var$RoadmapIcon = (props)=>/*#__PURE__*/ $d250f039686fbf24$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M6 2h10a3 3 0 0 1 0 6H6a3 3 0 1 1 0-6m0 2a1 1 0 1 0 0 2h10a1 1 0 0 0 0-2zm4 5h8a3 3 0 0 1 0 6h-8a3 3 0 0 1 0-6m0 2a1 1 0 0 0 0 2h8a1 1 0 0 0 0-2zm-4 5h6a3 3 0 0 1 0 6H6a3 3 0 0 1 0-6m0 2a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2z"/></svg>`
    }, props, {
        newIcon: $d250f039686fbf24$var$_roadmap.default
    }));
$d250f039686fbf24$var$RoadmapIcon.displayName = 'RoadmapIcon';
var $d250f039686fbf24$var$_default = module.exports.default = $d250f039686fbf24$var$RoadmapIcon;

});



parcelRegister("czzsL", function(module, exports) {

$parcel$export(module.exports, "filterAndSort", () => $0a04151ee5a00965$export$d0e0de50c701304c);
$parcel$export(module.exports, "findDependentFeature", () => $0a04151ee5a00965$export$4c8205136225a4e2);
$parcel$export(module.exports, "updateFeatureState", () => $0a04151ee5a00965$export$2bdeae30201d513c);
$parcel$export(module.exports, "fireErrorAnalyticsOnUnmatchFeatureKey", () => $0a04151ee5a00965$export$5da1e8c5ba5c0dc2);

var $hqTkp = parcelRequire("hqTkp");

var $jcw0u = parcelRequire("jcw0u");

var $6s1PB = parcelRequire("6s1PB");

var $3Jf4N = parcelRequire("3Jf4N");
const $0a04151ee5a00965$export$b70265791d2079d4 = (hasFeature)=>hasFeature ? 'ENABLED' : 'DISABLED';
const $0a04151ee5a00965$export$d0e0de50c701304c = (features)=>{
    const [expConfig] = (0, $6s1PB.UNSAFE_noExposureExp)('jsw_simplify_navigation_m2');
    const featureMap = (0, $3Jf4N.getFeatureMap)({
        isSimplifyNavExperimentEnabled: expConfig.get('isEnabled', false),
        isListViewEnabled: (0, $6s1PB.expValEquals)('jsw_list_view', 'cohort', 'variation')
    });
    return features.filter((f)=>Object.keys(featureMap).includes(f.feature)).sort((a, b)=>featureMap[a.feature].order - featureMap[b.feature].order);
};
const $0a04151ee5a00965$export$4c8205136225a4e2 = (features, featureId)=>{
    const featureToDisable = features.find((f)=>f.feature === featureId);
    // Will only show the modal when the current status is enabled for both the feature to disable and the dependent feature
    if (featureToDisable?.state !== 'ENABLED') return undefined;
    // For the scope of the feature toggle, we assume there is only one dependency for now
    return features.find((f)=>f.prerequisites.includes(featureId) && f.state === 'ENABLED');
};
const $0a04151ee5a00965$export$2bdeae30201d513c = (featureId, dependentFeatureId)=>(feature)=>feature.feature === featureId || dependentFeatureId && feature.feature === dependentFeatureId ? {
            ...feature,
            state: feature.state === 'ENABLED' ? 'DISABLED' : 'ENABLED'
        } : feature;
const $0a04151ee5a00965$export$5da1e8c5ba5c0dc2 = (filteredFeatures)=>{
    const [expConfig] = (0, $6s1PB.UNSAFE_noExposureExp)('jsw_simplify_navigation_m2');
    const featureMap = (0, $3Jf4N.getFeatureMap)({
        isSimplifyNavExperimentEnabled: expConfig.get('isEnabled', false),
        isListViewEnabled: (0, $6s1PB.expValEquals)('jsw_list_view', 'cohort', 'variation')
    });
    if (filteredFeatures.length < Object.keys(featureMap).length) {
        const unmatchedFeatureKeys = (0, (/*@__PURE__*/$parcel$interopDefault($hqTkp)))(Object.keys(featureMap), ...filteredFeatures.map((f)=>f.feature));
        (0, $jcw0u.default)({
            error: new Error("Some feature keys don't match . Please check API response"),
            meta: {
                ...(0, $3Jf4N.commonErrorAnalyticsMeta),
                id: 'unmatchFeatureKey'
            },
            attributes: {
                unmatchedFeatureKeys: unmatchedFeatureKeys.toString()
            }
        });
    }
};

});
parcelRegister("hqTkp", function(module, exports) {

var $55pzo = parcelRequire("55pzo");

var $g7i7g = parcelRequire("g7i7g");

var $f3SOL = parcelRequire("f3SOL");
/**
 * Creates an array excluding all given values using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * **Note:** Unlike `_.pull`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...*} [values] The values to exclude.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.difference, _.xor
 * @example
 *
 * _.without([2, 1, 2, 3], 1, 2);
 * // => [3]
 */ var $cb0fc8686550aa11$var$without = $g7i7g(function(array, values) {
    return $f3SOL(array) ? $55pzo(array, values) : [];
});
module.exports = $cb0fc8686550aa11$var$without;

});
parcelRegister("55pzo", function(module, exports) {

var $ijRUK = parcelRequire("ijRUK");

var $fUP98 = parcelRequire("fUP98");

var $dA3tP = parcelRequire("dA3tP");

var $1nIHN = parcelRequire("1nIHN");

var $cW28x = parcelRequire("cW28x");

var $40I25 = parcelRequire("40I25");
/** Used as the size to enable large array optimizations. */ var $3b41410a547f22d2$var$LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of methods like `_.difference` without support
 * for excluding multiple arrays or iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Array} values The values to exclude.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 */ function $3b41410a547f22d2$var$baseDifference(array, values, iteratee, comparator) {
    var index = -1, includes = $fUP98, isCommon = true, length = array.length, result = [], valuesLength = values.length;
    if (!length) return result;
    if (iteratee) values = $1nIHN(values, $cW28x(iteratee));
    if (comparator) {
        includes = $dA3tP;
        isCommon = false;
    } else if (values.length >= $3b41410a547f22d2$var$LARGE_ARRAY_SIZE) {
        includes = $40I25;
        isCommon = false;
        values = new $ijRUK(values);
    }
    outer: while(++index < length){
        var value = array[index], computed = iteratee == null ? value : iteratee(value);
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var valuesIndex = valuesLength;
            while(valuesIndex--){
                if (values[valuesIndex] === computed) continue outer;
            }
            result.push(value);
        } else if (!includes(values, computed, comparator)) result.push(value);
    }
    return result;
}
module.exports = $3b41410a547f22d2$var$baseDifference;

});



parcelRegister("iZZTd", function(module, exports) {

$parcel$export(module.exports, "getBoardFeatures", () => $140b4a0769fd2090$export$c20100b185d41ab0);

var $eusud = parcelRequire("eusud");

var $8djOx = parcelRequire("8djOx");
const $140b4a0769fd2090$export$c20100b185d41ab0 = async (boardId)=>{
    const data = await (0, $eusud.performGetRequest)((0, $8djOx.getBoardFeaturesUrl)(boardId));
    return data.features;
};

});
parcelRegister("8djOx", function(module, exports) {

$parcel$export(module.exports, "getBoardFeaturesUrl", () => $45a3789113fa4e8b$export$3f9939d302766b52);
const $45a3789113fa4e8b$export$3f9939d302766b52 = (boardId)=>`/rest/agile/latest/board/${boardId}/features`;

});


parcelRegister("ke207", function(module, exports) {

$parcel$export(module.exports, "updateBoardFeature", () => $1ce9149bd154bcf9$export$61f6bbb745b3a3);

var $eusud = parcelRequire("eusud");

var $8djOx = parcelRequire("8djOx");
const $1ce9149bd154bcf9$export$61f6bbb745b3a3 = async (request)=>{
    // it returns the board features array, but we don't use it for optimistic update
    // feature state is used instead to indicate if the updates successful or not
    const data = await (0, $eusud.performPutRequest)((0, $8djOx.getBoardFeaturesUrl)(request.boardId), {
        body: JSON.stringify(request)
    });
    const newState = data.features.find((f)=>f.feature === request.feature)?.state;
    return newState ?? (request.enabling ? 'ENABLED' : 'DISABLED');
};

});



parcelRegister("iHqA4", function(module, exports) {

$parcel$export(module.exports, "useClearSidebarToggled", () => $b80f211a69d994c6$export$2946f555c6f48127);

var $5uXOq = parcelRequire("5uXOq");

var $ajpes = parcelRequire("ajpes");

var $1J3t1 = parcelRequire("1J3t1");

var $1XJ20 = parcelRequire("1XJ20");

var $hDSPU = parcelRequire("hDSPU");

var $j8sa8 = parcelRequire("j8sa8");
const $b80f211a69d994c6$export$2946f555c6f48127 = ()=>{
    const { data: data, refresh: refresh } = (0, $1J3t1.useJiraSoftwareProjectNavigation)();
    const [sidebarFeatureToggled, { clearSiderbarFeatureToggled: clearSiderbarFeatureToggled }] = (0, $hDSPU.useSidebarFeatureToggled)();
    const isEligibleForFeatureToggle = (0, $j8sa8.useShouldApplyFeatureToggle)();
    const sidebarHasChanged = (0, $5uXOq.useRef)(false);
    const previousData = (0, $1XJ20.usePreviousWithInitial)(data);
    // if resource data has changed since the last refresh then remove the sidebar toggled data.
    // i.e. whatever that has been toggled is reflected on the latest resource
    const shouldClear = (0, $5uXOq.useMemo)(()=>isEligibleForFeatureToggle && !(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(previousData, data), [
        isEligibleForFeatureToggle,
        previousData,
        data
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (shouldClear) clearSiderbarFeatureToggled();
    }, [
        shouldClear,
        clearSiderbarFeatureToggled
    ]);
    (0, $5uXOq.useEffect)(()=>{
        sidebarHasChanged.current = isEligibleForFeatureToggle && !!sidebarFeatureToggled;
    }, [
        isEligibleForFeatureToggle,
        sidebarFeatureToggled
    ]);
    // refresh the navigation resource if sidebar has changed
    (0, $5uXOq.useEffect)(()=>()=>{
            if (sidebarHasChanged.current) refresh();
        }, [
        refresh
    ]);
};

});
parcelRegister("1XJ20", function(module, exports) {

$parcel$export(module.exports, "usePrevious", () => $011794d66b906d20$export$5cae361ad82dce8b);
$parcel$export(module.exports, "usePreviousPersistent", () => $011794d66b906d20$export$9c42f2690cfe6963);
$parcel$export(module.exports, "usePreviousWithInitial", () => $011794d66b906d20$export$23fbbb2e62c4a911);

var $5uXOq = parcelRequire("5uXOq");
const $011794d66b906d20$export$5cae361ad82dce8b = (value)=>{
    const ref = (0, $5uXOq.useRef)();
    (0, $5uXOq.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
};
const $011794d66b906d20$export$9c42f2690cfe6963 = (value)=>{
    // initialise the ref with previous and current values
    const ref = (0, $5uXOq.useRef)({
        value: value,
        prev: undefined
    });
    const current = ref.current.value;
    // if the value passed into hook doesn't match what we store as "current"
    // move the "current" to the "previous"
    // and store the passed value as "current"
    if (value !== current) ref.current = {
        value: value,
        prev: current
    };
    // return the previous value only
    return ref.current.prev;
};
const $011794d66b906d20$export$23fbbb2e62c4a911 = (value)=>{
    const ref = (0, $5uXOq.useRef)(value);
    (0, $5uXOq.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
};

});

parcelRegister("j8sa8", function(module, exports) {

$parcel$export(module.exports, "useShouldApplyFeatureToggle", () => $d568e02a383436d9$export$7deca16ba2d9eb74);

var $2vSU6 = parcelRequire("2vSU6");

var $dAfqg = parcelRequire("dAfqg");

var $dkqym = parcelRequire("dkqym");
const $d568e02a383436d9$export$7deca16ba2d9eb74 = ()=>{
    const { data: project } = (0, $dAfqg.useProjectContext)();
    const firstActivationDateMs = (0, $dkqym.useFirstActivationDateMs)() || 0;
    const isJSW = project?.projectType === (0, $2vSU6.SOFTWARE_PROJECT);
    const isTMP = !!project?.simplified;
    const isProjectAdmin = !!project?.isProjectAdmin;
    const isNewInstance = new Date(firstActivationDateMs) >= new Date('2023-09-25T15:00:00');
    return isJSW && isTMP && isProjectAdmin && isNewInstance;
};

});
parcelRegister("dkqym", function(module, exports) {

$parcel$export(module.exports, "useFirstActivationDateMs", () => $61794ef454831b86$export$9df3a539e50a284b);

var $9OXo1 = parcelRequire("9OXo1");
const $61794ef454831b86$export$9df3a539e50a284b = ()=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    return tenantContext && tenantContext.firstActivationDateMs != null ? tenantContext.firstActivationDateMs : null;
};

});








//# sourceMappingURL=async-software-project-onboarding-component.8b3ea9af.js.map
